(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree984"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree984"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nwvT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1bb6f341c8f857d6$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $aPFUy = parcelRequire("aPFUy");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $1bb6f341c8f857d6$export$71511d61b312f219(arr, i) {
    return (0, $1g4fM._)(arr) || (0, $aPFUy._)(arr, i) || (0, $2DD2t._)(arr, i) || (0, $9kJqn._)();
}

});
parcelRegister("1g4fM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0eaa95b9f3cb7234$export$71511d61b312f219; });
function $0eaa95b9f3cb7234$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("aPFUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e2f2d8338cd036c$export$71511d61b312f219; });
function $7e2f2d8338cd036c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("9kJqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6cb937a794637792$export$71511d61b312f219; });
function $6cb937a794637792$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2DD2t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ebd819a91fcf92e$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $1ebd819a91fcf92e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6exmR._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6exmR._)(o, minLen);
}

});
parcelRegister("6exmR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $489def0a77882a2a$export$71511d61b312f219; });
function $489def0a77882a2a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("iD4WH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1xne7"));

});
parcelRegister("1xne7", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $11eae3db0de2690a$export$ffb0004e005737fa; }, function (v) { return $11eae3db0de2690a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $11eae3db0de2690a$export$34b9dba7ce09269b; }, function (v) { return $11eae3db0de2690a$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $11eae3db0de2690a$export$25062201e9e25d76; }, function (v) { return $11eae3db0de2690a$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11eae3db0de2690a$export$ffb0004e005737fa;
var $11eae3db0de2690a$export$34b9dba7ce09269b;
var $11eae3db0de2690a$export$25062201e9e25d76;
"use strict";
var $11eae3db0de2690a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $11eae3db0de2690a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $11eae3db0de2690a$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $11eae3db0de2690a$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$11eae3db0de2690a$export$ffb0004e005737fa = $11eae3db0de2690a$var$REACT_FRAGMENT_TYPE;
$11eae3db0de2690a$export$34b9dba7ce09269b = $11eae3db0de2690a$var$jsxProd;
$11eae3db0de2690a$export$25062201e9e25d76 = $11eae3db0de2690a$var$jsxProd;

});


parcelRegister("dQFEZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("Dao4Y"));

});
parcelRegister("Dao4Y", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $075bb3596b32de15$export$dca3b0875bd9a954; }, function (v) { return $075bb3596b32de15$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $075bb3596b32de15$export$16fa2f45be04daa8; }, function (v) { return $075bb3596b32de15$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $075bb3596b32de15$export$ffb0004e005737fa; }, function (v) { return $075bb3596b32de15$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $075bb3596b32de15$export$e2c29f18771995cb; }, function (v) { return $075bb3596b32de15$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $075bb3596b32de15$export$221d75b3f55bb0bd; }, function (v) { return $075bb3596b32de15$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $075bb3596b32de15$export$5f8d39834fd61797; }, function (v) { return $075bb3596b32de15$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $075bb3596b32de15$export$74bf444e3cd11ea5; }, function (v) { return $075bb3596b32de15$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $075bb3596b32de15$export$1ced07cd6b1985ce; }, function (v) { return $075bb3596b32de15$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $075bb3596b32de15$export$3ba232387fd5d6dd; }, function (v) { return $075bb3596b32de15$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $075bb3596b32de15$export$69a3209f1a06c04d; }, function (v) { return $075bb3596b32de15$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $075bb3596b32de15$export$e530037191fcd5d7; }, function (v) { return $075bb3596b32de15$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $075bb3596b32de15$export$fd42f52fd3ae1109; }, function (v) { return $075bb3596b32de15$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $075bb3596b32de15$export$c8a8987d4410bf2d; }, function (v) { return $075bb3596b32de15$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $075bb3596b32de15$export$7d1e3a5e95ceca43; }, function (v) { return $075bb3596b32de15$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $075bb3596b32de15$export$257a8862b851cb5b; }, function (v) { return $075bb3596b32de15$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $075bb3596b32de15$export$a8257692ac88316c; }, function (v) { return $075bb3596b32de15$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $075bb3596b32de15$export$488013bae63b21da; }, function (v) { return $075bb3596b32de15$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $075bb3596b32de15$export$7c73462e0d25e514; }, function (v) { return $075bb3596b32de15$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $075bb3596b32de15$export$7568632d0d33d16d; }, function (v) { return $075bb3596b32de15$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $075bb3596b32de15$export$f93f40ac0ca7e3a8; }, function (v) { return $075bb3596b32de15$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $075bb3596b32de15$export$1f96ae73734a86cc; }, function (v) { return $075bb3596b32de15$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $075bb3596b32de15$export$9a47ced3238df325; }, function (v) { return $075bb3596b32de15$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $075bb3596b32de15$export$35808ee640e87ca7; }, function (v) { return $075bb3596b32de15$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $075bb3596b32de15$export$fae74005e78b1a27; }, function (v) { return $075bb3596b32de15$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $075bb3596b32de15$export$dc8fbce3eb94dc1e; }, function (v) { return $075bb3596b32de15$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $075bb3596b32de15$export$6a7bc4e911dc01cf; }, function (v) { return $075bb3596b32de15$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $075bb3596b32de15$export$6d9c69b0de29b591; }, function (v) { return $075bb3596b32de15$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $075bb3596b32de15$export$f680877a34711e37; }, function (v) { return $075bb3596b32de15$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $075bb3596b32de15$export$d5a552a76deda3c2; }, function (v) { return $075bb3596b32de15$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $075bb3596b32de15$export$aaabe4eda9ed9969; }, function (v) { return $075bb3596b32de15$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $075bb3596b32de15$export$e5c5a5f917a5871c; }, function (v) { return $075bb3596b32de15$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $075bb3596b32de15$export$1538c33de8887b59; }, function (v) { return $075bb3596b32de15$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $075bb3596b32de15$export$fca7f784ae7a249a; }, function (v) { return $075bb3596b32de15$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $075bb3596b32de15$export$13e3392192263954; }, function (v) { return $075bb3596b32de15$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $075bb3596b32de15$export$b8f5890fc79d6aca; }, function (v) { return $075bb3596b32de15$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $075bb3596b32de15$export$60241385465d0a34; }, function (v) { return $075bb3596b32de15$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $075bb3596b32de15$export$306c0aa65ff9ec16; }, function (v) { return $075bb3596b32de15$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $075bb3596b32de15$export$7b286972b8d8ccbf; }, function (v) { return $075bb3596b32de15$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $075bb3596b32de15$export$83d89fbfd8236492; }, function (v) { return $075bb3596b32de15$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $075bb3596b32de15$export$dca3b0875bd9a954;
var $075bb3596b32de15$export$16fa2f45be04daa8;
var $075bb3596b32de15$export$ffb0004e005737fa;
var $075bb3596b32de15$export$e2c29f18771995cb;
var $075bb3596b32de15$export$221d75b3f55bb0bd;
var $075bb3596b32de15$export$5f8d39834fd61797;
var $075bb3596b32de15$export$74bf444e3cd11ea5;
var $075bb3596b32de15$export$1ced07cd6b1985ce;
var $075bb3596b32de15$export$3ba232387fd5d6dd;
var $075bb3596b32de15$export$69a3209f1a06c04d;
var $075bb3596b32de15$export$e530037191fcd5d7;
var $075bb3596b32de15$export$fd42f52fd3ae1109;
var $075bb3596b32de15$export$c8a8987d4410bf2d;
var $075bb3596b32de15$export$7d1e3a5e95ceca43;
var $075bb3596b32de15$export$257a8862b851cb5b;
var $075bb3596b32de15$export$a8257692ac88316c;
var $075bb3596b32de15$export$488013bae63b21da;
var $075bb3596b32de15$export$7c73462e0d25e514;
var $075bb3596b32de15$export$7568632d0d33d16d;
var $075bb3596b32de15$export$f93f40ac0ca7e3a8;
var $075bb3596b32de15$export$1f96ae73734a86cc;
var $075bb3596b32de15$export$9a47ced3238df325;
var $075bb3596b32de15$export$35808ee640e87ca7;
var $075bb3596b32de15$export$fae74005e78b1a27;
var $075bb3596b32de15$export$dc8fbce3eb94dc1e;
var $075bb3596b32de15$export$6a7bc4e911dc01cf;
var $075bb3596b32de15$export$6d9c69b0de29b591;
var $075bb3596b32de15$export$f680877a34711e37;
var $075bb3596b32de15$export$d5a552a76deda3c2;
var $075bb3596b32de15$export$aaabe4eda9ed9969;
var $075bb3596b32de15$export$e5c5a5f917a5871c;
var $075bb3596b32de15$export$1538c33de8887b59;
var $075bb3596b32de15$export$fca7f784ae7a249a;
var $075bb3596b32de15$export$13e3392192263954;
var $075bb3596b32de15$export$b8f5890fc79d6aca;
var $075bb3596b32de15$export$60241385465d0a34;
var $075bb3596b32de15$export$306c0aa65ff9ec16;
var $075bb3596b32de15$export$7b286972b8d8ccbf;
var $075bb3596b32de15$export$83d89fbfd8236492;
"use strict";
var $075bb3596b32de15$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $075bb3596b32de15$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $075bb3596b32de15$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $075bb3596b32de15$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $075bb3596b32de15$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $075bb3596b32de15$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $075bb3596b32de15$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $075bb3596b32de15$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $075bb3596b32de15$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $075bb3596b32de15$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $075bb3596b32de15$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $075bb3596b32de15$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $075bb3596b32de15$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $bJtXW._)(maybeIterable))) return null;
    maybeIterable = $075bb3596b32de15$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$075bb3596b32de15$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $075bb3596b32de15$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $075bb3596b32de15$var$assign = Object.assign, $075bb3596b32de15$var$emptyObject = {};
function $075bb3596b32de15$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $075bb3596b32de15$var$emptyObject;
    this.updater = updater || $075bb3596b32de15$var$ReactNoopUpdateQueue;
}
$075bb3596b32de15$var$Component.prototype.isReactComponent = {};
$075bb3596b32de15$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $bJtXW._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$075bb3596b32de15$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $075bb3596b32de15$var$ComponentDummy() {}
$075bb3596b32de15$var$ComponentDummy.prototype = $075bb3596b32de15$var$Component.prototype;
function $075bb3596b32de15$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $075bb3596b32de15$var$emptyObject;
    this.updater = updater || $075bb3596b32de15$var$ReactNoopUpdateQueue;
}
var $075bb3596b32de15$var$pureComponentPrototype = $075bb3596b32de15$var$PureComponent.prototype = new $075bb3596b32de15$var$ComponentDummy();
$075bb3596b32de15$var$pureComponentPrototype.constructor = $075bb3596b32de15$var$PureComponent;
$075bb3596b32de15$var$assign($075bb3596b32de15$var$pureComponentPrototype, $075bb3596b32de15$var$Component.prototype);
$075bb3596b32de15$var$pureComponentPrototype.isPureReactComponent = !0;
var $075bb3596b32de15$var$isArrayImpl = Array.isArray, $075bb3596b32de15$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $075bb3596b32de15$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $075bb3596b32de15$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $075bb3596b32de15$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $075bb3596b32de15$var$cloneAndReplaceKey(oldElement, newKey) {
    return $075bb3596b32de15$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $075bb3596b32de15$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) && null !== object && object.$$typeof === $075bb3596b32de15$var$REACT_ELEMENT_TYPE;
}
function $075bb3596b32de15$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $075bb3596b32de15$var$userProvidedKeyEscapeRegex = /\/+/g;
function $075bb3596b32de15$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $bJtXW._)(element)) && null !== element && null != element.key ? $075bb3596b32de15$var$escape("" + element.key) : index.toString(36);
}
function $075bb3596b32de15$var$noop$1() {}
function $075bb3596b32de15$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($075bb3596b32de15$var$noop$1, $075bb3596b32de15$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $075bb3596b32de15$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $bJtXW._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $075bb3596b32de15$var$REACT_ELEMENT_TYPE:
                case $075bb3596b32de15$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $075bb3596b32de15$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $075bb3596b32de15$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $075bb3596b32de15$var$getElementKey(children, 0) : nameSoFar, $075bb3596b32de15$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($075bb3596b32de15$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $075bb3596b32de15$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($075bb3596b32de15$var$isValidElement(callback) && (callback = $075bb3596b32de15$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($075bb3596b32de15$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($075bb3596b32de15$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $075bb3596b32de15$var$getElementKey(nameSoFar, i), invokeCallback += $075bb3596b32de15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $075bb3596b32de15$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $075bb3596b32de15$var$getElementKey(nameSoFar, i++), invokeCallback += $075bb3596b32de15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $075bb3596b32de15$var$mapIntoArray($075bb3596b32de15$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $075bb3596b32de15$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $075bb3596b32de15$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $075bb3596b32de15$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $075bb3596b32de15$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $bJtXW._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $bJtXW._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $075bb3596b32de15$var$noop() {}
$075bb3596b32de15$export$dca3b0875bd9a954 = {
    map: $075bb3596b32de15$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $075bb3596b32de15$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $075bb3596b32de15$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $075bb3596b32de15$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$075bb3596b32de15$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$075bb3596b32de15$export$16fa2f45be04daa8 = $075bb3596b32de15$var$Component;
$075bb3596b32de15$export$ffb0004e005737fa = $075bb3596b32de15$var$REACT_FRAGMENT_TYPE;
$075bb3596b32de15$export$e2c29f18771995cb = $075bb3596b32de15$var$REACT_PROFILER_TYPE;
$075bb3596b32de15$export$221d75b3f55bb0bd = $075bb3596b32de15$var$PureComponent;
$075bb3596b32de15$export$5f8d39834fd61797 = $075bb3596b32de15$var$REACT_STRICT_MODE_TYPE;
$075bb3596b32de15$export$74bf444e3cd11ea5 = $075bb3596b32de15$var$REACT_SUSPENSE_TYPE;
$075bb3596b32de15$export$1ced07cd6b1985ce = $075bb3596b32de15$var$ReactSharedInternals;
$075bb3596b32de15$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$075bb3596b32de15$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$075bb3596b32de15$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $075bb3596b32de15$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$075bb3596b32de15$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $075bb3596b32de15$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$075bb3596b32de15$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $075bb3596b32de15$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $075bb3596b32de15$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$075bb3596b32de15$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$075bb3596b32de15$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $075bb3596b32de15$var$ReactElement(type, key, void 0, void 0, null, props);
};
$075bb3596b32de15$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$075bb3596b32de15$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $075bb3596b32de15$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$075bb3596b32de15$export$a8257692ac88316c = $075bb3596b32de15$var$isValidElement;
$075bb3596b32de15$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $075bb3596b32de15$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $075bb3596b32de15$var$lazyInitializer
    };
};
$075bb3596b32de15$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $075bb3596b32de15$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$075bb3596b32de15$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $075bb3596b32de15$var$ReactSharedInternals.T, currentTransition = {};
    $075bb3596b32de15$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $075bb3596b32de15$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $bJtXW._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($075bb3596b32de15$var$noop, $075bb3596b32de15$var$reportGlobalError);
    } catch (error) {
        $075bb3596b32de15$var$reportGlobalError(error);
    } finally{
        $075bb3596b32de15$var$ReactSharedInternals.T = prevTransition;
    }
};
$075bb3596b32de15$export$f93f40ac0ca7e3a8 = function() {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useCacheRefresh();
};
$075bb3596b32de15$export$1f96ae73734a86cc = function(usable) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.use(usable);
};
$075bb3596b32de15$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$075bb3596b32de15$export$35808ee640e87ca7 = function(callback, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$075bb3596b32de15$export$fae74005e78b1a27 = function(Context) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useContext(Context);
};
$075bb3596b32de15$export$dc8fbce3eb94dc1e = function() {};
$075bb3596b32de15$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$075bb3596b32de15$export$6d9c69b0de29b591 = function(create, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useEffect(create, deps);
};
$075bb3596b32de15$export$f680877a34711e37 = function() {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useId();
};
$075bb3596b32de15$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$075bb3596b32de15$export$aaabe4eda9ed9969 = function(create, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$075bb3596b32de15$export$e5c5a5f917a5871c = function(create, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$075bb3596b32de15$export$1538c33de8887b59 = function(create, deps) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useMemo(create, deps);
};
$075bb3596b32de15$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$075bb3596b32de15$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$075bb3596b32de15$export$b8f5890fc79d6aca = function(initialValue) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useRef(initialValue);
};
$075bb3596b32de15$export$60241385465d0a34 = function(initialState) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useState(initialState);
};
$075bb3596b32de15$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$075bb3596b32de15$export$7b286972b8d8ccbf = function() {
    return $075bb3596b32de15$var$ReactSharedInternals.H.useTransition();
};
$075bb3596b32de15$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("bJtXW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $88ab244363eded38$export$71511d61b312f219; });
function $88ab244363eded38$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("guBD8", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c01ca34426469d55$export$882461b6382ed46c; }, function (v) { return $c01ca34426469d55$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c01ca34426469d55$export$757ceba2d55c277e; }, function (v) { return $c01ca34426469d55$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $c01ca34426469d55$export$83d89fbfd8236492; }, function (v) { return $c01ca34426469d55$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $bJtXW = parcelRequire("bJtXW");
var $c01ca34426469d55$export$882461b6382ed46c;
var $c01ca34426469d55$export$757ceba2d55c277e;
var $c01ca34426469d55$export$83d89fbfd8236492;
"use strict";

var $1iyD5 = parcelRequire("1iyD5");

var $dQFEZ = parcelRequire("dQFEZ");

var $5Ia9Q = parcelRequire("5Ia9Q");
function $c01ca34426469d55$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c01ca34426469d55$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $c01ca34426469d55$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c01ca34426469d55$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c01ca34426469d55$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c01ca34426469d55$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c01ca34426469d55$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c01ca34426469d55$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c01ca34426469d55$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $c01ca34426469d55$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c01ca34426469d55$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c01ca34426469d55$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c01ca34426469d55$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c01ca34426469d55$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c01ca34426469d55$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c01ca34426469d55$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c01ca34426469d55$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c01ca34426469d55$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $c01ca34426469d55$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c01ca34426469d55$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $bJtXW._)(maybeIterable))) return null;
    maybeIterable = $c01ca34426469d55$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c01ca34426469d55$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c01ca34426469d55$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c01ca34426469d55$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c01ca34426469d55$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c01ca34426469d55$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c01ca34426469d55$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c01ca34426469d55$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c01ca34426469d55$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c01ca34426469d55$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c01ca34426469d55$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type))) switch(type.$$typeof){
        case $c01ca34426469d55$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $c01ca34426469d55$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c01ca34426469d55$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c01ca34426469d55$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c01ca34426469d55$var$getComponentNameFromType(type.type) || "Memo";
        case $c01ca34426469d55$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c01ca34426469d55$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c01ca34426469d55$var$ReactSharedInternals = $dQFEZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c01ca34426469d55$var$assign = Object.assign, $c01ca34426469d55$var$prefix, $c01ca34426469d55$var$suffix;
function $c01ca34426469d55$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c01ca34426469d55$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c01ca34426469d55$var$prefix = match && match[1] || "";
        $c01ca34426469d55$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c01ca34426469d55$var$prefix + name + $c01ca34426469d55$var$suffix;
}
var $c01ca34426469d55$var$reentry = !1;
function $c01ca34426469d55$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c01ca34426469d55$var$reentry) return "";
    $c01ca34426469d55$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c01ca34426469d55$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c01ca34426469d55$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c01ca34426469d55$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c01ca34426469d55$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c01ca34426469d55$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $c01ca34426469d55$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c01ca34426469d55$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $c01ca34426469d55$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $c01ca34426469d55$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $c01ca34426469d55$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $c01ca34426469d55$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $c01ca34426469d55$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $c01ca34426469d55$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c01ca34426469d55$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c01ca34426469d55$var$assertIsMounted(fiber) {
    if ($c01ca34426469d55$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c01ca34426469d55$var$formatProdErrorMessage(188));
}
function $c01ca34426469d55$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c01ca34426469d55$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c01ca34426469d55$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c01ca34426469d55$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c01ca34426469d55$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($c01ca34426469d55$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c01ca34426469d55$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c01ca34426469d55$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c01ca34426469d55$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c01ca34426469d55$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c01ca34426469d55$var$isArrayImpl = Array.isArray, $c01ca34426469d55$var$ReactDOMSharedInternals = $5Ia9Q.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c01ca34426469d55$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c01ca34426469d55$var$valueStack = [], $c01ca34426469d55$var$index = -1;
function $c01ca34426469d55$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c01ca34426469d55$var$pop(cursor) {
    0 > $c01ca34426469d55$var$index || (cursor.current = $c01ca34426469d55$var$valueStack[$c01ca34426469d55$var$index], $c01ca34426469d55$var$valueStack[$c01ca34426469d55$var$index] = null, $c01ca34426469d55$var$index--);
}
function $c01ca34426469d55$var$push(cursor, value) {
    $c01ca34426469d55$var$index++;
    $c01ca34426469d55$var$valueStack[$c01ca34426469d55$var$index] = cursor.current;
    cursor.current = value;
}
var $c01ca34426469d55$var$contextStackCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$contextFiberStackCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$rootInstanceStackCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$hostTransitionProviderCursor = $c01ca34426469d55$var$createCursor(null);
function $c01ca34426469d55$var$pushHostContainer(fiber, nextRootInstance) {
    $c01ca34426469d55$var$push($c01ca34426469d55$var$rootInstanceStackCursor, nextRootInstance);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$contextFiberStackCursor, fiber);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $c01ca34426469d55$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $c01ca34426469d55$var$getOwnHostContext(fiber), nextRootInstance = $c01ca34426469d55$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$contextStackCursor);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$contextStackCursor, nextRootInstance);
}
function $c01ca34426469d55$var$popHostContainer() {
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$contextStackCursor);
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$contextFiberStackCursor);
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$rootInstanceStackCursor);
}
function $c01ca34426469d55$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c01ca34426469d55$var$push($c01ca34426469d55$var$hostTransitionProviderCursor, fiber);
    var context = $c01ca34426469d55$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c01ca34426469d55$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c01ca34426469d55$var$push($c01ca34426469d55$var$contextFiberStackCursor, fiber), $c01ca34426469d55$var$push($c01ca34426469d55$var$contextStackCursor, JSCompiler_inline_result));
}
function $c01ca34426469d55$var$popHostContext(fiber) {
    $c01ca34426469d55$var$contextFiberStackCursor.current === fiber && ($c01ca34426469d55$var$pop($c01ca34426469d55$var$contextStackCursor), $c01ca34426469d55$var$pop($c01ca34426469d55$var$contextFiberStackCursor));
    $c01ca34426469d55$var$hostTransitionProviderCursor.current === fiber && ($c01ca34426469d55$var$pop($c01ca34426469d55$var$hostTransitionProviderCursor), $c01ca34426469d55$var$HostTransitionContext._currentValue = $c01ca34426469d55$var$sharedNotPendingObject);
}
var $c01ca34426469d55$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c01ca34426469d55$var$scheduleCallback$3 = $1iyD5.unstable_scheduleCallback, $c01ca34426469d55$var$cancelCallback$1 = $1iyD5.unstable_cancelCallback, $c01ca34426469d55$var$shouldYield = $1iyD5.unstable_shouldYield, $c01ca34426469d55$var$requestPaint = $1iyD5.unstable_requestPaint, $c01ca34426469d55$var$now = $1iyD5.unstable_now, $c01ca34426469d55$var$getCurrentPriorityLevel = $1iyD5.unstable_getCurrentPriorityLevel, $c01ca34426469d55$var$ImmediatePriority = $1iyD5.unstable_ImmediatePriority, $c01ca34426469d55$var$UserBlockingPriority = $1iyD5.unstable_UserBlockingPriority, $c01ca34426469d55$var$NormalPriority$1 = $1iyD5.unstable_NormalPriority, $c01ca34426469d55$var$LowPriority = $1iyD5.unstable_LowPriority, $c01ca34426469d55$var$IdlePriority = $1iyD5.unstable_IdlePriority, $c01ca34426469d55$var$log$1 = $1iyD5.log, $c01ca34426469d55$var$unstable_setDisableYieldValue = $1iyD5.unstable_setDisableYieldValue, $c01ca34426469d55$var$rendererID = null, $c01ca34426469d55$var$injectedHook = null;
function $c01ca34426469d55$var$onCommitRoot(root) {
    if ($c01ca34426469d55$var$injectedHook && "function" === typeof $c01ca34426469d55$var$injectedHook.onCommitFiberRoot) try {
        $c01ca34426469d55$var$injectedHook.onCommitFiberRoot($c01ca34426469d55$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $c01ca34426469d55$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c01ca34426469d55$var$log$1 && $c01ca34426469d55$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c01ca34426469d55$var$injectedHook && "function" === typeof $c01ca34426469d55$var$injectedHook.setStrictMode) try {
        $c01ca34426469d55$var$injectedHook.setStrictMode($c01ca34426469d55$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c01ca34426469d55$var$clz32 = Math.clz32 ? Math.clz32 : $c01ca34426469d55$var$clz32Fallback, $c01ca34426469d55$var$log = Math.log, $c01ca34426469d55$var$LN2 = Math.LN2;
function $c01ca34426469d55$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c01ca34426469d55$var$log(x) / $c01ca34426469d55$var$LN2 | 0) | 0;
}
var $c01ca34426469d55$var$nextTransitionLane = 128, $c01ca34426469d55$var$nextRetryLane = 4194304;
function $c01ca34426469d55$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c01ca34426469d55$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $c01ca34426469d55$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $c01ca34426469d55$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c01ca34426469d55$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c01ca34426469d55$var$claimNextTransitionLane() {
    var lane = $c01ca34426469d55$var$nextTransitionLane;
    $c01ca34426469d55$var$nextTransitionLane <<= 1;
    0 === ($c01ca34426469d55$var$nextTransitionLane & 4194176) && ($c01ca34426469d55$var$nextTransitionLane = 128);
    return lane;
}
function $c01ca34426469d55$var$claimNextRetryLane() {
    var lane = $c01ca34426469d55$var$nextRetryLane;
    $c01ca34426469d55$var$nextRetryLane <<= 1;
    0 === ($c01ca34426469d55$var$nextRetryLane & 62914560) && ($c01ca34426469d55$var$nextRetryLane = 4194304);
    return lane;
}
function $c01ca34426469d55$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c01ca34426469d55$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c01ca34426469d55$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c01ca34426469d55$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c01ca34426469d55$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c01ca34426469d55$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c01ca34426469d55$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $c01ca34426469d55$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c01ca34426469d55$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c01ca34426469d55$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c01ca34426469d55$var$resolveUpdatePriority() {
    var updatePriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c01ca34426469d55$var$getEventPriority(updatePriority.type);
}
function $c01ca34426469d55$var$runWithPriority(priority, fn) {
    var previousPriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    try {
        return $c01ca34426469d55$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c01ca34426469d55$var$randomKey = Math.random().toString(36).slice(2), $c01ca34426469d55$var$internalInstanceKey = "__reactFiber$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalPropsKey = "__reactProps$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalContainerInstanceKey = "__reactContainer$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalEventHandlersKey = "__reactEvents$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalEventHandlerListenersKey = "__reactListeners$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalEventHandlesSetKey = "__reactHandles$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalRootNodeResourcesKey = "__reactResources$" + $c01ca34426469d55$var$randomKey, $c01ca34426469d55$var$internalHoistableMarker = "__reactMarker$" + $c01ca34426469d55$var$randomKey;
function $c01ca34426469d55$var$detachDeletedInstance(node) {
    delete node[$c01ca34426469d55$var$internalInstanceKey];
    delete node[$c01ca34426469d55$var$internalPropsKey];
    delete node[$c01ca34426469d55$var$internalEventHandlersKey];
    delete node[$c01ca34426469d55$var$internalEventHandlerListenersKey];
    delete node[$c01ca34426469d55$var$internalEventHandlesSetKey];
}
function $c01ca34426469d55$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c01ca34426469d55$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c01ca34426469d55$var$internalContainerInstanceKey] || parentNode[$c01ca34426469d55$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c01ca34426469d55$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c01ca34426469d55$var$internalInstanceKey]) return parentNode;
                targetNode = $c01ca34426469d55$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c01ca34426469d55$var$getInstanceFromNode(node) {
    if (node = node[$c01ca34426469d55$var$internalInstanceKey] || node[$c01ca34426469d55$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c01ca34426469d55$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(33));
}
function $c01ca34426469d55$var$getResourcesFromRoot(root) {
    var resources = root[$c01ca34426469d55$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c01ca34426469d55$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c01ca34426469d55$var$markNodeAsHoistable(node) {
    node[$c01ca34426469d55$var$internalHoistableMarker] = !0;
}
var $c01ca34426469d55$var$allNativeEvents = new Set(), $c01ca34426469d55$var$registrationNameDependencies = {};
function $c01ca34426469d55$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c01ca34426469d55$var$registerDirectEvent(registrationName, dependencies);
    $c01ca34426469d55$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c01ca34426469d55$var$registerDirectEvent(registrationName, dependencies) {
    $c01ca34426469d55$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c01ca34426469d55$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c01ca34426469d55$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c01ca34426469d55$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c01ca34426469d55$var$illegalAttributeNameCache = {}, $c01ca34426469d55$var$validatedAttributeNameCache = {};
function $c01ca34426469d55$var$isAttributeNameSafe(attributeName) {
    if ($c01ca34426469d55$var$hasOwnProperty.call($c01ca34426469d55$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c01ca34426469d55$var$hasOwnProperty.call($c01ca34426469d55$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c01ca34426469d55$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c01ca34426469d55$var$validatedAttributeNameCache[attributeName] = !0;
    $c01ca34426469d55$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c01ca34426469d55$var$setValueForAttribute(node, name, value) {
    if ($c01ca34426469d55$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c01ca34426469d55$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c01ca34426469d55$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $c01ca34426469d55$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c01ca34426469d55$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c01ca34426469d55$var$trackValueOnNode(node) {
    var valueField = $c01ca34426469d55$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c01ca34426469d55$var$track(node) {
    node._valueTracker || (node._valueTracker = $c01ca34426469d55$var$trackValueOnNode(node));
}
function $c01ca34426469d55$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c01ca34426469d55$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c01ca34426469d55$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c01ca34426469d55$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c01ca34426469d55$var$getToStringValue(value);
        } else element.value !== "" + $c01ca34426469d55$var$getToStringValue(value) && (element.value = "" + $c01ca34426469d55$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c01ca34426469d55$var$setDefaultValue(element, type, $c01ca34426469d55$var$getToStringValue(value)) : null != defaultValue ? $c01ca34426469d55$var$setDefaultValue(element, type, $c01ca34426469d55$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $bJtXW._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) && "boolean" !== typeof name ? element.name = "" + $c01ca34426469d55$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c01ca34426469d55$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $c01ca34426469d55$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c01ca34426469d55$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $bJtXW._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) && "boolean" !== typeof name && (element.name = name);
}
function $c01ca34426469d55$var$setDefaultValue(node, type, value) {
    "number" === type && $c01ca34426469d55$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c01ca34426469d55$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c01ca34426469d55$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c01ca34426469d55$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c01ca34426469d55$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c01ca34426469d55$var$getToStringValue(defaultValue) : "";
}
function $c01ca34426469d55$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c01ca34426469d55$var$formatProdErrorMessage(92));
            if ($c01ca34426469d55$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c01ca34426469d55$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c01ca34426469d55$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $c01ca34426469d55$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c01ca34426469d55$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c01ca34426469d55$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c01ca34426469d55$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c01ca34426469d55$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $bJtXW._)(styles))) throw Error($c01ca34426469d55$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c01ca34426469d55$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c01ca34426469d55$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c01ca34426469d55$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c01ca34426469d55$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c01ca34426469d55$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c01ca34426469d55$var$sanitizeURL(url) {
    return $c01ca34426469d55$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $c01ca34426469d55$var$currentReplayingEvent = null;
function $c01ca34426469d55$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c01ca34426469d55$var$restoreTarget = null, $c01ca34426469d55$var$restoreQueue = null;
function $c01ca34426469d55$var$restoreStateOfTarget(target) {
    var internalInstance = $c01ca34426469d55$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c01ca34426469d55$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c01ca34426469d55$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c01ca34426469d55$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c01ca34426469d55$var$formatProdErrorMessage(90));
                            $c01ca34426469d55$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c01ca34426469d55$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c01ca34426469d55$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c01ca34426469d55$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c01ca34426469d55$var$isInsideEventHandler = !1;
function $c01ca34426469d55$var$batchedUpdates$1(fn, a, b) {
    if ($c01ca34426469d55$var$isInsideEventHandler) return fn(a, b);
    $c01ca34426469d55$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c01ca34426469d55$var$isInsideEventHandler = !1, null !== $c01ca34426469d55$var$restoreTarget || null !== $c01ca34426469d55$var$restoreQueue) {
            if ($c01ca34426469d55$var$flushSyncWork$1(), $c01ca34426469d55$var$restoreTarget && (a = $c01ca34426469d55$var$restoreTarget, fn = $c01ca34426469d55$var$restoreQueue, $c01ca34426469d55$var$restoreQueue = $c01ca34426469d55$var$restoreTarget = null, $c01ca34426469d55$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c01ca34426469d55$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c01ca34426469d55$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c01ca34426469d55$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c01ca34426469d55$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $bJtXW._)(stateNode)));
    return stateNode;
}
var $c01ca34426469d55$var$passiveBrowserEventsSupported = !1;
if ($c01ca34426469d55$var$canUseDOM) try {
    var $c01ca34426469d55$var$options = {};
    Object.defineProperty($c01ca34426469d55$var$options, "passive", {
        get: function get() {
            $c01ca34426469d55$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c01ca34426469d55$var$options, $c01ca34426469d55$var$options);
    window.removeEventListener("test", $c01ca34426469d55$var$options, $c01ca34426469d55$var$options);
} catch (e) {
    $c01ca34426469d55$var$passiveBrowserEventsSupported = !1;
}
var $c01ca34426469d55$var$root = null, $c01ca34426469d55$var$startText = null, $c01ca34426469d55$var$fallbackText = null;
function $c01ca34426469d55$var$getData() {
    if ($c01ca34426469d55$var$fallbackText) return $c01ca34426469d55$var$fallbackText;
    var start, startValue = $c01ca34426469d55$var$startText, startLength = startValue.length, end, endValue = "value" in $c01ca34426469d55$var$root ? $c01ca34426469d55$var$root.value : $c01ca34426469d55$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c01ca34426469d55$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c01ca34426469d55$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c01ca34426469d55$var$functionThatReturnsTrue() {
    return !0;
}
function $c01ca34426469d55$var$functionThatReturnsFalse() {
    return !1;
}
function $c01ca34426469d55$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c01ca34426469d55$var$functionThatReturnsTrue : $c01ca34426469d55$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c01ca34426469d55$var$functionThatReturnsFalse;
        return this;
    }
    $c01ca34426469d55$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $bJtXW._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $c01ca34426469d55$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $bJtXW._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $c01ca34426469d55$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $c01ca34426469d55$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c01ca34426469d55$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c01ca34426469d55$var$SyntheticEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$EventInterface), $c01ca34426469d55$var$UIEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    view: 0,
    detail: 0
}), $c01ca34426469d55$var$SyntheticUIEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$UIEventInterface), $c01ca34426469d55$var$lastMovementX, $c01ca34426469d55$var$lastMovementY, $c01ca34426469d55$var$lastMouseEvent, $c01ca34426469d55$var$MouseEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c01ca34426469d55$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c01ca34426469d55$var$lastMouseEvent && ($c01ca34426469d55$var$lastMouseEvent && "mousemove" === event.type ? ($c01ca34426469d55$var$lastMovementX = event.screenX - $c01ca34426469d55$var$lastMouseEvent.screenX, $c01ca34426469d55$var$lastMovementY = event.screenY - $c01ca34426469d55$var$lastMouseEvent.screenY) : $c01ca34426469d55$var$lastMovementY = $c01ca34426469d55$var$lastMovementX = 0, $c01ca34426469d55$var$lastMouseEvent = event);
        return $c01ca34426469d55$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $c01ca34426469d55$var$lastMovementY;
    }
}), $c01ca34426469d55$var$SyntheticMouseEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$MouseEventInterface), $c01ca34426469d55$var$DragEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$MouseEventInterface, {
    dataTransfer: 0
}), $c01ca34426469d55$var$SyntheticDragEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$DragEventInterface), $c01ca34426469d55$var$FocusEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$UIEventInterface, {
    relatedTarget: 0
}), $c01ca34426469d55$var$SyntheticFocusEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$FocusEventInterface), $c01ca34426469d55$var$AnimationEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c01ca34426469d55$var$SyntheticAnimationEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$AnimationEventInterface), $c01ca34426469d55$var$ClipboardEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c01ca34426469d55$var$SyntheticClipboardEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$ClipboardEventInterface), $c01ca34426469d55$var$CompositionEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    data: 0
}), $c01ca34426469d55$var$SyntheticCompositionEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$CompositionEventInterface), $c01ca34426469d55$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c01ca34426469d55$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c01ca34426469d55$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c01ca34426469d55$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c01ca34426469d55$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c01ca34426469d55$var$getEventModifierState() {
    return $c01ca34426469d55$var$modifierStateGetter;
}
var $c01ca34426469d55$var$KeyboardEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c01ca34426469d55$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c01ca34426469d55$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c01ca34426469d55$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c01ca34426469d55$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $c01ca34426469d55$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $c01ca34426469d55$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c01ca34426469d55$var$SyntheticKeyboardEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$KeyboardEventInterface), $c01ca34426469d55$var$PointerEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c01ca34426469d55$var$SyntheticPointerEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$PointerEventInterface), $c01ca34426469d55$var$TouchEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c01ca34426469d55$var$getEventModifierState
}), $c01ca34426469d55$var$SyntheticTouchEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$TouchEventInterface), $c01ca34426469d55$var$TransitionEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c01ca34426469d55$var$SyntheticTransitionEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$TransitionEventInterface), $c01ca34426469d55$var$WheelEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c01ca34426469d55$var$SyntheticWheelEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$WheelEventInterface), $c01ca34426469d55$var$ToggleEventInterface = $c01ca34426469d55$var$assign({}, $c01ca34426469d55$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c01ca34426469d55$var$SyntheticToggleEvent = $c01ca34426469d55$var$createSyntheticEvent($c01ca34426469d55$var$ToggleEventInterface), $c01ca34426469d55$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c01ca34426469d55$var$canUseCompositionEvent = $c01ca34426469d55$var$canUseDOM && "CompositionEvent" in window, $c01ca34426469d55$var$documentMode = null;
$c01ca34426469d55$var$canUseDOM && "documentMode" in document && ($c01ca34426469d55$var$documentMode = document.documentMode);
var $c01ca34426469d55$var$canUseTextInputEvent = $c01ca34426469d55$var$canUseDOM && "TextEvent" in window && !$c01ca34426469d55$var$documentMode, $c01ca34426469d55$var$useFallbackCompositionData = $c01ca34426469d55$var$canUseDOM && (!$c01ca34426469d55$var$canUseCompositionEvent || $c01ca34426469d55$var$documentMode && 8 < $c01ca34426469d55$var$documentMode && 11 >= $c01ca34426469d55$var$documentMode), $c01ca34426469d55$var$SPACEBAR_CHAR = String.fromCharCode(32), $c01ca34426469d55$var$hasSpaceKeypress = !1;
function $c01ca34426469d55$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c01ca34426469d55$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c01ca34426469d55$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $bJtXW._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c01ca34426469d55$var$isComposing = !1;
function $c01ca34426469d55$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c01ca34426469d55$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c01ca34426469d55$var$hasSpaceKeypress = !0;
            return $c01ca34426469d55$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c01ca34426469d55$var$SPACEBAR_CHAR && $c01ca34426469d55$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c01ca34426469d55$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c01ca34426469d55$var$isComposing) return "compositionend" === domEventName || !$c01ca34426469d55$var$canUseCompositionEvent && $c01ca34426469d55$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c01ca34426469d55$var$getData(), $c01ca34426469d55$var$fallbackText = $c01ca34426469d55$var$startText = $c01ca34426469d55$var$root = null, $c01ca34426469d55$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c01ca34426469d55$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c01ca34426469d55$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c01ca34426469d55$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c01ca34426469d55$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c01ca34426469d55$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c01ca34426469d55$var$restoreTarget ? $c01ca34426469d55$var$restoreQueue ? $c01ca34426469d55$var$restoreQueue.push(target) : $c01ca34426469d55$var$restoreQueue = [
        target
    ] : $c01ca34426469d55$var$restoreTarget = target;
    inst = $c01ca34426469d55$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c01ca34426469d55$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c01ca34426469d55$var$activeElement$1 = null, $c01ca34426469d55$var$activeElementInst$1 = null;
function $c01ca34426469d55$var$runEventInBatch(dispatchQueue) {
    $c01ca34426469d55$var$processDispatchQueue(dispatchQueue, 0);
}
function $c01ca34426469d55$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c01ca34426469d55$var$getNodeFromInstance(targetInst);
    if ($c01ca34426469d55$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c01ca34426469d55$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c01ca34426469d55$var$isInputEventSupported = !1;
if ($c01ca34426469d55$var$canUseDOM) {
    var $c01ca34426469d55$var$JSCompiler_inline_result$jscomp$283;
    if ($c01ca34426469d55$var$canUseDOM) {
        var $c01ca34426469d55$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$c01ca34426469d55$var$isSupported$jscomp$inline_418) {
            var $c01ca34426469d55$var$element$jscomp$inline_419 = document.createElement("div");
            $c01ca34426469d55$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $c01ca34426469d55$var$isSupported$jscomp$inline_418 = "function" === typeof $c01ca34426469d55$var$element$jscomp$inline_419.oninput;
        }
        $c01ca34426469d55$var$JSCompiler_inline_result$jscomp$283 = $c01ca34426469d55$var$isSupported$jscomp$inline_418;
    } else $c01ca34426469d55$var$JSCompiler_inline_result$jscomp$283 = !1;
    $c01ca34426469d55$var$isInputEventSupported = $c01ca34426469d55$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $c01ca34426469d55$var$stopWatchingForValueChange() {
    $c01ca34426469d55$var$activeElement$1 && ($c01ca34426469d55$var$activeElement$1.detachEvent("onpropertychange", $c01ca34426469d55$var$handlePropertyChange), $c01ca34426469d55$var$activeElementInst$1 = $c01ca34426469d55$var$activeElement$1 = null);
}
function $c01ca34426469d55$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c01ca34426469d55$var$getInstIfValueChanged($c01ca34426469d55$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c01ca34426469d55$var$createAndAccumulateChangeEvent(dispatchQueue, $c01ca34426469d55$var$activeElementInst$1, nativeEvent, $c01ca34426469d55$var$getEventTarget(nativeEvent));
        $c01ca34426469d55$var$batchedUpdates$1($c01ca34426469d55$var$runEventInBatch, dispatchQueue);
    }
}
function $c01ca34426469d55$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c01ca34426469d55$var$stopWatchingForValueChange(), $c01ca34426469d55$var$activeElement$1 = target, $c01ca34426469d55$var$activeElementInst$1 = targetInst, $c01ca34426469d55$var$activeElement$1.attachEvent("onpropertychange", $c01ca34426469d55$var$handlePropertyChange)) : "focusout" === domEventName && $c01ca34426469d55$var$stopWatchingForValueChange();
}
function $c01ca34426469d55$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c01ca34426469d55$var$getInstIfValueChanged($c01ca34426469d55$var$activeElementInst$1);
}
function $c01ca34426469d55$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c01ca34426469d55$var$getInstIfValueChanged(targetInst);
}
function $c01ca34426469d55$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c01ca34426469d55$var$getInstIfValueChanged(targetInst);
}
function $c01ca34426469d55$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c01ca34426469d55$var$objectIs = "function" === typeof Object.is ? Object.is : $c01ca34426469d55$var$is;
function $c01ca34426469d55$var$shallowEqual(objA, objB) {
    if ($c01ca34426469d55$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $bJtXW._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $bJtXW._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c01ca34426469d55$var$hasOwnProperty.call(objB, currentKey) || !$c01ca34426469d55$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c01ca34426469d55$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c01ca34426469d55$var$getNodeForCharacterOffset(root, offset) {
    var node = $c01ca34426469d55$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c01ca34426469d55$var$getLeafNode(node);
    }
}
function $c01ca34426469d55$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c01ca34426469d55$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c01ca34426469d55$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c01ca34426469d55$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c01ca34426469d55$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c01ca34426469d55$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $c01ca34426469d55$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $c01ca34426469d55$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $c01ca34426469d55$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $c01ca34426469d55$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $c01ca34426469d55$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $c01ca34426469d55$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $c01ca34426469d55$var$skipSelectionChangeEvent = $c01ca34426469d55$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c01ca34426469d55$var$activeElement = null, $c01ca34426469d55$var$activeElementInst = null, $c01ca34426469d55$var$lastSelection = null, $c01ca34426469d55$var$mouseDown = !1;
function $c01ca34426469d55$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c01ca34426469d55$var$mouseDown || null == $c01ca34426469d55$var$activeElement || $c01ca34426469d55$var$activeElement !== $c01ca34426469d55$var$getActiveElement(doc) || (doc = $c01ca34426469d55$var$activeElement, "selectionStart" in doc && $c01ca34426469d55$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c01ca34426469d55$var$lastSelection && $c01ca34426469d55$var$shallowEqual($c01ca34426469d55$var$lastSelection, doc) || ($c01ca34426469d55$var$lastSelection = doc, doc = $c01ca34426469d55$var$accumulateTwoPhaseListeners($c01ca34426469d55$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c01ca34426469d55$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c01ca34426469d55$var$activeElement)));
}
function $c01ca34426469d55$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c01ca34426469d55$var$vendorPrefixes = {
    animationend: $c01ca34426469d55$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c01ca34426469d55$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c01ca34426469d55$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c01ca34426469d55$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c01ca34426469d55$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c01ca34426469d55$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c01ca34426469d55$var$makePrefixMap("Transition", "TransitionEnd")
}, $c01ca34426469d55$var$prefixedEventNames = {}, $c01ca34426469d55$var$style = {};
$c01ca34426469d55$var$canUseDOM && ($c01ca34426469d55$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c01ca34426469d55$var$vendorPrefixes.animationend.animation, delete $c01ca34426469d55$var$vendorPrefixes.animationiteration.animation, delete $c01ca34426469d55$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c01ca34426469d55$var$vendorPrefixes.transitionend.transition);
function $c01ca34426469d55$var$getVendorPrefixedEventName(eventName) {
    if ($c01ca34426469d55$var$prefixedEventNames[eventName]) return $c01ca34426469d55$var$prefixedEventNames[eventName];
    if (!$c01ca34426469d55$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c01ca34426469d55$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c01ca34426469d55$var$style) return $c01ca34426469d55$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c01ca34426469d55$var$ANIMATION_END = $c01ca34426469d55$var$getVendorPrefixedEventName("animationend"), $c01ca34426469d55$var$ANIMATION_ITERATION = $c01ca34426469d55$var$getVendorPrefixedEventName("animationiteration"), $c01ca34426469d55$var$ANIMATION_START = $c01ca34426469d55$var$getVendorPrefixedEventName("animationstart"), $c01ca34426469d55$var$TRANSITION_RUN = $c01ca34426469d55$var$getVendorPrefixedEventName("transitionrun"), $c01ca34426469d55$var$TRANSITION_START = $c01ca34426469d55$var$getVendorPrefixedEventName("transitionstart"), $c01ca34426469d55$var$TRANSITION_CANCEL = $c01ca34426469d55$var$getVendorPrefixedEventName("transitioncancel"), $c01ca34426469d55$var$TRANSITION_END = $c01ca34426469d55$var$getVendorPrefixedEventName("transitionend"), $c01ca34426469d55$var$topLevelEventsToReactNames = new Map(), $c01ca34426469d55$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $c01ca34426469d55$var$registerSimpleEvent(domEventName, reactName) {
    $c01ca34426469d55$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c01ca34426469d55$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c01ca34426469d55$var$concurrentQueues = [], $c01ca34426469d55$var$concurrentQueuesIndex = 0, $c01ca34426469d55$var$concurrentlyUpdatedLanes = 0;
function $c01ca34426469d55$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c01ca34426469d55$var$concurrentQueuesIndex, i = $c01ca34426469d55$var$concurrentlyUpdatedLanes = $c01ca34426469d55$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c01ca34426469d55$var$concurrentQueues[i];
        $c01ca34426469d55$var$concurrentQueues[i++] = null;
        var queue = $c01ca34426469d55$var$concurrentQueues[i];
        $c01ca34426469d55$var$concurrentQueues[i++] = null;
        var update = $c01ca34426469d55$var$concurrentQueues[i];
        $c01ca34426469d55$var$concurrentQueues[i++] = null;
        var lane = $c01ca34426469d55$var$concurrentQueues[i];
        $c01ca34426469d55$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c01ca34426469d55$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c01ca34426469d55$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c01ca34426469d55$var$concurrentQueues[$c01ca34426469d55$var$concurrentQueuesIndex++] = fiber;
    $c01ca34426469d55$var$concurrentQueues[$c01ca34426469d55$var$concurrentQueuesIndex++] = queue;
    $c01ca34426469d55$var$concurrentQueues[$c01ca34426469d55$var$concurrentQueuesIndex++] = update;
    $c01ca34426469d55$var$concurrentQueues[$c01ca34426469d55$var$concurrentQueuesIndex++] = lane;
    $c01ca34426469d55$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c01ca34426469d55$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c01ca34426469d55$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c01ca34426469d55$var$getRootForUpdatedFiber(fiber);
}
function $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c01ca34426469d55$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c01ca34426469d55$var$getRootForUpdatedFiber(fiber);
}
function $c01ca34426469d55$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $c01ca34426469d55$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $c01ca34426469d55$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c01ca34426469d55$var$nestedUpdateCount) throw $c01ca34426469d55$var$nestedUpdateCount = 0, $c01ca34426469d55$var$rootWithNestedUpdates = null, Error($c01ca34426469d55$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c01ca34426469d55$var$emptyContextObject = {}, $c01ca34426469d55$var$CapturedStacks = new WeakMap();
function $c01ca34426469d55$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) && null !== value) {
        var existing = $c01ca34426469d55$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c01ca34426469d55$var$getStackByFiberInDevAndProd(source)
        };
        $c01ca34426469d55$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c01ca34426469d55$var$getStackByFiberInDevAndProd(source)
    };
}
var $c01ca34426469d55$var$forkStack = [], $c01ca34426469d55$var$forkStackIndex = 0, $c01ca34426469d55$var$treeForkProvider = null, $c01ca34426469d55$var$treeForkCount = 0, $c01ca34426469d55$var$idStack = [], $c01ca34426469d55$var$idStackIndex = 0, $c01ca34426469d55$var$treeContextProvider = null, $c01ca34426469d55$var$treeContextId = 1, $c01ca34426469d55$var$treeContextOverflow = "";
function $c01ca34426469d55$var$pushTreeFork(workInProgress, totalChildren) {
    $c01ca34426469d55$var$forkStack[$c01ca34426469d55$var$forkStackIndex++] = $c01ca34426469d55$var$treeForkCount;
    $c01ca34426469d55$var$forkStack[$c01ca34426469d55$var$forkStackIndex++] = $c01ca34426469d55$var$treeForkProvider;
    $c01ca34426469d55$var$treeForkProvider = workInProgress;
    $c01ca34426469d55$var$treeForkCount = totalChildren;
}
function $c01ca34426469d55$var$pushTreeId(workInProgress, totalChildren, index) {
    $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextId;
    $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextOverflow;
    $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextProvider;
    $c01ca34426469d55$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c01ca34426469d55$var$treeContextId;
    workInProgress = $c01ca34426469d55$var$treeContextOverflow;
    var baseLength = 32 - $c01ca34426469d55$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c01ca34426469d55$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c01ca34426469d55$var$treeContextId = 1 << 32 - $c01ca34426469d55$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c01ca34426469d55$var$treeContextOverflow = length + workInProgress;
    } else $c01ca34426469d55$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c01ca34426469d55$var$treeContextOverflow = workInProgress;
}
function $c01ca34426469d55$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c01ca34426469d55$var$pushTreeFork(workInProgress, 1), $c01ca34426469d55$var$pushTreeId(workInProgress, 1, 0));
}
function $c01ca34426469d55$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c01ca34426469d55$var$treeForkProvider;)$c01ca34426469d55$var$treeForkProvider = $c01ca34426469d55$var$forkStack[--$c01ca34426469d55$var$forkStackIndex], $c01ca34426469d55$var$forkStack[$c01ca34426469d55$var$forkStackIndex] = null, $c01ca34426469d55$var$treeForkCount = $c01ca34426469d55$var$forkStack[--$c01ca34426469d55$var$forkStackIndex], $c01ca34426469d55$var$forkStack[$c01ca34426469d55$var$forkStackIndex] = null;
    for(; workInProgress === $c01ca34426469d55$var$treeContextProvider;)$c01ca34426469d55$var$treeContextProvider = $c01ca34426469d55$var$idStack[--$c01ca34426469d55$var$idStackIndex], $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex] = null, $c01ca34426469d55$var$treeContextOverflow = $c01ca34426469d55$var$idStack[--$c01ca34426469d55$var$idStackIndex], $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex] = null, $c01ca34426469d55$var$treeContextId = $c01ca34426469d55$var$idStack[--$c01ca34426469d55$var$idStackIndex], $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex] = null;
}
var $c01ca34426469d55$var$hydrationParentFiber = null, $c01ca34426469d55$var$nextHydratableInstance = null, $c01ca34426469d55$var$isHydrating = !1, $c01ca34426469d55$var$hydrationErrors = null, $c01ca34426469d55$var$rootOrSingletonContext = !1, $c01ca34426469d55$var$HydrationMismatchException = Error($c01ca34426469d55$var$formatProdErrorMessage(519));
function $c01ca34426469d55$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c01ca34426469d55$var$formatProdErrorMessage(418, ""));
    $c01ca34426469d55$var$queueHydrationError($c01ca34426469d55$var$createCapturedValueAtFiber(error, fiber));
    throw $c01ca34426469d55$var$HydrationMismatchException;
}
function $c01ca34426469d55$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c01ca34426469d55$var$internalInstanceKey] = fiber;
    instance[$c01ca34426469d55$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("cancel", instance);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c01ca34426469d55$var$mediaEventTypes.length; type++)$c01ca34426469d55$var$listenToNonDelegatedEvent($c01ca34426469d55$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("error", instance);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", instance);
            $c01ca34426469d55$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $c01ca34426469d55$var$track(instance);
            break;
        case "select":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", instance), $c01ca34426469d55$var$initTextarea(instance, props.value, props.defaultValue, props.children), $c01ca34426469d55$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c01ca34426469d55$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c01ca34426469d55$var$listenToNonDelegatedEvent("beforetoggle", instance), $c01ca34426469d55$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c01ca34426469d55$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c01ca34426469d55$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c01ca34426469d55$var$noop$1), instance = !0) : instance = !1;
    instance || $c01ca34426469d55$var$throwOnHydrationMismatch(fiber);
}
function $c01ca34426469d55$var$popToNextHostParent(fiber) {
    for($c01ca34426469d55$var$hydrationParentFiber = fiber.return; $c01ca34426469d55$var$hydrationParentFiber;)switch($c01ca34426469d55$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $c01ca34426469d55$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $c01ca34426469d55$var$rootOrSingletonContext = !1;
            return;
        default:
            $c01ca34426469d55$var$hydrationParentFiber = $c01ca34426469d55$var$hydrationParentFiber.return;
    }
}
function $c01ca34426469d55$var$popHydrationState(fiber) {
    if (fiber !== $c01ca34426469d55$var$hydrationParentFiber) return !1;
    if (!$c01ca34426469d55$var$isHydrating) return $c01ca34426469d55$var$popToNextHostParent(fiber), $c01ca34426469d55$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c01ca34426469d55$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $c01ca34426469d55$var$nextHydratableInstance && $c01ca34426469d55$var$throwOnHydrationMismatch(fiber);
    $c01ca34426469d55$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c01ca34426469d55$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $c01ca34426469d55$var$nextHydratableInstance = null;
        }
    } else $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$hydrationParentFiber ? $c01ca34426469d55$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c01ca34426469d55$var$resetHydrationState() {
    $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$hydrationParentFiber = null;
    $c01ca34426469d55$var$isHydrating = !1;
}
function $c01ca34426469d55$var$queueHydrationError(error) {
    null === $c01ca34426469d55$var$hydrationErrors ? $c01ca34426469d55$var$hydrationErrors = [
        error
    ] : $c01ca34426469d55$var$hydrationErrors.push(error);
}
var $c01ca34426469d55$var$SuspenseException = Error($c01ca34426469d55$var$formatProdErrorMessage(460)), $c01ca34426469d55$var$SuspenseyCommitException = Error($c01ca34426469d55$var$formatProdErrorMessage(474)), $c01ca34426469d55$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $c01ca34426469d55$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c01ca34426469d55$var$noop$3() {}
function $c01ca34426469d55$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c01ca34426469d55$var$noop$3, $c01ca34426469d55$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $c01ca34426469d55$var$SuspenseException) throw Error($c01ca34426469d55$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c01ca34426469d55$var$noop$3, $c01ca34426469d55$var$noop$3);
            else {
                thenableState = $c01ca34426469d55$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c01ca34426469d55$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $c01ca34426469d55$var$SuspenseException) throw Error($c01ca34426469d55$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $c01ca34426469d55$var$suspendedThenable = thenable;
            throw $c01ca34426469d55$var$SuspenseException;
    }
}
var $c01ca34426469d55$var$suspendedThenable = null;
function $c01ca34426469d55$var$getSuspendedThenable() {
    if (null === $c01ca34426469d55$var$suspendedThenable) throw Error($c01ca34426469d55$var$formatProdErrorMessage(459));
    var thenable = $c01ca34426469d55$var$suspendedThenable;
    $c01ca34426469d55$var$suspendedThenable = null;
    return thenable;
}
var $c01ca34426469d55$var$thenableState$1 = null, $c01ca34426469d55$var$thenableIndexCounter$1 = 0;
function $c01ca34426469d55$var$unwrapThenable(thenable) {
    var index = $c01ca34426469d55$var$thenableIndexCounter$1;
    $c01ca34426469d55$var$thenableIndexCounter$1 += 1;
    null === $c01ca34426469d55$var$thenableState$1 && ($c01ca34426469d55$var$thenableState$1 = []);
    return $c01ca34426469d55$var$trackUsedThenable($c01ca34426469d55$var$thenableState$1, thenable, index);
}
function $c01ca34426469d55$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c01ca34426469d55$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $c01ca34426469d55$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c01ca34426469d55$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c01ca34426469d55$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $c01ca34426469d55$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c01ca34426469d55$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c01ca34426469d55$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c01ca34426469d55$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $bJtXW._)(elementType)) && null !== elementType && elementType.$$typeof === $c01ca34426469d55$var$REACT_LAZY_TYPE && $c01ca34426469d55$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c01ca34426469d55$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c01ca34426469d55$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c01ca34426469d55$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c01ca34426469d55$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c01ca34426469d55$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild))) return newChild = $c01ca34426469d55$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c01ca34426469d55$var$REACT_ELEMENT_TYPE:
                    return lanes = $c01ca34426469d55$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c01ca34426469d55$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c01ca34426469d55$var$REACT_PORTAL_TYPE:
                    return newChild = $c01ca34426469d55$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c01ca34426469d55$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($c01ca34426469d55$var$isArrayImpl(newChild) || $c01ca34426469d55$var$getIteratorFn(newChild)) return newChild = $c01ca34426469d55$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c01ca34426469d55$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c01ca34426469d55$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c01ca34426469d55$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c01ca34426469d55$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c01ca34426469d55$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c01ca34426469d55$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c01ca34426469d55$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c01ca34426469d55$var$isArrayImpl(newChild) || $c01ca34426469d55$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c01ca34426469d55$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c01ca34426469d55$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c01ca34426469d55$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c01ca34426469d55$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c01ca34426469d55$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c01ca34426469d55$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c01ca34426469d55$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c01ca34426469d55$var$isArrayImpl(newChild) || $c01ca34426469d55$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c01ca34426469d55$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c01ca34426469d55$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c01ca34426469d55$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c01ca34426469d55$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c01ca34426469d55$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c01ca34426469d55$var$isHydrating && $c01ca34426469d55$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) && null !== newChild && newChild.type === $c01ca34426469d55$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $c01ca34426469d55$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c01ca34426469d55$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) && null !== key && key.$$typeof === $c01ca34426469d55$var$REACT_LAZY_TYPE && $c01ca34426469d55$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c01ca34426469d55$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c01ca34426469d55$var$REACT_FRAGMENT_TYPE ? (lanes = $c01ca34426469d55$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c01ca34426469d55$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c01ca34426469d55$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c01ca34426469d55$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c01ca34426469d55$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c01ca34426469d55$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c01ca34426469d55$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c01ca34426469d55$var$getIteratorFn(newChild)) {
                key = $c01ca34426469d55$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c01ca34426469d55$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c01ca34426469d55$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c01ca34426469d55$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c01ca34426469d55$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c01ca34426469d55$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $bJtXW._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c01ca34426469d55$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c01ca34426469d55$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c01ca34426469d55$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c01ca34426469d55$var$SuspenseException) throw x;
            var fiber = $c01ca34426469d55$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c01ca34426469d55$var$reconcileChildFibers = $c01ca34426469d55$var$createChildReconciler(!0), $c01ca34426469d55$var$mountChildFibers = $c01ca34426469d55$var$createChildReconciler(!1), $c01ca34426469d55$var$currentTreeHiddenStackCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$prevEntangledRenderLanesCursor = $c01ca34426469d55$var$createCursor(0);
function $c01ca34426469d55$var$pushHiddenContext(fiber, context) {
    fiber = $c01ca34426469d55$var$entangledRenderLanes;
    $c01ca34426469d55$var$push($c01ca34426469d55$var$prevEntangledRenderLanesCursor, fiber);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$currentTreeHiddenStackCursor, context);
    $c01ca34426469d55$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c01ca34426469d55$var$reuseHiddenContextOnStack() {
    $c01ca34426469d55$var$push($c01ca34426469d55$var$prevEntangledRenderLanesCursor, $c01ca34426469d55$var$entangledRenderLanes);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$currentTreeHiddenStackCursor, $c01ca34426469d55$var$currentTreeHiddenStackCursor.current);
}
function $c01ca34426469d55$var$popHiddenContext() {
    $c01ca34426469d55$var$entangledRenderLanes = $c01ca34426469d55$var$prevEntangledRenderLanesCursor.current;
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$currentTreeHiddenStackCursor);
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$prevEntangledRenderLanesCursor);
}
var $c01ca34426469d55$var$suspenseHandlerStackCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$shellBoundary = null;
function $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, $c01ca34426469d55$var$suspenseStackCursor.current & 1);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseHandlerStackCursor, handler);
    null === $c01ca34426469d55$var$shellBoundary && (null === current || null !== $c01ca34426469d55$var$currentTreeHiddenStackCursor.current ? $c01ca34426469d55$var$shellBoundary = handler : null !== current.memoizedState && ($c01ca34426469d55$var$shellBoundary = handler));
}
function $c01ca34426469d55$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, $c01ca34426469d55$var$suspenseStackCursor.current), $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseHandlerStackCursor, fiber), null === $c01ca34426469d55$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($c01ca34426469d55$var$shellBoundary = fiber);
        }
    } else $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c01ca34426469d55$var$reuseSuspenseHandlerOnStack() {
    $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, $c01ca34426469d55$var$suspenseStackCursor.current);
    $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseHandlerStackCursor, $c01ca34426469d55$var$suspenseHandlerStackCursor.current);
}
function $c01ca34426469d55$var$popSuspenseHandler(fiber) {
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$suspenseHandlerStackCursor);
    $c01ca34426469d55$var$shellBoundary === fiber && ($c01ca34426469d55$var$shellBoundary = null);
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$suspenseStackCursor);
}
var $c01ca34426469d55$var$suspenseStackCursor = $c01ca34426469d55$var$createCursor(0);
function $c01ca34426469d55$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c01ca34426469d55$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c01ca34426469d55$var$scheduleCallback$2 = $1iyD5.unstable_scheduleCallback, $c01ca34426469d55$var$NormalPriority = $1iyD5.unstable_NormalPriority, $c01ca34426469d55$var$CacheContext = {
    $$typeof: $c01ca34426469d55$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c01ca34426469d55$var$createCache() {
    return {
        controller: new $c01ca34426469d55$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c01ca34426469d55$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c01ca34426469d55$var$scheduleCallback$2($c01ca34426469d55$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c01ca34426469d55$var$currentEntangledListeners = null, $c01ca34426469d55$var$currentEntangledPendingCount = 0, $c01ca34426469d55$var$currentEntangledLane = 0, $c01ca34426469d55$var$currentEntangledActionThenable = null;
function $c01ca34426469d55$var$entangleAsyncAction(transition, thenable) {
    if (null === $c01ca34426469d55$var$currentEntangledListeners) {
        var entangledListeners = $c01ca34426469d55$var$currentEntangledListeners = [];
        $c01ca34426469d55$var$currentEntangledPendingCount = 0;
        $c01ca34426469d55$var$currentEntangledLane = $c01ca34426469d55$var$requestTransitionLane();
        $c01ca34426469d55$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c01ca34426469d55$var$currentEntangledPendingCount++;
    thenable.then($c01ca34426469d55$var$pingEngtangledActionScope, $c01ca34426469d55$var$pingEngtangledActionScope);
    return thenable;
}
function $c01ca34426469d55$var$pingEngtangledActionScope() {
    if (0 === --$c01ca34426469d55$var$currentEntangledPendingCount && null !== $c01ca34426469d55$var$currentEntangledListeners) {
        null !== $c01ca34426469d55$var$currentEntangledActionThenable && ($c01ca34426469d55$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c01ca34426469d55$var$currentEntangledListeners;
        $c01ca34426469d55$var$currentEntangledListeners = null;
        $c01ca34426469d55$var$currentEntangledLane = 0;
        $c01ca34426469d55$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c01ca34426469d55$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c01ca34426469d55$var$prevOnStartTransitionFinish = $c01ca34426469d55$var$ReactSharedInternals.S;
$c01ca34426469d55$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $bJtXW._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $c01ca34426469d55$var$entangleAsyncAction(transition, returnValue);
    null !== $c01ca34426469d55$var$prevOnStartTransitionFinish && $c01ca34426469d55$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c01ca34426469d55$var$resumedCache = $c01ca34426469d55$var$createCursor(null);
function $c01ca34426469d55$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c01ca34426469d55$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c01ca34426469d55$var$workInProgressRoot.pooledCache;
}
function $c01ca34426469d55$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c01ca34426469d55$var$push($c01ca34426469d55$var$resumedCache, $c01ca34426469d55$var$resumedCache.current) : $c01ca34426469d55$var$push($c01ca34426469d55$var$resumedCache, prevCachePool.pool);
}
function $c01ca34426469d55$var$getSuspendedCache() {
    var cacheFromPool = $c01ca34426469d55$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c01ca34426469d55$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c01ca34426469d55$var$renderLanes = 0, $c01ca34426469d55$var$currentlyRenderingFiber$1 = null, $c01ca34426469d55$var$currentHook = null, $c01ca34426469d55$var$workInProgressHook = null, $c01ca34426469d55$var$didScheduleRenderPhaseUpdate = !1, $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c01ca34426469d55$var$localIdCounter = 0, $c01ca34426469d55$var$thenableIndexCounter = 0, $c01ca34426469d55$var$thenableState = null, $c01ca34426469d55$var$globalClientIdCounter = 0;
function $c01ca34426469d55$var$throwInvalidHookError() {
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(321));
}
function $c01ca34426469d55$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c01ca34426469d55$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c01ca34426469d55$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c01ca34426469d55$var$renderLanes = nextRenderLanes;
    $c01ca34426469d55$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c01ca34426469d55$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c01ca34426469d55$var$HooksDispatcherOnMount : $c01ca34426469d55$var$HooksDispatcherOnUpdate;
    $c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c01ca34426469d55$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c01ca34426469d55$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c01ca34426469d55$var$finishRenderingHooks(current) {
    $c01ca34426469d55$var$ReactSharedInternals.H = $c01ca34426469d55$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c01ca34426469d55$var$currentHook && null !== $c01ca34426469d55$var$currentHook.next;
    $c01ca34426469d55$var$renderLanes = 0;
    $c01ca34426469d55$var$workInProgressHook = $c01ca34426469d55$var$currentHook = $c01ca34426469d55$var$currentlyRenderingFiber$1 = null;
    $c01ca34426469d55$var$didScheduleRenderPhaseUpdate = !1;
    $c01ca34426469d55$var$thenableIndexCounter = 0;
    $c01ca34426469d55$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c01ca34426469d55$var$formatProdErrorMessage(300));
    null === current || $c01ca34426469d55$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c01ca34426469d55$var$checkIfContextChanged(current) && ($c01ca34426469d55$var$didReceiveUpdate = !0));
}
function $c01ca34426469d55$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c01ca34426469d55$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c01ca34426469d55$var$thenableState = null);
        $c01ca34426469d55$var$thenableIndexCounter = 0;
        $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c01ca34426469d55$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c01ca34426469d55$var$workInProgressHook = $c01ca34426469d55$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c01ca34426469d55$var$ReactSharedInternals.H = $c01ca34426469d55$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c01ca34426469d55$var$TransitionAwareHostComponent() {
    var dispatcher = $c01ca34426469d55$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c01ca34426469d55$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c01ca34426469d55$var$currentHook ? $c01ca34426469d55$var$currentHook.memoizedState : null) !== dispatcher && ($c01ca34426469d55$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $c01ca34426469d55$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c01ca34426469d55$var$localIdCounter;
    $c01ca34426469d55$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c01ca34426469d55$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c01ca34426469d55$var$resetHooksOnUnwind(workInProgress) {
    if ($c01ca34426469d55$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c01ca34426469d55$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c01ca34426469d55$var$renderLanes = 0;
    $c01ca34426469d55$var$workInProgressHook = $c01ca34426469d55$var$currentHook = $c01ca34426469d55$var$currentlyRenderingFiber$1 = null;
    $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c01ca34426469d55$var$thenableIndexCounter = $c01ca34426469d55$var$localIdCounter = 0;
    $c01ca34426469d55$var$thenableState = null;
}
function $c01ca34426469d55$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c01ca34426469d55$var$workInProgressHook ? $c01ca34426469d55$var$currentlyRenderingFiber$1.memoizedState = $c01ca34426469d55$var$workInProgressHook = hook : $c01ca34426469d55$var$workInProgressHook = $c01ca34426469d55$var$workInProgressHook.next = hook;
    return $c01ca34426469d55$var$workInProgressHook;
}
function $c01ca34426469d55$var$updateWorkInProgressHook() {
    if (null === $c01ca34426469d55$var$currentHook) {
        var nextCurrentHook = $c01ca34426469d55$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c01ca34426469d55$var$currentHook.next;
    var nextWorkInProgressHook = null === $c01ca34426469d55$var$workInProgressHook ? $c01ca34426469d55$var$currentlyRenderingFiber$1.memoizedState : $c01ca34426469d55$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c01ca34426469d55$var$workInProgressHook = nextWorkInProgressHook, $c01ca34426469d55$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c01ca34426469d55$var$currentlyRenderingFiber$1.alternate) throw Error($c01ca34426469d55$var$formatProdErrorMessage(467));
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(310));
        }
        $c01ca34426469d55$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c01ca34426469d55$var$currentHook.memoizedState,
            baseState: $c01ca34426469d55$var$currentHook.baseState,
            baseQueue: $c01ca34426469d55$var$currentHook.baseQueue,
            queue: $c01ca34426469d55$var$currentHook.queue,
            next: null
        };
        null === $c01ca34426469d55$var$workInProgressHook ? $c01ca34426469d55$var$currentlyRenderingFiber$1.memoizedState = $c01ca34426469d55$var$workInProgressHook = nextCurrentHook : $c01ca34426469d55$var$workInProgressHook = $c01ca34426469d55$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c01ca34426469d55$var$workInProgressHook;
}
var $c01ca34426469d55$var$createFunctionComponentUpdateQueue;
$c01ca34426469d55$var$createFunctionComponentUpdateQueue = function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $c01ca34426469d55$var$useThenable(thenable) {
    var index = $c01ca34426469d55$var$thenableIndexCounter;
    $c01ca34426469d55$var$thenableIndexCounter += 1;
    null === $c01ca34426469d55$var$thenableState && ($c01ca34426469d55$var$thenableState = []);
    thenable = $c01ca34426469d55$var$trackUsedThenable($c01ca34426469d55$var$thenableState, thenable, index);
    index = $c01ca34426469d55$var$currentlyRenderingFiber$1;
    null === (null === $c01ca34426469d55$var$workInProgressHook ? index.memoizedState : $c01ca34426469d55$var$workInProgressHook.next) && (index = index.alternate, $c01ca34426469d55$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c01ca34426469d55$var$HooksDispatcherOnMount : $c01ca34426469d55$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c01ca34426469d55$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $bJtXW._)(usable))) {
        if ("function" === typeof usable.then) return $c01ca34426469d55$var$useThenable(usable);
        if (usable.$$typeof === $c01ca34426469d55$var$REACT_CONTEXT_TYPE) return $c01ca34426469d55$var$readContext(usable);
    }
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(438, String(usable)));
}
function $c01ca34426469d55$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c01ca34426469d55$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c01ca34426469d55$var$createFunctionComponentUpdateQueue(), $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c01ca34426469d55$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c01ca34426469d55$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c01ca34426469d55$var$updateReducer(reducer) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    return $c01ca34426469d55$var$updateReducerImpl(hook, $c01ca34426469d55$var$currentHook, reducer);
}
function $c01ca34426469d55$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c01ca34426469d55$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c01ca34426469d55$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c01ca34426469d55$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c01ca34426469d55$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($c01ca34426469d55$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c01ca34426469d55$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c01ca34426469d55$var$currentlyRenderingFiber$1.lanes |= revertLane, $c01ca34426469d55$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c01ca34426469d55$var$currentlyRenderingFiber$1.lanes |= updateLane, $c01ca34426469d55$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c01ca34426469d55$var$objectIs(pendingQueue, hook.memoizedState) && ($c01ca34426469d55$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $c01ca34426469d55$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c01ca34426469d55$var$rerenderReducer(reducer) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c01ca34426469d55$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c01ca34426469d55$var$objectIs(newState, hook.memoizedState) || ($c01ca34426469d55$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c01ca34426469d55$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c01ca34426469d55$var$currentlyRenderingFiber$1, hook = $c01ca34426469d55$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c01ca34426469d55$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c01ca34426469d55$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c01ca34426469d55$var$objectIs(($c01ca34426469d55$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c01ca34426469d55$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c01ca34426469d55$var$updateEffect($c01ca34426469d55$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c01ca34426469d55$var$workInProgressHook && $c01ca34426469d55$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c01ca34426469d55$var$pushEffect(9, $c01ca34426469d55$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $c01ca34426469d55$var$workInProgressRoot) throw Error($c01ca34426469d55$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c01ca34426469d55$var$renderLanes & 60) || $c01ca34426469d55$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c01ca34426469d55$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $c01ca34426469d55$var$createFunctionComponentUpdateQueue(), $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c01ca34426469d55$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c01ca34426469d55$var$checkIfSnapshotChanged(inst) && $c01ca34426469d55$var$forceStoreRerender(fiber);
}
function $c01ca34426469d55$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c01ca34426469d55$var$checkIfSnapshotChanged(inst) && $c01ca34426469d55$var$forceStoreRerender(fiber);
    });
}
function $c01ca34426469d55$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c01ca34426469d55$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c01ca34426469d55$var$forceStoreRerender(fiber) {
    var root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c01ca34426469d55$var$mountStateImpl(initialState) {
    var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c01ca34426469d55$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c01ca34426469d55$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c01ca34426469d55$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c01ca34426469d55$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c01ca34426469d55$var$updateReducerImpl(hook, $c01ca34426469d55$var$currentHook, "function" === typeof reducer ? reducer : $c01ca34426469d55$var$basicStateReducer);
}
function $c01ca34426469d55$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c01ca34426469d55$var$isRenderPhaseUpdate(fiber)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c01ca34426469d55$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c01ca34426469d55$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c01ca34426469d55$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T, currentTransition = {};
        $c01ca34426469d55$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c01ca34426469d55$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c01ca34426469d55$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c01ca34426469d55$var$onActionError(actionQueue, node, error);
        } finally{
            $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c01ca34426469d55$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $c01ca34426469d55$var$onActionError(actionQueue, node, error$60);
    }
}
function $c01ca34426469d55$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $bJtXW._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c01ca34426469d55$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c01ca34426469d55$var$onActionError(actionQueue, node, error);
    }) : $c01ca34426469d55$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c01ca34426469d55$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c01ca34426469d55$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c01ca34426469d55$var$runActionStateAction(actionQueue, nextState)));
}
function $c01ca34426469d55$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c01ca34426469d55$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c01ca34426469d55$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c01ca34426469d55$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c01ca34426469d55$var$mountActionState(action, initialStateProp) {
    if ($c01ca34426469d55$var$isHydrating) {
        var ssrFormState = $c01ca34426469d55$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c01ca34426469d55$var$currentlyRenderingFiber$1;
                if ($c01ca34426469d55$var$isHydrating) {
                    if ($c01ca34426469d55$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c01ca34426469d55$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c01ca34426469d55$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c01ca34426469d55$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c01ca34426469d55$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c01ca34426469d55$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c01ca34426469d55$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c01ca34426469d55$var$dispatchSetState.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c01ca34426469d55$var$mountStateImpl(!1);
    inRootOrSingleton = $c01ca34426469d55$var$dispatchOptimisticSetState.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c01ca34426469d55$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c01ca34426469d55$var$dispatchActionState.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c01ca34426469d55$var$updateActionState(action) {
    var stateHook = $c01ca34426469d55$var$updateWorkInProgressHook();
    return $c01ca34426469d55$var$updateActionStateImpl(stateHook, $c01ca34426469d55$var$currentHook, action);
}
function $c01ca34426469d55$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c01ca34426469d55$var$updateReducerImpl(stateHook, currentStateHook, $c01ca34426469d55$var$actionStateReducer)[0];
    stateHook = $c01ca34426469d55$var$updateReducer($c01ca34426469d55$var$basicStateReducer)[0];
    currentStateHook = "object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $bJtXW._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then ? $c01ca34426469d55$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $c01ca34426469d55$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($c01ca34426469d55$var$currentlyRenderingFiber$1.flags |= 2048, $c01ca34426469d55$var$pushEffect(9, $c01ca34426469d55$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $c01ca34426469d55$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c01ca34426469d55$var$rerenderActionState(action) {
    var stateHook = $c01ca34426469d55$var$updateWorkInProgressHook(), currentStateHook = $c01ca34426469d55$var$currentHook;
    if (null !== currentStateHook) return $c01ca34426469d55$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c01ca34426469d55$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c01ca34426469d55$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c01ca34426469d55$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $c01ca34426469d55$var$createFunctionComponentUpdateQueue(), $c01ca34426469d55$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $c01ca34426469d55$var$updateRef() {
    return $c01ca34426469d55$var$updateWorkInProgressHook().memoizedState;
}
function $c01ca34426469d55$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
    $c01ca34426469d55$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $c01ca34426469d55$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $c01ca34426469d55$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c01ca34426469d55$var$currentHook && null !== deps && $c01ca34426469d55$var$areHookInputsEqual(deps, $c01ca34426469d55$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c01ca34426469d55$var$pushEffect(hookFlags, create, inst, deps) : ($c01ca34426469d55$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $c01ca34426469d55$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $c01ca34426469d55$var$mountEffect(create, deps) {
    $c01ca34426469d55$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c01ca34426469d55$var$updateEffect(create, deps) {
    $c01ca34426469d55$var$updateEffectImpl(2048, 8, create, deps);
}
function $c01ca34426469d55$var$updateInsertionEffect(create, deps) {
    return $c01ca34426469d55$var$updateEffectImpl(4, 2, create, deps);
}
function $c01ca34426469d55$var$updateLayoutEffect(create, deps) {
    return $c01ca34426469d55$var$updateEffectImpl(4, 4, create, deps);
}
function $c01ca34426469d55$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c01ca34426469d55$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c01ca34426469d55$var$updateEffectImpl(4, 4, $c01ca34426469d55$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c01ca34426469d55$var$mountDebugValue() {}
function $c01ca34426469d55$var$updateCallback(callback, deps) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c01ca34426469d55$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c01ca34426469d55$var$updateMemo(nextCreate, deps) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c01ca34426469d55$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c01ca34426469d55$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c01ca34426469d55$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c01ca34426469d55$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c01ca34426469d55$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c01ca34426469d55$var$requestDeferredLane();
    $c01ca34426469d55$var$currentlyRenderingFiber$1.lanes |= hook;
    $c01ca34426469d55$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c01ca34426469d55$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c01ca34426469d55$var$objectIs(value, prevValue)) return value;
    if (null !== $c01ca34426469d55$var$currentTreeHiddenStackCursor.current) return hook = $c01ca34426469d55$var$mountDeferredValueImpl(hook, value, initialValue), $c01ca34426469d55$var$objectIs(hook, prevValue) || ($c01ca34426469d55$var$didReceiveUpdate = !0), hook;
    if (0 === ($c01ca34426469d55$var$renderLanes & 42)) return $c01ca34426469d55$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c01ca34426469d55$var$requestDeferredLane();
    $c01ca34426469d55$var$currentlyRenderingFiber$1.lanes |= hook;
    $c01ca34426469d55$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c01ca34426469d55$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    $c01ca34426469d55$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T, currentTransition = {};
    $c01ca34426469d55$var$ReactSharedInternals.T = currentTransition;
    $c01ca34426469d55$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c01ca34426469d55$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $bJtXW._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c01ca34426469d55$var$chainThenableValue(returnValue, finishedState);
            $c01ca34426469d55$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c01ca34426469d55$var$requestUpdateLane(fiber));
        } else $c01ca34426469d55$var$dispatchSetStateInternal(fiber, queue, finishedState, $c01ca34426469d55$var$requestUpdateLane(fiber));
    } catch (error) {
        $c01ca34426469d55$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $c01ca34426469d55$var$requestUpdateLane());
    } finally{
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousPriority, $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c01ca34426469d55$var$noop$2() {}
function $c01ca34426469d55$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c01ca34426469d55$var$formatProdErrorMessage(476));
    var queue = $c01ca34426469d55$var$ensureFormComponentIsStateful(formFiber).queue;
    $c01ca34426469d55$var$startTransition(formFiber, queue, pendingState, $c01ca34426469d55$var$sharedNotPendingObject, null === action ? $c01ca34426469d55$var$noop$2 : function() {
        $c01ca34426469d55$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c01ca34426469d55$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c01ca34426469d55$var$sharedNotPendingObject,
        baseState: $c01ca34426469d55$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c01ca34426469d55$var$basicStateReducer,
            lastRenderedState: $c01ca34426469d55$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c01ca34426469d55$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c01ca34426469d55$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $c01ca34426469d55$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $c01ca34426469d55$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $c01ca34426469d55$var$requestUpdateLane());
}
function $c01ca34426469d55$var$useHostTransitionStatus() {
    return $c01ca34426469d55$var$readContext($c01ca34426469d55$var$HostTransitionContext);
}
function $c01ca34426469d55$var$updateId() {
    return $c01ca34426469d55$var$updateWorkInProgressHook().memoizedState;
}
function $c01ca34426469d55$var$updateRefresh() {
    return $c01ca34426469d55$var$updateWorkInProgressHook().memoizedState;
}
function $c01ca34426469d55$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c01ca34426469d55$var$requestUpdateLane();
                fiber = $c01ca34426469d55$var$createUpdate(lane);
                var root$63 = $c01ca34426469d55$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($c01ca34426469d55$var$scheduleUpdateOnFiber(root$63, provider, lane), $c01ca34426469d55$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $c01ca34426469d55$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c01ca34426469d55$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c01ca34426469d55$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c01ca34426469d55$var$isRenderPhaseUpdate(fiber) ? $c01ca34426469d55$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c01ca34426469d55$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c01ca34426469d55$var$scheduleUpdateOnFiber(action, fiber, lane), $c01ca34426469d55$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c01ca34426469d55$var$dispatchSetState(fiber, queue, action) {
    var lane = $c01ca34426469d55$var$requestUpdateLane();
    $c01ca34426469d55$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c01ca34426469d55$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c01ca34426469d55$var$isRenderPhaseUpdate(fiber)) $c01ca34426469d55$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c01ca34426469d55$var$objectIs(eagerState, currentState)) return $c01ca34426469d55$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c01ca34426469d55$var$workInProgressRoot && $c01ca34426469d55$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c01ca34426469d55$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c01ca34426469d55$var$scheduleUpdateOnFiber(action, fiber, lane), $c01ca34426469d55$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c01ca34426469d55$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c01ca34426469d55$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c01ca34426469d55$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c01ca34426469d55$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c01ca34426469d55$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c01ca34426469d55$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c01ca34426469d55$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c01ca34426469d55$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $c01ca34426469d55$var$currentlyRenderingFiber$1;
}
function $c01ca34426469d55$var$enqueueRenderPhaseUpdate(queue, update) {
    $c01ca34426469d55$var$didScheduleRenderPhaseUpdateDuringThisPass = $c01ca34426469d55$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c01ca34426469d55$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c01ca34426469d55$var$markRootEntangled(root, lane);
    }
}
var $c01ca34426469d55$var$ContextOnlyDispatcher = {
    readContext: $c01ca34426469d55$var$readContext,
    use: $c01ca34426469d55$var$use,
    useCallback: $c01ca34426469d55$var$throwInvalidHookError,
    useContext: $c01ca34426469d55$var$throwInvalidHookError,
    useEffect: $c01ca34426469d55$var$throwInvalidHookError,
    useImperativeHandle: $c01ca34426469d55$var$throwInvalidHookError,
    useLayoutEffect: $c01ca34426469d55$var$throwInvalidHookError,
    useInsertionEffect: $c01ca34426469d55$var$throwInvalidHookError,
    useMemo: $c01ca34426469d55$var$throwInvalidHookError,
    useReducer: $c01ca34426469d55$var$throwInvalidHookError,
    useRef: $c01ca34426469d55$var$throwInvalidHookError,
    useState: $c01ca34426469d55$var$throwInvalidHookError,
    useDebugValue: $c01ca34426469d55$var$throwInvalidHookError,
    useDeferredValue: $c01ca34426469d55$var$throwInvalidHookError,
    useTransition: $c01ca34426469d55$var$throwInvalidHookError,
    useSyncExternalStore: $c01ca34426469d55$var$throwInvalidHookError,
    useId: $c01ca34426469d55$var$throwInvalidHookError
};
$c01ca34426469d55$var$ContextOnlyDispatcher.useCacheRefresh = $c01ca34426469d55$var$throwInvalidHookError;
$c01ca34426469d55$var$ContextOnlyDispatcher.useMemoCache = $c01ca34426469d55$var$throwInvalidHookError;
$c01ca34426469d55$var$ContextOnlyDispatcher.useHostTransitionStatus = $c01ca34426469d55$var$throwInvalidHookError;
$c01ca34426469d55$var$ContextOnlyDispatcher.useFormState = $c01ca34426469d55$var$throwInvalidHookError;
$c01ca34426469d55$var$ContextOnlyDispatcher.useActionState = $c01ca34426469d55$var$throwInvalidHookError;
$c01ca34426469d55$var$ContextOnlyDispatcher.useOptimistic = $c01ca34426469d55$var$throwInvalidHookError;
var $c01ca34426469d55$var$HooksDispatcherOnMount = {
    readContext: $c01ca34426469d55$var$readContext,
    use: $c01ca34426469d55$var$use,
    useCallback: function useCallback(callback, deps) {
        $c01ca34426469d55$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c01ca34426469d55$var$readContext,
    useEffect: $c01ca34426469d55$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c01ca34426469d55$var$mountEffectImpl(4194308, 4, $c01ca34426469d55$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $c01ca34426469d55$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $c01ca34426469d55$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c01ca34426469d55$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c01ca34426469d55$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c01ca34426469d55$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c01ca34426469d55$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c01ca34426469d55$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c01ca34426469d55$var$dispatchReducerAction.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $c01ca34426469d55$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c01ca34426469d55$var$dispatchSetState.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c01ca34426469d55$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
        return $c01ca34426469d55$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $c01ca34426469d55$var$mountStateImpl(!1);
        stateHook = $c01ca34426469d55$var$startTransition.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $c01ca34426469d55$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c01ca34426469d55$var$currentlyRenderingFiber$1, hook = $c01ca34426469d55$var$mountWorkInProgressHook();
        if ($c01ca34426469d55$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c01ca34426469d55$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c01ca34426469d55$var$workInProgressRoot) throw Error($c01ca34426469d55$var$formatProdErrorMessage(349));
            0 !== ($c01ca34426469d55$var$workInProgressRootRenderLanes & 60) || $c01ca34426469d55$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c01ca34426469d55$var$mountEffect($c01ca34426469d55$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c01ca34426469d55$var$pushEffect(9, $c01ca34426469d55$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $c01ca34426469d55$var$mountWorkInProgressHook(), identifierPrefix = $c01ca34426469d55$var$workInProgressRoot.identifierPrefix;
        if ($c01ca34426469d55$var$isHydrating) {
            var JSCompiler_inline_result = $c01ca34426469d55$var$treeContextOverflow;
            var idWithLeadingBit = $c01ca34426469d55$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c01ca34426469d55$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c01ca34426469d55$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $c01ca34426469d55$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function useCacheRefresh() {
        return $c01ca34426469d55$var$mountWorkInProgressHook().memoizedState = $c01ca34426469d55$var$refreshCache.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1);
    }
};
$c01ca34426469d55$var$HooksDispatcherOnMount.useMemoCache = $c01ca34426469d55$var$useMemoCache;
$c01ca34426469d55$var$HooksDispatcherOnMount.useHostTransitionStatus = $c01ca34426469d55$var$useHostTransitionStatus;
$c01ca34426469d55$var$HooksDispatcherOnMount.useFormState = $c01ca34426469d55$var$mountActionState;
$c01ca34426469d55$var$HooksDispatcherOnMount.useActionState = $c01ca34426469d55$var$mountActionState;
$c01ca34426469d55$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $c01ca34426469d55$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $c01ca34426469d55$var$dispatchOptimisticSetState.bind(null, $c01ca34426469d55$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $c01ca34426469d55$var$HooksDispatcherOnUpdate = {
    readContext: $c01ca34426469d55$var$readContext,
    use: $c01ca34426469d55$var$use,
    useCallback: $c01ca34426469d55$var$updateCallback,
    useContext: $c01ca34426469d55$var$readContext,
    useEffect: $c01ca34426469d55$var$updateEffect,
    useImperativeHandle: $c01ca34426469d55$var$updateImperativeHandle,
    useInsertionEffect: $c01ca34426469d55$var$updateInsertionEffect,
    useLayoutEffect: $c01ca34426469d55$var$updateLayoutEffect,
    useMemo: $c01ca34426469d55$var$updateMemo,
    useReducer: $c01ca34426469d55$var$updateReducer,
    useRef: $c01ca34426469d55$var$updateRef,
    useState: function useState() {
        return $c01ca34426469d55$var$updateReducer($c01ca34426469d55$var$basicStateReducer);
    },
    useDebugValue: $c01ca34426469d55$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
        return $c01ca34426469d55$var$updateDeferredValueImpl(hook, $c01ca34426469d55$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $c01ca34426469d55$var$updateReducer($c01ca34426469d55$var$basicStateReducer)[0], start = $c01ca34426469d55$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c01ca34426469d55$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c01ca34426469d55$var$updateSyncExternalStore,
    useId: $c01ca34426469d55$var$updateId
};
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useCacheRefresh = $c01ca34426469d55$var$updateRefresh;
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useMemoCache = $c01ca34426469d55$var$useMemoCache;
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $c01ca34426469d55$var$useHostTransitionStatus;
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useFormState = $c01ca34426469d55$var$updateActionState;
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useActionState = $c01ca34426469d55$var$updateActionState;
$c01ca34426469d55$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    return $c01ca34426469d55$var$updateOptimisticImpl(hook, $c01ca34426469d55$var$currentHook, passthrough, reducer);
};
var $c01ca34426469d55$var$HooksDispatcherOnRerender = {
    readContext: $c01ca34426469d55$var$readContext,
    use: $c01ca34426469d55$var$use,
    useCallback: $c01ca34426469d55$var$updateCallback,
    useContext: $c01ca34426469d55$var$readContext,
    useEffect: $c01ca34426469d55$var$updateEffect,
    useImperativeHandle: $c01ca34426469d55$var$updateImperativeHandle,
    useInsertionEffect: $c01ca34426469d55$var$updateInsertionEffect,
    useLayoutEffect: $c01ca34426469d55$var$updateLayoutEffect,
    useMemo: $c01ca34426469d55$var$updateMemo,
    useReducer: $c01ca34426469d55$var$rerenderReducer,
    useRef: $c01ca34426469d55$var$updateRef,
    useState: function useState() {
        return $c01ca34426469d55$var$rerenderReducer($c01ca34426469d55$var$basicStateReducer);
    },
    useDebugValue: $c01ca34426469d55$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
        return null === $c01ca34426469d55$var$currentHook ? $c01ca34426469d55$var$mountDeferredValueImpl(hook, value, initialValue) : $c01ca34426469d55$var$updateDeferredValueImpl(hook, $c01ca34426469d55$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $c01ca34426469d55$var$rerenderReducer($c01ca34426469d55$var$basicStateReducer)[0], start = $c01ca34426469d55$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c01ca34426469d55$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c01ca34426469d55$var$updateSyncExternalStore,
    useId: $c01ca34426469d55$var$updateId
};
$c01ca34426469d55$var$HooksDispatcherOnRerender.useCacheRefresh = $c01ca34426469d55$var$updateRefresh;
$c01ca34426469d55$var$HooksDispatcherOnRerender.useMemoCache = $c01ca34426469d55$var$useMemoCache;
$c01ca34426469d55$var$HooksDispatcherOnRerender.useHostTransitionStatus = $c01ca34426469d55$var$useHostTransitionStatus;
$c01ca34426469d55$var$HooksDispatcherOnRerender.useFormState = $c01ca34426469d55$var$rerenderActionState;
$c01ca34426469d55$var$HooksDispatcherOnRerender.useActionState = $c01ca34426469d55$var$rerenderActionState;
$c01ca34426469d55$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $c01ca34426469d55$var$updateWorkInProgressHook();
    if (null !== $c01ca34426469d55$var$currentHook) return $c01ca34426469d55$var$updateOptimisticImpl(hook, $c01ca34426469d55$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $c01ca34426469d55$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c01ca34426469d55$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c01ca34426469d55$var$classComponentUpdater = {
    isMounted: function isMounted(component) {
        return (component = component._reactInternals) ? $c01ca34426469d55$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c01ca34426469d55$var$requestUpdateLane(), update = $c01ca34426469d55$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c01ca34426469d55$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c01ca34426469d55$var$scheduleUpdateOnFiber(payload, inst, lane), $c01ca34426469d55$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c01ca34426469d55$var$requestUpdateLane(), update = $c01ca34426469d55$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c01ca34426469d55$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c01ca34426469d55$var$scheduleUpdateOnFiber(payload, inst, lane), $c01ca34426469d55$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c01ca34426469d55$var$requestUpdateLane(), update = $c01ca34426469d55$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c01ca34426469d55$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c01ca34426469d55$var$scheduleUpdateOnFiber(callback, inst, lane), $c01ca34426469d55$var$entangleTransitions(callback, inst, lane));
    }
};
function $c01ca34426469d55$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c01ca34426469d55$var$shallowEqual(oldProps, newProps) || !$c01ca34426469d55$var$shallowEqual(oldState, newState) : !0;
}
function $c01ca34426469d55$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c01ca34426469d55$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c01ca34426469d55$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c01ca34426469d55$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $c01ca34426469d55$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $bJtXW._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $bJtXW._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $c01ca34426469d55$var$defaultOnUncaughtError(error) {
    $c01ca34426469d55$var$reportGlobalError(error);
}
function $c01ca34426469d55$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c01ca34426469d55$var$defaultOnRecoverableError(error) {
    $c01ca34426469d55$var$reportGlobalError(error);
}
function $c01ca34426469d55$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $c01ca34426469d55$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $c01ca34426469d55$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c01ca34426469d55$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c01ca34426469d55$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c01ca34426469d55$var$createClassErrorUpdate(lane) {
    lane = $c01ca34426469d55$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c01ca34426469d55$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c01ca34426469d55$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c01ca34426469d55$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed ? $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c01ca34426469d55$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c01ca34426469d55$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c01ca34426469d55$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $c01ca34426469d55$var$shellBoundary ? $c01ca34426469d55$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c01ca34426469d55$var$workInProgressRootExitStatus && ($c01ca34426469d55$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c01ca34426469d55$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c01ca34426469d55$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c01ca34426469d55$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c01ca34426469d55$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c01ca34426469d55$var$attachPingListener(root, value, rootRenderLanes);
        $c01ca34426469d55$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c01ca34426469d55$var$isHydrating) return returnFiber = $c01ca34426469d55$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c01ca34426469d55$var$HydrationMismatchException && (root = Error($c01ca34426469d55$var$formatProdErrorMessage(422), {
        cause: value
    }), $c01ca34426469d55$var$queueHydrationError($c01ca34426469d55$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c01ca34426469d55$var$HydrationMismatchException && (returnFiber = Error($c01ca34426469d55$var$formatProdErrorMessage(423), {
        cause: value
    }), $c01ca34426469d55$var$queueHydrationError($c01ca34426469d55$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c01ca34426469d55$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c01ca34426469d55$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c01ca34426469d55$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c01ca34426469d55$var$workInProgressRootExitStatus && ($c01ca34426469d55$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c01ca34426469d55$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c01ca34426469d55$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c01ca34426469d55$var$workInProgressRootConcurrentErrors ? $c01ca34426469d55$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c01ca34426469d55$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c01ca34426469d55$var$workInProgressRootExitStatus && ($c01ca34426469d55$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c01ca34426469d55$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c01ca34426469d55$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c01ca34426469d55$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed || !$c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c01ca34426469d55$var$createClassErrorUpdate(rootRenderLanes), $c01ca34426469d55$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c01ca34426469d55$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c01ca34426469d55$var$SelectiveHydrationException = Error($c01ca34426469d55$var$formatProdErrorMessage(461)), $c01ca34426469d55$var$didReceiveUpdate = !1;
function $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c01ca34426469d55$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c01ca34426469d55$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c01ca34426469d55$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c01ca34426469d55$var$prepareToReadContext(workInProgress);
    nextProps = $c01ca34426469d55$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c01ca34426469d55$var$checkDidRenderIdHook();
    if (null !== current && !$c01ca34426469d55$var$didReceiveUpdate) return $c01ca34426469d55$var$bailoutHooks(current, workInProgress, renderLanes), $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c01ca34426469d55$var$isHydrating && key && $c01ca34426469d55$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c01ca34426469d55$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c01ca34426469d55$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c01ca34426469d55$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c01ca34426469d55$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c01ca34426469d55$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c01ca34426469d55$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c01ca34426469d55$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c01ca34426469d55$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c01ca34426469d55$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c01ca34426469d55$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c01ca34426469d55$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c01ca34426469d55$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c01ca34426469d55$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c01ca34426469d55$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $c01ca34426469d55$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $c01ca34426469d55$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c01ca34426469d55$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c01ca34426469d55$var$pushHiddenContext(workInProgress, prevState) : $c01ca34426469d55$var$reuseHiddenContextOnStack(), $c01ca34426469d55$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $c01ca34426469d55$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($c01ca34426469d55$var$pushTransition(workInProgress, prevState.cachePool), $c01ca34426469d55$var$pushHiddenContext(workInProgress, prevState), $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c01ca34426469d55$var$pushTransition(workInProgress, null), $c01ca34426469d55$var$reuseHiddenContextOnStack(), $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c01ca34426469d55$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $c01ca34426469d55$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c01ca34426469d55$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c01ca34426469d55$var$pushTransition(workInProgress, null);
    $c01ca34426469d55$var$reuseHiddenContextOnStack();
    $c01ca34426469d55$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c01ca34426469d55$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $c01ca34426469d55$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $bJtXW._)(ref))) throw Error($c01ca34426469d55$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $c01ca34426469d55$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c01ca34426469d55$var$prepareToReadContext(workInProgress);
    Component = $c01ca34426469d55$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c01ca34426469d55$var$checkDidRenderIdHook();
    if (null !== current && !$c01ca34426469d55$var$didReceiveUpdate) return $c01ca34426469d55$var$bailoutHooks(current, workInProgress, renderLanes), $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c01ca34426469d55$var$isHydrating && nextProps && $c01ca34426469d55$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c01ca34426469d55$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c01ca34426469d55$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c01ca34426469d55$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c01ca34426469d55$var$finishRenderingHooks(current);
    Component = $c01ca34426469d55$var$checkDidRenderIdHook();
    if (null !== current && !$c01ca34426469d55$var$didReceiveUpdate) return $c01ca34426469d55$var$bailoutHooks(current, workInProgress, renderLanes), $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c01ca34426469d55$var$isHydrating && Component && $c01ca34426469d55$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c01ca34426469d55$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c01ca34426469d55$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c01ca34426469d55$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $bJtXW._)(contextType)) && null !== contextType && (context = $c01ca34426469d55$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c01ca34426469d55$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c01ca34426469d55$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $bJtXW._)(contextType)) && null !== contextType ? $c01ca34426469d55$var$readContext(contextType) : $c01ca34426469d55$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c01ca34426469d55$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c01ca34426469d55$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c01ca34426469d55$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c01ca34426469d55$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c01ca34426469d55$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $bJtXW._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $c01ca34426469d55$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c01ca34426469d55$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c01ca34426469d55$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c01ca34426469d55$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c01ca34426469d55$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c01ca34426469d55$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c01ca34426469d55$var$hasForceUpdate || $c01ca34426469d55$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c01ca34426469d55$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c01ca34426469d55$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c01ca34426469d55$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $bJtXW._)(oldContext)) && null !== oldContext && (oldProps = $c01ca34426469d55$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c01ca34426469d55$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c01ca34426469d55$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c01ca34426469d55$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c01ca34426469d55$var$hasForceUpdate || null !== current && null !== current.dependencies && $c01ca34426469d55$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c01ca34426469d55$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c01ca34426469d55$var$hasForceUpdate || $c01ca34426469d55$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c01ca34426469d55$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c01ca34426469d55$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c01ca34426469d55$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c01ca34426469d55$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c01ca34426469d55$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c01ca34426469d55$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c01ca34426469d55$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c01ca34426469d55$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c01ca34426469d55$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c01ca34426469d55$var$getSuspendedCache()
    };
}
function $c01ca34426469d55$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c01ca34426469d55$var$workInProgressDeferredLane);
    return current;
}
function $c01ca34426469d55$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c01ca34426469d55$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c01ca34426469d55$var$isHydrating) {
            showFallback ? $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($c01ca34426469d55$var$isHydrating) {
                var nextInstance = $c01ca34426469d55$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $c01ca34426469d55$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $c01ca34426469d55$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $c01ca34426469d55$var$treeContextProvider ? {
                            id: $c01ca34426469d55$var$treeContextId,
                            overflow: $c01ca34426469d55$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $c01ca34426469d55$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $c01ca34426469d55$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $c01ca34426469d55$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $c01ca34426469d55$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $c01ca34426469d55$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $c01ca34426469d55$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $c01ca34426469d55$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c01ca34426469d55$var$SUSPENDED_MARKER, nextProps;
        $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c01ca34426469d55$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c01ca34426469d55$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $c01ca34426469d55$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $c01ca34426469d55$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $c01ca34426469d55$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c01ca34426469d55$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c01ca34426469d55$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c01ca34426469d55$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c01ca34426469d55$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c01ca34426469d55$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c01ca34426469d55$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c01ca34426469d55$var$didReceiveUpdate || $c01ca34426469d55$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c01ca34426469d55$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c01ca34426469d55$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $c01ca34426469d55$var$enqueueConcurrentRenderForLane(current, nextProps), $c01ca34426469d55$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c01ca34426469d55$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $c01ca34426469d55$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c01ca34426469d55$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $c01ca34426469d55$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(nextInstance.nextSibling), $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$isHydrating = !0, $c01ca34426469d55$var$hydrationErrors = null, $c01ca34426469d55$var$rootOrSingletonContext = !1, null !== current && ($c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextId, $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextOverflow, $c01ca34426469d55$var$idStack[$c01ca34426469d55$var$idStackIndex++] = $c01ca34426469d55$var$treeContextProvider, $c01ca34426469d55$var$treeContextId = current.id, $c01ca34426469d55$var$treeContextOverflow = current.overflow, $c01ca34426469d55$var$treeContextProvider = workInProgress), workInProgress = $c01ca34426469d55$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c01ca34426469d55$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $c01ca34426469d55$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $c01ca34426469d55$var$createWorkInProgress(digest, showFallback) : (showFallback = $c01ca34426469d55$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $c01ca34426469d55$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $c01ca34426469d55$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $c01ca34426469d55$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $c01ca34426469d55$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c01ca34426469d55$var$SUSPENDED_MARKER, nextProps;
    $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c01ca34426469d55$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c01ca34426469d55$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c01ca34426469d55$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c01ca34426469d55$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $c01ca34426469d55$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $c01ca34426469d55$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c01ca34426469d55$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c01ca34426469d55$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c01ca34426469d55$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c01ca34426469d55$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c01ca34426469d55$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $c01ca34426469d55$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $c01ca34426469d55$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $c01ca34426469d55$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $c01ca34426469d55$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c01ca34426469d55$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c01ca34426469d55$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c01ca34426469d55$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c01ca34426469d55$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $c01ca34426469d55$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c01ca34426469d55$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c01ca34426469d55$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c01ca34426469d55$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c01ca34426469d55$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c01ca34426469d55$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c01ca34426469d55$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c01ca34426469d55$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c01ca34426469d55$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c01ca34426469d55$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, current.memoizedState.cache);
            $c01ca34426469d55$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c01ca34426469d55$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c01ca34426469d55$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c01ca34426469d55$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c01ca34426469d55$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c01ca34426469d55$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($c01ca34426469d55$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $c01ca34426469d55$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, $c01ca34426469d55$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $c01ca34426469d55$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, current.memoizedState.cache);
    }
    return $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c01ca34426469d55$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c01ca34426469d55$var$didReceiveUpdate = !0;
        else {
            if (!$c01ca34426469d55$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c01ca34426469d55$var$didReceiveUpdate = !1, $c01ca34426469d55$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c01ca34426469d55$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c01ca34426469d55$var$didReceiveUpdate = !1, $c01ca34426469d55$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c01ca34426469d55$var$pushTreeId(workInProgress, $c01ca34426469d55$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $c01ca34426469d55$var$shouldConstruct(lazyComponent) ? (current = $c01ca34426469d55$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $c01ca34426469d55$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c01ca34426469d55$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $c01ca34426469d55$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c01ca34426469d55$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $c01ca34426469d55$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c01ca34426469d55$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c01ca34426469d55$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($c01ca34426469d55$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c01ca34426469d55$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $c01ca34426469d55$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $c01ca34426469d55$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $c01ca34426469d55$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c01ca34426469d55$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $c01ca34426469d55$var$cloneUpdateQueue(current, workInProgress);
                $c01ca34426469d55$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, nextProps);
                nextProps !== init.cache && $c01ca34426469d55$var$propagateContextChanges(workInProgress, [
                    $c01ca34426469d55$var$CacheContext
                ], renderLanes, !0);
                $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $c01ca34426469d55$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $c01ca34426469d55$var$createCapturedValueAtFiber(Error($c01ca34426469d55$var$formatProdErrorMessage(424)), workInProgress);
                        $c01ca34426469d55$var$queueHydrationError(lazyComponent);
                        workInProgress = $c01ca34426469d55$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$isHydrating = !0, $c01ca34426469d55$var$hydrationErrors = null, $c01ca34426469d55$var$rootOrSingletonContext = !0, renderLanes = $c01ca34426469d55$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $c01ca34426469d55$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $c01ca34426469d55$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c01ca34426469d55$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c01ca34426469d55$var$markRef(current, workInProgress), null === current ? (renderLanes = $c01ca34426469d55$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c01ca34426469d55$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $c01ca34426469d55$var$getOwnerDocumentFromRootContainer($c01ca34426469d55$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$c01ca34426469d55$var$internalInstanceKey] = workInProgress, lazyComponent[$c01ca34426469d55$var$internalPropsKey] = current, $c01ca34426469d55$var$setInitialProperties(lazyComponent, renderLanes, current), $c01ca34426469d55$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $c01ca34426469d55$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c01ca34426469d55$var$pushHostContext(workInProgress), null === current && $c01ca34426469d55$var$isHydrating && (lazyComponent = workInProgress.stateNode = $c01ca34426469d55$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c01ca34426469d55$var$rootInstanceStackCursor.current), $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$rootOrSingletonContext = !0, $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $c01ca34426469d55$var$isHydrating ? $c01ca34426469d55$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $c01ca34426469d55$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $c01ca34426469d55$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $c01ca34426469d55$var$isHydrating) {
                if (init = lazyComponent = $c01ca34426469d55$var$nextHydratableInstance) lazyComponent = $c01ca34426469d55$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $c01ca34426469d55$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$nextHydratableInstance = $c01ca34426469d55$var$getNextHydratable(lazyComponent.firstChild), $c01ca34426469d55$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $c01ca34426469d55$var$throwOnHydrationMismatch(workInProgress);
            }
            $c01ca34426469d55$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $c01ca34426469d55$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $c01ca34426469d55$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $c01ca34426469d55$var$renderWithHooks(current, workInProgress, $c01ca34426469d55$var$TransitionAwareHostComponent, null, null, renderLanes), $c01ca34426469d55$var$HostTransitionContext._currentValue = init);
            $c01ca34426469d55$var$markRef(current, workInProgress);
            $c01ca34426469d55$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c01ca34426469d55$var$isHydrating) {
                if (current = renderLanes = $c01ca34426469d55$var$nextHydratableInstance) renderLanes = $c01ca34426469d55$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c01ca34426469d55$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c01ca34426469d55$var$hydrationParentFiber = workInProgress, $c01ca34426469d55$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c01ca34426469d55$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c01ca34426469d55$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c01ca34426469d55$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $c01ca34426469d55$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $c01ca34426469d55$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $c01ca34426469d55$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c01ca34426469d55$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c01ca34426469d55$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c01ca34426469d55$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $c01ca34426469d55$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $c01ca34426469d55$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $c01ca34426469d55$var$prepareToReadContext(workInProgress), init = $c01ca34426469d55$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $c01ca34426469d55$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $c01ca34426469d55$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c01ca34426469d55$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c01ca34426469d55$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $c01ca34426469d55$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $c01ca34426469d55$var$prepareToReadContext(workInProgress), lazyComponent = $c01ca34426469d55$var$readContext($c01ca34426469d55$var$CacheContext), null === current ? (init = $c01ca34426469d55$var$peekCacheFromPool(), null === init && (init = $c01ca34426469d55$var$workInProgressRoot, nextProps = $c01ca34426469d55$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $c01ca34426469d55$var$initializeUpdateQueue(workInProgress), $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($c01ca34426469d55$var$cloneUpdateQueue(current, workInProgress), $c01ca34426469d55$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $c01ca34426469d55$var$pushProvider(workInProgress, $c01ca34426469d55$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $c01ca34426469d55$var$propagateContextChanges(workInProgress, [
                $c01ca34426469d55$var$CacheContext
            ], renderLanes, !0))), $c01ca34426469d55$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $c01ca34426469d55$var$valueCursor = $c01ca34426469d55$var$createCursor(null), $c01ca34426469d55$var$currentlyRenderingFiber = null, $c01ca34426469d55$var$lastContextDependency = null;
function $c01ca34426469d55$var$pushProvider(providerFiber, context, nextValue) {
    $c01ca34426469d55$var$push($c01ca34426469d55$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c01ca34426469d55$var$popProvider(context) {
    context._currentValue = $c01ca34426469d55$var$valueCursor.current;
    $c01ca34426469d55$var$pop($c01ca34426469d55$var$valueCursor);
}
function $c01ca34426469d55$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c01ca34426469d55$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c01ca34426469d55$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c01ca34426469d55$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c01ca34426469d55$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c01ca34426469d55$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c01ca34426469d55$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c01ca34426469d55$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c01ca34426469d55$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c01ca34426469d55$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c01ca34426469d55$var$HostTransitionContext) : current = [
                $c01ca34426469d55$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c01ca34426469d55$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c01ca34426469d55$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c01ca34426469d55$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c01ca34426469d55$var$prepareToReadContext(workInProgress) {
    $c01ca34426469d55$var$currentlyRenderingFiber = workInProgress;
    $c01ca34426469d55$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c01ca34426469d55$var$readContext(context) {
    return $c01ca34426469d55$var$readContextForConsumer($c01ca34426469d55$var$currentlyRenderingFiber, context);
}
function $c01ca34426469d55$var$readContextDuringReconciliation(consumer, context) {
    null === $c01ca34426469d55$var$currentlyRenderingFiber && $c01ca34426469d55$var$prepareToReadContext(consumer);
    return $c01ca34426469d55$var$readContextForConsumer(consumer, context);
}
function $c01ca34426469d55$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c01ca34426469d55$var$lastContextDependency) {
        if (null === consumer) throw Error($c01ca34426469d55$var$formatProdErrorMessage(308));
        $c01ca34426469d55$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c01ca34426469d55$var$lastContextDependency = $c01ca34426469d55$var$lastContextDependency.next = context;
    return value;
}
var $c01ca34426469d55$var$hasForceUpdate = !1;
function $c01ca34426469d55$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c01ca34426469d55$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c01ca34426469d55$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c01ca34426469d55$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c01ca34426469d55$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c01ca34426469d55$var$getRootForUpdatedFiber(fiber);
        $c01ca34426469d55$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c01ca34426469d55$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c01ca34426469d55$var$getRootForUpdatedFiber(fiber);
}
function $c01ca34426469d55$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c01ca34426469d55$var$markRootEntangled(root, lane);
    }
}
function $c01ca34426469d55$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c01ca34426469d55$var$didReadFromEntangledAsyncAction = !1;
function $c01ca34426469d55$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c01ca34426469d55$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c01ca34426469d55$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c01ca34426469d55$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c01ca34426469d55$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c01ca34426469d55$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c01ca34426469d55$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c01ca34426469d55$var$currentEntangledLane && ($c01ca34426469d55$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c01ca34426469d55$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c01ca34426469d55$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c01ca34426469d55$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c01ca34426469d55$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c01ca34426469d55$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c01ca34426469d55$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c01ca34426469d55$var$callCallback(callbacks[updateQueue], context);
}
function $c01ca34426469d55$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c01ca34426469d55$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $c01ca34426469d55$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c01ca34426469d55$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c01ca34426469d55$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c01ca34426469d55$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c01ca34426469d55$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c01ca34426469d55$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c01ca34426469d55$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c01ca34426469d55$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $c01ca34426469d55$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $c01ca34426469d55$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c01ca34426469d55$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c01ca34426469d55$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c01ca34426469d55$var$internalPropsKey] = newProps;
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c01ca34426469d55$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $c01ca34426469d55$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c01ca34426469d55$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c01ca34426469d55$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c01ca34426469d55$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($c01ca34426469d55$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c01ca34426469d55$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c01ca34426469d55$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($c01ca34426469d55$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c01ca34426469d55$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $c01ca34426469d55$var$offscreenSubtreeIsHidden = !1, $c01ca34426469d55$var$offscreenSubtreeWasHidden = !1, $c01ca34426469d55$var$needsFormReset = !1, $c01ca34426469d55$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c01ca34426469d55$var$nextEffect = null, $c01ca34426469d55$var$shouldFireAfterActiveInstanceBlur = !1;
function $c01ca34426469d55$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c01ca34426469d55$var$eventsEnabled = $c01ca34426469d55$var$_enabled;
    root = $c01ca34426469d55$var$getActiveElementDeep(root);
    if ($c01ca34426469d55$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c01ca34426469d55$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c01ca34426469d55$var$_enabled = !1;
    for($c01ca34426469d55$var$nextEffect = firstChild; null !== $c01ca34426469d55$var$nextEffect;)if (firstChild = $c01ca34426469d55$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $c01ca34426469d55$var$nextEffect = root;
    else for(; null !== $c01ca34426469d55$var$nextEffect;){
        firstChild = $c01ca34426469d55$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c01ca34426469d55$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c01ca34426469d55$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c01ca34426469d55$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c01ca34426469d55$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c01ca34426469d55$var$nextEffect = root;
            break;
        }
        $c01ca34426469d55$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $c01ca34426469d55$var$shouldFireAfterActiveInstanceBlur;
    $c01ca34426469d55$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $c01ca34426469d55$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c01ca34426469d55$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c01ca34426469d55$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $c01ca34426469d55$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $c01ca34426469d55$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c01ca34426469d55$var$commitHostMount(finishedWork);
            flags & 512 && $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c01ca34426469d55$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $c01ca34426469d55$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $c01ca34426469d55$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $c01ca34426469d55$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c01ca34426469d55$var$offscreenSubtreeWasHidden;
                $c01ca34426469d55$var$offscreenSubtreeIsHidden = prevProps;
                ($c01ca34426469d55$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c01ca34426469d55$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $c01ca34426469d55$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return) : $c01ca34426469d55$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c01ca34426469d55$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c01ca34426469d55$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c01ca34426469d55$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c01ca34426469d55$var$hostParent = null, $c01ca34426469d55$var$hostParentIsContainer = !1;
function $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c01ca34426469d55$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c01ca34426469d55$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c01ca34426469d55$var$injectedHook && "function" === typeof $c01ca34426469d55$var$injectedHook.onCommitFiberUnmount) try {
        $c01ca34426469d55$var$injectedHook.onCommitFiberUnmount($c01ca34426469d55$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c01ca34426469d55$var$hostParent, prevHostParentIsContainer = $c01ca34426469d55$var$hostParentIsContainer;
            $c01ca34426469d55$var$hostParent = deletedFiber.stateNode;
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $c01ca34426469d55$var$detachDeletedInstance(deletedFiber);
            $c01ca34426469d55$var$hostParent = prevHostParent;
            $c01ca34426469d55$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $c01ca34426469d55$var$hostParent;
            var prevHostParentIsContainer$119 = $c01ca34426469d55$var$hostParentIsContainer;
            $c01ca34426469d55$var$hostParent = null;
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c01ca34426469d55$var$hostParent = prevHostParentIsContainer;
            $c01ca34426469d55$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $c01ca34426469d55$var$hostParent) {
                if ($c01ca34426469d55$var$hostParentIsContainer) try {
                    finishedRoot = $c01ca34426469d55$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c01ca34426469d55$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c01ca34426469d55$var$hostParent && ($c01ca34426469d55$var$hostParentIsContainer ? (nearestMountedAncestor = $c01ca34426469d55$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $c01ca34426469d55$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $c01ca34426469d55$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $c01ca34426469d55$var$retryIfBlockedOn(nearestMountedAncestor)) : $c01ca34426469d55$var$clearSuspenseBoundary($c01ca34426469d55$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c01ca34426469d55$var$hostParent;
            prevHostParentIsContainer = $c01ca34426469d55$var$hostParentIsContainer;
            $c01ca34426469d55$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c01ca34426469d55$var$hostParentIsContainer = !0;
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c01ca34426469d55$var$hostParent = prevHostParent;
            $c01ca34426469d55$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || ($c01ca34426469d55$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c01ca34426469d55$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c01ca34426469d55$var$offscreenSubtreeWasHidden || $c01ca34426469d55$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c01ca34426469d55$var$offscreenSubtreeWasHidden = (prevHostParent = $c01ca34426469d55$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c01ca34426469d55$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c01ca34426469d55$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c01ca34426469d55$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c01ca34426469d55$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c01ca34426469d55$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c01ca34426469d55$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c01ca34426469d55$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c01ca34426469d55$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c01ca34426469d55$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $c01ca34426469d55$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $c01ca34426469d55$var$hostParent = parent.stateNode;
                    $c01ca34426469d55$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $c01ca34426469d55$var$hostParent = parent.stateNode.containerInfo;
                    $c01ca34426469d55$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $c01ca34426469d55$var$hostParent = parent.stateNode.containerInfo;
                    $c01ca34426469d55$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c01ca34426469d55$var$hostParent) throw Error($c01ca34426469d55$var$formatProdErrorMessage(160));
        $c01ca34426469d55$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c01ca34426469d55$var$hostParent = null;
        $c01ca34426469d55$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$c01ca34426469d55$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c01ca34426469d55$var$currentHoistableRoot = null;
function $c01ca34426469d55$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c01ca34426469d55$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c01ca34426469d55$var$commitHookEffectListMount(3, finishedWork), $c01ca34426469d55$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c01ca34426469d55$var$offscreenSubtreeWasHidden || null === current || $c01ca34426469d55$var$safelyDetachRef(current, current.return));
            flags & 64 && $c01ca34426469d55$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c01ca34426469d55$var$currentHoistableRoot;
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c01ca34426469d55$var$offscreenSubtreeWasHidden || null === current || $c01ca34426469d55$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c01ca34426469d55$var$internalHoistableMarker] || currentResource[$c01ca34426469d55$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c01ca34426469d55$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c01ca34426469d55$var$internalInstanceKey] = finishedWork;
                                        $c01ca34426469d55$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c01ca34426469d55$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c01ca34426469d55$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c01ca34426469d55$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c01ca34426469d55$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c01ca34426469d55$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c01ca34426469d55$var$internalInstanceKey] = finishedWork;
                                $c01ca34426469d55$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c01ca34426469d55$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c01ca34426469d55$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c01ca34426469d55$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c01ca34426469d55$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c01ca34426469d55$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$c01ca34426469d55$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $c01ca34426469d55$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$c01ca34426469d55$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$c01ca34426469d55$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c01ca34426469d55$var$offscreenSubtreeWasHidden || null === current || $c01ca34426469d55$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c01ca34426469d55$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c01ca34426469d55$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c01ca34426469d55$var$needsFormReset = !0);
            break;
        case 6:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c01ca34426469d55$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c01ca34426469d55$var$tagCaches = null;
            hoistableRoot = $c01ca34426469d55$var$currentHoistableRoot;
            $c01ca34426469d55$var$currentHoistableRoot = $c01ca34426469d55$var$getHoistableRoot(root.containerInfo);
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$currentHoistableRoot = hoistableRoot;
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c01ca34426469d55$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c01ca34426469d55$var$needsFormReset && ($c01ca34426469d55$var$needsFormReset = !1, $c01ca34426469d55$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c01ca34426469d55$var$currentHoistableRoot;
            $c01ca34426469d55$var$currentHoistableRoot = $c01ca34426469d55$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            $c01ca34426469d55$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c01ca34426469d55$var$globalMostRecentFallbackTime = $c01ca34426469d55$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c01ca34426469d55$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($c01ca34426469d55$var$offscreenSubtreeWasHidden || null === current || $c01ca34426469d55$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $c01ca34426469d55$var$offscreenSubtreeIsHidden;
            type = $c01ca34426469d55$var$offscreenSubtreeWasHidden;
            $c01ca34426469d55$var$offscreenSubtreeIsHidden = nodeName || node;
            $c01ca34426469d55$var$offscreenSubtreeWasHidden = type || nextNode;
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$offscreenSubtreeWasHidden = type;
            $c01ca34426469d55$var$offscreenSubtreeIsHidden = nodeName;
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $c01ca34426469d55$var$offscreenSubtreeIsHidden || $c01ca34426469d55$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c01ca34426469d55$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $c01ca34426469d55$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c01ca34426469d55$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c01ca34426469d55$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $c01ca34426469d55$var$recursivelyTraverseMutationEffects(root, finishedWork), $c01ca34426469d55$var$commitReconciliationEffects(finishedWork);
    }
}
function $c01ca34426469d55$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($c01ca34426469d55$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($c01ca34426469d55$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $c01ca34426469d55$var$getHostSibling(finishedWork);
                        $c01ca34426469d55$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($c01ca34426469d55$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $c01ca34426469d55$var$getHostSibling(finishedWork);
                        $c01ca34426469d55$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $c01ca34426469d55$var$getHostSibling(finishedWork);
                        $c01ca34426469d55$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($c01ca34426469d55$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c01ca34426469d55$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c01ca34426469d55$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c01ca34426469d55$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c01ca34426469d55$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c01ca34426469d55$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c01ca34426469d55$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c01ca34426469d55$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $c01ca34426469d55$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $c01ca34426469d55$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c01ca34426469d55$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c01ca34426469d55$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c01ca34426469d55$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c01ca34426469d55$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c01ca34426469d55$var$commitClassCallbacks(finishedWork);
                $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c01ca34426469d55$var$commitHostMount(finishedWork);
                $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c01ca34426469d55$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c01ca34426469d55$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $c01ca34426469d55$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c01ca34426469d55$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c01ca34426469d55$var$releaseCache(previousCache));
}
function $c01ca34426469d55$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c01ca34426469d55$var$releaseCache(current));
}
function $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c01ca34426469d55$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c01ca34426469d55$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c01ca34426469d55$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c01ca34426469d55$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c01ca34426469d55$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $c01ca34426469d55$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c01ca34426469d55$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c01ca34426469d55$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c01ca34426469d55$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c01ca34426469d55$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c01ca34426469d55$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c01ca34426469d55$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c01ca34426469d55$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c01ca34426469d55$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c01ca34426469d55$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c01ca34426469d55$var$suspenseyCommitFlag = 8192;
function $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $c01ca34426469d55$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c01ca34426469d55$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c01ca34426469d55$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $c01ca34426469d55$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c01ca34426469d55$var$suspendResource($c01ca34426469d55$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c01ca34426469d55$var$currentHoistableRoot;
            $c01ca34426469d55$var$currentHoistableRoot = $c01ca34426469d55$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $c01ca34426469d55$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c01ca34426469d55$var$suspenseyCommitFlag, $c01ca34426469d55$var$suspenseyCommitFlag = 16777216, $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber), $c01ca34426469d55$var$suspenseyCommitFlag = previousHoistableRoot) : $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $c01ca34426469d55$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $c01ca34426469d55$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c01ca34426469d55$var$nextEffect = childToDelete;
            $c01ca34426469d55$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c01ca34426469d55$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c01ca34426469d55$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c01ca34426469d55$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c01ca34426469d55$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $c01ca34426469d55$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c01ca34426469d55$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c01ca34426469d55$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c01ca34426469d55$var$nextEffect = childToDelete;
            $c01ca34426469d55$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c01ca34426469d55$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c01ca34426469d55$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c01ca34426469d55$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $c01ca34426469d55$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c01ca34426469d55$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c01ca34426469d55$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c01ca34426469d55$var$nextEffect;){
        var fiber = $c01ca34426469d55$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c01ca34426469d55$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c01ca34426469d55$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c01ca34426469d55$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c01ca34426469d55$var$nextEffect;){
            cache = $c01ca34426469d55$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c01ca34426469d55$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c01ca34426469d55$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c01ca34426469d55$var$nextEffect = sibling;
                break a;
            }
            $c01ca34426469d55$var$nextEffect = returnFiber;
        }
    }
}
function $c01ca34426469d55$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c01ca34426469d55$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c01ca34426469d55$var$FiberNode(tag, pendingProps, key, mode);
}
function $c01ca34426469d55$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c01ca34426469d55$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c01ca34426469d55$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c01ca34426469d55$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c01ca34426469d55$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c01ca34426469d55$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c01ca34426469d55$var$isHostHoistableType(type, pendingProps, $c01ca34426469d55$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c01ca34426469d55$var$REACT_FRAGMENT_TYPE:
            return $c01ca34426469d55$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c01ca34426469d55$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c01ca34426469d55$var$REACT_PROFILER_TYPE:
            return type = $c01ca34426469d55$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c01ca34426469d55$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c01ca34426469d55$var$REACT_SUSPENSE_TYPE:
            return type = $c01ca34426469d55$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c01ca34426469d55$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c01ca34426469d55$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c01ca34426469d55$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c01ca34426469d55$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $c01ca34426469d55$var$REACT_OFFSCREEN_TYPE:
            return $c01ca34426469d55$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) && null !== type) switch(type.$$typeof){
                case $c01ca34426469d55$var$REACT_PROVIDER_TYPE:
                case $c01ca34426469d55$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c01ca34426469d55$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c01ca34426469d55$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c01ca34426469d55$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c01ca34426469d55$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c01ca34426469d55$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type), ""));
            owner = null;
    }
    key = $c01ca34426469d55$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c01ca34426469d55$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c01ca34426469d55$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c01ca34426469d55$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $c01ca34426469d55$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $c01ca34426469d55$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function detach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($c01ca34426469d55$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function attach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($c01ca34426469d55$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $c01ca34426469d55$var$createFiberFromText(content, mode, lanes) {
    content = $c01ca34426469d55$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c01ca34426469d55$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c01ca34426469d55$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $c01ca34426469d55$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c01ca34426469d55$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c01ca34426469d55$var$preloadResource(resource)) {
        resource = $c01ca34426469d55$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($c01ca34426469d55$var$workInProgressRootRenderLanes & 4194176) === $c01ca34426469d55$var$workInProgressRootRenderLanes ? null !== $c01ca34426469d55$var$shellBoundary : ($c01ca34426469d55$var$workInProgressRootRenderLanes & 62914560) !== $c01ca34426469d55$var$workInProgressRootRenderLanes && 0 === ($c01ca34426469d55$var$workInProgressRootRenderLanes & 536870912) || resource !== $c01ca34426469d55$var$shellBoundary)) throw $c01ca34426469d55$var$suspendedThenable = $c01ca34426469d55$var$noopSuspenseyCommitThenable, $c01ca34426469d55$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $c01ca34426469d55$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c01ca34426469d55$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c01ca34426469d55$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c01ca34426469d55$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c01ca34426469d55$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $c01ca34426469d55$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c01ca34426469d55$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c01ca34426469d55$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext);
            $c01ca34426469d55$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c01ca34426469d55$var$popHydrationState(workInProgress) ? $c01ca34426469d55$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $c01ca34426469d55$var$hydrationErrors && ($c01ca34426469d55$var$queueRecoverableErrors($c01ca34426469d55$var$hydrationErrors), $c01ca34426469d55$var$hydrationErrors = null));
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($c01ca34426469d55$var$markUpdate(workInProgress), null !== renderLanes ? ($c01ca34426469d55$var$bubbleProperties(workInProgress), $c01ca34426469d55$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c01ca34426469d55$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($c01ca34426469d55$var$markUpdate(workInProgress), $c01ca34426469d55$var$bubbleProperties(workInProgress), $c01ca34426469d55$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c01ca34426469d55$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $c01ca34426469d55$var$markUpdate(workInProgress), $c01ca34426469d55$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $c01ca34426469d55$var$popHostContext(workInProgress);
            renderLanes = $c01ca34426469d55$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c01ca34426469d55$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c01ca34426469d55$var$formatProdErrorMessage(166));
                    $c01ca34426469d55$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c01ca34426469d55$var$contextStackCursor.current;
                $c01ca34426469d55$var$popHydrationState(workInProgress) ? $c01ca34426469d55$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c01ca34426469d55$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c01ca34426469d55$var$markUpdate(workInProgress));
            }
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c01ca34426469d55$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c01ca34426469d55$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c01ca34426469d55$var$formatProdErrorMessage(166));
                    $c01ca34426469d55$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c01ca34426469d55$var$contextStackCursor.current;
                if ($c01ca34426469d55$var$popHydrationState(workInProgress)) $c01ca34426469d55$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $c01ca34426469d55$var$getOwnerDocumentFromRootContainer($c01ca34426469d55$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$c01ca34426469d55$var$internalInstanceKey] = workInProgress;
                    current[$c01ca34426469d55$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($c01ca34426469d55$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $c01ca34426469d55$var$markUpdate(workInProgress);
                }
            }
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c01ca34426469d55$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c01ca34426469d55$var$formatProdErrorMessage(166));
                current = $c01ca34426469d55$var$rootInstanceStackCursor.current;
                if ($c01ca34426469d55$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c01ca34426469d55$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c01ca34426469d55$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c01ca34426469d55$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c01ca34426469d55$var$throwOnHydrationMismatch(workInProgress);
                } else current = $c01ca34426469d55$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c01ca34426469d55$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c01ca34426469d55$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c01ca34426469d55$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c01ca34426469d55$var$formatProdErrorMessage(317));
                        type[$c01ca34426469d55$var$internalInstanceKey] = workInProgress;
                    } else $c01ca34426469d55$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c01ca34426469d55$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $c01ca34426469d55$var$hydrationErrors && ($c01ca34426469d55$var$queueRecoverableErrors($c01ca34426469d55$var$hydrationErrors), $c01ca34426469d55$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c01ca34426469d55$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c01ca34426469d55$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c01ca34426469d55$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c01ca34426469d55$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c01ca34426469d55$var$popHostContainer(), null === current && $c01ca34426469d55$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c01ca34426469d55$var$popProvider(workInProgress.type), $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
        case 19:
            $c01ca34426469d55$var$pop($c01ca34426469d55$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $c01ca34426469d55$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $c01ca34426469d55$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $c01ca34426469d55$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $c01ca34426469d55$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $c01ca34426469d55$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c01ca34426469d55$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, $c01ca34426469d55$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $c01ca34426469d55$var$now() > $c01ca34426469d55$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $c01ca34426469d55$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $c01ca34426469d55$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c01ca34426469d55$var$scheduleRetryEffect(workInProgress, current), $c01ca34426469d55$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$c01ca34426469d55$var$isHydrating) return $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c01ca34426469d55$var$now() - type.renderingStartTime > $c01ca34426469d55$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $c01ca34426469d55$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $c01ca34426469d55$var$now(), workInProgress.sibling = null, current = $c01ca34426469d55$var$suspenseStackCursor.current, $c01ca34426469d55$var$push($c01ca34426469d55$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $c01ca34426469d55$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c01ca34426469d55$var$popSuspenseHandler(workInProgress), $c01ca34426469d55$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c01ca34426469d55$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c01ca34426469d55$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c01ca34426469d55$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c01ca34426469d55$var$pop($c01ca34426469d55$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext), $c01ca34426469d55$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($c01ca34426469d55$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c01ca34426469d55$var$unwindWork(current, workInProgress) {
    $c01ca34426469d55$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext), $c01ca34426469d55$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c01ca34426469d55$var$popHostContext(workInProgress), null;
        case 13:
            $c01ca34426469d55$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c01ca34426469d55$var$formatProdErrorMessage(340));
                $c01ca34426469d55$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c01ca34426469d55$var$pop($c01ca34426469d55$var$suspenseStackCursor), null;
        case 4:
            return $c01ca34426469d55$var$popHostContainer(), null;
        case 10:
            return $c01ca34426469d55$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c01ca34426469d55$var$popSuspenseHandler(workInProgress), $c01ca34426469d55$var$popHiddenContext(), null !== current && $c01ca34426469d55$var$pop($c01ca34426469d55$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c01ca34426469d55$var$unwindInterruptedWork(current, interruptedWork) {
    $c01ca34426469d55$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext);
            $c01ca34426469d55$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c01ca34426469d55$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c01ca34426469d55$var$popHostContainer();
            break;
        case 13:
            $c01ca34426469d55$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c01ca34426469d55$var$pop($c01ca34426469d55$var$suspenseStackCursor);
            break;
        case 10:
            $c01ca34426469d55$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c01ca34426469d55$var$popSuspenseHandler(interruptedWork);
            $c01ca34426469d55$var$popHiddenContext();
            null !== current && $c01ca34426469d55$var$pop($c01ca34426469d55$var$resumedCache);
            break;
        case 24:
            $c01ca34426469d55$var$popProvider($c01ca34426469d55$var$CacheContext);
    }
}
var $c01ca34426469d55$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $c01ca34426469d55$var$readContext($c01ca34426469d55$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $c01ca34426469d55$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c01ca34426469d55$var$executionContext = 0, $c01ca34426469d55$var$workInProgressRoot = null, $c01ca34426469d55$var$workInProgress = null, $c01ca34426469d55$var$workInProgressRootRenderLanes = 0, $c01ca34426469d55$var$workInProgressSuspendedReason = 0, $c01ca34426469d55$var$workInProgressThrownValue = null, $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c01ca34426469d55$var$workInProgressRootIsPrerendering = !1, $c01ca34426469d55$var$workInProgressRootDidAttachPingListener = !1, $c01ca34426469d55$var$entangledRenderLanes = 0, $c01ca34426469d55$var$workInProgressRootExitStatus = 0, $c01ca34426469d55$var$workInProgressRootSkippedLanes = 0, $c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes = 0, $c01ca34426469d55$var$workInProgressRootPingedLanes = 0, $c01ca34426469d55$var$workInProgressDeferredLane = 0, $c01ca34426469d55$var$workInProgressSuspendedRetryLanes = 0, $c01ca34426469d55$var$workInProgressRootConcurrentErrors = null, $c01ca34426469d55$var$workInProgressRootRecoverableErrors = null, $c01ca34426469d55$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c01ca34426469d55$var$globalMostRecentFallbackTime = 0, $c01ca34426469d55$var$workInProgressRootRenderTargetTime = Infinity, $c01ca34426469d55$var$workInProgressTransitions = null, $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed = null, $c01ca34426469d55$var$rootDoesHavePassiveEffects = !1, $c01ca34426469d55$var$rootWithPendingPassiveEffects = null, $c01ca34426469d55$var$pendingPassiveEffectsLanes = 0, $c01ca34426469d55$var$pendingPassiveEffectsRemainingLanes = 0, $c01ca34426469d55$var$pendingPassiveTransitions = null, $c01ca34426469d55$var$nestedUpdateCount = 0, $c01ca34426469d55$var$rootWithNestedUpdates = null;
function $c01ca34426469d55$var$requestUpdateLane() {
    if (0 !== ($c01ca34426469d55$var$executionContext & 2) && 0 !== $c01ca34426469d55$var$workInProgressRootRenderLanes) return $c01ca34426469d55$var$workInProgressRootRenderLanes & -$c01ca34426469d55$var$workInProgressRootRenderLanes;
    if (null !== $c01ca34426469d55$var$ReactSharedInternals.T) {
        var actionScopeLane = $c01ca34426469d55$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $c01ca34426469d55$var$requestTransitionLane();
    }
    return $c01ca34426469d55$var$resolveUpdatePriority();
}
function $c01ca34426469d55$var$requestDeferredLane() {
    0 === $c01ca34426469d55$var$workInProgressDeferredLane && ($c01ca34426469d55$var$workInProgressDeferredLane = 0 === ($c01ca34426469d55$var$workInProgressRootRenderLanes & 536870912) || $c01ca34426469d55$var$isHydrating ? $c01ca34426469d55$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $c01ca34426469d55$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $c01ca34426469d55$var$workInProgressDeferredLane;
}
function $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c01ca34426469d55$var$workInProgressRoot && 2 === $c01ca34426469d55$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $c01ca34426469d55$var$prepareFreshStack(root, 0), $c01ca34426469d55$var$markRootSuspended(root, $c01ca34426469d55$var$workInProgressRootRenderLanes, $c01ca34426469d55$var$workInProgressDeferredLane, !1);
    $c01ca34426469d55$var$markRootUpdated$1(root, lane);
    if (0 === ($c01ca34426469d55$var$executionContext & 2) || root !== $c01ca34426469d55$var$workInProgressRoot) root === $c01ca34426469d55$var$workInProgressRoot && (0 === ($c01ca34426469d55$var$executionContext & 2) && ($c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c01ca34426469d55$var$workInProgressRootExitStatus && $c01ca34426469d55$var$markRootSuspended(root, $c01ca34426469d55$var$workInProgressRootRenderLanes, $c01ca34426469d55$var$workInProgressDeferredLane, !1)), $c01ca34426469d55$var$ensureRootIsScheduled(root);
}
function $c01ca34426469d55$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c01ca34426469d55$var$executionContext & 6)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c01ca34426469d55$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c01ca34426469d55$var$renderRootConcurrent(root$jscomp$0, lanes) : $c01ca34426469d55$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c01ca34426469d55$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c01ca34426469d55$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $c01ca34426469d55$var$markRootSuspended(root$jscomp$0, lanes, 0, !$c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c01ca34426469d55$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c01ca34426469d55$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c01ca34426469d55$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c01ca34426469d55$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c01ca34426469d55$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c01ca34426469d55$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c01ca34426469d55$var$workInProgressRootRecoverableErrors;
                            $c01ca34426469d55$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $c01ca34426469d55$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c01ca34426469d55$var$prepareFreshStack(root$jscomp$0, 0);
                $c01ca34426469d55$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($c01ca34426469d55$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $c01ca34426469d55$var$markRootSuspended(shouldTimeSlice, lanes, $c01ca34426469d55$var$workInProgressDeferredLane, !$c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $c01ca34426469d55$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c01ca34426469d55$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $c01ca34426469d55$var$globalMostRecentFallbackTime + 300 - $c01ca34426469d55$var$now(), 10 < renderWasConcurrent)) {
                    $c01ca34426469d55$var$markRootSuspended(shouldTimeSlice, lanes, $c01ca34426469d55$var$workInProgressDeferredLane, !$c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c01ca34426469d55$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $c01ca34426469d55$var$scheduleTimeout($c01ca34426469d55$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c01ca34426469d55$var$workInProgressRootRecoverableErrors, $c01ca34426469d55$var$workInProgressTransitions, $c01ca34426469d55$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c01ca34426469d55$var$workInProgressDeferredLane, $c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes, $c01ca34426469d55$var$workInProgressSuspendedRetryLanes, $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $c01ca34426469d55$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c01ca34426469d55$var$workInProgressRootRecoverableErrors, $c01ca34426469d55$var$workInProgressTransitions, $c01ca34426469d55$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c01ca34426469d55$var$workInProgressDeferredLane, $c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes, $c01ca34426469d55$var$workInProgressSuspendedRetryLanes, $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $c01ca34426469d55$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c01ca34426469d55$var$queueRecoverableErrors(errors) {
    null === $c01ca34426469d55$var$workInProgressRootRecoverableErrors ? $c01ca34426469d55$var$workInProgressRootRecoverableErrors = errors : $c01ca34426469d55$var$workInProgressRootRecoverableErrors.push.apply($c01ca34426469d55$var$workInProgressRootRecoverableErrors, errors);
}
function $c01ca34426469d55$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($c01ca34426469d55$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $c01ca34426469d55$var$noop
        }, $c01ca34426469d55$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $c01ca34426469d55$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($c01ca34426469d55$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $c01ca34426469d55$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c01ca34426469d55$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $c01ca34426469d55$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c01ca34426469d55$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c01ca34426469d55$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c01ca34426469d55$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c01ca34426469d55$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c01ca34426469d55$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c01ca34426469d55$var$flushSyncWork$1() {
    return 0 === ($c01ca34426469d55$var$executionContext & 6) ? ($c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c01ca34426469d55$var$resetWorkInProgressStack() {
    if (null !== $c01ca34426469d55$var$workInProgress) {
        if (0 === $c01ca34426469d55$var$workInProgressSuspendedReason) var interruptedWork = $c01ca34426469d55$var$workInProgress.return;
        else interruptedWork = $c01ca34426469d55$var$workInProgress, $c01ca34426469d55$var$lastContextDependency = $c01ca34426469d55$var$currentlyRenderingFiber = null, $c01ca34426469d55$var$resetHooksOnUnwind(interruptedWork), $c01ca34426469d55$var$thenableState$1 = null, $c01ca34426469d55$var$thenableIndexCounter$1 = 0, interruptedWork = $c01ca34426469d55$var$workInProgress;
        for(; null !== interruptedWork;)$c01ca34426469d55$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c01ca34426469d55$var$workInProgress = null;
    }
}
function $c01ca34426469d55$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c01ca34426469d55$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c01ca34426469d55$var$resetWorkInProgressStack();
    $c01ca34426469d55$var$workInProgressRoot = root;
    $c01ca34426469d55$var$workInProgress = timeoutHandle = $c01ca34426469d55$var$createWorkInProgress(root.current, null);
    $c01ca34426469d55$var$workInProgressRootRenderLanes = lanes;
    $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
    $c01ca34426469d55$var$workInProgressThrownValue = null;
    $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c01ca34426469d55$var$workInProgressRootIsPrerendering = $c01ca34426469d55$var$checkIfRootIsPrerendering(root, lanes);
    $c01ca34426469d55$var$workInProgressRootDidAttachPingListener = !1;
    $c01ca34426469d55$var$workInProgressSuspendedRetryLanes = $c01ca34426469d55$var$workInProgressDeferredLane = $c01ca34426469d55$var$workInProgressRootPingedLanes = $c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes = $c01ca34426469d55$var$workInProgressRootSkippedLanes = $c01ca34426469d55$var$workInProgressRootExitStatus = 0;
    $c01ca34426469d55$var$workInProgressRootRecoverableErrors = $c01ca34426469d55$var$workInProgressRootConcurrentErrors = null;
    $c01ca34426469d55$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c01ca34426469d55$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $c01ca34426469d55$var$entangledRenderLanes = lanes;
    $c01ca34426469d55$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c01ca34426469d55$var$handleThrow(root, thrownValue) {
    $c01ca34426469d55$var$currentlyRenderingFiber$1 = null;
    $c01ca34426469d55$var$ReactSharedInternals.H = $c01ca34426469d55$var$ContextOnlyDispatcher;
    thrownValue === $c01ca34426469d55$var$SuspenseException ? (thrownValue = $c01ca34426469d55$var$getSuspendedThenable(), $c01ca34426469d55$var$workInProgressSuspendedReason = 3) : thrownValue === $c01ca34426469d55$var$SuspenseyCommitException ? (thrownValue = $c01ca34426469d55$var$getSuspendedThenable(), $c01ca34426469d55$var$workInProgressSuspendedReason = 4) : $c01ca34426469d55$var$workInProgressSuspendedReason = thrownValue === $c01ca34426469d55$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $bJtXW._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $c01ca34426469d55$var$workInProgressThrownValue = thrownValue;
    null === $c01ca34426469d55$var$workInProgress && ($c01ca34426469d55$var$workInProgressRootExitStatus = 1, $c01ca34426469d55$var$logUncaughtError(root, $c01ca34426469d55$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c01ca34426469d55$var$pushDispatcher() {
    var prevDispatcher = $c01ca34426469d55$var$ReactSharedInternals.H;
    $c01ca34426469d55$var$ReactSharedInternals.H = $c01ca34426469d55$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c01ca34426469d55$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c01ca34426469d55$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c01ca34426469d55$var$ReactSharedInternals.A;
    $c01ca34426469d55$var$ReactSharedInternals.A = $c01ca34426469d55$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c01ca34426469d55$var$renderDidSuspendDelayIfPossible() {
    $c01ca34426469d55$var$workInProgressRootExitStatus = 4;
    $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings || ($c01ca34426469d55$var$workInProgressRootRenderLanes & 4194176) !== $c01ca34426469d55$var$workInProgressRootRenderLanes && null !== $c01ca34426469d55$var$suspenseHandlerStackCursor.current || ($c01ca34426469d55$var$workInProgressRootIsPrerendering = !0);
    0 === ($c01ca34426469d55$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c01ca34426469d55$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c01ca34426469d55$var$workInProgressRoot || $c01ca34426469d55$var$markRootSuspended($c01ca34426469d55$var$workInProgressRoot, $c01ca34426469d55$var$workInProgressRootRenderLanes, $c01ca34426469d55$var$workInProgressDeferredLane, !1);
}
function $c01ca34426469d55$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c01ca34426469d55$var$executionContext;
    $c01ca34426469d55$var$executionContext |= 2;
    var prevDispatcher = $c01ca34426469d55$var$pushDispatcher(), prevAsyncDispatcher = $c01ca34426469d55$var$pushAsyncDispatcher();
    if ($c01ca34426469d55$var$workInProgressRoot !== root || $c01ca34426469d55$var$workInProgressRootRenderLanes !== lanes) $c01ca34426469d55$var$workInProgressTransitions = null, $c01ca34426469d55$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c01ca34426469d55$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c01ca34426469d55$var$workInProgressSuspendedReason && null !== $c01ca34426469d55$var$workInProgress) {
            var unitOfWork = $c01ca34426469d55$var$workInProgress, thrownValue = $c01ca34426469d55$var$workInProgressThrownValue;
            switch($c01ca34426469d55$var$workInProgressSuspendedReason){
                case 8:
                    $c01ca34426469d55$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $c01ca34426469d55$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c01ca34426469d55$var$workInProgressSuspendedReason;
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                    $c01ca34426469d55$var$workInProgressThrownValue = null;
                    $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c01ca34426469d55$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c01ca34426469d55$var$workInProgressSuspendedReason, $c01ca34426469d55$var$workInProgressSuspendedReason = 0, $c01ca34426469d55$var$workInProgressThrownValue = null, $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c01ca34426469d55$var$workLoopSync();
        exitStatus = $c01ca34426469d55$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $c01ca34426469d55$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c01ca34426469d55$var$lastContextDependency = $c01ca34426469d55$var$currentlyRenderingFiber = null;
    $c01ca34426469d55$var$executionContext = prevExecutionContext;
    $c01ca34426469d55$var$ReactSharedInternals.H = prevDispatcher;
    $c01ca34426469d55$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c01ca34426469d55$var$workInProgress && ($c01ca34426469d55$var$workInProgressRoot = null, $c01ca34426469d55$var$workInProgressRootRenderLanes = 0, $c01ca34426469d55$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c01ca34426469d55$var$workLoopSync() {
    for(; null !== $c01ca34426469d55$var$workInProgress;)$c01ca34426469d55$var$performUnitOfWork($c01ca34426469d55$var$workInProgress);
}
function $c01ca34426469d55$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c01ca34426469d55$var$executionContext;
    $c01ca34426469d55$var$executionContext |= 2;
    var prevDispatcher = $c01ca34426469d55$var$pushDispatcher(), prevAsyncDispatcher = $c01ca34426469d55$var$pushAsyncDispatcher();
    $c01ca34426469d55$var$workInProgressRoot !== root || $c01ca34426469d55$var$workInProgressRootRenderLanes !== lanes ? ($c01ca34426469d55$var$workInProgressTransitions = null, $c01ca34426469d55$var$workInProgressRootRenderTargetTime = $c01ca34426469d55$var$now() + 500, $c01ca34426469d55$var$prepareFreshStack(root, lanes)) : $c01ca34426469d55$var$workInProgressRootIsPrerendering = $c01ca34426469d55$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c01ca34426469d55$var$workInProgressSuspendedReason && null !== $c01ca34426469d55$var$workInProgress) {
            lanes = $c01ca34426469d55$var$workInProgress;
            var thrownValue = $c01ca34426469d55$var$workInProgressThrownValue;
            b: switch($c01ca34426469d55$var$workInProgressSuspendedReason){
                case 1:
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                    $c01ca34426469d55$var$workInProgressThrownValue = null;
                    $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($c01ca34426469d55$var$isThenableResolved(thrownValue)) {
                        $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                        $c01ca34426469d55$var$workInProgressThrownValue = null;
                        $c01ca34426469d55$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 === $c01ca34426469d55$var$workInProgressSuspendedReason && $c01ca34426469d55$var$workInProgressRoot === root && ($c01ca34426469d55$var$workInProgressSuspendedReason = 7);
                        $c01ca34426469d55$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c01ca34426469d55$var$isThenableResolved(thrownValue) ? ($c01ca34426469d55$var$workInProgressSuspendedReason = 0, $c01ca34426469d55$var$workInProgressThrownValue = null, $c01ca34426469d55$var$replaySuspendedUnitOfWork(lanes)) : ($c01ca34426469d55$var$workInProgressSuspendedReason = 0, $c01ca34426469d55$var$workInProgressThrownValue = null, $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c01ca34426469d55$var$workInProgress.tag){
                        case 26:
                            resource = $c01ca34426469d55$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c01ca34426469d55$var$workInProgress;
                            if (resource ? $c01ca34426469d55$var$preloadResource(resource) : 1) {
                                $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                                $c01ca34426469d55$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c01ca34426469d55$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c01ca34426469d55$var$workInProgress = returnFiber, $c01ca34426469d55$var$completeUnitOfWork(returnFiber)) : $c01ca34426469d55$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                    $c01ca34426469d55$var$workInProgressThrownValue = null;
                    $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c01ca34426469d55$var$workInProgressSuspendedReason = 0;
                    $c01ca34426469d55$var$workInProgressThrownValue = null;
                    $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c01ca34426469d55$var$resetWorkInProgressStack();
                    $c01ca34426469d55$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c01ca34426469d55$var$formatProdErrorMessage(462));
            }
        }
        $c01ca34426469d55$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $c01ca34426469d55$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $c01ca34426469d55$var$lastContextDependency = $c01ca34426469d55$var$currentlyRenderingFiber = null;
    $c01ca34426469d55$var$ReactSharedInternals.H = prevDispatcher;
    $c01ca34426469d55$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c01ca34426469d55$var$executionContext = prevExecutionContext;
    if (null !== $c01ca34426469d55$var$workInProgress) return 0;
    $c01ca34426469d55$var$workInProgressRoot = null;
    $c01ca34426469d55$var$workInProgressRootRenderLanes = 0;
    $c01ca34426469d55$var$finishQueueingConcurrentUpdates();
    return $c01ca34426469d55$var$workInProgressRootExitStatus;
}
function $c01ca34426469d55$var$workLoopConcurrent() {
    for(; null !== $c01ca34426469d55$var$workInProgress && !$c01ca34426469d55$var$shouldYield();)$c01ca34426469d55$var$performUnitOfWork($c01ca34426469d55$var$workInProgress);
}
function $c01ca34426469d55$var$performUnitOfWork(unitOfWork) {
    var next = $c01ca34426469d55$var$beginWork(unitOfWork.alternate, unitOfWork, $c01ca34426469d55$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c01ca34426469d55$var$completeUnitOfWork(unitOfWork) : $c01ca34426469d55$var$workInProgress = next;
}
function $c01ca34426469d55$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c01ca34426469d55$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c01ca34426469d55$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c01ca34426469d55$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c01ca34426469d55$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c01ca34426469d55$var$resetHooksOnUnwind(next);
        default:
            $c01ca34426469d55$var$unwindInterruptedWork(current, next), next = $c01ca34426469d55$var$workInProgress = $c01ca34426469d55$var$resetWorkInProgress(next, $c01ca34426469d55$var$entangledRenderLanes), next = $c01ca34426469d55$var$beginWork(current, next, $c01ca34426469d55$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c01ca34426469d55$var$completeUnitOfWork(unitOfWork) : $c01ca34426469d55$var$workInProgress = next;
}
function $c01ca34426469d55$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c01ca34426469d55$var$lastContextDependency = $c01ca34426469d55$var$currentlyRenderingFiber = null;
    $c01ca34426469d55$var$resetHooksOnUnwind(unitOfWork);
    $c01ca34426469d55$var$thenableState$1 = null;
    $c01ca34426469d55$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c01ca34426469d55$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c01ca34426469d55$var$workInProgressRootRenderLanes)) {
            $c01ca34426469d55$var$workInProgressRootExitStatus = 1;
            $c01ca34426469d55$var$logUncaughtError(root, $c01ca34426469d55$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c01ca34426469d55$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c01ca34426469d55$var$workInProgress = returnFiber, error;
        $c01ca34426469d55$var$workInProgressRootExitStatus = 1;
        $c01ca34426469d55$var$logUncaughtError(root, $c01ca34426469d55$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c01ca34426469d55$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c01ca34426469d55$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c01ca34426469d55$var$workInProgressRootIsPrerendering || 0 !== ($c01ca34426469d55$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c01ca34426469d55$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c01ca34426469d55$var$unwindUnitOfWork(unitOfWork, root);
    } else $c01ca34426469d55$var$completeUnitOfWork(unitOfWork);
}
function $c01ca34426469d55$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c01ca34426469d55$var$unwindUnitOfWork(completedWork, $c01ca34426469d55$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c01ca34426469d55$var$completeWork(completedWork.alternate, completedWork, $c01ca34426469d55$var$entangledRenderLanes);
        if (null !== next) {
            $c01ca34426469d55$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c01ca34426469d55$var$workInProgress = completedWork;
            return;
        }
        $c01ca34426469d55$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c01ca34426469d55$var$workInProgressRootExitStatus && ($c01ca34426469d55$var$workInProgressRootExitStatus = 5);
}
function $c01ca34426469d55$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c01ca34426469d55$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c01ca34426469d55$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c01ca34426469d55$var$workInProgress = unitOfWork;
            return;
        }
        $c01ca34426469d55$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c01ca34426469d55$var$workInProgressRootExitStatus = 6;
    $c01ca34426469d55$var$workInProgress = null;
}
function $c01ca34426469d55$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T, previousUpdateLanePriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    try {
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = 2, $c01ca34426469d55$var$ReactSharedInternals.T = null, $c01ca34426469d55$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition, $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $c01ca34426469d55$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $c01ca34426469d55$var$flushPassiveEffects();
    while (null !== $c01ca34426469d55$var$rootWithPendingPassiveEffects);
    if (0 !== ($c01ca34426469d55$var$executionContext & 6)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($c01ca34426469d55$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $c01ca34426469d55$var$concurrentlyUpdatedLanes;
    $c01ca34426469d55$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $c01ca34426469d55$var$workInProgressRoot && ($c01ca34426469d55$var$workInProgress = $c01ca34426469d55$var$workInProgressRoot = null, $c01ca34426469d55$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $c01ca34426469d55$var$rootDoesHavePassiveEffects || ($c01ca34426469d55$var$rootDoesHavePassiveEffects = !0, $c01ca34426469d55$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $c01ca34426469d55$var$pendingPassiveTransitions = transitions, $c01ca34426469d55$var$scheduleCallback$1($c01ca34426469d55$var$NormalPriority$1, function() {
        $c01ca34426469d55$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $c01ca34426469d55$var$ReactSharedInternals.T, $c01ca34426469d55$var$ReactSharedInternals.T = null, spawnedLane = $c01ca34426469d55$var$ReactDOMSharedInternals.p, $c01ca34426469d55$var$ReactDOMSharedInternals.p = 2, updatedLanes = $c01ca34426469d55$var$executionContext, $c01ca34426469d55$var$executionContext |= 4, $c01ca34426469d55$var$commitBeforeMutationEffects(root, finishedWork), $c01ca34426469d55$var$commitMutationEffectsOnFiber(finishedWork, root), $c01ca34426469d55$var$restoreSelection($c01ca34426469d55$var$selectionInformation, root.containerInfo), $c01ca34426469d55$var$_enabled = !!$c01ca34426469d55$var$eventsEnabled, $c01ca34426469d55$var$selectionInformation = $c01ca34426469d55$var$eventsEnabled = null, root.current = finishedWork, $c01ca34426469d55$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $c01ca34426469d55$var$requestPaint(), $c01ca34426469d55$var$executionContext = updatedLanes, $c01ca34426469d55$var$ReactDOMSharedInternals.p = spawnedLane, $c01ca34426469d55$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $c01ca34426469d55$var$rootDoesHavePassiveEffects ? ($c01ca34426469d55$var$rootDoesHavePassiveEffects = !1, $c01ca34426469d55$var$rootWithPendingPassiveEffects = root, $c01ca34426469d55$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $c01ca34426469d55$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $c01ca34426469d55$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $c01ca34426469d55$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($c01ca34426469d55$var$pendingPassiveEffectsLanes & 3) && $c01ca34426469d55$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $c01ca34426469d55$var$rootWithNestedUpdates ? $c01ca34426469d55$var$nestedUpdateCount++ : ($c01ca34426469d55$var$nestedUpdateCount = 0, $c01ca34426469d55$var$rootWithNestedUpdates = root) : $c01ca34426469d55$var$nestedUpdateCount = 0;
    $c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $c01ca34426469d55$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c01ca34426469d55$var$releaseCache(remainingLanes)));
}
function $c01ca34426469d55$var$flushPassiveEffects() {
    if (null !== $c01ca34426469d55$var$rootWithPendingPassiveEffects) {
        var root$170 = $c01ca34426469d55$var$rootWithPendingPassiveEffects, remainingLanes = $c01ca34426469d55$var$pendingPassiveEffectsRemainingLanes;
        $c01ca34426469d55$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $c01ca34426469d55$var$lanesToEventPriority($c01ca34426469d55$var$pendingPassiveEffectsLanes), prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T, previousPriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
        try {
            $c01ca34426469d55$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $c01ca34426469d55$var$ReactSharedInternals.T = null;
            if (null === $c01ca34426469d55$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $c01ca34426469d55$var$pendingPassiveTransitions;
                $c01ca34426469d55$var$pendingPassiveTransitions = null;
                var root = $c01ca34426469d55$var$rootWithPendingPassiveEffects, lanes = $c01ca34426469d55$var$pendingPassiveEffectsLanes;
                $c01ca34426469d55$var$rootWithPendingPassiveEffects = null;
                $c01ca34426469d55$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($c01ca34426469d55$var$executionContext & 6)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(331));
                var prevExecutionContext = $c01ca34426469d55$var$executionContext;
                $c01ca34426469d55$var$executionContext |= 4;
                $c01ca34426469d55$var$commitPassiveUnmountOnFiber(root.current);
                $c01ca34426469d55$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $c01ca34426469d55$var$executionContext = prevExecutionContext;
                $c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($c01ca34426469d55$var$injectedHook && "function" === typeof $c01ca34426469d55$var$injectedHook.onPostCommitFiberRoot) try {
                    $c01ca34426469d55$var$injectedHook.onPostCommitFiberRoot($c01ca34426469d55$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousPriority, $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition, $c01ca34426469d55$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $c01ca34426469d55$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c01ca34426469d55$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c01ca34426469d55$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c01ca34426469d55$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c01ca34426469d55$var$markRootUpdated$1(rootFiber, 2), $c01ca34426469d55$var$ensureRootIsScheduled(rootFiber));
}
function $c01ca34426469d55$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c01ca34426469d55$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c01ca34426469d55$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed || !$c01ca34426469d55$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c01ca34426469d55$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c01ca34426469d55$var$createClassErrorUpdate(2);
                instance = $c01ca34426469d55$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c01ca34426469d55$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c01ca34426469d55$var$markRootUpdated$1(instance, 2), $c01ca34426469d55$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c01ca34426469d55$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c01ca34426469d55$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c01ca34426469d55$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c01ca34426469d55$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c01ca34426469d55$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c01ca34426469d55$var$workInProgressRoot === root && ($c01ca34426469d55$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c01ca34426469d55$var$workInProgressRootExitStatus || 3 === $c01ca34426469d55$var$workInProgressRootExitStatus && ($c01ca34426469d55$var$workInProgressRootRenderLanes & 62914560) === $c01ca34426469d55$var$workInProgressRootRenderLanes && 300 > $c01ca34426469d55$var$now() - $c01ca34426469d55$var$globalMostRecentFallbackTime ? 0 === ($c01ca34426469d55$var$executionContext & 2) && $c01ca34426469d55$var$prepareFreshStack(root, 0) : $c01ca34426469d55$var$workInProgressRootPingedLanes |= pingedLanes, $c01ca34426469d55$var$workInProgressSuspendedRetryLanes === $c01ca34426469d55$var$workInProgressRootRenderLanes && ($c01ca34426469d55$var$workInProgressSuspendedRetryLanes = 0));
    $c01ca34426469d55$var$ensureRootIsScheduled(root);
}
function $c01ca34426469d55$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c01ca34426469d55$var$claimNextRetryLane());
    boundaryFiber = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c01ca34426469d55$var$markRootUpdated$1(boundaryFiber, retryLane), $c01ca34426469d55$var$ensureRootIsScheduled(boundaryFiber));
}
function $c01ca34426469d55$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c01ca34426469d55$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c01ca34426469d55$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c01ca34426469d55$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c01ca34426469d55$var$scheduleCallback$1(priorityLevel, callback) {
    return $c01ca34426469d55$var$scheduleCallback$3(priorityLevel, callback);
}
var $c01ca34426469d55$var$firstScheduledRoot = null, $c01ca34426469d55$var$lastScheduledRoot = null, $c01ca34426469d55$var$didScheduleMicrotask = !1, $c01ca34426469d55$var$mightHavePendingSyncWork = !1, $c01ca34426469d55$var$isFlushingWork = !1, $c01ca34426469d55$var$currentEventTransitionLane = 0;
function $c01ca34426469d55$var$ensureRootIsScheduled(root) {
    root !== $c01ca34426469d55$var$lastScheduledRoot && null === root.next && (null === $c01ca34426469d55$var$lastScheduledRoot ? $c01ca34426469d55$var$firstScheduledRoot = $c01ca34426469d55$var$lastScheduledRoot = root : $c01ca34426469d55$var$lastScheduledRoot = $c01ca34426469d55$var$lastScheduledRoot.next = root);
    $c01ca34426469d55$var$mightHavePendingSyncWork = !0;
    $c01ca34426469d55$var$didScheduleMicrotask || ($c01ca34426469d55$var$didScheduleMicrotask = !0, $c01ca34426469d55$var$scheduleImmediateTask($c01ca34426469d55$var$processRootScheduleInMicrotask));
}
function $c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c01ca34426469d55$var$isFlushingWork && $c01ca34426469d55$var$mightHavePendingSyncWork) {
        $c01ca34426469d55$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $c01ca34426469d55$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c01ca34426469d55$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c01ca34426469d55$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c01ca34426469d55$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c01ca34426469d55$var$getNextLanes(root$172, root$172 === $c01ca34426469d55$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $c01ca34426469d55$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c01ca34426469d55$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $c01ca34426469d55$var$isFlushingWork = !1;
    }
}
function $c01ca34426469d55$var$processRootScheduleInMicrotask() {
    $c01ca34426469d55$var$mightHavePendingSyncWork = $c01ca34426469d55$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c01ca34426469d55$var$currentEventTransitionLane && ($c01ca34426469d55$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c01ca34426469d55$var$currentEventTransitionLane), $c01ca34426469d55$var$currentEventTransitionLane = 0);
    for(var currentTime = $c01ca34426469d55$var$now(), prev = null, root = $c01ca34426469d55$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c01ca34426469d55$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c01ca34426469d55$var$firstScheduledRoot = next : prev.next = next, null === next && ($c01ca34426469d55$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c01ca34426469d55$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $c01ca34426469d55$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c01ca34426469d55$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c01ca34426469d55$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c01ca34426469d55$var$workInProgressRoot;
    suspendedLanes = $c01ca34426469d55$var$workInProgressRootRenderLanes;
    suspendedLanes = $c01ca34426469d55$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $c01ca34426469d55$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c01ca34426469d55$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c01ca34426469d55$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c01ca34426469d55$var$cancelCallback$1(pingedLanes);
        switch($c01ca34426469d55$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c01ca34426469d55$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c01ca34426469d55$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c01ca34426469d55$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c01ca34426469d55$var$NormalPriority$1;
        }
        pingedLanes = $c01ca34426469d55$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c01ca34426469d55$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c01ca34426469d55$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c01ca34426469d55$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($c01ca34426469d55$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c01ca34426469d55$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c01ca34426469d55$var$getNextLanes(root, root === $c01ca34426469d55$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c01ca34426469d55$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c01ca34426469d55$var$scheduleTaskForRootDuringMicrotask(root, $c01ca34426469d55$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c01ca34426469d55$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c01ca34426469d55$var$performSyncWorkOnRoot(root, lanes) {
    if ($c01ca34426469d55$var$flushPassiveEffects()) return null;
    $c01ca34426469d55$var$performWorkOnRoot(root, lanes, !0);
}
function $c01ca34426469d55$var$scheduleImmediateTask(cb) {
    $c01ca34426469d55$var$scheduleMicrotask(function() {
        0 !== ($c01ca34426469d55$var$executionContext & 6) ? $c01ca34426469d55$var$scheduleCallback$3($c01ca34426469d55$var$ImmediatePriority, cb) : cb();
    });
}
function $c01ca34426469d55$var$requestTransitionLane() {
    0 === $c01ca34426469d55$var$currentEventTransitionLane && ($c01ca34426469d55$var$currentEventTransitionLane = $c01ca34426469d55$var$claimNextTransitionLane());
    return $c01ca34426469d55$var$currentEventTransitionLane;
}
function $c01ca34426469d55$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $bJtXW._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c01ca34426469d55$var$sanitizeURL("" + actionProp);
}
function $c01ca34426469d55$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c01ca34426469d55$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c01ca34426469d55$var$coerceFormActionProp((nativeEventTarget[$c01ca34426469d55$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c01ca34426469d55$var$internalPropsKey] || null) ? $c01ca34426469d55$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c01ca34426469d55$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c01ca34426469d55$var$currentEventTransitionLane) {
                                var formData = submitter ? $c01ca34426469d55$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c01ca34426469d55$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c01ca34426469d55$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c01ca34426469d55$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c01ca34426469d55$var$i$jscomp$inline_1439 = 0; $c01ca34426469d55$var$i$jscomp$inline_1439 < $c01ca34426469d55$var$simpleEventPluginEvents.length; $c01ca34426469d55$var$i$jscomp$inline_1439++){
    var $c01ca34426469d55$var$eventName$jscomp$inline_1440 = $c01ca34426469d55$var$simpleEventPluginEvents[$c01ca34426469d55$var$i$jscomp$inline_1439], $c01ca34426469d55$var$domEventName$jscomp$inline_1441 = $c01ca34426469d55$var$eventName$jscomp$inline_1440.toLowerCase(), $c01ca34426469d55$var$capitalizedEvent$jscomp$inline_1442 = $c01ca34426469d55$var$eventName$jscomp$inline_1440[0].toUpperCase() + $c01ca34426469d55$var$eventName$jscomp$inline_1440.slice(1);
    $c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$domEventName$jscomp$inline_1441, "on" + $c01ca34426469d55$var$capitalizedEvent$jscomp$inline_1442);
}
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$ANIMATION_END, "onAnimationEnd");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$ANIMATION_ITERATION, "onAnimationIteration");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$ANIMATION_START, "onAnimationStart");
$c01ca34426469d55$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c01ca34426469d55$var$registerSimpleEvent("focusin", "onFocus");
$c01ca34426469d55$var$registerSimpleEvent("focusout", "onBlur");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$TRANSITION_RUN, "onTransitionRun");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$TRANSITION_START, "onTransitionStart");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$TRANSITION_CANCEL, "onTransitionCancel");
$c01ca34426469d55$var$registerSimpleEvent($c01ca34426469d55$var$TRANSITION_END, "onTransitionEnd");
$c01ca34426469d55$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c01ca34426469d55$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c01ca34426469d55$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c01ca34426469d55$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c01ca34426469d55$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c01ca34426469d55$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c01ca34426469d55$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c01ca34426469d55$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c01ca34426469d55$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c01ca34426469d55$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c01ca34426469d55$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c01ca34426469d55$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c01ca34426469d55$var$mediaEventTypes));
function $c01ca34426469d55$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c01ca34426469d55$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c01ca34426469d55$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c01ca34426469d55$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c01ca34426469d55$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c01ca34426469d55$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c01ca34426469d55$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c01ca34426469d55$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c01ca34426469d55$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c01ca34426469d55$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c01ca34426469d55$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c01ca34426469d55$var$listeningMarker]) {
        rootContainerElement[$c01ca34426469d55$var$listeningMarker] = !0;
        $c01ca34426469d55$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c01ca34426469d55$var$nonDelegatedEvents.has(domEventName) || $c01ca34426469d55$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c01ca34426469d55$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c01ca34426469d55$var$listeningMarker] || (ownerDocument[$c01ca34426469d55$var$listeningMarker] = !0, $c01ca34426469d55$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c01ca34426469d55$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c01ca34426469d55$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c01ca34426469d55$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c01ca34426469d55$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c01ca34426469d55$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c01ca34426469d55$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c01ca34426469d55$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c01ca34426469d55$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c01ca34426469d55$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c01ca34426469d55$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c01ca34426469d55$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c01ca34426469d55$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c01ca34426469d55$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticTouchEvent;
                        break;
                    case $c01ca34426469d55$var$ANIMATION_END:
                    case $c01ca34426469d55$var$ANIMATION_ITERATION:
                    case $c01ca34426469d55$var$ANIMATION_START:
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticAnimationEvent;
                        break;
                    case $c01ca34426469d55$var$TRANSITION_END:
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c01ca34426469d55$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c01ca34426469d55$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c01ca34426469d55$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c01ca34426469d55$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c01ca34426469d55$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c01ca34426469d55$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c01ca34426469d55$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c01ca34426469d55$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c01ca34426469d55$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c01ca34426469d55$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c01ca34426469d55$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c01ca34426469d55$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c01ca34426469d55$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $c01ca34426469d55$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $c01ca34426469d55$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $c01ca34426469d55$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $c01ca34426469d55$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $c01ca34426469d55$var$getParent(inCapturePhase);
                                reactEventName = $c01ca34426469d55$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c01ca34426469d55$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c01ca34426469d55$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c01ca34426469d55$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c01ca34426469d55$var$getTargetInstForChangeEvent;
                else if ($c01ca34426469d55$var$isTextInputElement(reactName)) {
                    if ($c01ca34426469d55$var$isInputEventSupported) getTargetInstFunc = $c01ca34426469d55$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c01ca34426469d55$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c01ca34426469d55$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c01ca34426469d55$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c01ca34426469d55$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c01ca34426469d55$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c01ca34426469d55$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c01ca34426469d55$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c01ca34426469d55$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c01ca34426469d55$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c01ca34426469d55$var$activeElement = handleEventFunc, $c01ca34426469d55$var$activeElementInst = targetInst, $c01ca34426469d55$var$lastSelection = null;
                    break;
                case "focusout":
                    $c01ca34426469d55$var$lastSelection = $c01ca34426469d55$var$activeElementInst = $c01ca34426469d55$var$activeElement = null;
                    break;
                case "mousedown":
                    $c01ca34426469d55$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c01ca34426469d55$var$mouseDown = !1;
                    $c01ca34426469d55$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c01ca34426469d55$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c01ca34426469d55$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c01ca34426469d55$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c01ca34426469d55$var$isComposing ? $c01ca34426469d55$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c01ca34426469d55$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c01ca34426469d55$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c01ca34426469d55$var$isComposing && (fallbackData = $c01ca34426469d55$var$getData()) : ($c01ca34426469d55$var$root = nativeEventTarget, $c01ca34426469d55$var$startText = "value" in $c01ca34426469d55$var$root ? $c01ca34426469d55$var$root.value : $c01ca34426469d55$var$root.textContent, $c01ca34426469d55$var$isComposing = !0)), handleEventFunc = $c01ca34426469d55$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c01ca34426469d55$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c01ca34426469d55$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c01ca34426469d55$var$canUseTextInputEvent ? $c01ca34426469d55$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c01ca34426469d55$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c01ca34426469d55$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c01ca34426469d55$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c01ca34426469d55$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c01ca34426469d55$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c01ca34426469d55$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c01ca34426469d55$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c01ca34426469d55$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c01ca34426469d55$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c01ca34426469d55$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c01ca34426469d55$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $c01ca34426469d55$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c01ca34426469d55$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c01ca34426469d55$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c01ca34426469d55$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c01ca34426469d55$var$getListener(target, registrationName), null != stateNode && listeners.push($c01ca34426469d55$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c01ca34426469d55$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c01ca34426469d55$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c01ca34426469d55$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c01ca34426469d55$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c01ca34426469d55$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c01ca34426469d55$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c01ca34426469d55$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c01ca34426469d55$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c01ca34426469d55$var$noop$1() {}
function $c01ca34426469d55$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c01ca34426469d55$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value))) && "body" !== tag && $c01ca34426469d55$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c01ca34426469d55$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c01ca34426469d55$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c01ca34426469d55$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c01ca34426469d55$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c01ca34426469d55$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c01ca34426469d55$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c01ca34426469d55$var$setProp(domElement, tag, "name", props.name, props, null), $c01ca34426469d55$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c01ca34426469d55$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c01ca34426469d55$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c01ca34426469d55$var$setProp(domElement, tag, "encType", props.encType, props, null), $c01ca34426469d55$var$setProp(domElement, tag, "method", props.method, props, null), $c01ca34426469d55$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c01ca34426469d55$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c01ca34426469d55$var$noop$1);
            break;
        case "onScroll":
            null != value && $c01ca34426469d55$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c01ca34426469d55$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) || !("__html" in value)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c01ca34426469d55$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c01ca34426469d55$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("toggle", domElement);
            $c01ca34426469d55$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c01ca34426469d55$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c01ca34426469d55$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c01ca34426469d55$var$aliases.get(key) || key, $c01ca34426469d55$var$setValueForAttribute(domElement, key, value);
    }
}
function $c01ca34426469d55$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c01ca34426469d55$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) || !("__html" in value)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c01ca34426469d55$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c01ca34426469d55$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value))) && $c01ca34426469d55$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c01ca34426469d55$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c01ca34426469d55$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c01ca34426469d55$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c01ca34426469d55$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c01ca34426469d55$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c01ca34426469d55$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c01ca34426469d55$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("error", domElement);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c01ca34426469d55$var$formatProdErrorMessage(137, tag));
                    default:
                        $c01ca34426469d55$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c01ca34426469d55$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c01ca34426469d55$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($c01ca34426469d55$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c01ca34426469d55$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $c01ca34426469d55$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $c01ca34426469d55$var$track(domElement);
            return;
        case "select":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c01ca34426469d55$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c01ca34426469d55$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c01ca34426469d55$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c01ca34426469d55$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $c01ca34426469d55$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $bJtXW._)(hasSrc));
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("cancel", domElement);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c01ca34426469d55$var$mediaEventTypes.length; hasSrc++)$c01ca34426469d55$var$listenToNonDelegatedEvent($c01ca34426469d55$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("error", domElement);
            $c01ca34426469d55$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c01ca34426469d55$var$listenToNonDelegatedEvent("error", domElement), $c01ca34426469d55$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c01ca34426469d55$var$formatProdErrorMessage(137, tag));
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c01ca34426469d55$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $c01ca34426469d55$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c01ca34426469d55$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c01ca34426469d55$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c01ca34426469d55$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c01ca34426469d55$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c01ca34426469d55$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $c01ca34426469d55$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c01ca34426469d55$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c01ca34426469d55$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $c01ca34426469d55$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $c01ca34426469d55$var$updateOptions(domElement, !!lastProps, tag, !0) : $c01ca34426469d55$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c01ca34426469d55$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c01ca34426469d55$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c01ca34426469d55$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== (typeof propKey$203 === "undefined" ? "undefined" : (0, $bJtXW._)(propKey$203));
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $c01ca34426469d55$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($c01ca34426469d55$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c01ca34426469d55$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($c01ca34426469d55$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $c01ca34426469d55$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $c01ca34426469d55$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $c01ca34426469d55$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $c01ca34426469d55$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $c01ca34426469d55$var$eventsEnabled = null, $c01ca34426469d55$var$selectionInformation = null;
function $c01ca34426469d55$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c01ca34426469d55$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c01ca34426469d55$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c01ca34426469d55$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $bJtXW._)(props.children) || "object" === (0, $bJtXW._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c01ca34426469d55$var$currentPopstateTransitionEvent = null;
function $c01ca34426469d55$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c01ca34426469d55$var$currentPopstateTransitionEvent) return !1;
        $c01ca34426469d55$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c01ca34426469d55$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c01ca34426469d55$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c01ca34426469d55$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c01ca34426469d55$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c01ca34426469d55$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c01ca34426469d55$var$localPromise ? function scheduleMicrotask(callback) {
    return $c01ca34426469d55$var$localPromise.resolve(null).then(callback).catch($c01ca34426469d55$var$handleErrorInNextTick);
} : $c01ca34426469d55$var$scheduleTimeout;
function $c01ca34426469d55$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c01ca34426469d55$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c01ca34426469d55$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $c01ca34426469d55$var$retryIfBlockedOn(suspenseInstance);
}
function $c01ca34426469d55$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c01ca34426469d55$var$clearContainerSparingly(node);
                $c01ca34426469d55$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c01ca34426469d55$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c01ca34426469d55$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c01ca34426469d55$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c01ca34426469d55$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c01ca34426469d55$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c01ca34426469d55$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $c01ca34426469d55$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c01ca34426469d55$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c01ca34426469d55$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c01ca34426469d55$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c01ca34426469d55$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c01ca34426469d55$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(451));
    }
}
var $c01ca34426469d55$var$preloadPropsMap = new Map(), $c01ca34426469d55$var$preconnectsSet = new Set();
function $c01ca34426469d55$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $c01ca34426469d55$var$previousDispatcher = $c01ca34426469d55$var$ReactDOMSharedInternals.d;
$c01ca34426469d55$var$ReactDOMSharedInternals.d = {
    f: $c01ca34426469d55$var$flushSyncWork,
    r: $c01ca34426469d55$var$requestFormReset,
    D: $c01ca34426469d55$var$prefetchDNS,
    C: $c01ca34426469d55$var$preconnect,
    L: $c01ca34426469d55$var$preload,
    m: $c01ca34426469d55$var$preloadModule,
    X: $c01ca34426469d55$var$preinitScript,
    S: $c01ca34426469d55$var$preinitStyle,
    M: $c01ca34426469d55$var$preinitModuleScript
};
function $c01ca34426469d55$var$flushSyncWork() {
    var previousWasRendering = $c01ca34426469d55$var$previousDispatcher.f(), wasRendering = $c01ca34426469d55$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c01ca34426469d55$var$requestFormReset(form) {
    var formInst = $c01ca34426469d55$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c01ca34426469d55$var$requestFormReset$1(formInst) : $c01ca34426469d55$var$previousDispatcher.r(form);
}
var $c01ca34426469d55$var$globalDocument = "undefined" === typeof document ? null : document;
function $c01ca34426469d55$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c01ca34426469d55$var$preconnectsSet.has(limitedEscapedHref) || ($c01ca34426469d55$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c01ca34426469d55$var$setInitialProperties(href, "link", rel), $c01ca34426469d55$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c01ca34426469d55$var$prefetchDNS(href) {
    $c01ca34426469d55$var$previousDispatcher.D(href);
    $c01ca34426469d55$var$preconnectAs("dns-prefetch", href, null);
}
function $c01ca34426469d55$var$preconnect(href, crossOrigin) {
    $c01ca34426469d55$var$previousDispatcher.C(href, crossOrigin);
    $c01ca34426469d55$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c01ca34426469d55$var$preload(href, as, options) {
    $c01ca34426469d55$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c01ca34426469d55$var$getStyleKey(href);
                break;
            case "script":
                key = $c01ca34426469d55$var$getScriptKey(href);
        }
        $c01ca34426469d55$var$preloadPropsMap.has(key) || (href = $c01ca34426469d55$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c01ca34426469d55$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c01ca34426469d55$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c01ca34426469d55$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c01ca34426469d55$var$setInitialProperties(as, "link", href), $c01ca34426469d55$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c01ca34426469d55$var$preloadModule(href, options) {
    $c01ca34426469d55$var$previousDispatcher.m(href, options);
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c01ca34426469d55$var$getScriptKey(href);
        }
        if (!$c01ca34426469d55$var$preloadPropsMap.has(key) && (href = $c01ca34426469d55$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c01ca34426469d55$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c01ca34426469d55$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c01ca34426469d55$var$setInitialProperties(as, "link", href);
            $c01ca34426469d55$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c01ca34426469d55$var$preinitStyle(href, precedence, options) {
    $c01ca34426469d55$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c01ca34426469d55$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c01ca34426469d55$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c01ca34426469d55$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c01ca34426469d55$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c01ca34426469d55$var$preloadPropsMap.get(key)) && $c01ca34426469d55$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c01ca34426469d55$var$markNodeAsHoistable(link);
                $c01ca34426469d55$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c01ca34426469d55$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c01ca34426469d55$var$preinitScript(src, options) {
    $c01ca34426469d55$var$previousDispatcher.X(src, options);
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c01ca34426469d55$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c01ca34426469d55$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c01ca34426469d55$var$getScriptSelectorFromKey(key)), resource || (src = $c01ca34426469d55$var$assign({
            src: src,
            async: !0
        }, options), (options = $c01ca34426469d55$var$preloadPropsMap.get(key)) && $c01ca34426469d55$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c01ca34426469d55$var$markNodeAsHoistable(resource), $c01ca34426469d55$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c01ca34426469d55$var$preinitModuleScript(src, options) {
    $c01ca34426469d55$var$previousDispatcher.M(src, options);
    var ownerDocument = $c01ca34426469d55$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c01ca34426469d55$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c01ca34426469d55$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c01ca34426469d55$var$getScriptSelectorFromKey(key)), resource || (src = $c01ca34426469d55$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c01ca34426469d55$var$preloadPropsMap.get(key)) && $c01ca34426469d55$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c01ca34426469d55$var$markNodeAsHoistable(resource), $c01ca34426469d55$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c01ca34426469d55$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c01ca34426469d55$var$rootInstanceStackCursor.current) ? $c01ca34426469d55$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c01ca34426469d55$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c01ca34426469d55$var$getStyleKey(pendingProps.href), pendingProps = $c01ca34426469d55$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c01ca34426469d55$var$getStyleKey(pendingProps.href);
                var styles$242 = $c01ca34426469d55$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($c01ca34426469d55$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $c01ca34426469d55$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c01ca34426469d55$var$preloadPropsMap.set(type, pendingProps), styles$242 || $c01ca34426469d55$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($c01ca34426469d55$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($c01ca34426469d55$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $bJtXW._)(currentProps)) ? (currentProps = $c01ca34426469d55$var$getScriptKey(pendingProps), pendingProps = $c01ca34426469d55$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(444, type));
    }
}
function $c01ca34426469d55$var$getStyleKey(href) {
    return 'href="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c01ca34426469d55$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c01ca34426469d55$var$stylesheetPropsFromRawProps(rawProps) {
    return $c01ca34426469d55$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c01ca34426469d55$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c01ca34426469d55$var$setInitialProperties(key, "link", preloadProps), $c01ca34426469d55$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c01ca34426469d55$var$getScriptKey(src) {
    return '[src="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c01ca34426469d55$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c01ca34426469d55$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c01ca34426469d55$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c01ca34426469d55$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c01ca34426469d55$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c01ca34426469d55$var$markNodeAsHoistable(instance);
            $c01ca34426469d55$var$setInitialProperties(instance, "style", styleProps);
            $c01ca34426469d55$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c01ca34426469d55$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($c01ca34426469d55$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $c01ca34426469d55$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $c01ca34426469d55$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c01ca34426469d55$var$preloadPropsMap.get(styleProps)) && $c01ca34426469d55$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c01ca34426469d55$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c01ca34426469d55$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $c01ca34426469d55$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $c01ca34426469d55$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c01ca34426469d55$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $c01ca34426469d55$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c01ca34426469d55$var$preloadPropsMap.get(instance$248)) instance = $c01ca34426469d55$var$assign({}, props), $c01ca34426469d55$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c01ca34426469d55$var$markNodeAsHoistable(styleProps);
            $c01ca34426469d55$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c01ca34426469d55$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c01ca34426469d55$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c01ca34426469d55$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c01ca34426469d55$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c01ca34426469d55$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c01ca34426469d55$var$tagCaches = null;
function $c01ca34426469d55$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c01ca34426469d55$var$tagCaches) {
        var cache = new Map();
        var caches = $c01ca34426469d55$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c01ca34426469d55$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c01ca34426469d55$var$internalHoistableMarker] || node[$c01ca34426469d55$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c01ca34426469d55$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c01ca34426469d55$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $bJtXW._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c01ca34426469d55$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $c01ca34426469d55$var$suspendedState = null;
function $c01ca34426469d55$var$noop() {}
function $c01ca34426469d55$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $c01ca34426469d55$var$suspendedState) throw Error($c01ca34426469d55$var$formatProdErrorMessage(475));
    var state = $c01ca34426469d55$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c01ca34426469d55$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c01ca34426469d55$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $bJtXW._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $c01ca34426469d55$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c01ca34426469d55$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c01ca34426469d55$var$stylesheetPropsFromRawProps(props);
            (key = $c01ca34426469d55$var$preloadPropsMap.get(key)) && $c01ca34426469d55$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c01ca34426469d55$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c01ca34426469d55$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c01ca34426469d55$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $c01ca34426469d55$var$waitForCommitToBeReady() {
    if (null === $c01ca34426469d55$var$suspendedState) throw Error($c01ca34426469d55$var$formatProdErrorMessage(475));
    var state = $c01ca34426469d55$var$suspendedState;
    state.stylesheets && 0 === state.count && $c01ca34426469d55$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c01ca34426469d55$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $c01ca34426469d55$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $c01ca34426469d55$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c01ca34426469d55$var$precedencesByRoot = null;
function $c01ca34426469d55$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c01ca34426469d55$var$precedencesByRoot = new Map(), resources.forEach($c01ca34426469d55$var$insertStylesheetIntoRoot, state), $c01ca34426469d55$var$precedencesByRoot = null, $c01ca34426469d55$var$onUnsuspend.call(state));
}
function $c01ca34426469d55$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c01ca34426469d55$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c01ca34426469d55$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c01ca34426469d55$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c01ca34426469d55$var$HostTransitionContext = {
    $$typeof: $c01ca34426469d55$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c01ca34426469d55$var$sharedNotPendingObject,
    _currentValue2: $c01ca34426469d55$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c01ca34426469d55$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c01ca34426469d55$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c01ca34426469d55$var$createLaneMap(0);
    this.hiddenUpdates = $c01ca34426469d55$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c01ca34426469d55$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $c01ca34426469d55$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c01ca34426469d55$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c01ca34426469d55$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c01ca34426469d55$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c01ca34426469d55$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c01ca34426469d55$var$emptyContextObject;
    parentComponent = $c01ca34426469d55$var$emptyContextObject;
    return parentComponent;
}
function $c01ca34426469d55$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c01ca34426469d55$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c01ca34426469d55$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c01ca34426469d55$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c01ca34426469d55$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c01ca34426469d55$var$entangleTransitions(element, rootFiber, lane));
}
function $c01ca34426469d55$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c01ca34426469d55$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c01ca34426469d55$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c01ca34426469d55$var$markRetryLaneImpl(fiber, retryLane);
}
function $c01ca34426469d55$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c01ca34426469d55$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $c01ca34426469d55$var$_enabled = !0;
function $c01ca34426469d55$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T;
    $c01ca34426469d55$var$ReactSharedInternals.T = null;
    var previousPriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    try {
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = 2, $c01ca34426469d55$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousPriority, $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c01ca34426469d55$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c01ca34426469d55$var$ReactSharedInternals.T;
    $c01ca34426469d55$var$ReactSharedInternals.T = null;
    var previousPriority = $c01ca34426469d55$var$ReactDOMSharedInternals.p;
    try {
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = 8, $c01ca34426469d55$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c01ca34426469d55$var$ReactDOMSharedInternals.p = previousPriority, $c01ca34426469d55$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c01ca34426469d55$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c01ca34426469d55$var$_enabled) {
        var blockedOn = $c01ca34426469d55$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c01ca34426469d55$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c01ca34426469d55$var$return_targetInst, targetContainer), $c01ca34426469d55$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c01ca34426469d55$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c01ca34426469d55$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c01ca34426469d55$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c01ca34426469d55$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c01ca34426469d55$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c01ca34426469d55$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c01ca34426469d55$var$ensureRootIsScheduled(fiber);
                                0 === ($c01ca34426469d55$var$executionContext & 6) && ($c01ca34426469d55$var$workInProgressRootRenderTargetTime = $c01ca34426469d55$var$now() + 500, $c01ca34426469d55$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c01ca34426469d55$var$scheduleUpdateOnFiber(root, fiber, 2), $c01ca34426469d55$var$flushSyncWork$1(), $c01ca34426469d55$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c01ca34426469d55$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c01ca34426469d55$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c01ca34426469d55$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c01ca34426469d55$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c01ca34426469d55$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c01ca34426469d55$var$getEventTarget(nativeEvent);
    return $c01ca34426469d55$var$findInstanceBlockingTarget(nativeEvent);
}
var $c01ca34426469d55$var$return_targetInst = null;
function $c01ca34426469d55$var$findInstanceBlockingTarget(targetNode) {
    $c01ca34426469d55$var$return_targetInst = null;
    targetNode = $c01ca34426469d55$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c01ca34426469d55$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c01ca34426469d55$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c01ca34426469d55$var$return_targetInst = targetNode;
    return null;
}
function $c01ca34426469d55$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c01ca34426469d55$var$getCurrentPriorityLevel()){
                case $c01ca34426469d55$var$ImmediatePriority:
                    return 2;
                case $c01ca34426469d55$var$UserBlockingPriority:
                    return 8;
                case $c01ca34426469d55$var$NormalPriority$1:
                case $c01ca34426469d55$var$LowPriority:
                    return 32;
                case $c01ca34426469d55$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c01ca34426469d55$var$hasScheduledReplayAttempt = !1, $c01ca34426469d55$var$queuedFocus = null, $c01ca34426469d55$var$queuedDrag = null, $c01ca34426469d55$var$queuedMouse = null, $c01ca34426469d55$var$queuedPointers = new Map(), $c01ca34426469d55$var$queuedPointerCaptures = new Map(), $c01ca34426469d55$var$queuedExplicitHydrationTargets = [], $c01ca34426469d55$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c01ca34426469d55$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c01ca34426469d55$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c01ca34426469d55$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c01ca34426469d55$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c01ca34426469d55$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c01ca34426469d55$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c01ca34426469d55$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c01ca34426469d55$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c01ca34426469d55$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c01ca34426469d55$var$queuedFocus = $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent($c01ca34426469d55$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c01ca34426469d55$var$queuedDrag = $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent($c01ca34426469d55$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c01ca34426469d55$var$queuedMouse = $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent($c01ca34426469d55$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c01ca34426469d55$var$queuedPointers.set(pointerId, $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent($c01ca34426469d55$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c01ca34426469d55$var$queuedPointerCaptures.set(pointerId, $c01ca34426469d55$var$accumulateOrCreateContinuousQueuedReplayableEvent($c01ca34426469d55$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c01ca34426469d55$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c01ca34426469d55$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c01ca34426469d55$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c01ca34426469d55$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c01ca34426469d55$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $c01ca34426469d55$var$requestUpdateLane(), root = $c01ca34426469d55$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $c01ca34426469d55$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $c01ca34426469d55$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c01ca34426469d55$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c01ca34426469d55$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c01ca34426469d55$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c01ca34426469d55$var$currentReplayingEvent = null;
        } else return targetContainers = $c01ca34426469d55$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c01ca34426469d55$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c01ca34426469d55$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c01ca34426469d55$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c01ca34426469d55$var$replayUnblockedEvents() {
    $c01ca34426469d55$var$hasScheduledReplayAttempt = !1;
    null !== $c01ca34426469d55$var$queuedFocus && $c01ca34426469d55$var$attemptReplayContinuousQueuedEvent($c01ca34426469d55$var$queuedFocus) && ($c01ca34426469d55$var$queuedFocus = null);
    null !== $c01ca34426469d55$var$queuedDrag && $c01ca34426469d55$var$attemptReplayContinuousQueuedEvent($c01ca34426469d55$var$queuedDrag) && ($c01ca34426469d55$var$queuedDrag = null);
    null !== $c01ca34426469d55$var$queuedMouse && $c01ca34426469d55$var$attemptReplayContinuousQueuedEvent($c01ca34426469d55$var$queuedMouse) && ($c01ca34426469d55$var$queuedMouse = null);
    $c01ca34426469d55$var$queuedPointers.forEach($c01ca34426469d55$var$attemptReplayContinuousQueuedEventInMap);
    $c01ca34426469d55$var$queuedPointerCaptures.forEach($c01ca34426469d55$var$attemptReplayContinuousQueuedEventInMap);
}
function $c01ca34426469d55$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c01ca34426469d55$var$hasScheduledReplayAttempt || ($c01ca34426469d55$var$hasScheduledReplayAttempt = !0, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, $c01ca34426469d55$var$replayUnblockedEvents)));
}
var $c01ca34426469d55$var$lastScheduledReplayQueue = null;
function $c01ca34426469d55$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c01ca34426469d55$var$lastScheduledReplayQueue !== formReplayingQueue && ($c01ca34426469d55$var$lastScheduledReplayQueue = formReplayingQueue, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, function() {
        $c01ca34426469d55$var$lastScheduledReplayQueue === formReplayingQueue && ($c01ca34426469d55$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c01ca34426469d55$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c01ca34426469d55$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c01ca34426469d55$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c01ca34426469d55$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c01ca34426469d55$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c01ca34426469d55$var$queuedFocus && $c01ca34426469d55$var$scheduleCallbackIfUnblocked($c01ca34426469d55$var$queuedFocus, unblocked);
    null !== $c01ca34426469d55$var$queuedDrag && $c01ca34426469d55$var$scheduleCallbackIfUnblocked($c01ca34426469d55$var$queuedDrag, unblocked);
    null !== $c01ca34426469d55$var$queuedMouse && $c01ca34426469d55$var$scheduleCallbackIfUnblocked($c01ca34426469d55$var$queuedMouse, unblocked);
    $c01ca34426469d55$var$queuedPointers.forEach(unblock);
    $c01ca34426469d55$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c01ca34426469d55$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c01ca34426469d55$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c01ca34426469d55$var$queuedExplicitHydrationTargets.length && (i = $c01ca34426469d55$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c01ca34426469d55$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c01ca34426469d55$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c01ca34426469d55$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c01ca34426469d55$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c01ca34426469d55$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c01ca34426469d55$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c01ca34426469d55$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c01ca34426469d55$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c01ca34426469d55$var$ReactDOMHydrationRoot.prototype.render = $c01ca34426469d55$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c01ca34426469d55$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c01ca34426469d55$var$requestUpdateLane();
    $c01ca34426469d55$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c01ca34426469d55$var$ReactDOMHydrationRoot.prototype.unmount = $c01ca34426469d55$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $c01ca34426469d55$var$flushPassiveEffects();
        $c01ca34426469d55$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c01ca34426469d55$var$flushSyncWork$1();
        container[$c01ca34426469d55$var$internalContainerInstanceKey] = null;
    }
};
function $c01ca34426469d55$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c01ca34426469d55$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c01ca34426469d55$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c01ca34426469d55$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c01ca34426469d55$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c01ca34426469d55$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c01ca34426469d55$var$attemptExplicitHydrationTarget(target);
    }
};
var $c01ca34426469d55$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $dQFEZ.version;
if ("19.0.0" !== $c01ca34426469d55$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($c01ca34426469d55$var$formatProdErrorMessage(527, $c01ca34426469d55$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$c01ca34426469d55$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c01ca34426469d55$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c01ca34426469d55$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c01ca34426469d55$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c01ca34426469d55$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c01ca34426469d55$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c01ca34426469d55$var$ReactSharedInternals,
    findFiberByHostInstance: $c01ca34426469d55$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c01ca34426469d55$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c01ca34426469d55$var$hook$jscomp$inline_2166.isDisabled && $c01ca34426469d55$var$hook$jscomp$inline_2166.supportsFiber) try {
        $c01ca34426469d55$var$rendererID = $c01ca34426469d55$var$hook$jscomp$inline_2166.inject($c01ca34426469d55$var$internals$jscomp$inline_2165), $c01ca34426469d55$var$injectedHook = $c01ca34426469d55$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$c01ca34426469d55$export$882461b6382ed46c = function(container, options) {
    if (!$c01ca34426469d55$var$isValidContainer(container)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c01ca34426469d55$var$defaultOnUncaughtError, onCaughtError = $c01ca34426469d55$var$defaultOnCaughtError, onRecoverableError = $c01ca34426469d55$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $c01ca34426469d55$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$c01ca34426469d55$var$internalContainerInstanceKey] = options.current;
    $c01ca34426469d55$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $c01ca34426469d55$var$ReactDOMRoot(options);
};
$c01ca34426469d55$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c01ca34426469d55$var$isValidContainer(container)) throw Error($c01ca34426469d55$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c01ca34426469d55$var$defaultOnUncaughtError, onCaughtError = $c01ca34426469d55$var$defaultOnCaughtError, onRecoverableError = $c01ca34426469d55$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c01ca34426469d55$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $c01ca34426469d55$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c01ca34426469d55$var$requestUpdateLane();
    identifierPrefix = $c01ca34426469d55$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c01ca34426469d55$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $c01ca34426469d55$var$markRootUpdated$1(initialChildren, isStrictMode);
    $c01ca34426469d55$var$ensureRootIsScheduled(initialChildren);
    container[$c01ca34426469d55$var$internalContainerInstanceKey] = initialChildren.current;
    $c01ca34426469d55$var$listenToAllSupportedEvents(container);
    return new $c01ca34426469d55$var$ReactDOMHydrationRoot(initialChildren);
};
$c01ca34426469d55$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("1iyD5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4LMr0"));

});
parcelRegister("4LMr0", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $37911f502aafc14a$export$c4744153514ff05d; }, function (v) { return $37911f502aafc14a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $37911f502aafc14a$export$3e506c1ccc9cc1a7; }, function (v) { return $37911f502aafc14a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $37911f502aafc14a$export$e26fe2ed2fa76875; }, function (v) { return $37911f502aafc14a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $37911f502aafc14a$export$502329bbf4b505b1; }, function (v) { return $37911f502aafc14a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $37911f502aafc14a$export$6e3807111c4874c4; }, function (v) { return $37911f502aafc14a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $37911f502aafc14a$export$c27134553091fb3a; }, function (v) { return $37911f502aafc14a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $37911f502aafc14a$export$33ee1acdc04fd2a2; }, function (v) { return $37911f502aafc14a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $37911f502aafc14a$export$b00a404bbd5edef2; }, function (v) { return $37911f502aafc14a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $37911f502aafc14a$export$8352ce38b91d0c62; }, function (v) { return $37911f502aafc14a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $37911f502aafc14a$export$d66a1c1c77bd778b; }, function (v) { return $37911f502aafc14a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $37911f502aafc14a$export$d3dfb8e4810cb555; }, function (v) { return $37911f502aafc14a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $37911f502aafc14a$export$839f9183b0465a69; }, function (v) { return $37911f502aafc14a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $37911f502aafc14a$export$72fdf0e06517287b; }, function (v) { return $37911f502aafc14a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $37911f502aafc14a$export$4b844e58a3e414b4; }, function (v) { return $37911f502aafc14a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $37911f502aafc14a$export$816d2913ae6b83b1; }, function (v) { return $37911f502aafc14a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $37911f502aafc14a$export$61bcfe829111a1d0; }, function (v) { return $37911f502aafc14a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $37911f502aafc14a$export$7ee8c9beb337bc3f; }, function (v) { return $37911f502aafc14a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $37911f502aafc14a$export$b5836b71941fa3ed; }, function (v) { return $37911f502aafc14a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $37911f502aafc14a$export$cf845f2c119da08a; }, function (v) { return $37911f502aafc14a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $37911f502aafc14a$export$c4744153514ff05d;
var $37911f502aafc14a$export$3e506c1ccc9cc1a7;
var $37911f502aafc14a$export$e26fe2ed2fa76875;
var $37911f502aafc14a$export$502329bbf4b505b1;
var $37911f502aafc14a$export$6e3807111c4874c4;
var $37911f502aafc14a$export$c27134553091fb3a;
var $37911f502aafc14a$export$33ee1acdc04fd2a2;
var $37911f502aafc14a$export$b00a404bbd5edef2;
var $37911f502aafc14a$export$8352ce38b91d0c62;
var $37911f502aafc14a$export$d66a1c1c77bd778b;
var $37911f502aafc14a$export$d3dfb8e4810cb555;
var $37911f502aafc14a$export$839f9183b0465a69;
var $37911f502aafc14a$export$72fdf0e06517287b;
var $37911f502aafc14a$export$4b844e58a3e414b4;
var $37911f502aafc14a$export$816d2913ae6b83b1;
var $37911f502aafc14a$export$61bcfe829111a1d0;
var $37911f502aafc14a$export$7ee8c9beb337bc3f;
var $37911f502aafc14a$export$b5836b71941fa3ed;
var $37911f502aafc14a$export$cf845f2c119da08a;
"use strict";
function $37911f502aafc14a$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $37911f502aafc14a$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $37911f502aafc14a$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $37911f502aafc14a$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $37911f502aafc14a$var$compare(left, last)) rightIndex < length && 0 > $37911f502aafc14a$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $37911f502aafc14a$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $37911f502aafc14a$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$37911f502aafc14a$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $bJtXW._)(performance)) && "function" === typeof performance.now) {
    var $37911f502aafc14a$var$localPerformance = performance;
    $37911f502aafc14a$export$c4744153514ff05d = function() {
        return $37911f502aafc14a$var$localPerformance.now();
    };
} else {
    var $37911f502aafc14a$var$localDate = Date, $37911f502aafc14a$var$initialTime = $37911f502aafc14a$var$localDate.now();
    $37911f502aafc14a$export$c4744153514ff05d = function() {
        return $37911f502aafc14a$var$localDate.now() - $37911f502aafc14a$var$initialTime;
    };
}
var $37911f502aafc14a$var$taskQueue = [], $37911f502aafc14a$var$timerQueue = [], $37911f502aafc14a$var$taskIdCounter = 1, $37911f502aafc14a$var$currentTask = null, $37911f502aafc14a$var$currentPriorityLevel = 3, $37911f502aafc14a$var$isPerformingWork = !1, $37911f502aafc14a$var$isHostCallbackScheduled = !1, $37911f502aafc14a$var$isHostTimeoutScheduled = !1, $37911f502aafc14a$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $37911f502aafc14a$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $37911f502aafc14a$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $37911f502aafc14a$var$advanceTimers(currentTime) {
    for(var timer = $37911f502aafc14a$var$peek($37911f502aafc14a$var$timerQueue); null !== timer;){
        if (null === timer.callback) $37911f502aafc14a$var$pop($37911f502aafc14a$var$timerQueue);
        else if (timer.startTime <= currentTime) $37911f502aafc14a$var$pop($37911f502aafc14a$var$timerQueue), timer.sortIndex = timer.expirationTime, $37911f502aafc14a$var$push($37911f502aafc14a$var$taskQueue, timer);
        else break;
        timer = $37911f502aafc14a$var$peek($37911f502aafc14a$var$timerQueue);
    }
}
function $37911f502aafc14a$var$handleTimeout(currentTime) {
    $37911f502aafc14a$var$isHostTimeoutScheduled = !1;
    $37911f502aafc14a$var$advanceTimers(currentTime);
    if (!$37911f502aafc14a$var$isHostCallbackScheduled) {
        if (null !== $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue)) $37911f502aafc14a$var$isHostCallbackScheduled = !0, $37911f502aafc14a$var$requestHostCallback();
        else {
            var firstTimer = $37911f502aafc14a$var$peek($37911f502aafc14a$var$timerQueue);
            null !== firstTimer && $37911f502aafc14a$var$requestHostTimeout($37911f502aafc14a$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $37911f502aafc14a$var$isMessageLoopRunning = !1, $37911f502aafc14a$var$taskTimeoutID = -1, $37911f502aafc14a$var$frameInterval = 5, $37911f502aafc14a$var$startTime = -1;
function $37911f502aafc14a$var$shouldYieldToHost() {
    return $37911f502aafc14a$export$c4744153514ff05d() - $37911f502aafc14a$var$startTime < $37911f502aafc14a$var$frameInterval ? !1 : !0;
}
function $37911f502aafc14a$var$performWorkUntilDeadline() {
    if ($37911f502aafc14a$var$isMessageLoopRunning) {
        var currentTime = $37911f502aafc14a$export$c4744153514ff05d();
        $37911f502aafc14a$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $37911f502aafc14a$var$isHostCallbackScheduled = !1;
                $37911f502aafc14a$var$isHostTimeoutScheduled && ($37911f502aafc14a$var$isHostTimeoutScheduled = !1, $37911f502aafc14a$var$localClearTimeout($37911f502aafc14a$var$taskTimeoutID), $37911f502aafc14a$var$taskTimeoutID = -1);
                $37911f502aafc14a$var$isPerformingWork = !0;
                var previousPriorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
                try {
                    b: {
                        $37911f502aafc14a$var$advanceTimers(currentTime);
                        for($37911f502aafc14a$var$currentTask = $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue); null !== $37911f502aafc14a$var$currentTask && !($37911f502aafc14a$var$currentTask.expirationTime > currentTime && $37911f502aafc14a$var$shouldYieldToHost());){
                            var callback = $37911f502aafc14a$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $37911f502aafc14a$var$currentTask.callback = null;
                                $37911f502aafc14a$var$currentPriorityLevel = $37911f502aafc14a$var$currentTask.priorityLevel;
                                var continuationCallback = callback($37911f502aafc14a$var$currentTask.expirationTime <= currentTime);
                                currentTime = $37911f502aafc14a$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $37911f502aafc14a$var$currentTask.callback = continuationCallback;
                                    $37911f502aafc14a$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $37911f502aafc14a$var$currentTask === $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue) && $37911f502aafc14a$var$pop($37911f502aafc14a$var$taskQueue);
                                $37911f502aafc14a$var$advanceTimers(currentTime);
                            } else $37911f502aafc14a$var$pop($37911f502aafc14a$var$taskQueue);
                            $37911f502aafc14a$var$currentTask = $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue);
                        }
                        if (null !== $37911f502aafc14a$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $37911f502aafc14a$var$peek($37911f502aafc14a$var$timerQueue);
                            null !== firstTimer && $37911f502aafc14a$var$requestHostTimeout($37911f502aafc14a$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $37911f502aafc14a$var$currentTask = null, $37911f502aafc14a$var$currentPriorityLevel = previousPriorityLevel, $37911f502aafc14a$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $37911f502aafc14a$var$schedulePerformWorkUntilDeadline() : $37911f502aafc14a$var$isMessageLoopRunning = !1;
        }
    }
}
var $37911f502aafc14a$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $37911f502aafc14a$var$localSetImmediate) $37911f502aafc14a$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $37911f502aafc14a$var$localSetImmediate($37911f502aafc14a$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $37911f502aafc14a$var$channel = new MessageChannel(), $37911f502aafc14a$var$port = $37911f502aafc14a$var$channel.port2;
    $37911f502aafc14a$var$channel.port1.onmessage = $37911f502aafc14a$var$performWorkUntilDeadline;
    $37911f502aafc14a$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $37911f502aafc14a$var$port.postMessage(null);
    };
} else $37911f502aafc14a$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $37911f502aafc14a$var$localSetTimeout($37911f502aafc14a$var$performWorkUntilDeadline, 0);
};
function $37911f502aafc14a$var$requestHostCallback() {
    $37911f502aafc14a$var$isMessageLoopRunning || ($37911f502aafc14a$var$isMessageLoopRunning = !0, $37911f502aafc14a$var$schedulePerformWorkUntilDeadline());
}
function $37911f502aafc14a$var$requestHostTimeout(callback, ms) {
    $37911f502aafc14a$var$taskTimeoutID = $37911f502aafc14a$var$localSetTimeout(function() {
        callback($37911f502aafc14a$export$c4744153514ff05d());
    }, ms);
}
$37911f502aafc14a$export$3e506c1ccc9cc1a7 = 5;
$37911f502aafc14a$export$e26fe2ed2fa76875 = 1;
$37911f502aafc14a$export$502329bbf4b505b1 = 4;
$37911f502aafc14a$export$6e3807111c4874c4 = 3;
$37911f502aafc14a$export$c27134553091fb3a = null;
$37911f502aafc14a$export$33ee1acdc04fd2a2 = 2;
$37911f502aafc14a$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$37911f502aafc14a$export$8352ce38b91d0c62 = function() {
    $37911f502aafc14a$var$isHostCallbackScheduled || $37911f502aafc14a$var$isPerformingWork || ($37911f502aafc14a$var$isHostCallbackScheduled = !0, $37911f502aafc14a$var$requestHostCallback());
};
$37911f502aafc14a$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $37911f502aafc14a$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$37911f502aafc14a$export$d3dfb8e4810cb555 = function() {
    return $37911f502aafc14a$var$currentPriorityLevel;
};
$37911f502aafc14a$export$839f9183b0465a69 = function() {
    return $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue);
};
$37911f502aafc14a$export$72fdf0e06517287b = function(eventHandler) {
    switch($37911f502aafc14a$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
    $37911f502aafc14a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $37911f502aafc14a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$37911f502aafc14a$export$4b844e58a3e414b4 = function() {};
$37911f502aafc14a$export$816d2913ae6b83b1 = function() {};
$37911f502aafc14a$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
    $37911f502aafc14a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $37911f502aafc14a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$37911f502aafc14a$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $37911f502aafc14a$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $bJtXW._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $37911f502aafc14a$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $37911f502aafc14a$var$push($37911f502aafc14a$var$timerQueue, priorityLevel), null === $37911f502aafc14a$var$peek($37911f502aafc14a$var$taskQueue) && priorityLevel === $37911f502aafc14a$var$peek($37911f502aafc14a$var$timerQueue) && ($37911f502aafc14a$var$isHostTimeoutScheduled ? ($37911f502aafc14a$var$localClearTimeout($37911f502aafc14a$var$taskTimeoutID), $37911f502aafc14a$var$taskTimeoutID = -1) : $37911f502aafc14a$var$isHostTimeoutScheduled = !0, $37911f502aafc14a$var$requestHostTimeout($37911f502aafc14a$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $37911f502aafc14a$var$push($37911f502aafc14a$var$taskQueue, priorityLevel), $37911f502aafc14a$var$isHostCallbackScheduled || $37911f502aafc14a$var$isPerformingWork || ($37911f502aafc14a$var$isHostCallbackScheduled = !0, $37911f502aafc14a$var$requestHostCallback()));
    return priorityLevel;
};
$37911f502aafc14a$export$b5836b71941fa3ed = $37911f502aafc14a$var$shouldYieldToHost;
$37911f502aafc14a$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $37911f502aafc14a$var$currentPriorityLevel;
        $37911f502aafc14a$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $37911f502aafc14a$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("5Ia9Q", function(module, exports) {
'use strict';
function $4288f0eb191085d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4288f0eb191085d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4288f0eb191085d1$var$checkDCE();

module.exports = (parcelRequire("iBaip"));

});
parcelRegister("iBaip", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $d8a3ab42aab19d45$export$69ce8ef3fe5cead0; }, function (v) { return $d8a3ab42aab19d45$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $d8a3ab42aab19d45$export$d39a5bbd09211389; }, function (v) { return $d8a3ab42aab19d45$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d8a3ab42aab19d45$export$cd75ccfd720a3cd4; }, function (v) { return $d8a3ab42aab19d45$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $d8a3ab42aab19d45$export$a0816fa17a9e79be; }, function (v) { return $d8a3ab42aab19d45$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $d8a3ab42aab19d45$export$7292efcadded39f3; }, function (v) { return $d8a3ab42aab19d45$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $d8a3ab42aab19d45$export$da407abadb9b8f86; }, function (v) { return $d8a3ab42aab19d45$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $d8a3ab42aab19d45$export$314cfea32580671c; }, function (v) { return $d8a3ab42aab19d45$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $d8a3ab42aab19d45$export$513ccb98c53b8039; }, function (v) { return $d8a3ab42aab19d45$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $d8a3ab42aab19d45$export$dbca993bc2d264a; }, function (v) { return $d8a3ab42aab19d45$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $d8a3ab42aab19d45$export$4797a8006f0655d0; }, function (v) { return $d8a3ab42aab19d45$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d8a3ab42aab19d45$export$c78a37762a8d58e1; }, function (v) { return $d8a3ab42aab19d45$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $d8a3ab42aab19d45$export$606f11b2eb45ecc6; }, function (v) { return $d8a3ab42aab19d45$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $d8a3ab42aab19d45$export$f7e8a0bf92324b1e; }, function (v) { return $d8a3ab42aab19d45$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $d8a3ab42aab19d45$export$83d89fbfd8236492; }, function (v) { return $d8a3ab42aab19d45$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $d8a3ab42aab19d45$export$69ce8ef3fe5cead0;
var $d8a3ab42aab19d45$export$d39a5bbd09211389;
var $d8a3ab42aab19d45$export$cd75ccfd720a3cd4;
var $d8a3ab42aab19d45$export$a0816fa17a9e79be;
var $d8a3ab42aab19d45$export$7292efcadded39f3;
var $d8a3ab42aab19d45$export$da407abadb9b8f86;
var $d8a3ab42aab19d45$export$314cfea32580671c;
var $d8a3ab42aab19d45$export$513ccb98c53b8039;
var $d8a3ab42aab19d45$export$dbca993bc2d264a;
var $d8a3ab42aab19d45$export$4797a8006f0655d0;
var $d8a3ab42aab19d45$export$c78a37762a8d58e1;
var $d8a3ab42aab19d45$export$606f11b2eb45ecc6;
var $d8a3ab42aab19d45$export$f7e8a0bf92324b1e;
var $d8a3ab42aab19d45$export$83d89fbfd8236492;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
function $d8a3ab42aab19d45$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d8a3ab42aab19d45$var$noop() {}
var $d8a3ab42aab19d45$var$Internals = {
    d: {
        f: $d8a3ab42aab19d45$var$noop,
        r: function r() {
            throw Error($d8a3ab42aab19d45$var$formatProdErrorMessage(522));
        },
        D: $d8a3ab42aab19d45$var$noop,
        C: $d8a3ab42aab19d45$var$noop,
        L: $d8a3ab42aab19d45$var$noop,
        m: $d8a3ab42aab19d45$var$noop,
        X: $d8a3ab42aab19d45$var$noop,
        S: $d8a3ab42aab19d45$var$noop,
        M: $d8a3ab42aab19d45$var$noop
    },
    p: 0,
    findDOMNode: null
}, $d8a3ab42aab19d45$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $d8a3ab42aab19d45$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d8a3ab42aab19d45$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $d8a3ab42aab19d45$var$ReactSharedInternals = $dQFEZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $d8a3ab42aab19d45$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$d8a3ab42aab19d45$export$69ce8ef3fe5cead0 = $d8a3ab42aab19d45$var$Internals;
$d8a3ab42aab19d45$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($d8a3ab42aab19d45$var$formatProdErrorMessage(299));
    return $d8a3ab42aab19d45$var$createPortal$1(children, container, null, key);
};
$d8a3ab42aab19d45$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $d8a3ab42aab19d45$var$ReactSharedInternals.T, previousUpdatePriority = $d8a3ab42aab19d45$var$Internals.p;
    try {
        if ($d8a3ab42aab19d45$var$ReactSharedInternals.T = null, $d8a3ab42aab19d45$var$Internals.p = 2, fn) return fn();
    } finally{
        $d8a3ab42aab19d45$var$ReactSharedInternals.T = previousTransition, $d8a3ab42aab19d45$var$Internals.p = previousUpdatePriority, $d8a3ab42aab19d45$var$Internals.d.f();
    }
};
$d8a3ab42aab19d45$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $d8a3ab42aab19d45$var$Internals.d.C(href, options));
};
$d8a3ab42aab19d45$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $d8a3ab42aab19d45$var$Internals.d.D(href);
};
$d8a3ab42aab19d45$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d8a3ab42aab19d45$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $d8a3ab42aab19d45$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $d8a3ab42aab19d45$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$d8a3ab42aab19d45$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $bJtXW._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $d8a3ab42aab19d45$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $d8a3ab42aab19d45$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $d8a3ab42aab19d45$var$Internals.d.M(href);
    }
};
$d8a3ab42aab19d45$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $bJtXW._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d8a3ab42aab19d45$var$getCrossOriginStringAs(as, options.crossOrigin);
        $d8a3ab42aab19d45$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$d8a3ab42aab19d45$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $d8a3ab42aab19d45$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $d8a3ab42aab19d45$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $d8a3ab42aab19d45$var$Internals.d.m(href);
    }
};
$d8a3ab42aab19d45$export$4797a8006f0655d0 = function(form) {
    $d8a3ab42aab19d45$var$Internals.d.r(form);
};
$d8a3ab42aab19d45$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$d8a3ab42aab19d45$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $d8a3ab42aab19d45$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$d8a3ab42aab19d45$export$f7e8a0bf92324b1e = function() {
    return $d8a3ab42aab19d45$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$d8a3ab42aab19d45$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("lEL1W", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $fc41d09ddc03e3ec$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $fc41d09ddc03e3ec$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("c2rik")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("c2rik")).useNavigate; });
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $grujF = parcelRequire("grujF");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $dQFEZ = parcelRequire("dQFEZ");

var $5Ia9Q = parcelRequire("5Ia9Q");

var $gl7zH = parcelRequire("gl7zH");
var $c2rik = parcelRequire("c2rik");

var $gl7zH = parcelRequire("gl7zH");
function $fc41d09ddc03e3ec$var$_extends() {
    $fc41d09ddc03e3ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc41d09ddc03e3ec$var$_extends.apply(this, arguments);
}
function $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fc41d09ddc03e3ec$var$defaultMethod = "get";
var $fc41d09ddc03e3ec$var$defaultEncType = "application/x-www-form-urlencoded";
function $fc41d09ddc03e3ec$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fc41d09ddc03e3ec$var$isButtonElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fc41d09ddc03e3ec$var$isFormElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fc41d09ddc03e3ec$var$isInputElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fc41d09ddc03e3ec$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fc41d09ddc03e3ec$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fc41d09ddc03e3ec$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = null;
function $fc41d09ddc03e3ec$var$isFormDataSubmitterSupported() {
    if ($fc41d09ddc03e3ec$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = true;
    }
    return $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter;
}
var $fc41d09ddc03e3ec$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fc41d09ddc03e3ec$var$getFormEncType(encType) {
    if (encType != null && !$fc41d09ddc03e3ec$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fc41d09ddc03e3ec$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $gl7zH.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fc41d09ddc03e3ec$var$isButtonElement(target) || $fc41d09ddc03e3ec$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $gl7zH.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("formenctype")) || $fc41d09ddc03e3ec$var$getFormEncType(form.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fc41d09ddc03e3ec$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fc41d09ddc03e3ec$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fc41d09ddc03e3ec$var$defaultMethod;
        action = null;
        encType = $fc41d09ddc03e3ec$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fc41d09ddc03e3ec$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fc41d09ddc03e3ec$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fc41d09ddc03e3ec$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fc41d09ddc03e3ec$export$1f3f55432a00e06d(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c2rik.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $c2rik.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fc41d09ddc03e3ec$var$_extends({}, state, {
        errors: $fc41d09ddc03e3ec$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fc41d09ddc03e3ec$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $gl7zH.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $fc41d09ddc03e3ec$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dQFEZ.createContext({
    isTransitioning: false
});
var $fc41d09ddc03e3ec$export$148fd98d095596d4 = /*#__PURE__*/ $dQFEZ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fc41d09ddc03e3ec$var$START_TRANSITION = "startTransition";
var $fc41d09ddc03e3ec$var$startTransitionImpl = $dQFEZ[$fc41d09ddc03e3ec$var$START_TRANSITION];
var $fc41d09ddc03e3ec$var$FLUSH_SYNC = "flushSync";
var $fc41d09ddc03e3ec$var$flushSyncImpl = $5Ia9Q[$fc41d09ddc03e3ec$var$FLUSH_SYNC];
var $fc41d09ddc03e3ec$var$USE_ID = "useId";
var $fc41d09ddc03e3ec$var$useIdImpl = $dQFEZ[$fc41d09ddc03e3ec$var$USE_ID];
function $fc41d09ddc03e3ec$var$startTransitionSafe(cb) {
    if ($fc41d09ddc03e3ec$var$startTransitionImpl) $fc41d09ddc03e3ec$var$startTransitionImpl(cb);
    else cb();
}
function $fc41d09ddc03e3ec$var$flushSyncSafe(cb) {
    if ($fc41d09ddc03e3ec$var$flushSyncImpl) $fc41d09ddc03e3ec$var$flushSyncImpl(cb);
    else cb();
}
var $fc41d09ddc03e3ec$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $grujF._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fc41d09ddc03e3ec$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $2nwvT._)($dQFEZ.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $2nwvT._)($dQFEZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $2nwvT._)($dQFEZ.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $2nwvT._)($dQFEZ.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $2nwvT._)($dQFEZ.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $dQFEZ.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $dQFEZ.useCallback(function(cb) {
        if (v7_startTransition) $fc41d09ddc03e3ec$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $dQFEZ.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dQFEZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fc41d09ddc03e3ec$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $g3gsR._)(function() {
                return (0, $fRv9I.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dQFEZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $dQFEZ.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $c2rik.UNSAFE_logV6DeprecationWarnings)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $fc41d09ddc03e3ec$var$MemoizedDataRoutes = /*#__PURE__*/ $dQFEZ.memo($fc41d09ddc03e3ec$var$DataRoutes);
function $fc41d09ddc03e3ec$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $c2rik.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fc41d09ddc03e3ec$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $c2rik.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fc41d09ddc03e3ec$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $c2rik.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fc41d09ddc03e3ec$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $c2rik.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $c2rik.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $fc41d09ddc03e3ec$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dQFEZ.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref7, $fc41d09ddc03e3ec$var$_excluded);
    var basename = $dQFEZ.useContext((0, $c2rik.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fc41d09ddc03e3ec$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $gl7zH.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $c2rik.useHref)(to, {
        relative: relative
    });
    var internalOnClick = $fc41d09ddc03e3ec$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dQFEZ.createElement("a", $fc41d09ddc03e3ec$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dQFEZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref8, $fc41d09ddc03e3ec$var$_excluded2);
    var path = (0, $c2rik.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, $c2rik.useLocation)();
    var routerState = $dQFEZ.useContext((0, $c2rik.UNSAFE_DataRouterStateContext));
    var _React_useContext = $dQFEZ.useContext((0, $c2rik.UNSAFE_NavigationContext)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fc41d09ddc03e3ec$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $gl7zH.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a6c7ac8248d6e38a, $fc41d09ddc03e3ec$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fc41d09ddc03e3ec$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dQFEZ.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $fc41d09ddc03e3ec$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref9, $fc41d09ddc03e3ec$var$_excluded3);
    var submit = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var formAction = $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dQFEZ.createElement("form", $fc41d09ddc03e3ec$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fc41d09ddc03e3ec$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $fc41d09ddc03e3ec$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fc41d09ddc03e3ec$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fc41d09ddc03e3ec$var$DataRouterHook || ($fc41d09ddc03e3ec$var$DataRouterHook = {}));
var $fc41d09ddc03e3ec$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fc41d09ddc03e3ec$var$DataRouterStateHook || ($fc41d09ddc03e3ec$var$DataRouterStateHook = {}));
// Internal hooks
function $fc41d09ddc03e3ec$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fc41d09ddc03e3ec$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext((0, $c2rik.UNSAFE_DataRouterContext));
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $fc41d09ddc03e3ec$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext((0, $c2rik.UNSAFE_DataRouterStateContext));
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fc41d09ddc03e3ec$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $c2rik.useNavigate)();
    var location = (0, $c2rik.useLocation)();
    var path = (0, $c2rik.useResolvedPath)(to, {
        relative: relative
    });
    return $dQFEZ.useCallback(function(event) {
        if ($fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $gl7zH.createPath)(location) === (0, $gl7zH.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fc41d09ddc03e3ec$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $dQFEZ.useRef($fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $dQFEZ.useRef(false);
    var location = (0, $c2rik.useLocation)();
    var searchParams = $dQFEZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fc41d09ddc03e3ec$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $c2rik.useNavigate)();
    var setSearchParams = $dQFEZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fc41d09ddc03e3ec$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $fc41d09ddc03e3ec$var$fetcherId = 0;
var $fc41d09ddc03e3ec$var$getUniqueFetcherId = function() {
    return "__" + String(++$fc41d09ddc03e3ec$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fc41d09ddc03e3ec$export$47c85c6e3a081d3() {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmit).router;
    var basename = $dQFEZ.useContext((0, $c2rik.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, $c2rik.UNSAFE_useRouteId)();
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $fc41d09ddc03e3ec$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $dQFEZ.useContext((0, $c2rik.UNSAFE_NavigationContext)).basename;
    var routeContext = $dQFEZ.useContext((0, $c2rik.UNSAFE_RouteContext));
    !routeContext && (0, $gl7zH.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $2nwvT._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fc41d09ddc03e3ec$var$_extends({}, (0, $c2rik.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $c2rik.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $gl7zH.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fc41d09ddc03e3ec$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseFetcher).router;
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $dQFEZ.useContext($fc41d09ddc03e3ec$export$148fd98d095596d4);
    var route = $dQFEZ.useContext((0, $c2rik.UNSAFE_RouteContext));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $gl7zH.UNSAFE_invariant)(false);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $fc41d09ddc03e3ec$var$useIdImpl ? $fc41d09ddc03e3ec$var$useIdImpl() : "";
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fc41d09ddc03e3ec$var$getUniqueFetcherId());
    // Registration/cleanup
    $dQFEZ.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $dQFEZ.useCallback(function(href, opts) {
        !routeId && (0, $gl7zH.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var submit = $dQFEZ.useCallback(function(target, opts) {
        submitImpl(target, $fc41d09ddc03e3ec$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $dQFEZ.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a7fed597f4b8afd8, $fc41d09ddc03e3ec$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $gl7zH.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $dQFEZ.useMemo(function() {
        return $fc41d09ddc03e3ec$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fc41d09ddc03e3ec$export$fa996778a3a31087() {
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $2nwvT._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $fc41d09ddc03e3ec$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fc41d09ddc03e3ec$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fc41d09ddc03e3ec$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $dQFEZ.useContext((0, $c2rik.UNSAFE_NavigationContext)).basename;
    var location = (0, $c2rik.useLocation)();
    var matches = (0, $c2rik.useMatches)();
    var navigation = (0, $c2rik.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $dQFEZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fc41d09ddc03e3ec$var$usePageHide($dQFEZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fc41d09ddc03e3ec$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fc41d09ddc03e3ec$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fc41d09ddc03e3ec$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fc41d09ddc03e3ec$var$_extends({}, location, {
                    pathname: (0, $gl7zH.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fc41d09ddc03e3ec$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fc41d09ddc03e3ec$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $c2rik.useBlocker)(when);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fc41d09ddc03e3ec$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $dQFEZ.useContext($fc41d09ddc03e3ec$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    var basename = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $c2rik.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $gl7zH.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $gl7zH.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $gl7zH.matchPath)(path.pathname, nextPath) != null || (0, $gl7zH.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("g3gsR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $baf9b2a64fedef68$export$71511d61b312f219; });
function $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $baf9b2a64fedef68$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("grujF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf86af1e5034cb56$export$71511d61b312f219; });
function $bf86af1e5034cb56$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fRv9I", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $b8c3f91e5973f862$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $b8c3f91e5973f862$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $bJtXW = parcelRequire("bJtXW");
var $b8c3f91e5973f862$var$extendStatics = function extendStatics1(d, b) {
    $b8c3f91e5973f862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b8c3f91e5973f862$var$extendStatics(d, b);
};
function $b8c3f91e5973f862$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b8c3f91e5973f862$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8c3f91e5973f862$export$18ce0697a983be9b = function __assign1() {
    $b8c3f91e5973f862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8c3f91e5973f862$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8c3f91e5973f862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8c3f91e5973f862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8c3f91e5973f862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8c3f91e5973f862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b8c3f91e5973f862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b8c3f91e5973f862$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bJtXW._)(x)) === "symbol" ? x : "".concat(x);
}
function $b8c3f91e5973f862$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b8c3f91e5973f862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8c3f91e5973f862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8c3f91e5973f862$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b8c3f91e5973f862$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b8c3f91e5973f862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b8c3f91e5973f862$export$45d3717a4c69092e(o, m, p);
}
function $b8c3f91e5973f862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8c3f91e5973f862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8c3f91e5973f862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8c3f91e5973f862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8c3f91e5973f862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8c3f91e5973f862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b8c3f91e5973f862$export$10c90e4f7922046c(v) {
    return this instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? (this.v = v, this) : new $b8c3f91e5973f862$export$10c90e4f7922046c(v);
}
function $b8c3f91e5973f862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b8c3f91e5973f862$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8c3f91e5973f862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b8c3f91e5973f862$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8c3f91e5973f862$export$19a8beecd37a4c45 === "function" ? $b8c3f91e5973f862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b8c3f91e5973f862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b8c3f91e5973f862$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b8c3f91e5973f862$var$ownKeys = function ownKeys1(o) {
    $b8c3f91e5973f862$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b8c3f91e5973f862$var$ownKeys(o);
};
function $b8c3f91e5973f862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b8c3f91e5973f862$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b8c3f91e5973f862$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b8c3f91e5973f862$var$__setModuleDefault(result, mod);
    return result;
}
function $b8c3f91e5973f862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8c3f91e5973f862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b8c3f91e5973f862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b8c3f91e5973f862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $bJtXW._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b8c3f91e5973f862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b8c3f91e5973f862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b8c3f91e5973f862$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b8c3f91e5973f862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b8c3f91e5973f862$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b8c3f91e5973f862$export$2e2bcd8739ae039 = {
    __extends: $b8c3f91e5973f862$export$a8ba968b8961cb8a,
    __assign: $b8c3f91e5973f862$export$18ce0697a983be9b,
    __rest: $b8c3f91e5973f862$export$3c9a16f847548506,
    __decorate: $b8c3f91e5973f862$export$29e00dfd3077644b,
    __param: $b8c3f91e5973f862$export$d5ad3fd78186038f,
    __esDecorate: $b8c3f91e5973f862$export$3a84e1ae4e97e9b0,
    __runInitializers: $b8c3f91e5973f862$export$d831c04e792af3d,
    __propKey: $b8c3f91e5973f862$export$6a2a36740a146cb8,
    __setFunctionName: $b8c3f91e5973f862$export$d1a06452d3489bc7,
    __metadata: $b8c3f91e5973f862$export$f1db080c865becb9,
    __awaiter: $b8c3f91e5973f862$export$1050f835b63b671e,
    __generator: $b8c3f91e5973f862$export$67ebef60e6f28a6,
    __createBinding: $b8c3f91e5973f862$export$45d3717a4c69092e,
    __exportStar: $b8c3f91e5973f862$export$f33643c0debef087,
    __values: $b8c3f91e5973f862$export$19a8beecd37a4c45,
    __read: $b8c3f91e5973f862$export$8d051b38c9118094,
    __spread: $b8c3f91e5973f862$export$afc72e2116322959,
    __spreadArrays: $b8c3f91e5973f862$export$6388937ca91ccae8,
    __spreadArray: $b8c3f91e5973f862$export$1216008129fb82ed,
    __await: $b8c3f91e5973f862$export$10c90e4f7922046c,
    __asyncGenerator: $b8c3f91e5973f862$export$e427f37a30a4de9b,
    __asyncDelegator: $b8c3f91e5973f862$export$bbd80228419bb833,
    __asyncValues: $b8c3f91e5973f862$export$e3b29a3d6162315f,
    __makeTemplateObject: $b8c3f91e5973f862$export$4fb47efe1390b86f,
    __importStar: $b8c3f91e5973f862$export$c21735bcef00d192,
    __importDefault: $b8c3f91e5973f862$export$da59b14a69baef04,
    __classPrivateFieldGet: $b8c3f91e5973f862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b8c3f91e5973f862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b8c3f91e5973f862$export$81fdc39f203e4e04,
    __addDisposableResource: $b8c3f91e5973f862$export$88ac25d8e944e405,
    __disposeResources: $b8c3f91e5973f862$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b8c3f91e5973f862$export$889dfb5d17574b0b
};

});

parcelRegister("gl7zH", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $l8eKX = parcelRequire("l8eKX");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");

var $fRv9I = parcelRequire("fRv9I");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2us1u._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $l8eKX._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2us1u._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2us1u._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $2nwvT._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $2nwvT._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $grujF._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $j6Mzi._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $grujF._)(this, AbortedDeferredError);
        return (0, $f3Okx._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $1EZOw._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $grujF._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && (typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $2nwvT._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $72osQ._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $dhMkv._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $g3gsR._)(function() {
                    var aborted, onAbort;
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $2nwvT._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $72osQ._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $grujF._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $2us1u._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $72osQ._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2us1u._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach(function(key) {
            return deletedFetchers.delete(key);
        });
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $g3gsR._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $g3gsR._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $72osQ._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $2nwvT._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $g3gsR._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $g3gsR._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $g3gsR._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $g3gsR._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $g3gsR._)(function(request, redirect, isNavigation, _temp2) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $g3gsR._)(function(type, state, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $2nwvT._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $g3gsR._)(function(state, matches, matchesToLoad, fetchersToLoad, request) {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/ function() {
                            var _ref = (0, $g3gsR._)(function(f) {
                                var results, result;
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $72osQ._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $72osQ._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2us1u._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $72osQ._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $2nwvT._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $g3gsR._)(function(matches, pathname, signal, fetcherKey) {
            var _loop, partialMatches, _ret;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $fRv9I.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $2us1u._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $fRv9I.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $bJtXW._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2us1u._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $g3gsR._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $g3gsR._)(function(request, _temp4) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $g3gsR._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $g3gsR._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $g3gsR._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $72osQ._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $g3gsR._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(/*#__PURE__*/ function() {
                                var _ref = (0, $g3gsR._)(function(match) {
                                    var result, response, _;
                                    return (0, $fRv9I.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $72osQ._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $2nwvT._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $2us1u._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $g3gsR._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_ref4) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = // Default implementation of `dataStrategy` which fetches all loaders in parallel
    (0, $g3gsR._)(function(_ref4) {
        var matches, matchesToLoad, results;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $72osQ._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, $g3gsR._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = /*#__PURE__*/ function() {
                            var _ref = (0, $g3gsR._)(function(handlerOverride) {
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $g3gsR._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2us1u._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, $g3gsR._)(function() {
                            var val, e;
                            return (0, $fRv9I.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $2nwvT._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, $g3gsR._)(function(dataStrategyResult) {
        var result, type, data, contentType, e, _result$init3, _result$init4, _result$init, _result$init2, _result$init5, _result$init6, _result$init7, _result$init8;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                        headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            return [
                                2,
                                {
                                    type: ResultType.error,
                                    error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                                    statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                                    headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
                                headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $72osQ._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $72osQ._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2us1u._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $2nwvT._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $bJtXW._)(deferred)) === "object" && (0, $bJtXW._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $bJtXW._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
    _resolveNavigationDeferredResults = (0, $g3gsR._)(function(matches, results, signal, currentMatches, currentLoaderData) {
        var _loop, entries, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $2nwvT._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
    _resolveFetcherDeferredResults = (0, $g3gsR._)(function(matches, results, revalidatingFetchers) {
        var _loop, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, $g3gsR._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2us1u._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("f3Okx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af6e2d59c2ac092d$export$71511d61b312f219; });

var $gyGuQ = parcelRequire("gyGuQ");

var $ftVlM = parcelRequire("ftVlM");

var $gvVNz = parcelRequire("gvVNz");
function $af6e2d59c2ac092d$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $gyGuQ._)(derived);
    return (0, $gvVNz._)(_this, (0, $ftVlM._)() ? Reflect.construct(derived, args || [], (0, $gyGuQ._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("gyGuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c0e0c9403f4e59d3$export$71511d61b312f219; });
function $c0e0c9403f4e59d3$export$71511d61b312f219(o) {
    $c0e0c9403f4e59d3$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0e0c9403f4e59d3$export$71511d61b312f219(o);
}

});

parcelRegister("ftVlM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4560d09ed0b6bd9$export$71511d61b312f219; });
function $b4560d09ed0b6bd9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b4560d09ed0b6bd9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("gvVNz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $031a439d9bd8f8b3$export$71511d61b312f219; });

var $dcJGd = parcelRequire("dcJGd");

var $bJtXW = parcelRequire("bJtXW");
function $031a439d9bd8f8b3$export$71511d61b312f219(self, call) {
    if (call && ((0, $bJtXW._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dcJGd._)(self);
}

});
parcelRegister("dcJGd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99cfd4696d3ae8ed$export$71511d61b312f219; });
function $99cfd4696d3ae8ed$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("dhMkv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9ac25a306229a9ff$export$71511d61b312f219; });
function $9ac25a306229a9ff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ac25a306229a9ff$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $9ac25a306229a9ff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ac25a306229a9ff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("72osQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $51fbb26672273063$export$71511d61b312f219; });
function $51fbb26672273063$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("j6Mzi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de944088b801fe33$export$71511d61b312f219; });

var $fMryZ = parcelRequire("fMryZ");
function $de944088b801fe33$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fMryZ._)(subClass, superClass);
}

});
parcelRegister("fMryZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b7d0b832e35ee57e$export$71511d61b312f219; });
function $b7d0b832e35ee57e$export$71511d61b312f219(o, p) {
    $b7d0b832e35ee57e$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7d0b832e35ee57e$export$71511d61b312f219(o, p);
}

});


parcelRegister("l8eKX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f625ca9f0dc92caa$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $eaxdf = parcelRequire("eaxdf");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $f625ca9f0dc92caa$export$71511d61b312f219(arr) {
    return (0, $1g4fM._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $9kJqn._)();
}

});
parcelRegister("eaxdf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a50bc32ea5ddcbbf$export$71511d61b312f219; });
function $a50bc32ea5ddcbbf$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("2us1u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d041ee89e51af1b$export$71511d61b312f219; });

var $eYsRh = parcelRequire("eYsRh");

var $eaxdf = parcelRequire("eaxdf");

var $46sYX = parcelRequire("46sYX");

var $2DD2t = parcelRequire("2DD2t");
function $1d041ee89e51af1b$export$71511d61b312f219(arr) {
    return (0, $eYsRh._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $46sYX._)();
}

});
parcelRegister("eYsRh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae6d0dee9f5eb3eb$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $ae6d0dee9f5eb3eb$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6exmR._)(arr);
}

});

parcelRegister("46sYX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2fce3437f4cf1874$export$71511d61b312f219; });
function $2fce3437f4cf1874$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1EZOw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $135979cf6d0dc133$export$71511d61b312f219; });

var $8wAe0 = parcelRequire("8wAe0");

var $gyGuQ = parcelRequire("gyGuQ");

var $aFtfV = parcelRequire("aFtfV");

var $fMryZ = parcelRequire("fMryZ");
function $135979cf6d0dc133$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $135979cf6d0dc133$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $aFtfV._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $8wAe0._)(Class, arguments, (0, $gyGuQ._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fMryZ._)(Wrapper, Class);
    };
    return $135979cf6d0dc133$export$71511d61b312f219(Class);
}

});
parcelRegister("8wAe0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $634d6964686a1afa$export$71511d61b312f219; });

var $ftVlM = parcelRequire("ftVlM");

var $fMryZ = parcelRequire("fMryZ");
function $634d6964686a1afa$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ftVlM._)()) $634d6964686a1afa$export$71511d61b312f219 = Reflect.construct;
    else $634d6964686a1afa$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fMryZ._)(instance, Class.prototype);
        return instance;
    };
    return $634d6964686a1afa$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("aFtfV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7c446d547ed0cd60$export$71511d61b312f219; });
function $7c446d547ed0cd60$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("c2rik", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $8c3ad80f8a436e0f$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $8c3ad80f8a436e0f$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $8c3ad80f8a436e0f$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $8c3ad80f8a436e0f$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $8c3ad80f8a436e0f$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $8c3ad80f8a436e0f$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $8c3ad80f8a436e0f$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $8c3ad80f8a436e0f$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $8c3ad80f8a436e0f$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $8c3ad80f8a436e0f$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $8c3ad80f8a436e0f$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $8c3ad80f8a436e0f$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $8c3ad80f8a436e0f$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $8c3ad80f8a436e0f$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $8c3ad80f8a436e0f$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $8c3ad80f8a436e0f$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $8c3ad80f8a436e0f$export$52b333d321859367; });
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $dQFEZ = parcelRequire("dQFEZ");

var $gl7zH = parcelRequire("gl7zH");
function $8c3ad80f8a436e0f$var$_extends() {
    $8c3ad80f8a436e0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3ad80f8a436e0f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $8c3ad80f8a436e0f$export$3add0d5dce533e2e = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$145dfa71566a64dc = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$var$AwaitContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $8c3ad80f8a436e0f$export$26749e8557646306 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dQFEZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $8c3ad80f8a436e0f$var$RouteErrorContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $8c3ad80f8a436e0f$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $8c3ad80f8a436e0f$export$9c954a9d03d32f4a() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $8c3ad80f8a436e0f$export$45d76561a5302f2b() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $8c3ad80f8a436e0f$export$1b3f31771c5d07c() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $8c3ad80f8a436e0f$export$6c330e8992e8a295(pattern) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var pathname = $8c3ad80f8a436e0f$export$45d76561a5302f2b().pathname;
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.matchPath)(pattern, (0, $gl7zH.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $8c3ad80f8a436e0f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dQFEZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $8c3ad80f8a436e0f$export$9770f232ac06a008() {
    var isDataRoute = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $8c3ad80f8a436e0f$var$useNavigateStable() : $8c3ad80f8a436e0f$var$useNavigateUnstable();
}
function $8c3ad80f8a436e0f$var$useNavigateUnstable() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$OutletContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $8c3ad80f8a436e0f$export$4138103a3ae699cc() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(context) {
    var outlet = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef() {
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).future;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $8c3ad80f8a436e0f$export$5d3fca4a98652595(routes, locationArg) {
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), navigator = _React_useContext.navigator, isStatic = _React_useContext.static;
    var _React_useContext1 = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057), parentMatches = _React_useContext1.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $8c3ad80f8a436e0f$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $gl7zH.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $gl7zH.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $gl7zH.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $8c3ad80f8a436e0f$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $8c3ad80f8a436e0f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $gl7zH.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $8c3ad80f8a436e0f$var$DefaultErrorComponent() {
    var error = $8c3ad80f8a436e0f$export$ed527bf60f6e05f2();
    var message = (0, $gl7zH.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dQFEZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dQFEZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $8c3ad80f8a436e0f$var$defaultErrorElement = /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DefaultErrorComponent, null);
var $8c3ad80f8a436e0f$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $grujF._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $dhMkv._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($dQFEZ.Component);
function $8c3ad80f8a436e0f$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $8c3ad80f8a436e0f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $gl7zH.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $8c3ad80f8a436e0f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $8c3ad80f8a436e0f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dQFEZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $8c3ad80f8a436e0f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($8c3ad80f8a436e0f$var$DataRouterHook || {});
var $8c3ad80f8a436e0f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($8c3ad80f8a436e0f$var$DataRouterStateHook || {});
function $8c3ad80f8a436e0f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $8c3ad80f8a436e0f$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $8c3ad80f8a436e0f$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext($8c3ad80f8a436e0f$export$145dfa71566a64dc);
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
function $8c3ad80f8a436e0f$var$useRouteContext(hookName) {
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $8c3ad80f8a436e0f$var$useCurrentRouteId(hookName) {
    var route = $8c3ad80f8a436e0f$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $gl7zH.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $8c3ad80f8a436e0f$export$5fc8298006ad9e58() {
    return $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $8c3ad80f8a436e0f$export$d0fd4b7106de2769() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $8c3ad80f8a436e0f$export$600dc272ed516c15() {
    var dataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseRevalidator);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRevalidator);
    return $dQFEZ.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $8c3ad80f8a436e0f$export$2378eb7f5ff86053() {
    var _useDataRouterState = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $dQFEZ.useMemo(function() {
        return matches.map(function(m) {
            return (0, $gl7zH.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $8c3ad80f8a436e0f$export$1448a5050d252c4d() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $8c3ad80f8a436e0f$export$fd5d37484eab868d(routeId) {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $8c3ad80f8a436e0f$export$fdc00f3f26066d5e() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseActionData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $8c3ad80f8a436e0f$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $dQFEZ.useContext($8c3ad80f8a436e0f$var$RouteErrorContext);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$78a72ddb39bdd145() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$17f53340677d5831() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $8c3ad80f8a436e0f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $8c3ad80f8a436e0f$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $dQFEZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $8c3ad80f8a436e0f$var$_extends({}, currentLocation, {
                pathname: (0, $gl7zH.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $8c3ad80f8a436e0f$var$_extends({}, nextLocation, {
                pathname: (0, $gl7zH.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dQFEZ.useEffect(function() {
        var key = String(++$8c3ad80f8a436e0f$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dQFEZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $gl7zH.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $8c3ad80f8a436e0f$var$useNavigateStable() {
    var router = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseNavigateStable).router;
    var id = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $8c3ad80f8a436e0f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$alreadyWarned$1 = {};
function $8c3ad80f8a436e0f$var$warningOnce(key, cond, message) {
    if (!cond && !$8c3ad80f8a436e0f$var$alreadyWarned$1[key]) $8c3ad80f8a436e0f$var$alreadyWarned$1[key] = true;
}
var $8c3ad80f8a436e0f$var$alreadyWarned = {};
function $8c3ad80f8a436e0f$var$warnOnce(key, message) {}
var $8c3ad80f8a436e0f$var$logDeprecation = function(flag, msg, link) {
    return $8c3ad80f8a436e0f$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function $8c3ad80f8a436e0f$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $8c3ad80f8a436e0f$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $8c3ad80f8a436e0f$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8c3ad80f8a436e0f$var$START_TRANSITION = "startTransition";
var $8c3ad80f8a436e0f$var$startTransitionImpl = $dQFEZ[$8c3ad80f8a436e0f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8c3ad80f8a436e0f$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        if (v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl) $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $8c3ad80f8a436e0f$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $8c3ad80f8a436e0f$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $8c3ad80f8a436e0f$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $8c3ad80f8a436e0f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $gl7zH.resolveTo)(to, (0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $dQFEZ.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $8c3ad80f8a436e0f$export$910ae8079b2c2852(props) {
    return $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $8c3ad80f8a436e0f$export$e7b0ac011bb776c6(_props) {
    (0, $gl7zH.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $8c3ad80f8a436e0f$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $gl7zH.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $dQFEZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $8c3ad80f8a436e0f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $gl7zH.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $dQFEZ.useMemo(function() {
        var trailingPathname = (0, $gl7zH.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $8c3ad80f8a436e0f$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $8c3ad80f8a436e0f$export$5d3fca4a98652595($8c3ad80f8a436e0f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $8c3ad80f8a436e0f$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$ResolveAwait, null, children));
}
var $8c3ad80f8a436e0f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($8c3ad80f8a436e0f$var$AwaitRenderStatus || {});
var $8c3ad80f8a436e0f$var$neverSettledPromise = new Promise(function() {});
var $8c3ad80f8a436e0f$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $grujF._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $dhMkv._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.error : "_data" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.success : $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && promise._error instanceof (0, $gl7zH.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $8c3ad80f8a436e0f$var$neverSettledPromise;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($dQFEZ.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $8c3ad80f8a436e0f$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $8c3ad80f8a436e0f$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $8c3ad80f8a436e0f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $dQFEZ.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $dQFEZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2us1u._)(parentPath).concat([
            index
        ]);
        if (element.type === $dQFEZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $8c3ad80f8a436e0f$export$e7b0ac011bb776c6) && (0, $gl7zH.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $gl7zH.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $8c3ad80f8a436e0f$export$daf73786167a7f72(matches) {
    return $8c3ad80f8a436e0f$var$_renderMatches(matches);
}
function $8c3ad80f8a436e0f$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dQFEZ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dQFEZ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dQFEZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $8c3ad80f8a436e0f$export$f30f7e456d254e83(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8c3ad80f8a436e0f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $8c3ad80f8a436e0f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("imka8", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42; }, function (v) { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5d9ebee7c4f223e$export$bf730a2d8bf68b42;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
function $d5d9ebee7c4f223e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d5d9ebee7c4f223e$var$objectIs = "function" === typeof Object.is ? Object.is : $d5d9ebee7c4f223e$var$is, $d5d9ebee7c4f223e$var$useSyncExternalStore = $dQFEZ.useSyncExternalStore, $d5d9ebee7c4f223e$var$useRef = $dQFEZ.useRef, $d5d9ebee7c4f223e$var$useEffect = $dQFEZ.useEffect, $d5d9ebee7c4f223e$var$useMemo = $dQFEZ.useMemo, $d5d9ebee7c4f223e$var$useDebugValue = $dQFEZ.useDebugValue;
$d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d5d9ebee7c4f223e$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d5d9ebee7c4f223e$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d5d9ebee7c4f223e$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d5d9ebee7c4f223e$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d5d9ebee7c4f223e$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d5d9ebee7c4f223e$var$useDebugValue(value);
    return value;
};

});

parcelRegister("kK8g8", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $2nwvT._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $bJtXW._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $grujF._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2us1u._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $bJtXW._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2us1u._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $dhMkv._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $bJtXW._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $2nwvT._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $j6Mzi._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $grujF._)(this, DraftMap);
            var _this;
            _this = (0, $f3Okx._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $1EZOw._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $j6Mzi._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $grujF._)(this, DraftSet);
            var _this;
            _this = (0, $f3Okx._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $1EZOw._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});

parcelRegister("aod4b", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("atTUP"))($parcel$resolve("15rtL")),
    (parcelRequire("dxJzZ"))($parcel$resolve("eGMej"))
]).then(function() {
    return parcelRequire('6h9j5');
});

});
parcelRegister("atTUP", function(module, exports) {
"use strict";

var $dzhUQ = parcelRequire("dzhUQ");
module.exports = $dzhUQ(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("dzhUQ", function(module, exports) {
"use strict";
var $9e0c70f198b0df6a$var$cachedBundles = {};
var $9e0c70f198b0df6a$var$cachedPreloads = {};
var $9e0c70f198b0df6a$var$cachedPrefetches = {};
function $9e0c70f198b0df6a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $9e0c70f198b0df6a$var$cachedPreloads;
        case 'prefetch':
            return $9e0c70f198b0df6a$var$cachedPrefetches;
        default:
            return $9e0c70f198b0df6a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9e0c70f198b0df6a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("dxJzZ", function(module, exports) {
"use strict";

var $dzhUQ = parcelRequire("dzhUQ");
module.exports = $dzhUQ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


var $046f59f4f6216b86$exports = {};
$parcel$extendImportMap({
    "eGMej": "Grocery.d1109f03.js",
    "15rtL": "Grocery.34dc41d1.css"
});


var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $8dbfa3fee6dc40a7$exports = {};
'use strict';
function $8dbfa3fee6dc40a7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8dbfa3fee6dc40a7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8dbfa3fee6dc40a7$var$checkDCE();

$8dbfa3fee6dc40a7$exports = (parcelRequire("guBD8"));



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");

var $lEL1W = parcelRequire("lEL1W");
var $c2rik = parcelRequire("c2rik");

var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $dQFEZ = parcelRequire("dQFEZ");
var $f6758991d88cb14f$exports = {};
'use strict';

$f6758991d88cb14f$exports = (parcelRequire("imka8"));


var $d7d37dc522b09008$var$__defProp = Object.defineProperty;
var $d7d37dc522b09008$var$__defProps = Object.defineProperties;
var $d7d37dc522b09008$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7d37dc522b09008$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7d37dc522b09008$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7d37dc522b09008$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d7d37dc522b09008$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d7d37dc522b09008$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d7d37dc522b09008$var$__hasOwnProp.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d7d37dc522b09008$var$__propIsEnum.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d7d37dc522b09008$var$__spreadProps = function(a, b) {
    return $d7d37dc522b09008$var$__defProps(a, $d7d37dc522b09008$var$__getOwnPropDescs(b));
};
var $d7d37dc522b09008$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d7d37dc522b09008$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d7d37dc522b09008$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/react-is.ts
var $d7d37dc522b09008$var$IS_REACT_19 = /* @__PURE__ */ $dQFEZ.version.startsWith("19");
var $d7d37dc522b09008$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($d7d37dc522b09008$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $d7d37dc522b09008$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $d7d37dc522b09008$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $d7d37dc522b09008$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $d7d37dc522b09008$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $d7d37dc522b09008$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $d7d37dc522b09008$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $d7d37dc522b09008$var$ForwardRef = $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE;
var $d7d37dc522b09008$var$Memo = $d7d37dc522b09008$var$REACT_MEMO_TYPE;
function $d7d37dc522b09008$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE || type === $d7d37dc522b09008$var$REACT_PROFILER_TYPE || type === $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE || type === $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE || (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) === "object" && type !== null && (type.$$typeof === $d7d37dc522b09008$var$REACT_LAZY_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_MEMO_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $d7d37dc522b09008$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d7d37dc522b09008$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE:
                    case $d7d37dc522b09008$var$REACT_PROFILER_TYPE:
                    case $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d7d37dc522b09008$var$REACT_CONTEXT_TYPE:
                            case $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE:
                            case $d7d37dc522b09008$var$REACT_LAZY_TYPE:
                            case $d7d37dc522b09008$var$REACT_MEMO_TYPE:
                                return object;
                            case $d7d37dc522b09008$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d7d37dc522b09008$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $d7d37dc522b09008$var$isContextConsumer(object) {
    return $d7d37dc522b09008$var$IS_REACT_19 ? $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE : $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE;
}
function $d7d37dc522b09008$var$isMemo(object) {
    return $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d7d37dc522b09008$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d7d37dc522b09008$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d7d37dc522b09008$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $d7d37dc522b09008$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d7d37dc522b09008$var$verify(mapStateToProps, "mapStateToProps");
    $d7d37dc522b09008$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d7d37dc522b09008$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d7d37dc522b09008$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $d7d37dc522b09008$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d7d37dc522b09008$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2us1u._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d7d37dc522b09008$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d7d37dc522b09008$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d7d37dc522b09008$var$isPlainObject(value)) $d7d37dc522b09008$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $d7d37dc522b09008$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d7d37dc522b09008$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d7d37dc522b09008$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $bJtXW._)(mapDispatchToProps)) === "object" ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $d7d37dc522b09008$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d7d37dc522b09008$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d7d37dc522b09008$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $d7d37dc522b09008$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) : $d7d37dc522b09008$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d7d37dc522b09008$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d7d37dc522b09008$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $d7d37dc522b09008$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d7d37dc522b09008$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d7d37dc522b09008$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $d7d37dc522b09008$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d7d37dc522b09008$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d7d37dc522b09008$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d7d37dc522b09008$var$canUseDOM = function() {
    return !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
var $d7d37dc522b09008$var$isDOM = /* @__PURE__ */ $d7d37dc522b09008$var$canUseDOM();
var $d7d37dc522b09008$var$isRunningInReactNative = function() {
    return typeof navigator !== "undefined" && navigator.product === "ReactNative";
};
var $d7d37dc522b09008$var$isReactNative = /* @__PURE__ */ $d7d37dc522b09008$var$isRunningInReactNative();
var $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect = function() {
    return $d7d37dc522b09008$var$isDOM || $d7d37dc522b09008$var$isReactNative ? $dQFEZ.useLayoutEffect : $dQFEZ.useEffect;
};
var $d7d37dc522b09008$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $d7d37dc522b09008$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d7d37dc522b09008$export$d36bdfa510afb180(objA, objB) {
    if ($d7d37dc522b09008$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $bJtXW._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $bJtXW._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d7d37dc522b09008$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d7d37dc522b09008$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d7d37dc522b09008$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d7d37dc522b09008$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$_obj;
var $d7d37dc522b09008$var$TYPE_STATICS = ($d7d37dc522b09008$var$_obj = {}, (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$ForwardRef, $d7d37dc522b09008$var$FORWARD_REF_STATICS), (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$Memo, $d7d37dc522b09008$var$MEMO_STATICS), $d7d37dc522b09008$var$_obj);
function $d7d37dc522b09008$var$getStatics(component) {
    if ($d7d37dc522b09008$var$isMemo(component)) return $d7d37dc522b09008$var$MEMO_STATICS;
    return $d7d37dc522b09008$var$TYPE_STATICS[component["$$typeof"]] || $d7d37dc522b09008$var$REACT_STATICS;
}
var $d7d37dc522b09008$var$defineProperty = Object.defineProperty;
var $d7d37dc522b09008$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d7d37dc522b09008$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d7d37dc522b09008$var$getPrototypeOf = Object.getPrototypeOf;
var $d7d37dc522b09008$var$objectPrototype = Object.prototype;
function $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d7d37dc522b09008$var$objectPrototype) {
            var inheritedComponent = $d7d37dc522b09008$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d7d37dc522b09008$var$objectPrototype) $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $d7d37dc522b09008$var$getOwnPropertyNames(sourceComponent);
        if ($d7d37dc522b09008$var$getOwnPropertySymbols) keys = keys.concat($d7d37dc522b09008$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d7d37dc522b09008$var$getStatics(targetComponent);
        var sourceStatics = $d7d37dc522b09008$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d7d37dc522b09008$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d7d37dc522b09008$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d7d37dc522b09008$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $d7d37dc522b09008$var$ContextKey = /* @__PURE__ */ Symbol.for("react-redux-context");
var $d7d37dc522b09008$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d7d37dc522b09008$var$getContext() {
    var _a;
    if (!$dQFEZ.createContext) return {};
    var contextMap = (_a = $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey]) != null ? _a : $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($dQFEZ.createContext);
    if (!realContext) {
        realContext = $dQFEZ.createContext(null);
        contextMap.set($dQFEZ.createContext, realContext);
    }
    return realContext;
}
var $d7d37dc522b09008$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d7d37dc522b09008$var$getContext();
// src/components/connect.tsx
var $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d7d37dc522b09008$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2us1u._)(effectArgs));
    }, dependencies);
}
function $d7d37dc522b09008$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d7d37dc522b09008$var$strictEqual(a, b) {
    return a === b;
}
var $d7d37dc522b09008$var$hasWarnedAboutDeprecatedPureOption = false;
function $d7d37dc522b09008$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $d7d37dc522b09008$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $d7d37dc522b09008$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $d7d37dc522b09008$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $d7d37dc522b09008$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $dQFEZ.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $dQFEZ.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $dQFEZ.useMemo(function() {
                return $d7d37dc522b09008$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                if (!shouldHandleStateChanges) return $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $d7d37dc522b09008$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $dQFEZ.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $dQFEZ.useRef(void 0);
            var lastWrapperProps = $dQFEZ.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $dQFEZ.useRef(void 0);
            var renderIsScheduled = $dQFEZ.useRef(false);
            var isMounted = $dQFEZ.useRef(false);
            var latestSubscriptionCallbackError = $dQFEZ.useRef(void 0);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $dQFEZ.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $dQFEZ.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs($d7d37dc522b09008$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $dQFEZ.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $dQFEZ.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $dQFEZ.createElement(WrappedComponent, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $dQFEZ.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $dQFEZ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $dQFEZ.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $dQFEZ.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $dQFEZ.createElement(Connect, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d7d37dc522b09008$export$64605811ab45167f = $d7d37dc522b09008$var$connect;
// src/components/Provider.tsx
function $d7d37dc522b09008$var$Provider(providerProps) {
    var children = providerProps.children, context = providerProps.context, serverState = providerProps.serverState, store = providerProps.store;
    var contextValue = $dQFEZ.useMemo(function() {
        var subscription = $d7d37dc522b09008$var$createSubscription(store);
        var baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    var previousState = $dQFEZ.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $dQFEZ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d7d37dc522b09008$export$2881499e37b75b9a = $d7d37dc522b09008$var$Provider;
// src/hooks/useReduxContext.ts
function $d7d37dc522b09008$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $dQFEZ.useContext(context);
        return contextValue;
    };
}
var $d7d37dc522b09008$var$useReduxContext = /* @__PURE__ */ $d7d37dc522b09008$var$createReduxContextHook();
// src/hooks/useStore.ts
function $d7d37dc522b09008$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : // @ts-ignore
    $d7d37dc522b09008$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $d7d37dc522b09008$export$6ccbb43953eebf8 = /* @__PURE__ */ $d7d37dc522b09008$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d7d37dc522b09008$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useStore2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$export$6ccbb43953eebf8 : $d7d37dc522b09008$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $d7d37dc522b09008$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d7d37dc522b09008$export$bc9b55530897c558();
var $d7d37dc522b09008$var$refEquality = function(a, b) {
    return a === b;
};
function $d7d37dc522b09008$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : $d7d37dc522b09008$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $d7d37dc522b09008$var$refEquality : _ref_equalityFn;
        var reduxContext = useReduxContext2();
        var store = reduxContext.store, subscription = reduxContext.subscription, getServerState = reduxContext.getServerState;
        var firstRun = $dQFEZ.useRef(true);
        var wrappedSelector = $dQFEZ.useCallback((0, $72osQ._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector
        ]);
        var selectedState = (0, $f6758991d88cb14f$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $dQFEZ.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $d7d37dc522b09008$export$2105062e25df4afe = /* @__PURE__ */ $d7d37dc522b09008$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $d7d37dc522b09008$export$712ea50be43a7858 = $d7d37dc522b09008$var$defaultNoopBatch;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $72osQ = parcelRequire("72osQ");
function $e1f0c9b9d3f0410c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $72osQ._)(target, key, source[key]);
        });
    }
    return target;
}


function $c856efe13547de99$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $85cafde4a2dd4f41$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $c856efe13547de99$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $dQFEZ = parcelRequire("dQFEZ");
/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $425e31b6d9cc7675$export$3d46f4579dba46e5 = function() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(function(className, index, array) {
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
};


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $8fbab29799d0353b$export$73bda83cddbc7187 = function(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
};


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $db2334f3cfb3d284$export$86f54f62aa7a7514 = function(string) {
    return string.replace(/^([A-Z])|[\s-_]+(\w)/g, function(match, p1, p2) {
        return p2 ? p2.toUpperCase() : p1.toLowerCase();
    });
};


var $0c2b5bdde84f249b$export$6fb43ff9addf7357 = function(string) {
    var camelCase = (0, $db2334f3cfb3d284$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



function $68f469483b2832ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68f469483b2832ee$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $68f469483b2832ee$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $dQFEZ = parcelRequire("dQFEZ");
/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $2614d094167bdc29$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $95c1f201d84cae2f$export$ab365959aa6deed0 = function(props) {
    for(var prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};




var $dQFEZ = parcelRequire("dQFEZ");
"use strict";
"use client";
var $ecff66c989b5a885$var$LucideContext = (0, $dQFEZ.createContext)({});
function $ecff66c989b5a885$export$f4a5ae9d8b2d8a16(param) {
    var children = param.children, size = param.size, color = param.color, strokeWidth = param.strokeWidth, absoluteStrokeWidth = param.absoluteStrokeWidth, className = param.className;
    var value = (0, $dQFEZ.useMemo)(function() {
        return {
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        };
    }, [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $dQFEZ.createElement)($ecff66c989b5a885$var$LucideContext.Provider, {
        value: value
    }, children);
}
var $ecff66c989b5a885$export$52ee7576b6cde767 = function() {
    return (0, $dQFEZ.useContext)($ecff66c989b5a885$var$LucideContext);
};


"use strict";
"use client";
var $d2365fbdc1092859$export$2e2bcd8739ae039 = (0, $dQFEZ.forwardRef)(function(_param, ref) {
    var color = _param.color, size = _param.size, strokeWidth = _param.strokeWidth, absoluteStrokeWidth = _param.absoluteStrokeWidth, _param_className = _param.className, className = _param_className === void 0 ? "" : _param_className, children = _param.children, iconNode = _param.iconNode, rest = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
        "color",
        "size",
        "strokeWidth",
        "absoluteStrokeWidth",
        "className",
        "children",
        "iconNode"
    ]);
    var _useLucideContext;
    var _ref = (_useLucideContext = (0, $ecff66c989b5a885$export$52ee7576b6cde767)()) !== null && _useLucideContext !== void 0 ? _useLucideContext : {}, tmp = _ref.size, contextSize = tmp === void 0 ? 24 : tmp, tmp1 = _ref.strokeWidth, contextStrokeWidth = tmp1 === void 0 ? 2 : tmp1, tmp2 = _ref.absoluteStrokeWidth, contextAbsoluteStrokeWidth = tmp2 === void 0 ? false : tmp2, tmp3 = _ref.color, contextColor = tmp3 === void 0 ? "currentColor" : tmp3, tmp4 = _ref.className, contextClass = tmp4 === void 0 ? "" : tmp4;
    var calculatedStrokeWidth = (absoluteStrokeWidth !== null && absoluteStrokeWidth !== void 0 ? absoluteStrokeWidth : contextAbsoluteStrokeWidth) ? Number(strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : contextStrokeWidth) * 24 / Number(size !== null && size !== void 0 ? size : contextSize) : strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : contextStrokeWidth;
    var _ref1, _ref2;
    return (0, $dQFEZ.createElement)("svg", (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
        ref: ref
    }, (0, $2614d094167bdc29$export$2e2bcd8739ae039)), {
        width: (_ref1 = size !== null && size !== void 0 ? size : contextSize) !== null && _ref1 !== void 0 ? _ref1 : (0, $2614d094167bdc29$export$2e2bcd8739ae039).width,
        height: (_ref2 = size !== null && size !== void 0 ? size : contextSize) !== null && _ref2 !== void 0 ? _ref2 : (0, $2614d094167bdc29$export$2e2bcd8739ae039).height,
        stroke: color !== null && color !== void 0 ? color : contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $425e31b6d9cc7675$export$3d46f4579dba46e5)("lucide", contextClass, className)
    }), !children && !(0, $95c1f201d84cae2f$export$ab365959aa6deed0)(rest) && {
        "aria-hidden": "true"
    }, rest), (0, $2us1u._)(iconNode.map(function(param) {
        var _$_param = (0, $2nwvT._)(param, 2), tag = _$_param[0], attrs = _$_param[1];
        return (0, $dQFEZ.createElement)(tag, attrs);
    })).concat((0, $2us1u._)(Array.isArray(children) ? children : [
        children
    ])));
});


var $b9b3db22bf3a92cf$export$2e2bcd8739ae039 = function(iconName, iconNode) {
    var Component = (0, $dQFEZ.forwardRef)(function(_param, ref) {
        var className = _param.className, props = (0, $85cafde4a2dd4f41$export$71511d61b312f219)(_param, [
            "className"
        ]);
        return (0, $dQFEZ.createElement)((0, $d2365fbdc1092859$export$2e2bcd8739ae039), (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
            ref: ref,
            iconNode: iconNode,
            className: (0, $425e31b6d9cc7675$export$3d46f4579dba46e5)("lucide-".concat((0, $8fbab29799d0353b$export$73bda83cddbc7187)((0, $0c2b5bdde84f249b$export$6fb43ff9addf7357)(iconName))), "lucide-".concat(iconName), className)
        }, props));
    });
    Component.displayName = (0, $0c2b5bdde84f249b$export$6fb43ff9addf7357)(iconName);
    return Component;
};


var $9ef178eef6358c0b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 5h16",
            key: "1tepv9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 19h16",
            key: "1djgab"
        }
    ]
];
var $9ef178eef6358c0b$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("menu", $9ef178eef6358c0b$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $47391425dff710ab$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "21",
            r: "1",
            key: "jimo8o"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "21",
            r: "1",
            key: "13723u"
        }
    ],
    [
        "path",
        {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            key: "9zh506"
        }
    ]
];
var $47391425dff710ab$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("shopping-cart", $47391425dff710ab$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bab7dcf773ac5003$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
var $bab7dcf773ac5003$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("x", $bab7dcf773ac5003$export$3efd853dbb351e94);


var $97819e7f4fb8b01d$var$Header = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), scrolled = _useState[0], setScrolled = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), menuOpen = _useState1[0], setMenuOpen = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), loggedIn = _useState2[0], setLoggedIn = _useState2[1];
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var cartCount = cartItems.reduce(function(sum, item) {
        return sum + item.quantity;
    }, 0);
    var location = (0, $c2rik.useLocation)();
    // Adds a hairline shadow once the page scrolls past the top
    (0, $dQFEZ.useEffect)(function() {
        var onScroll = function() {
            return setScrolled(window.scrollY > 60);
        };
        window.addEventListener('scroll', onScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', onScroll);
        };
    }, []);
    // Close mobile menu on route change
    (0, $dQFEZ.useEffect)(function() {
        setMenuOpen(false);
    }, [
        location
    ]);
    var navLinkClass = function(param) {
        var isActive = param.isActive;
        return "nav-link ".concat(isActive ? 'nav-link-active' : '');
    };
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("header", {
        className: "navbar ".concat(scrolled ? 'navbar-scrolled' : ''),
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "navbar-inner",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $lEL1W.Link), {
                        to: "/",
                        className: "navbar-logo",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "logo-icon",
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                className: "logo-text",
                                children: [
                                    "Bite",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "logo-accent",
                                        children: "Swift"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("nav", {
                        className: "navbar-nav",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                end: true,
                                to: "/",
                                className: navLinkClass,
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/grocery",
                                className: navLinkClass,
                                children: "Grocery"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/about",
                                className: navLinkClass,
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/contact",
                                className: navLinkClass,
                                children: "Contact"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "navbar-right",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $lEL1W.Link), {
                                to: "/cart",
                                className: "cart-btn",
                                "aria-label": "Cart",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $47391425dff710ab$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    cartCount > 0 && /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "cart-badge",
                                        children: cartCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "auth-btn ".concat(loggedIn ? 'auth-btn-outline' : ''),
                                onClick: function() {
                                    return setLoggedIn(function(p) {
                                        return !p;
                                    });
                                },
                                children: loggedIn ? 'Logout' : 'Login'
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "hamburger",
                                onClick: function() {
                                    return setMenuOpen(function(p) {
                                        return !p;
                                    });
                                },
                                "aria-label": "Toggle menu",
                                children: menuOpen ? /*#__PURE__*/ (0, $iD4WH.jsx)((0, $bab7dcf773ac5003$export$2e2bcd8739ae039), {
                                    size: 22
                                }) : /*#__PURE__*/ (0, $iD4WH.jsx)((0, $9ef178eef6358c0b$export$2e2bcd8739ae039), {
                                    size: 22
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "mobile-drawer ".concat(menuOpen ? 'drawer-open' : ''),
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("nav", {
                        className: "drawer-nav",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                end: true,
                                to: "/",
                                className: navLinkClass,
                                children: "Home"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/grocery",
                                className: navLinkClass,
                                children: "Grocery"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/about",
                                className: navLinkClass,
                                children: "About"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.NavLink), {
                                to: "/contact",
                                className: navLinkClass,
                                children: "Contact"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $lEL1W.NavLink), {
                                to: "/cart",
                                className: navLinkClass,
                                children: [
                                    "Cart ",
                                    cartCount > 0 && "(".concat(cartCount, ")")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        className: "auth-btn drawer-auth-btn ".concat(loggedIn ? 'auth-btn-outline' : ''),
                        onClick: function() {
                            return setLoggedIn(function(p) {
                                return !p;
                            });
                        },
                        children: loggedIn ? 'Logout' : 'Login'
                    })
                ]
            })
        ]
    });
};
var $97819e7f4fb8b01d$export$2e2bcd8739ae039 = $97819e7f4fb8b01d$var$Header;



var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $fRv9I = parcelRequire("fRv9I");

var $iD4WH = parcelRequire("iD4WH");


var $iD4WH = parcelRequire("iD4WH");
var $1ad00fd5a6f8ced9$export$2c4e825dc9120f87 = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9046136&lng=77.614948&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
var $1ad00fd5a6f8ced9$export$3c67ec6258c4a827 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $1ad00fd5a6f8ced9$export$a91f4fe650c27642 = "https://png.pngtree.com/png-clipart/20241114/original/pngtree-fast-food-meal-clipart-illustration-burgers-fries-and-soda-png-image_17060160.png";
var $1ad00fd5a6f8ced9$export$8878ead86ed0da0b = "https://static.vecteezy.com/system/resources/previews/050/585/647/non_2x/a-hamburger-and-a-drink-are-shown-in-a-line-free-vector.jpg";
var $1ad00fd5a6f8ced9$export$b77c1aa4fb57bd1c = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=" // we won't be using default export
 //! named export
;



var $befb75561cb9b7e5$var$FALLBACK_IMAGES = [
    'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=660&q=80',
    'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=660&q=80',
    'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=660&q=80',
    'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=660&q=80',
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=660&q=80'
];
var $befb75561cb9b7e5$var$ratingColor = function(rating) {
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
var $befb75561cb9b7e5$var$RestaurantCard = function(param) {
    var resData = param.resData;
    var _resData_info = resData.info, cloudinaryImageId = _resData_info.cloudinaryImageId, name = _resData_info.name, avgRating = _resData_info.avgRating, costForTwo = _resData_info.costForTwo, cuisines = _resData_info.cuisines, areaName = _resData_info.areaName, sla = _resData_info.sla, aggregatedDiscountInfoV3 = _resData_info.aggregatedDiscountInfoV3, veg = _resData_info.veg;
    var _sla_slaString, _ref;
    var deliveryTime = (_ref = (_sla_slaString = sla === null || sla === void 0 ? void 0 : sla.slaString) !== null && _sla_slaString !== void 0 ? _sla_slaString : (sla === null || sla === void 0 ? void 0 : sla.deliveryTime) + ' mins') !== null && _ref !== void 0 ? _ref : "\u2014";
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "res-card",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "res-card-img-wrap",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                        className: "res-card-img",
                        src: (cloudinaryImageId === null || cloudinaryImageId === void 0 ? void 0 : cloudinaryImageId.startsWith('http')) ? cloudinaryImageId : (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + cloudinaryImageId,
                        alt: name,
                        loading: "lazy",
                        onError: function(e) {
                            e.target.onerror = null;
                            e.target.src = $befb75561cb9b7e5$var$FALLBACK_IMAGES[Math.floor(Math.random() * $befb75561cb9b7e5$var$FALLBACK_IMAGES.length)];
                        }
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "res-card-img-overlay"
                    }),
                    aggregatedDiscountInfoV3 && /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "res-discount-badge",
                        children: [
                            aggregatedDiscountInfoV3.header,
                            aggregatedDiscountInfoV3.subHeader ? " ".concat(aggregatedDiscountInfoV3.subHeader) : ''
                        ]
                    }),
                    veg && /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        className: "res-veg-dot",
                        title: "Pure Veg",
                        children: "\uD83E\uDD66"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "res-card-body",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                        className: "res-card-name",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "res-card-meta",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                className: "res-card-rating",
                                style: {
                                    background: $befb75561cb9b7e5$var$ratingColor(avgRating)
                                },
                                children: [
                                    "\u2605 ",
                                    avgRating
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "res-card-dot",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "res-card-time",
                                children: deliveryTime
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "res-card-dot",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "res-card-price",
                                children: costForTwo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "res-card-cuisine",
                        children: [
                            cuisines === null || cuisines === void 0 ? void 0 : cuisines.slice(0, 3).join(', '),
                            (cuisines === null || cuisines === void 0 ? void 0 : cuisines.length) > 3 ? " +".concat(cuisines.length - 3) : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "res-card-area",
                        children: [
                            "\uD83D\uDCCD ",
                            areaName
                        ]
                    })
                ]
            })
        ]
    });
};
var $befb75561cb9b7e5$export$69fb0609e92726e3 = function(WrappedCard) {
    return function(props) {
        var aggregatedDiscountInfoV3 = props.resData.info.aggregatedDiscountInfoV3;
        if (!aggregatedDiscountInfoV3) return /*#__PURE__*/ (0, $iD4WH.jsx)(WrappedCard, (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props));
        return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
            className: "res-card-hoc-wrap",
            children: /*#__PURE__*/ (0, $iD4WH.jsx)(WrappedCard, (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props))
        });
    };
};
var $befb75561cb9b7e5$export$2e2bcd8739ae039 = $befb75561cb9b7e5$var$RestaurantCard;



var $dQFEZ = parcelRequire("dQFEZ");

var $iD4WH = parcelRequire("iD4WH");

var $0cbdcd5845c3443e$var$ShimmerCard = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "shimmer-card",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-img-wrap",
                children: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                    className: "shimmer-pulse shimmer-img"
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "shimmer-body",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-75"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "shimmer-meta-row",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "shimmer-pulse shimmer-badge"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "shimmer-pulse shimmer-line w-40"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "shimmer-pulse shimmer-line w-30"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-85"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "shimmer-pulse shimmer-line w-50"
                    })
                ]
            })
        ]
    });
};
var $0cbdcd5845c3443e$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "shimmer-grid",
        children: Array(8).fill('').map(function(_, i) {
            return /*#__PURE__*/ (0, $iD4WH.jsx)($0cbdcd5845c3443e$var$ShimmerCard, {}, i);
        })
    });
};
var $0cbdcd5845c3443e$export$2e2bcd8739ae039 = $0cbdcd5845c3443e$var$Shimmer;



var $lEL1W = parcelRequire("lEL1W");
var $c2rik = parcelRequire("c2rik");

var $2nwvT = parcelRequire("2nwvT");

var $dQFEZ = parcelRequire("dQFEZ");
var $85e4e4add9845b6c$var$useOnlineStatus = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    // check if online
    (0, $dQFEZ.useEffect)(function() {
        window.addEventListener('offline', function() {
            setOnlineStatus(false);
        });
        window.addEventListener('online', function() {
            setOnlineStatus(true);
        });
    }, []) // dependency array to make sure it runs only once
    ;
    // boolean value
    return onlineStatus;
};
var $85e4e4add9845b6c$export$2e2bcd8739ae039 //! creating custom hook to check if user is online/offline
 // we will be using addEventListener... window's online and offline events
 = $85e4e4add9845b6c$var$useOnlineStatus;


// All collection IDs verified from Swiggy network tab (Bangalore — lat=12.97530, lng=77.59100)
var $de128caf1be3641e$export$a513ea61a7bee91c = [
    {
        emoji: "\uD83C\uDF55",
        label: 'Pizza',
        slug: 'pizza',
        collection: '83631',
        tags: 'layout_CCS_Pizza',
        color: [
            '#FF6B35',
            '#F7443E'
        ]
    },
    {
        emoji: "\uD83C\uDF57",
        label: 'Biryani',
        slug: 'biryani',
        collection: '83639',
        tags: 'layout_CCS_Biryani',
        color: [
            '#F7B731',
            '#F0932B'
        ]
    },
    {
        emoji: "\uD83C\uDF5B",
        label: 'South Indian',
        slug: 'south-indian',
        collection: '83634',
        tags: 'layout_CCS_SouthIndian',
        color: [
            '#20BF6B',
            '#0FB9B1'
        ]
    },
    {
        emoji: "\uD83E\uDD5E",
        label: 'Dosa',
        slug: 'dosa',
        collection: '80424',
        tags: 'layout_CCS_Dosa',
        color: [
            '#F7971E',
            '#FFD200'
        ]
    },
    {
        emoji: "\uD83C\uDF54",
        label: 'Burgers',
        slug: 'burgers',
        collection: '83637',
        tags: 'layout_CCS_Burger',
        color: [
            '#FF416C',
            '#FF4B2B'
        ]
    },
    {
        emoji: "\uD83E\uDD61",
        label: 'Chinese',
        slug: 'chinese',
        collection: '83636',
        tags: 'layout_CCS_Chinese',
        color: [
            '#c94b4b',
            '#4b134f'
        ]
    },
    {
        emoji: "\uD83C\uDF2F",
        label: 'Rolls',
        slug: 'rolls',
        collection: '83669',
        tags: 'layout_CCS_Rolls',
        color: [
            '#A18CD1',
            '#FBC2EB'
        ]
    },
    {
        emoji: "\uD83C\uDF70",
        label: 'Desserts',
        slug: 'desserts',
        collection: '83661',
        tags: 'layout_CCS_Desserts',
        color: [
            '#FD79A8',
            '#D63031'
        ]
    },
    {
        emoji: "\uD83E\uDD5F",
        label: 'Momos',
        slug: 'momos',
        collection: '80461',
        tags: 'layout_CCS_Momos',
        color: [
            '#4facfe',
            '#00f2fe'
        ]
    },
    {
        emoji: "\uD83E\uDD57",
        label: 'Salad',
        slug: 'salad',
        collection: '80394',
        tags: 'layout_CCS_Salad',
        color: [
            '#43E97B',
            '#38F9D7'
        ]
    },
    {
        emoji: "\uD83C\uDF82",
        label: 'Cakes',
        slug: 'cakes',
        collection: '83655',
        tags: 'layout_CCS_Cake',
        color: [
            '#f093fb',
            '#f5576c'
        ]
    },
    {
        emoji: "\uD83C\uDF5A",
        label: 'Idli',
        slug: 'idli',
        collection: '80440',
        tags: 'layout_CCS_Idli',
        color: [
            '#FDDB92',
            '#D1FDFF'
        ]
    },
    {
        emoji: "\uD83C\uDF5C",
        label: 'Noodles',
        slug: 'noodles',
        collection: '80463',
        tags: 'layout_ux4',
        color: [
            '#f7971e',
            '#ffd200'
        ]
    },
    {
        emoji: "\uD83E\uDD59",
        label: 'Shawarma',
        slug: 'shawarma',
        collection: '80402',
        tags: 'layout_Shawarma_Contextual',
        color: [
            '#c79081',
            '#dfa579'
        ]
    },
    {
        emoji: "\uD83C\uDF5D",
        label: 'Pasta',
        slug: 'pasta',
        collection: '80479',
        tags: 'layout_CCS_Pasta',
        color: [
            '#f953c6',
            '#b91d73'
        ]
    },
    {
        emoji: "\uD83E\uDD64",
        label: 'Shakes',
        slug: 'shakes',
        collection: '83673',
        tags: 'layout_CCS_Shakes',
        color: [
            '#4776E6',
            '#8E54E9'
        ]
    },
    {
        emoji: "\uD83E\uDD50",
        label: 'Samosa',
        slug: 'samosa',
        collection: '80396',
        tags: '',
        color: [
            '#F2994A',
            '#F2C94C'
        ]
    },
    {
        emoji: "\u2615",
        label: 'Coffee',
        slug: 'coffee',
        collection: '83907',
        tags: 'layout_CCS_Coffee',
        color: [
            '#6F4E37',
            '#C9A96E'
        ]
    },
    {
        emoji: "\uD83E\uDDC1",
        label: 'Pastry',
        slug: 'pastry',
        collection: '80355',
        tags: 'layout_ux4',
        color: [
            '#FC5C7D',
            '#6A82FB'
        ]
    },
    {
        emoji: "\uD83C\uDF79",
        label: 'Juices',
        slug: 'juices',
        collection: '80445',
        tags: 'layout_Juices_Contextual',
        color: [
            '#56AB2F',
            '#A8E063'
        ]
    }
];



var $44eff52b21fb216f$var$SWIGGY_LIST_URL = '/.netlify/functions/swiggy-list';
var $44eff52b21fb216f$var$SWIGGY_UPDATE_URL = '/.netlify/functions/swiggy-update';
// Search every card for the restaurant grid — Swiggy's index shifts between responses
var $44eff52b21fb216f$var$extractRestaurants = function() {
    var cards = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var card = _step.value;
            var _card_card_card_gridElements_infoWithStyle, _card_card_card_gridElements, _card_card_card, _card_card;
            var list = card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_gridElements = _card_card_card.gridElements) === null || _card_card_card_gridElements === void 0 ? void 0 : (_card_card_card_gridElements_infoWithStyle = _card_card_card_gridElements.infoWithStyle) === null || _card_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _card_card_card_gridElements_infoWithStyle.restaurants;
            if (list === null || list === void 0 ? void 0 : list.length) return list;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
};
var $44eff52b21fb216f$var$FILTERS = [
    {
        id: 'all',
        label: 'All'
    },
    {
        id: 'rating',
        label: "\u2B50  Rating 4.0+"
    },
    {
        id: 'fast',
        label: "\u26A1  Under 30 min"
    },
    {
        id: 'veg',
        label: "\uD83E\uDD66  Pure Veg"
    },
    {
        id: 'offers',
        label: "\uD83C\uDF81  Offers"
    }
];
var $44eff52b21fb216f$var$applyFilters = function(list, filter, search) {
    var result = (0, $2us1u._)(list);
    if (search.trim()) result = result.filter(function(r) {
        return r.info.name.toLowerCase().includes(search.toLowerCase());
    });
    switch(filter){
        case 'rating':
            result = result.filter(function(r) {
                return r.info.avgRating >= 4.0;
            });
            break;
        case 'fast':
            result = result.filter(function(r) {
                var _r_info_sla;
                var _r_info_sla_deliveryTime;
                return ((_r_info_sla_deliveryTime = (_r_info_sla = r.info.sla) === null || _r_info_sla === void 0 ? void 0 : _r_info_sla.deliveryTime) !== null && _r_info_sla_deliveryTime !== void 0 ? _r_info_sla_deliveryTime : 99) <= 30;
            });
            break;
        case 'veg':
            result = result.filter(function(r) {
                return r.info.veg;
            });
            break;
        case 'offers':
            result = result.filter(function(r) {
                return r.info.aggregatedDiscountInfoV3;
            });
            break;
        default:
            break;
    }
    return result;
};
var $44eff52b21fb216f$var$Body = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), allRestaurants = _useState[0], setAllRestaurants = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), filteredRestaurants = _useState1[0], setFilteredRestaurants = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(''), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var _useState3 = (0, $2nwvT._)((0, $dQFEZ.useState)('all'), 2), activeFilter = _useState3[0], setActiveFilter = _useState3[1];
    var _useState4 = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var _useState5 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), isFetchingMore = _useState5[0], setIsFetchingMore = _useState5[1];
    var _useState6 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), hasMore = _useState6[0], setHasMore = _useState6[1];
    // Swiggy pagination tokens
    var _useState7 = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), nextOffset = _useState7[0], setNextOffset = _useState7[1];
    var _useState8 = (0, $2nwvT._)((0, $dQFEZ.useState)({}), 2), widgetOffset = _useState8[0], setWidgetOffset = _useState8[1];
    var swiggySessionRef = (0, $dQFEZ.useRef)('') // Swiggy session cookies forwarded on pagination
    ;
    // Infinite scroll
    var observerRef = (0, $dQFEZ.useRef)(null) // holds the IntersectionObserver instance
    ;
    var loadMoreRef = (0, $dQFEZ.useRef)(null) // always points to the latest loadMore
    ;
    var fetchingRef = (0, $dQFEZ.useRef)(false) // prevents double-fire from observer
    ;
    var navigate = (0, $c2rik.useNavigate)();
    var RestaurantCardWithDiscount = (0, $befb75561cb9b7e5$export$69fb0609e92726e3)((0, $befb75561cb9b7e5$export$2e2bcd8739ae039));
    var onlineStatus = (0, $85e4e4add9845b6c$export$2e2bcd8739ae039)();
    // ── Initial fetch ──────────────────────────────────────────────────────────
    (0, $dQFEZ.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function() {
            var _json_data, _json_data1, _json_data2, res, json, restaurants, pageOffset, _pageOffset_nextOffset, _pageOffset_widgetOffset, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch($44eff52b21fb216f$var$SWIGGY_LIST_URL)
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        json = _state.sent();
                        restaurants = $44eff52b21fb216f$var$extractRestaurants(json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards);
                        console.log("[BiteSwift] initial load \u2014 restaurants:", restaurants.length, '| pageOffset:', json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : _json_data1.pageOffset);
                        setAllRestaurants(restaurants);
                        swiggySessionRef.current = (json === null || json === void 0 ? void 0 : json.__cookies) || '';
                        pageOffset = json === null || json === void 0 ? void 0 : (_json_data2 = json.data) === null || _json_data2 === void 0 ? void 0 : _json_data2.pageOffset;
                        setNextOffset((_pageOffset_nextOffset = pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.nextOffset) !== null && _pageOffset_nextOffset !== void 0 ? _pageOffset_nextOffset : null);
                        setWidgetOffset((_pageOffset_widgetOffset = pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.widgetOffset) !== null && _pageOffset_widgetOffset !== void 0 ? _pageOffset_widgetOffset : {});
                        setHasMore(!!(pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.nextOffset));
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        console.log('[BiteSwift] Swiggy fetch failed:', e.message);
                        setAllRestaurants([]);
                        setHasMore(false);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    // ── Load more (called by intersection observer) ────────────────────────────
    var loadMore = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function() {
            var _json_data, _json_data1, res, json, more, pageOffset, _pageOffset_nextOffset, _pageOffset_widgetOffset, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (fetchingRef.current || !hasMore) return [
                            2
                        ];
                        fetchingRef.current = true;
                        setIsFetchingMore(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch($44eff52b21fb216f$var$SWIGGY_UPDATE_URL, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-swiggy-cookies': swiggySessionRef.current
                                },
                                body: JSON.stringify({
                                    lat: 12.9046136,
                                    lng: 77.614948,
                                    nextOffset: nextOffset,
                                    widgetOffset: widgetOffset,
                                    filters: {},
                                    seoParams: {
                                        seoUrl: 'https://www.swiggy.com/',
                                        pageType: 'DESKTOP_WEB_LISTING',
                                        apiName: 'FoodHomePage'
                                    },
                                    pageType: 'DESKTOP_WEB_LISTING',
                                    type: 'DESKTOP_WEB_LISTING'
                                })
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        json = _state.sent();
                        more = $44eff52b21fb216f$var$extractRestaurants(json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards);
                        pageOffset = json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : _json_data1.pageOffset;
                        console.log("[BiteSwift] pagination \u2014 got:", more.length, '| nextOffset:', pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.nextOffset);
                        setAllRestaurants(function(prev) {
                            return (0, $2us1u._)(prev).concat((0, $2us1u._)(more));
                        });
                        setNextOffset((_pageOffset_nextOffset = pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.nextOffset) !== null && _pageOffset_nextOffset !== void 0 ? _pageOffset_nextOffset : null);
                        setWidgetOffset((_pageOffset_widgetOffset = pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.widgetOffset) !== null && _pageOffset_widgetOffset !== void 0 ? _pageOffset_widgetOffset : {});
                        setHasMore(!!(pageOffset === null || pageOffset === void 0 ? void 0 : pageOffset.nextOffset));
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        console.log('[BiteSwift] pagination failed:', e.message);
                        setHasMore(false);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        fetchingRef.current = false;
                        setIsFetchingMore(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    // Keep ref current every render so the observer always calls the latest version
    loadMoreRef.current = loadMore;
    // Callback ref — fires when the sentinel mounts/unmounts (after data loads),
    // so the observer always attaches to a real DOM node.
    var sentinelRef = (0, $dQFEZ.useCallback)(function(node) {
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (!node) return;
        observerRef.current = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) loadMoreRef.current();
        }, {
            rootMargin: '0px'
        });
        observerRef.current.observe(node);
    }, []);
    // ── Re-filter whenever search / filter / category / allRestaurants changes ─
    (0, $dQFEZ.useEffect)(function() {
        setFilteredRestaurants($44eff52b21fb216f$var$applyFilters(allRestaurants, activeFilter, searchText));
    }, [
        searchText,
        activeFilter,
        allRestaurants
    ]);
    var handleFilterClick = function(id) {
        return setActiveFilter(function(prev) {
            return prev === id ? 'all' : id;
        });
    };
    if (onlineStatus === false) return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "offline-screen",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                className: "offline-icon",
                children: "\uD83D\uDCE1"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                children: "You're offline"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                children: "Check your internet connection and try again."
            })
        ]
    });
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "home-page",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "hero",
                children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "hero-content",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            className: "hero-badge",
                            children: "\uD83D\uDD25 Hot & fresh, always"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("h1", {
                            className: "hero-headline",
                            children: [
                                "HUNGRY?",
                                /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                    className: "hero-accent",
                                    children: "WE'VE GOT YOU."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            className: "hero-sub",
                            children: "200+ restaurants. One tap. Delivered fast."
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "hero-search",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                    className: "hero-search-icon",
                                    children: "\uD83D\uDD0D"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                    className: "hero-search-input",
                                    type: "text",
                                    placeholder: "Search restaurants, cuisines...",
                                    value: searchText,
                                    onChange: function(e) {
                                        return setSearchText(e.target.value);
                                    }
                                }),
                                searchText && /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                    className: "hero-search-clear",
                                    onClick: function() {
                                        return setSearchText('');
                                    },
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "hero-stats",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                            children: "200+"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            children: "Restaurants"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                    className: "hstat-sep"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                            children: "30 min"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            children: "Avg delivery"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                    className: "hstat-sep"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "hstat",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                            children: "4.8 \u2605"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            children: "Avg rating"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "how-strip",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDDFA\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                        children: "Browse restaurants"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "200+ local spots near you"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "how-divider"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDED2"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                        children: "Build your order"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Customize every item your way"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "how-divider"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "how-item",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "how-icon-wrap",
                                children: "\uD83D\uDEF5"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "how-text",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                        children: "Track live"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Door-to-door, in real time"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "feature-row",
                children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "feature-row__inner",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "feature-row__text",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Fast. Every time."
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                                    className: "feature-row__heading",
                                    children: [
                                        "Your food,",
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                        "in 30 minutes."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "feature-row__desc",
                                    children: "We've optimized every step so your food arrives hot, fast, and exactly as you ordered it."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            className: "feature-row__visual",
                            children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "fvisual-card",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                        className: "fvc-label",
                                        children: "Your order"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        className: "fvc-steps",
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "fvc-step fvc-step--done",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Order received"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "0:00"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "fvc-step fvc-step--done",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Kitchen preparing"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "5:12"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "fvc-step fvc-step--active",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "On the way"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "18:30"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "fvc-step",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-dot"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-name",
                                                        children: "Delivered"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        className: "fvcs-time",
                                                        children: "~28 min"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        className: "fvc-eta",
                                        children: [
                                            "Estimated arrival ",
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                                children: "28 min"
                                            }),
                                            " \uD83D\uDEF5"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "feature-row feature-row--alt",
                children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "feature-row__inner feature-row__inner--reverse",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "feature-row__text",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Every craving covered"
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                                    className: "feature-row__heading",
                                    children: [
                                        "Whatever you're",
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                        "in the mood for."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "feature-row__desc",
                                    children: "Late-night biryani. Weekend brunch. Midnight dessert. 20 cuisines across 200+ restaurants \u2014 all in one place."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            className: "feature-row__visual",
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "fvisual-cravings",
                                children: (0, $de128caf1be3641e$export$a513ea61a7bee91c).slice(0, 6).map(function(cat) {
                                    return /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                        className: "fvc-craving",
                                        style: {
                                            background: "linear-gradient(135deg, ".concat(cat.color[0], ", ").concat(cat.color[1], ")")
                                        },
                                        onClick: function() {
                                            return navigate("/collection/".concat(cat.slug));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "fvc-craving-emoji",
                                                children: cat.emoji
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "fvc-craving-label",
                                                children: cat.label
                                            })
                                        ]
                                    }, cat.slug);
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "categories-section",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "section-inner",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "eyebrow",
                                children: "Explore by craving"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                className: "section-heading",
                                children: "What are you in the mood for?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "category-scroll-wrapper",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            className: "category-scroll",
                            children: (0, $de128caf1be3641e$export$a513ea61a7bee91c).map(function(cat) {
                                return /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                    className: "category-pill",
                                    style: {
                                        background: "linear-gradient(145deg, ".concat(cat.color[0], ", ").concat(cat.color[1], ")")
                                    },
                                    onClick: function() {
                                        return navigate("/collection/".concat(cat.slug));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "cat-emoji",
                                            children: cat.emoji
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "cat-label",
                                            children: cat.label
                                        })
                                    ]
                                }, cat.slug);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "filter-bar",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "filter-chips",
                        children: $44eff52b21fb216f$var$FILTERS.map(function(f) {
                            return /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "filter-chip ".concat(activeFilter === f.id ? 'active' : ''),
                                onClick: function() {
                                    return handleFilterClick(f.id);
                                },
                                children: f.label
                            }, f.id);
                        })
                    }),
                    !isLoading && /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "results-count",
                        children: [
                            filteredRestaurants.length,
                            " restaurant",
                            filteredRestaurants.length !== 1 ? 's' : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "restaurants-section",
                children: isLoading ? /*#__PURE__*/ (0, $iD4WH.jsx)((0, $0cbdcd5845c3443e$export$2e2bcd8739ae039), {}) : allRestaurants.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            children: "\uD83D\uDCE1"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                            children: "Couldn't load restaurants"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            children: "Something went wrong reaching Swiggy. Please try again."
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            onClick: fetchData,
                            children: "Retry"
                        })
                    ]
                }) : filteredRestaurants.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            children: "\uD83C\uDF7D\uFE0F"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                            children: "No restaurants found"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            children: "Try a different search or clear your filters."
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            onClick: function() {
                                setSearchText('');
                                setActiveFilter('all');
                            },
                            children: "Clear all filters"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $iD4WH.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                            className: "section-title",
                            children: searchText ? 'Results for "'.concat(searchText, '"') : 'Restaurants near you'
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            className: "restaurant-grid",
                            children: filteredRestaurants.map(function(restaurant) {
                                return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                                    to: '/restaurant/' + restaurant.info.id,
                                    className: "card-link",
                                    children: restaurant.info.aggregatedDiscountInfoV3 ? /*#__PURE__*/ (0, $iD4WH.jsx)(RestaurantCardWithDiscount, {
                                        resData: restaurant
                                    }) : /*#__PURE__*/ (0, $iD4WH.jsx)((0, $befb75561cb9b7e5$export$2e2bcd8739ae039), {
                                        resData: restaurant
                                    })
                                }, restaurant.info.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            ref: sentinelRef,
                            className: "scroll-sentinel",
                            children: [
                                isFetchingMore && /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "fetching-more",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            className: "fetching-spinner"
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                            children: "Loading more restaurants\u2026"
                                        })
                                    ]
                                }),
                                !hasMore && allRestaurants.length > 0 && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                    className: "end-of-list",
                                    children: "You've seen all restaurants nearby \uD83C\uDF7D\uFE0F"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $44eff52b21fb216f$export$2e2bcd8739ae039 = $44eff52b21fb216f$var$Body;





var $iD4WH = parcelRequire("iD4WH");

var $lEL1W = parcelRequire("lEL1W");

var $72osQ = parcelRequire("72osQ");



var $2nwvT = parcelRequire("2nwvT");

var $bJtXW = parcelRequire("bJtXW");

var $dQFEZ = parcelRequire("dQFEZ");
'use client';
/**
* Resolve icon set icons
*
* Returns parent icon for each icon
*/ function $cff12353be849bfd$var$getIconsTree(data, names) {
    var icons = data.icons;
    var aliases = data.aliases || Object.create(null);
    var resolved = Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            var parent = aliases[name] && aliases[name].parent;
            var value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    Object.keys(icons).concat(Object.keys(aliases)).forEach(resolve);
    return resolved;
}
/**
* Default values for dimensions
*/ var $cff12353be849bfd$var$defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
/**
* Default values for transformations
*/ var $cff12353be849bfd$var$defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
/**
* Default values for all optional IconifyIcon properties
*/ var $cff12353be849bfd$var$defaultIconProps = Object.freeze((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconDimensions, $cff12353be849bfd$var$defaultIconTransformations));
/**
* Default values for all properties used in ExtendedIconifyIcon
*/ var $cff12353be849bfd$var$defaultExtendedIconProps = Object.freeze((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconProps), {
    body: "",
    hidden: false
}));
/**
* Merge transformations
*/ function $cff12353be849bfd$var$mergeIconTransformations(obj1, obj2) {
    var result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    var rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
/**
* Merge icon and alias
*
* Can also be used to merge default values and icon
*/ function $cff12353be849bfd$var$mergeIconData(parent, child) {
    var result = $cff12353be849bfd$var$mergeIconTransformations(parent, child);
    for(var key in $cff12353be849bfd$var$defaultExtendedIconProps)if (key in $cff12353be849bfd$var$defaultIconTransformations) {
        if (key in parent && !(key in result)) result[key] = $cff12353be849bfd$var$defaultIconTransformations[key];
    } else if (key in child) result[key] = child[key];
    else if (key in parent) result[key] = parent[key];
    return result;
}
/**
* Get icon data, using prepared aliases tree
*/ function $cff12353be849bfd$var$internalGetIconData(data, name, tree) {
    var icons = data.icons;
    var aliases = data.aliases || Object.create(null);
    var currentProps = {};
    function parse(name$1) {
        currentProps = $cff12353be849bfd$var$mergeIconData(icons[name$1] || aliases[name$1], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return $cff12353be849bfd$var$mergeIconData(data, currentProps);
}
/**
* Extract icons from an icon set
*
* Returns list of icons that were found in icon set
*/ function $cff12353be849bfd$var$parseIconSet(data, callback) {
    var names = [];
    if ((typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) !== "object" || (0, $bJtXW._)(data.icons) !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach(function(name) {
        callback(name, null);
        names.push(name);
    });
    var tree = $cff12353be849bfd$var$getIconsTree(data);
    for(var name in tree){
        var item = tree[name];
        if (item) {
            callback(name, $cff12353be849bfd$var$internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
/**
* Optional properties
*/ var $cff12353be849bfd$var$optionalPropertyDefaults = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
    provider: "",
    aliases: {},
    not_found: {}
}, $cff12353be849bfd$var$defaultIconDimensions);
/**
* Check props
*/ function $cff12353be849bfd$var$checkOptionalProps(item, defaults) {
    for(var prop in defaults)if (prop in item && (0, $bJtXW._)(item[prop]) !== (0, $bJtXW._)(defaults[prop])) return false;
    return true;
}
/**
* Validate icon set, return it as IconifyJSON on success, null on failure
*
* Unlike validateIconSet(), this function is very basic.
* It does not throw exceptions, it does not check metadata, it does not fix stuff.
*/ function $cff12353be849bfd$var$quicklyValidateIconSet(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return null;
    var data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || (0, $bJtXW._)(obj.icons) !== "object") return null;
    if (!$cff12353be849bfd$var$checkOptionalProps(obj, $cff12353be849bfd$var$optionalPropertyDefaults)) return null;
    var icons = data.icons;
    for(var name in icons){
        var icon = icons[name];
        if (!name || typeof icon.body !== "string" || !$cff12353be849bfd$var$checkOptionalProps(icon, $cff12353be849bfd$var$defaultExtendedIconProps)) return null;
    }
    var aliases = data.aliases || Object.create(null);
    for(var name1 in aliases){
        var icon1 = aliases[name1];
        var parent = icon1.parent;
        if (!name1 || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !$cff12353be849bfd$var$checkOptionalProps(icon1, $cff12353be849bfd$var$defaultExtendedIconProps)) return null;
    }
    return data;
}
/**
* Storage by provider and prefix
*/ var $cff12353be849bfd$var$dataStorage = Object.create(null);
/**
* Create new storage
*/ function $cff12353be849bfd$var$newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
/**
* Get storage for provider and prefix
*/ function $cff12353be849bfd$var$getStorage(provider, prefix) {
    var providerStorage = $cff12353be849bfd$var$dataStorage[provider] || ($cff12353be849bfd$var$dataStorage[provider] = Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = $cff12353be849bfd$var$newStorage(provider, prefix));
}
/**
* Add icon set to storage
*
* Returns array of added icons
*/ function $cff12353be849bfd$var$addIconSet(storage, data) {
    if (!$cff12353be849bfd$var$quicklyValidateIconSet(data)) return [];
    return $cff12353be849bfd$var$parseIconSet(data, function(name, icon) {
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
/**
* Add icon to storage
*/ function $cff12353be849bfd$var$addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, icon);
            return true;
        }
    } catch (err) {}
    return false;
}
/**
* List available icons
*/ function $cff12353be849bfd$export$a598a3910899291f(provider, prefix) {
    var allIcons = [];
    var providers = typeof provider === "string" ? [
        provider
    ] : Object.keys($cff12353be849bfd$var$dataStorage);
    providers.forEach(function(provider$1) {
        var prefixes = typeof provider$1 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys($cff12353be849bfd$var$dataStorage[provider$1] || {});
        prefixes.forEach(function(prefix$1) {
            var storage = $cff12353be849bfd$var$getStorage(provider$1, prefix$1);
            allIcons = allIcons.concat(Object.keys(storage.icons).map(function(name) {
                return (provider$1 !== "" ? "@" + provider$1 + ":" : "") + prefix$1 + ":" + name;
            }));
        });
    });
    return allIcons;
}
/**
* Expression to test part of icon name.
*
* Used when loading icons from Iconify API due to project naming convension.
* Ignored when using custom icon sets - convension does not apply.
*/ var $cff12353be849bfd$var$matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
/**
* Convert string icon name to IconifyIconName object.
*/ var $cff12353be849bfd$var$stringToIcon = function(value, validate, allowSimpleName) {
    var provider = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        var name$1 = colonSeparated.pop();
        var prefix = colonSeparated.pop();
        var result = {
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name$1
        };
        return validate && !$cff12353be849bfd$var$validateIconName(result) ? null : result;
    }
    var name = colonSeparated[0];
    var dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        var result1 = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !$cff12353be849bfd$var$validateIconName(result1) ? null : result1;
    }
    if (allowSimpleName && provider === "") {
        var result2 = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !$cff12353be849bfd$var$validateIconName(result2, allowSimpleName) ? null : result2;
    }
    return null;
};
/**
* Check if icon is valid.
*
* This function is not part of stringToIcon because validation is not needed for most code.
*/ var $cff12353be849bfd$var$validateIconName = function(icon, allowSimpleName) {
    if (!icon) return false;
    return !!((allowSimpleName && icon.prefix === "" || !!icon.prefix) && !!icon.name);
};
/**
* Allow storing icons without provider or prefix, making it possible to store icons like "home"
*/ var $cff12353be849bfd$var$simpleNames = false;
function $cff12353be849bfd$var$allowSimpleNames(allow) {
    if (typeof allow === "boolean") $cff12353be849bfd$var$simpleNames = allow;
    return $cff12353be849bfd$var$simpleNames;
}
/**
* Get icon data
*
* Returns:
* - IconifyIcon on success, object directly from storage so don't modify it
* - null if icon is marked as missing (returned in `not_found` property from API, so don't bother sending API requests)
* - undefined if icon is missing in storage
*/ function $cff12353be849bfd$var$getIconData(name) {
    var icon = typeof name === "string" ? $cff12353be849bfd$var$stringToIcon(name, true, $cff12353be849bfd$var$simpleNames) : name;
    if (icon) {
        var storage = $cff12353be849bfd$var$getStorage(icon.provider, icon.prefix);
        var iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
/**
* Add one icon
*/ function $cff12353be849bfd$export$3488242433cbedb(name, data) {
    var icon = $cff12353be849bfd$var$stringToIcon(name, true, $cff12353be849bfd$var$simpleNames);
    if (!icon) return false;
    var storage = $cff12353be849bfd$var$getStorage(icon.provider, icon.prefix);
    if (data) return $cff12353be849bfd$var$addIconToStorage(storage, icon.name, data);
    else {
        storage.missing.add(icon.name);
        return true;
    }
}
/**
* Add icon set
*/ function $cff12353be849bfd$export$933f273b2a11730f(data, provider) {
    if ((typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if ($cff12353be849bfd$var$simpleNames && !provider && !data.prefix) {
        var added = false;
        if ($cff12353be849bfd$var$quicklyValidateIconSet(data)) {
            data.prefix = "";
            $cff12353be849bfd$var$parseIconSet(data, function(name, icon) {
                if ($cff12353be849bfd$export$3488242433cbedb(name, icon)) added = true;
            });
        }
        return added;
    }
    var prefix = data.prefix;
    if (!$cff12353be849bfd$var$validateIconName({
        prefix: prefix,
        name: "a"
    })) return false;
    var storage = $cff12353be849bfd$var$getStorage(provider, prefix);
    return !!$cff12353be849bfd$var$addIconSet(storage, data);
}
/**
* Check if icon data is available
*/ function $cff12353be849bfd$export$6728fff2d370396a(name) {
    return !!$cff12353be849bfd$var$getIconData(name);
}
/**
* Get full icon
*/ function $cff12353be849bfd$export$16b26cd5e98d9100(name) {
    var result = $cff12353be849bfd$var$getIconData(name);
    return result ? (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconProps, result) : result;
}
/**
* Default icon customisations values
*/ var $cff12353be849bfd$var$defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
var $cff12353be849bfd$var$defaultIconCustomisations = Object.freeze((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconSizeCustomisations, $cff12353be849bfd$var$defaultIconTransformations));
/**
* Regular expressions for calculating dimensions
*/ var $cff12353be849bfd$var$unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var $cff12353be849bfd$var$unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $cff12353be849bfd$export$907c7b8171f13ef1(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    var oldParts = size.split($cff12353be849bfd$var$unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    var newParts = [];
    var code = oldParts.shift();
    var isNumber = $cff12353be849bfd$var$unitsTest.test(code);
    while(true){
        if (isNumber) {
            var num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
function $cff12353be849bfd$var$splitSVGDefs(content) {
    var tag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "defs";
    var defs = "";
    var index = content.indexOf("<" + tag);
    while(index >= 0){
        var start = content.indexOf(">", index);
        var end = content.indexOf("</" + tag);
        if (start === -1 || end === -1) break;
        var endEnd = content.indexOf(">", end);
        if (endEnd === -1) break;
        defs += content.slice(start + 1, end).trim();
        content = content.slice(0, index).trim() + content.slice(endEnd + 1);
    }
    return {
        defs: defs,
        content: content
    };
}
/**
* Merge defs and content
*/ function $cff12353be849bfd$var$mergeDefsAndContent(defs, content) {
    return defs ? "<defs>" + defs + "</defs>" + content : content;
}
/**
* Wrap SVG content, without wrapping definitions
*/ function $cff12353be849bfd$var$wrapSVGContent(body, start, end) {
    var split = $cff12353be849bfd$var$splitSVGDefs(body);
    return $cff12353be849bfd$var$mergeDefsAndContent(split.defs, start + split.content + end);
}
/**
* Check if value should be unset. Allows multiple keywords
*/ var $cff12353be849bfd$var$isUnsetKeyword = function(value) {
    return value === "unset" || value === "undefined" || value === "none";
};
/**
* Get SVG attributes and content from icon + customisations
*
* Does not generate style to make it compatible with frameworks that use objects for style, such as React.
* Instead, it generates 'inline' value. If true, rendering engine should add verticalAlign: -0.125em to icon.
*
* Customisations should be normalised by platform specific parser.
* Result should be converted to <svg> by platform specific parser.
* Use replaceIDs to generate unique IDs for body.
*/ function $cff12353be849bfd$export$78c1051fc6863a0b(icon, customisations) {
    var fullIcon = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconProps, icon);
    var fullCustomisations = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconCustomisations, customisations);
    var box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    var body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach(function(props) {
        var transformations = [];
        var hFlip = props.hFlip;
        var vFlip = props.vFlip;
        var rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        var tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = $cff12353be849bfd$var$wrapSVGContent(body, "<g transform=\"" + transformations.join(" ") + "\">", "</g>");
    });
    var customisationsWidth = fullCustomisations.width;
    var customisationsHeight = fullCustomisations.height;
    var boxWidth = box.width;
    var boxHeight = box.height;
    var width;
    var height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = $cff12353be849bfd$export$907c7b8171f13ef1(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? $cff12353be849bfd$export$907c7b8171f13ef1(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    var attributes = {};
    var setAttr = function(prop, value) {
        if (!$cff12353be849bfd$var$isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    var viewBox = [
        box.left,
        box.top,
        boxWidth,
        boxHeight
    ];
    attributes.viewBox = viewBox.join(" ");
    return {
        attributes: attributes,
        viewBox: viewBox,
        body: body
    };
}
/**
* IDs usage:
*
* id="{id}"
* xlink:href="#{id}"
* url(#{id})
*
* From SVG animations:
*
* begin="0;{id}.end"
* begin="{id}.end"
* begin="{id}.click"
*/ /**
* Regular expression for finding ids
*/ var $cff12353be849bfd$var$regex = /\sid="(\S+)"/g;
/**
* New random-ish prefix for ids
*
* Do not use dash, it cannot be used in SVG 2 animations
*/ var $cff12353be849bfd$var$randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
/**
* Counter for ids, increasing with every replacement
*/ var $cff12353be849bfd$var$counter = 0;
/**
* Replace IDs in SVG output with unique IDs
*/ function $cff12353be849bfd$export$cae0fa3719aa5dc4(body) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cff12353be849bfd$var$randomPrefix;
    var ids = [];
    var match;
    while(match = $cff12353be849bfd$var$regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    var suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach(function(id) {
        var newID = typeof prefix === "function" ? prefix(id) : prefix + ($cff12353be849bfd$var$counter++).toString();
        var escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(new RegExp("([#;\"])(" + escapedID + ")([\")]|\\.[a-z])", "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
/**
* Local storate types and entries
*/ var $cff12353be849bfd$var$storage = Object.create(null);
/**
* Set API module
*/ function $cff12353be849bfd$var$setAPIModule(provider, item) {
    $cff12353be849bfd$var$storage[provider] = item;
}
/**
* Get API module
*/ function $cff12353be849bfd$var$getAPIModule(provider) {
    return $cff12353be849bfd$var$storage[provider] || $cff12353be849bfd$var$storage[""];
}
/**
* Create full API configuration from partial data
*/ function $cff12353be849bfd$var$createAPIConfig(source) {
    var resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    var result = {
        resources: resources,
        path: source.path || "/",
        maxURL: source.maxURL || 500,
        rotate: source.rotate || 750,
        timeout: source.timeout || 5e3,
        random: source.random === true,
        index: source.index || 0,
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
/**
* Local storage
*/ var $cff12353be849bfd$var$configStorage = Object.create(null);
/**
* Redundancy for API servers.
*
* API should have very high uptime because of implemented redundancy at server level, but
* sometimes bad things happen. On internet 100% uptime is not possible.
*
* There could be routing problems. Server might go down for whatever reason, but it takes
* few minutes to detect that downtime, so during those few minutes API might not be accessible.
*
* This script has some redundancy to mitigate possible network issues.
*
* If one host cannot be reached in 'rotate' (750 by default) ms, script will try to retrieve
* data from different host. Hosts have different configurations, pointing to different
* API servers hosted at different providers.
*/ var $cff12353be849bfd$var$fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
var $cff12353be849bfd$var$fallBackAPI = [];
while($cff12353be849bfd$var$fallBackAPISources.length > 0)if ($cff12353be849bfd$var$fallBackAPISources.length === 1) $cff12353be849bfd$var$fallBackAPI.push($cff12353be849bfd$var$fallBackAPISources.shift());
else if (Math.random() > .5) $cff12353be849bfd$var$fallBackAPI.push($cff12353be849bfd$var$fallBackAPISources.shift());
else $cff12353be849bfd$var$fallBackAPI.push($cff12353be849bfd$var$fallBackAPISources.pop());
$cff12353be849bfd$var$configStorage[""] = $cff12353be849bfd$var$createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat($cff12353be849bfd$var$fallBackAPI)
});
/**
* Add custom config for provider
*/ function $cff12353be849bfd$export$ddfda4eca64d59f6(provider, customConfig) {
    var config = $cff12353be849bfd$var$createAPIConfig(customConfig);
    if (config === null) return false;
    $cff12353be849bfd$var$configStorage[provider] = config;
    return true;
}
/**
* Get API configuration
*/ function $cff12353be849bfd$var$getAPIConfig(provider) {
    return $cff12353be849bfd$var$configStorage[provider];
}
/**
* List API providers
*/ function $cff12353be849bfd$var$listAPIProviders() {
    return Object.keys($cff12353be849bfd$var$configStorage);
}
var $cff12353be849bfd$var$detectFetch = function() {
    var callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
/**
* Fetch function
*/ var $cff12353be849bfd$var$fetchModule = $cff12353be849bfd$var$detectFetch();
/**
* Set custom fetch() function
*/ function $cff12353be849bfd$var$setFetch(fetch$1) {
    $cff12353be849bfd$var$fetchModule = fetch$1;
}
/**
* Get fetch() function. Used by Icon Finder Core
*/ function $cff12353be849bfd$var$getFetch() {
    return $cff12353be849bfd$var$fetchModule;
}
/**
* Calculate maximum icons list length for prefix
*/ function $cff12353be849bfd$var$calculateMaxLength(provider, prefix) {
    var config = $cff12353be849bfd$var$getAPIConfig(provider);
    if (!config) return 0;
    var result;
    if (!config.maxURL) result = 0;
    else {
        var maxHostLength = 0;
        config.resources.forEach(function(item) {
            var host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        var url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
/**
* Should query be aborted, based on last HTTP status
*/ function $cff12353be849bfd$var$shouldAbort(status) {
    return status === 404;
}
/**
* Prepare params
*/ var $cff12353be849bfd$var$prepare = function(provider, prefix, icons) {
    var results = [];
    var maxLength = $cff12353be849bfd$var$calculateMaxLength(provider, prefix);
    var type = "icons";
    var item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    var length = 0;
    icons.forEach(function(name, index) {
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
/**
* Get path
*/ function $cff12353be849bfd$var$getPath(provider) {
    if (typeof provider === "string") {
        var config = $cff12353be849bfd$var$getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
/**
* Load icons
*/ var $cff12353be849bfd$var$send = function(host, params, callback) {
    if (!$cff12353be849bfd$var$fetchModule) {
        callback("abort", 424);
        return;
    }
    var path = $cff12353be849bfd$var$getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                var prefix = params.prefix;
                var icons = params.icons;
                var iconsList = icons.join(",");
                var urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                var uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    var defaultError = 503;
    $cff12353be849bfd$var$fetchModule(host + path).then(function(response) {
        var status = response.status;
        if (status !== 200) {
            setTimeout(function() {
                callback($cff12353be849bfd$var$shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then(function(data) {
        if ((typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) !== "object" || data === null) {
            setTimeout(function() {
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(function() {
            callback("success", data);
        });
    }).catch(function() {
        callback("next", defaultError);
    });
};
/**
* Export module
*/ var $cff12353be849bfd$var$fetchAPIModule = {
    prepare: $cff12353be849bfd$var$prepare,
    send: $cff12353be849bfd$var$send
};
/**
* Remove callback
*/ function $cff12353be849bfd$var$removeCallback(storages, id) {
    storages.forEach(function(storage) {
        var items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter(function(row) {
            return row.id !== id;
        });
    });
}
/**
* Update all callbacks for provider and prefix
*/ function $cff12353be849bfd$var$updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(function() {
            storage.pendingCallbacksFlag = false;
            var items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            var hasPending = false;
            var provider = storage.provider;
            var prefix = storage.prefix;
            items.forEach(function(item) {
                var icons = item.icons;
                var oldLength = icons.pending.length;
                icons.pending = icons.pending.filter(function(icon) {
                    if (icon.prefix !== prefix) return true;
                    var name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) $cff12353be849bfd$var$removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
/**
* Unique id counter for callbacks
*/ var $cff12353be849bfd$var$idCounter = 0;
/**
* Add callback
*/ function $cff12353be849bfd$var$storeCallback(callback, icons, pendingSources) {
    var id = $cff12353be849bfd$var$idCounter++;
    var abort = $cff12353be849bfd$var$removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    var item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach(function(storage) {
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
/**
* Check if icons have been loaded
*/ function $cff12353be849bfd$var$sortIcons(icons) {
    var result = {
        loaded: [],
        missing: [],
        pending: []
    };
    var storage = Object.create(null);
    icons.sort(function(a, b) {
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    var lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach(function(icon) {
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        var provider = icon.provider;
        var prefix = icon.prefix;
        var name = icon.name;
        var providerStorage = storage[provider] || (storage[provider] = Object.create(null));
        var localStorage = providerStorage[prefix] || (providerStorage[prefix] = $cff12353be849bfd$var$getStorage(provider, prefix));
        var list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        var item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
/**
* Convert icons list from string/icon mix to icons and validate them
*/ function $cff12353be849bfd$var$listToIcons(list) {
    var validate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, simpleNames = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var result = [];
    list.forEach(function(item) {
        var icon = typeof item === "string" ? $cff12353be849bfd$var$stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
/**
* Default RedundancyConfig for API calls
*/ var $cff12353be849bfd$var$defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
/**
* Send query
*/ function $cff12353be849bfd$var$sendQuery(config, payload, query, done) {
    var resourcesCount = config.resources.length;
    var startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    var resources;
    if (config.random) {
        var list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            var nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    var startTime = Date.now();
    var status = "pending";
    var queriesSent = 0;
    var lastError;
    var timer = null;
    var queue = [];
    var doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    /**
	* Reset timer
	*/ function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    /**
	* Abort everything
	*/ function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach(function(item) {
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Add / replace callback to call when execution is complete.
	* This can be used to abort pending query implementations when query is complete or aborted.
	*/ function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    /**
	* Get query status
	*/ function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    /**
	* Fail query
	*/ function failQuery() {
        status = "failed";
        doneCallbacks.forEach(function(callback) {
            callback(void 0, lastError);
        });
    }
    /**
	* Clear queue
	*/ function clearQueue() {
        queue.forEach(function(item) {
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    /**
	* Got response from module
	*/ function moduleResponse(item, response, data) {
        var isError = response !== "success";
        queue = queue.filter(function(queued) {
            return queued !== item;
        });
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            var index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach(function(callback) {
            callback(data);
        });
    }
    /**
	* Execute next query
	*/ function execNext() {
        if (status !== "pending") return;
        resetTimer();
        var resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(function() {
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        var item = {
            status: "pending",
            resource: resource,
            callback: function(status$1, data) {
                moduleResponse(item, status$1, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
/**
* Redundancy instance
*/ function $cff12353be849bfd$var$initRedundancy(cfg) {
    var config = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultConfig, cfg);
    var queries = [];
    /**
	* Remove aborted and completed queries
	*/ function cleanup() {
        queries = queries.filter(function(item) {
            return item().status === "pending";
        });
    }
    /**
	* Send query
	*/ function query(payload, queryCallback, doneCallback) {
        var query$1 = $cff12353be849bfd$var$sendQuery(config, payload, queryCallback, function(data, error) {
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query$1);
        return query$1;
    }
    /**
	* Find instance
	*/ function find(callback) {
        return queries.find(function(value) {
            return callback(value);
        }) || null;
    }
    var instance = {
        query: query,
        find: find,
        setIndex: function(index) {
            config.index = index;
        },
        getIndex: function() {
            return config.index;
        },
        cleanup: cleanup
    };
    return instance;
}
function $cff12353be849bfd$var$emptyCallback$1() {}
var $cff12353be849bfd$var$redundancyCache = Object.create(null);
/**
* Get Redundancy instance for provider
*/ function $cff12353be849bfd$var$getRedundancyCache(provider) {
    if (!$cff12353be849bfd$var$redundancyCache[provider]) {
        var config = $cff12353be849bfd$var$getAPIConfig(provider);
        if (!config) return;
        var redundancy = $cff12353be849bfd$var$initRedundancy(config);
        var cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        $cff12353be849bfd$var$redundancyCache[provider] = cachedReundancy;
    }
    return $cff12353be849bfd$var$redundancyCache[provider];
}
/**
* Send API query
*/ function $cff12353be849bfd$var$sendAPIQuery(target, query, callback) {
    var redundancy;
    var send;
    if (typeof target === "string") {
        var api = $cff12353be849bfd$var$getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return $cff12353be849bfd$var$emptyCallback$1;
        }
        send = api.send;
        var cached = $cff12353be849bfd$var$getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        var config = $cff12353be849bfd$var$createAPIConfig(target);
        if (config) {
            redundancy = $cff12353be849bfd$var$initRedundancy(config);
            var moduleKey = target.resources ? target.resources[0] : "";
            var api1 = $cff12353be849bfd$var$getAPIModule(moduleKey);
            if (api1) send = api1.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return $cff12353be849bfd$var$emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
function $cff12353be849bfd$var$emptyCallback() {}
/**
* Function called when new icons have been loaded
*/ function $cff12353be849bfd$var$loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(function() {
            storage.iconsLoaderFlag = false;
            $cff12353be849bfd$var$updateCallbacks(storage);
        });
    }
}
/**
* Check icon names for API
*/ function $cff12353be849bfd$var$checkIconNamesForAPI(icons) {
    var valid = [];
    var invalid = [];
    icons.forEach(function(name) {
        (name.match($cff12353be849bfd$var$matchIconName) ? valid : invalid).push(name);
    });
    return {
        valid: valid,
        invalid: invalid
    };
}
/**
* Parse loader response
*/ function $cff12353be849bfd$var$parseLoaderResponse(storage, icons, data) {
    function checkMissing() {
        var pending = storage.pendingIcons;
        icons.forEach(function(name) {
            if (pending) pending.delete(name);
            if (!storage.icons[name]) storage.missing.add(name);
        });
    }
    if (data && (typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) === "object") try {
        var parsed = $cff12353be849bfd$var$addIconSet(storage, data);
        if (!parsed.length) {
            checkMissing();
            return;
        }
    } catch (err) {
        console.error(err);
    }
    checkMissing();
    $cff12353be849bfd$var$loadedNewIcons(storage);
}
/**
* Handle response that can be async
*/ function $cff12353be849bfd$var$parsePossiblyAsyncResponse(response, callback) {
    if (response instanceof Promise) response.then(function(data) {
        callback(data);
    }).catch(function() {
        callback(null);
    });
    else callback(response);
}
/**
* Load icons
*/ function $cff12353be849bfd$var$loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(function() {
            storage.iconsQueueFlag = false;
            var provider = storage.provider, prefix = storage.prefix;
            var icons$1 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            if (!icons$1 || !icons$1.length) return;
            var customIconLoader = storage.loadIcon;
            if (storage.loadIcons && (icons$1.length > 1 || !customIconLoader)) {
                $cff12353be849bfd$var$parsePossiblyAsyncResponse(storage.loadIcons(icons$1, prefix, provider), function(data) {
                    $cff12353be849bfd$var$parseLoaderResponse(storage, icons$1, data);
                });
                return;
            }
            if (customIconLoader) {
                icons$1.forEach(function(name) {
                    var response = customIconLoader(name, prefix, provider);
                    $cff12353be849bfd$var$parsePossiblyAsyncResponse(response, function(data) {
                        var iconSet = data ? {
                            prefix: prefix,
                            icons: (0, $72osQ._)({}, name, data)
                        } : null;
                        $cff12353be849bfd$var$parseLoaderResponse(storage, [
                            name
                        ], iconSet);
                    });
                });
                return;
            }
            var _checkIconNamesForAPI = $cff12353be849bfd$var$checkIconNamesForAPI(icons$1), valid = _checkIconNamesForAPI.valid, invalid = _checkIconNamesForAPI.invalid;
            if (invalid.length) $cff12353be849bfd$var$parseLoaderResponse(storage, invalid, null);
            if (!valid.length) return;
            var api = prefix.match($cff12353be849bfd$var$matchIconName) ? $cff12353be849bfd$var$getAPIModule(provider) : null;
            if (!api) {
                $cff12353be849bfd$var$parseLoaderResponse(storage, valid, null);
                return;
            }
            var params = api.prepare(provider, prefix, valid);
            params.forEach(function(item) {
                $cff12353be849bfd$var$sendAPIQuery(provider, item, function(data) {
                    $cff12353be849bfd$var$parseLoaderResponse(storage, item.icons, data);
                });
            });
        });
    }
}
/**
* Load icons
*/ var $cff12353be849bfd$export$2527eb85cb3fa9f = function(icons, callback) {
    var cleanedIcons = $cff12353be849bfd$var$listToIcons(icons, true, $cff12353be849bfd$var$allowSimpleNames());
    var sortedIcons = $cff12353be849bfd$var$sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        var callCallback = true;
        if (callback) setTimeout(function() {
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, $cff12353be849bfd$var$emptyCallback);
        });
        return function() {
            callCallback = false;
        };
    }
    var newIcons = Object.create(null);
    var sources = [];
    var lastProvider, lastPrefix;
    sortedIcons.pending.forEach(function(icon) {
        var provider = icon.provider, prefix = icon.prefix;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push($cff12353be849bfd$var$getStorage(provider, prefix));
        var providerNewIcons = newIcons[provider] || (newIcons[provider] = Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach(function(icon) {
        var provider = icon.provider, prefix = icon.prefix, name = icon.name;
        var storage = $cff12353be849bfd$var$getStorage(provider, prefix);
        var pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach(function(storage) {
        var list = newIcons[storage.provider][storage.prefix];
        if (list.length) $cff12353be849bfd$var$loadNewIcons(storage, list);
    });
    return callback ? $cff12353be849bfd$var$storeCallback(callback, sortedIcons, sources) : $cff12353be849bfd$var$emptyCallback;
};
/**
* Load one icon using Promise
*/ var $cff12353be849bfd$export$8e757e0542ac47f6 = function(icon) {
    return new Promise(function(fulfill, reject) {
        var iconObj = typeof icon === "string" ? $cff12353be849bfd$var$stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        $cff12353be849bfd$export$2527eb85cb3fa9f([
            iconObj || icon
        ], function(loaded) {
            if (loaded.length && iconObj) {
                var data = $cff12353be849bfd$var$getIconData(iconObj);
                if (data) {
                    fulfill((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconProps, data));
                    return;
                }
            }
            reject(icon);
        });
    });
};
/**
* Set custom loader for multiple icons
*/ function $cff12353be849bfd$export$e4c6e88f1f5eeacc(loader, prefix, provider) {
    $cff12353be849bfd$var$getStorage(provider || "", prefix).loadIcons = loader;
}
/**
* Set custom loader for one icon
*/ function $cff12353be849bfd$export$605d11454a711a89(loader, prefix, provider) {
    $cff12353be849bfd$var$getStorage(provider || "", prefix).loadIcon = loader;
}
/**
* Convert IconifyIconCustomisations to FullIconCustomisations, checking value types
*/ function $cff12353be849bfd$var$mergeCustomisations(defaults, item) {
    var result = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, defaults);
    for(var key in item){
        var value = item[key];
        var valueType = typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value);
        if (key in $cff12353be849bfd$var$defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === (0, $bJtXW._)(result[key])) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
var $cff12353be849bfd$var$separator = /[\s,]+/;
/**
* Apply "flip" string to icon customisations
*/ function $cff12353be849bfd$var$flipFromString(custom, flip) {
    flip.split($cff12353be849bfd$var$separator).forEach(function(str) {
        var value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
/**
* Get rotation value
*/ function $cff12353be849bfd$var$rotateFromString(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value$1) {
        while(value$1 < 0)value$1 += 4;
        return value$1 % 4;
    }
    if (units === "") {
        var num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        var split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            var num1 = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num1)) return 0;
            num1 = num1 / split;
            return num1 % 1 === 0 ? cleanup(num1) : 0;
        }
    }
    return defaultValue;
}
/**
* Generate <svg>
*/ function $cff12353be849bfd$var$iconToHTML(body, attributes) {
    var renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : " xmlns:xlink=\"http://www.w3.org/1999/xlink\"";
    for(var attr in attributes)renderAttribsHTML += " " + attr + "=\"" + attributes[attr] + "\"";
    return "<svg xmlns=\"http://www.w3.org/2000/svg\"" + renderAttribsHTML + ">" + body + "</svg>";
}
/**
* Encode SVG for use in url()
*
* Short alternative to encodeURIComponent() that encodes only stuff used in SVG, generating
* smaller code.
*/ function $cff12353be849bfd$var$encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
/**
* Generate data: URL from SVG
*/ function $cff12353be849bfd$var$svgToData(svg) {
    return "data:image/svg+xml," + $cff12353be849bfd$var$encodeSVGforURL(svg);
}
/**
* Generate url() from SVG
*/ function $cff12353be849bfd$var$svgToURL(svg) {
    return "url(\"" + $cff12353be849bfd$var$svgToData(svg) + "\")";
}
var $cff12353be849bfd$var$policy;
/**
* Attempt to create policy
*/ function $cff12353be849bfd$var$createPolicy() {
    try {
        $cff12353be849bfd$var$policy = window.trustedTypes.createPolicy("iconify", {
            createHTML: function(s) {
                return s;
            }
        });
    } catch (err) {
        $cff12353be849bfd$var$policy = null;
    }
}
/**
* Clean up value for innerHTML assignment
*
* This code doesn't actually clean up anything.
* It is intended be used with Iconify icon data, which has already been validated
*/ function $cff12353be849bfd$var$cleanUpInnerHTML(html) {
    if ($cff12353be849bfd$var$policy === void 0) $cff12353be849bfd$var$createPolicy();
    return $cff12353be849bfd$var$policy ? $cff12353be849bfd$var$policy.createHTML(html) : html;
}
var $cff12353be849bfd$var$defaultExtendedIconCustomisations = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconCustomisations), {
    inline: false
});
/**
 * Default SVG attributes
 */ var $cff12353be849bfd$var$svgDefaults = {
    'xmlns': 'http://www.w3.org/2000/svg',
    'xmlnsXlink': 'http://www.w3.org/1999/xlink',
    'aria-hidden': true,
    'role': 'img'
};
/**
 * Style modes
 */ var $cff12353be849bfd$var$commonProps = {
    display: 'inline-block'
};
var $cff12353be849bfd$var$monotoneProps = {
    backgroundColor: 'currentColor'
};
var $cff12353be849bfd$var$coloredProps = {
    backgroundColor: 'transparent'
};
// Dynamically add common props to variables above
var $cff12353be849bfd$var$propsToAdd = {
    Image: 'var(--svg)',
    Repeat: 'no-repeat',
    Size: '100% 100%'
};
var $cff12353be849bfd$var$propsToAddTo = {
    WebkitMask: $cff12353be849bfd$var$monotoneProps,
    mask: $cff12353be849bfd$var$monotoneProps,
    background: $cff12353be849bfd$var$coloredProps
};
for(var $cff12353be849bfd$var$prefix in $cff12353be849bfd$var$propsToAddTo){
    var $cff12353be849bfd$var$list = $cff12353be849bfd$var$propsToAddTo[$cff12353be849bfd$var$prefix];
    for(var $cff12353be849bfd$var$prop in $cff12353be849bfd$var$propsToAdd)$cff12353be849bfd$var$list[$cff12353be849bfd$var$prefix + $cff12353be849bfd$var$prop] = $cff12353be849bfd$var$propsToAdd[$cff12353be849bfd$var$prop];
}
/**
 * Default values for customisations for inline icon
 */ var $cff12353be849bfd$var$inlineDefaults = (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultExtendedIconCustomisations), {
    inline: true
});
/**
 * Fix size: add 'px' to numbers
 */ function $cff12353be849bfd$var$fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? 'px' : '');
}
/**
 * Render icon
 */ var $cff12353be849bfd$var$render = function(// Icon must be validated before calling this function
icon, // Partial properties
props, // Icon name
name) {
    // Get default properties
    var defaultProps = props.inline ? $cff12353be849bfd$var$inlineDefaults : $cff12353be849bfd$var$defaultExtendedIconCustomisations;
    // Get all customisations
    var customisations = $cff12353be849bfd$var$mergeCustomisations(defaultProps, props);
    // Check mode
    var mode = props.mode || 'svg';
    // Create style
    var style = {};
    var customStyle = props.style || {};
    // Create SVG component properties
    var componentProps = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, mode === 'svg' ? $cff12353be849bfd$var$svgDefaults : {});
    if (name) {
        var iconName = $cff12353be849bfd$var$stringToIcon(name, false, true);
        if (iconName) {
            var classNames = [
                'iconify'
            ];
            var _$props = [
                'provider',
                'prefix'
            ];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _$props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prop = _step.value;
                    if (iconName[prop]) classNames.push('iconify--' + iconName[prop]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            componentProps.className = classNames.join(' ');
        }
    }
    // Get element properties
    for(var key in props){
        var value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case 'icon':
            case 'style':
            case 'children':
            case 'onLoad':
            case 'mode':
            case 'ssr':
            case 'fallback':
                break;
            // Forward ref
            case '_ref':
                componentProps.ref = value;
                break;
            // Merge class names
            case 'className':
                componentProps[key] = (componentProps[key] ? componentProps[key] + ' ' : '') + value;
                break;
            // Boolean attributes
            case 'inline':
            case 'hFlip':
            case 'vFlip':
                customisations[key] = value === true || value === 'true' || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case 'flip':
                if (typeof value === 'string') $cff12353be849bfd$var$flipFromString(customisations, value);
                break;
            // Color: copy to style
            case 'color':
                style.color = value;
                break;
            // Rotation as string
            case 'rotate':
                if (typeof value === 'string') customisations[key] = $cff12353be849bfd$var$rotateFromString(value);
                else if (typeof value === 'number') customisations[key] = value;
                break;
            // Remove aria-hidden
            case 'ariaHidden':
            case 'aria-hidden':
                if (value !== true && value !== 'true') delete componentProps['aria-hidden'];
                break;
            // Copy missing property if it does not exist in customisations
            default:
                if (defaultProps[key] === void 0) componentProps[key] = value;
        }
    }
    // Generate icon
    var item = $cff12353be849bfd$export$78c1051fc6863a0b(icon, customisations);
    var renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = '-0.125em';
    if (mode === 'svg') {
        // Add style
        componentProps.style = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, style, customStyle);
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        var localCounter = 0;
        var id = props.id;
        if (typeof id === 'string') // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, '_');
        // Add icon stuff
        componentProps.dangerouslySetInnerHTML = {
            __html: $cff12353be849bfd$var$cleanUpInnerHTML($cff12353be849bfd$export$cae0fa3719aa5dc4(item.body, id ? function() {
                return id + 'ID' + localCounter++;
            } : 'iconifyReact'))
        };
        return (0, $dQFEZ.createElement)('svg', componentProps);
    }
    // Render <span> with style
    var body = icon.body, width = icon.width, height = icon.height;
    var useMask = mode === 'mask' || (mode === 'bg' ? false : body.indexOf('currentColor') !== -1);
    // Generate SVG
    var html = $cff12353be849bfd$var$iconToHTML(body, (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, renderAttribs), {
        width: width + '',
        height: height + ''
    }));
    // Generate style
    componentProps.style = (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, style), {
        '--svg': $cff12353be849bfd$var$svgToURL(html),
        'width': $cff12353be849bfd$var$fixSize(renderAttribs.width),
        'height': $cff12353be849bfd$var$fixSize(renderAttribs.height)
    }), $cff12353be849bfd$var$commonProps, useMask ? $cff12353be849bfd$var$monotoneProps : $cff12353be849bfd$var$coloredProps, customStyle);
    return (0, $dQFEZ.createElement)('span', componentProps);
};
/**
 * Initialise stuff
 */ // Enable short names
$cff12353be849bfd$var$allowSimpleNames(true);
// Set API module
$cff12353be849bfd$var$setAPIModule('', $cff12353be849bfd$var$fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    var $cff12353be849bfd$var$_window = window;
    // Load icons from global "IconifyPreload"
    if ($cff12353be849bfd$var$_window.IconifyPreload !== void 0) {
        var $cff12353be849bfd$var$preload = $cff12353be849bfd$var$_window.IconifyPreload;
        var $cff12353be849bfd$var$err = 'Invalid IconifyPreload syntax.';
        if ((typeof $cff12353be849bfd$var$preload === "undefined" ? "undefined" : (0, $bJtXW._)($cff12353be849bfd$var$preload)) === 'object' && $cff12353be849bfd$var$preload !== null) ($cff12353be849bfd$var$preload instanceof Array ? $cff12353be849bfd$var$preload : [
            $cff12353be849bfd$var$preload
        ]).forEach(function(item) {
            try {
                if (// Check if item is an object and not null/array
                (typeof item === "undefined" ? "undefined" : (0, $bJtXW._)(item)) !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                (0, $bJtXW._)(item.icons) !== 'object' || typeof item.prefix !== 'string' || // Add icon set
                !$cff12353be849bfd$export$933f273b2a11730f(item)) console.error($cff12353be849bfd$var$err);
            } catch (e) {
                console.error($cff12353be849bfd$var$err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if ($cff12353be849bfd$var$_window.IconifyProviders !== void 0) {
        var $cff12353be849bfd$var$providers = $cff12353be849bfd$var$_window.IconifyProviders;
        if ((typeof $cff12353be849bfd$var$providers === "undefined" ? "undefined" : (0, $bJtXW._)($cff12353be849bfd$var$providers)) === 'object' && $cff12353be849bfd$var$providers !== null) for(var $cff12353be849bfd$var$key in $cff12353be849bfd$var$providers){
            var $cff12353be849bfd$var$err1 = 'IconifyProviders[' + $cff12353be849bfd$var$key + '] is invalid.';
            try {
                var $cff12353be849bfd$var$value = $cff12353be849bfd$var$providers[$cff12353be849bfd$var$key];
                if ((typeof $cff12353be849bfd$var$value === "undefined" ? "undefined" : (0, $bJtXW._)($cff12353be849bfd$var$value)) !== 'object' || !$cff12353be849bfd$var$value || $cff12353be849bfd$var$value.resources === void 0) continue;
                if (!$cff12353be849bfd$export$ddfda4eca64d59f6($cff12353be849bfd$var$key, $cff12353be849bfd$var$value)) console.error($cff12353be849bfd$var$err1);
            } catch (e) {
                console.error($cff12353be849bfd$var$err1);
            }
        }
    }
}
function $cff12353be849bfd$var$IconComponent(props) {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(!!props.ssr), 2), mounted = _useState[0], setMounted = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)({}), 2), abort = _useState1[0], setAbort = _useState1[1];
    // Get initial state
    function getInitialState(mounted) {
        if (mounted) {
            var name = props.icon;
            if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === 'object') // Icon as object
            return {
                name: '',
                data: name
            };
            var data = $cff12353be849bfd$var$getIconData(name);
            if (data) return {
                name: name,
                data: data
            };
        }
        return {
            name: ''
        };
    }
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(getInitialState(!!props.ssr)), 2), state = _useState2[0], setState = _useState2[1];
    // Cancel loading
    function cleanup() {
        var callback = abort.callback;
        if (callback) {
            callback();
            setAbort({});
        }
    }
    // Change state if it is different
    function changeState(newState) {
        if (JSON.stringify(state) !== JSON.stringify(newState)) {
            cleanup();
            setState(newState);
            return true;
        }
    }
    // Update state
    function updateState() {
        var _a;
        var name = props.icon;
        if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === 'object') {
            // Icon as object
            changeState({
                name: '',
                data: name
            });
            return;
        }
        // New icon or got icon data
        var data = $cff12353be849bfd$var$getIconData(name);
        if (changeState({
            name: name,
            data: data
        })) {
            if (data === undefined) {
                // Load icon, update state when done
                var callback = $cff12353be849bfd$export$2527eb85cb3fa9f([
                    name
                ], updateState);
                setAbort({
                    callback: callback
                });
            } else if (data) // Icon data is available: trigger onLoad callback if present
            (_a = props.onLoad) === null || _a === void 0 || _a.call(props, name);
        }
    }
    // Mounted state, cleanup for loader
    (0, $dQFEZ.useEffect)(function() {
        setMounted(true);
        return cleanup;
    }, []);
    // Icon changed or component mounted
    (0, $dQFEZ.useEffect)(function() {
        if (mounted) updateState();
    }, [
        props.icon,
        mounted
    ]);
    // Render icon
    var name = state.name, data = state.data;
    if (!data) return props.children ? props.children : props.fallback ? props.fallback : (0, $dQFEZ.createElement)('span', {});
    return $cff12353be849bfd$var$render((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, $cff12353be849bfd$var$defaultIconProps, data), props, name);
}
/**
 * Block icon
 *
 * @param props - Component properties
 */ var $cff12353be849bfd$export$f04a61298a47a40f = (0, $dQFEZ.forwardRef)(function(props, ref) {
    return $cff12353be849bfd$var$IconComponent((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props), {
        _ref: ref
    }));
});
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */ var $cff12353be849bfd$export$d1314c9fc3bb2a13 = (0, $dQFEZ.forwardRef)(function(props, ref) {
    return $cff12353be849bfd$var$IconComponent((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
        inline: true
    }, props), {
        _ref: ref
    }));
});
/**
 * Internal API
 */ var $cff12353be849bfd$export$14dadc205e26d636 = {
    getAPIConfig: $cff12353be849bfd$var$getAPIConfig,
    setAPIModule: $cff12353be849bfd$var$setAPIModule,
    sendAPIQuery: $cff12353be849bfd$var$sendAPIQuery,
    setFetch: $cff12353be849bfd$var$setFetch,
    getFetch: $cff12353be849bfd$var$getFetch,
    listAPIProviders: $cff12353be849bfd$var$listAPIProviders
};


var $30f9340b3b908793$export$d26e8f33c4622b5b = [
    {
        id: '100',
        title: 'Company',
        data: [
            'About',
            'Careers',
            'Team',
            'BiteSwift One',
            'BiteSwift Instamart',
            'BiteSwift Express'
        ]
    },
    {
        id: '101',
        title: 'Contact Us',
        data: [
            'Help & Support',
            'Partner with us',
            'Deliver with us'
        ]
    },
    {
        id: '102',
        title: 'Legal',
        data: [
            'Terms & Conditions',
            'Cookie Policy',
            'Privacy Policy',
            'Investor Relations'
        ]
    }
];
var $30f9340b3b908793$export$7f3e64c91644437c = [
    {
        type: 'general',
        title: 'General Issues',
        description: 'Covers general issues faced by customers, restaurant partners, and delivery partners on the BiteSwift platform.',
        data: [
            {
                id: 11500,
                title: 'What is BiteSwift Customer Care?',
                description: "We value your time, so we use a comprehensive chat-based support system instead of a single phone number. Just search for your issue in the Help section and start a chat \u2014 a support executive will be assigned to you promptly.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 206,
                title: 'I have a query related to placing an order',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 212,
                title: 'I am unable to log in to BiteSwift',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 215,
                title: 'I have a payment or refund related query',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 223,
                title: 'I have a coupon or offer related query',
                description: null,
                isLeaf: false,
                isResolutionNode: false,
                options: [
                    {
                        type: 'chat',
                        phoneNumber: null,
                        provider: 'chatengine',
                        waitTime: 'Wait time under 2 min(s)',
                        emailId: null
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 228,
                title: 'I want to unsubscribe from BiteSwift communications',
                description: "Email us mentioning which channels you would like to opt out from. We will process your request and confirm within 24\u201348 hours.",
                isLeaf: true,
                isResolutionNode: false,
                options: [
                    {
                        type: 'email',
                        phoneNumber: null,
                        provider: null,
                        waitTime: "We will revert within 24\u201348 hrs",
                        emailId: 'support@biteswift.in'
                    }
                ],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'partner-onboarding',
        title: 'Partner Onboarding',
        description: 'Everything you need to know about listing your restaurant or becoming a delivery partner on BiteSwift.',
        data: [
            {
                id: 492,
                title: 'I want to partner my restaurant with BiteSwift',
                description: null,
                isLeaf: false,
                isResolutionNode: true,
                options: [
                    {
                        type: 'email',
                        phoneNumber: null,
                        provider: null,
                        waitTime: "We will revert within 24\u201348 hrs",
                        emailId: 'partnersupport@biteswift.in'
                    }
                ],
                hyperLinkText: 'Partner with us',
                hyperLink: null
            },
            {
                id: 100175,
                title: 'What documents are needed to list my restaurant on BiteSwift?',
                description: 'The following documents are mandatory:\n- FSSAI Licence or FSSAI Acknowledgement\n- PAN Card\n- GSTIN Certificate\n- Cancelled Cheque or Bank Passbook\n- Menu',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100176,
                title: 'How long does it take for my restaurant to go live after submission?',
                description: "After all mandatory documents have been received and verified, it takes up to 7\u201310 working days for onboarding to be completed and your restaurant to go live.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100177,
                title: 'What is the one-time onboarding fee?',
                description: 'This is a one-time fee covering system and admin costs during onboarding. It is deducted from your weekly payouts after you begin receiving orders on BiteSwift.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100178,
                title: 'Who can I contact for help with onboarding?',
                description: "You can reach Partner Support by writing to onboarding@biteswift.in. Our team will respond within 24\u201348 hours.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100179,
                title: 'How much commission does BiteSwift charge?',
                description: 'Commission rates vary by city and restaurant category. You will see the applicable rate once your preliminary onboarding details have been submitted.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100180,
                title: "I don't have an FSSAI licence yet. Can I still onboard?",
                description: "FSSAI registration is mandatory per government policy. However, if your licence is pending, you may proceed with the FSSAI Acknowledgement number you received upon registration.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'legal',
        title: 'Legal, Terms & Conditions',
        description: 'Legal policies, terms of use, and data practices for all BiteSwift stakeholders.',
        data: [
            {
                id: 100043,
                title: 'Terms of Use',
                description: 'These Terms of Use govern your use of the BiteSwift website and mobile application (collectively, the "Services"). By installing, downloading, or using the Services you agree to be bound by these Terms. If you do not agree, please do not use the Services.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100044,
                title: 'Privacy Policy',
                description: 'BiteSwift is committed to protecting your privacy. This policy describes what personal information we collect, how we use it, and with whom we share it. By using BiteSwift you consent to the practices described here.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100045,
                title: 'Cancellations and Refunds',
                description: "You may cancel an order within 1 minute of placing it. After that, a cancellation fee of up to 100% of the order value may apply to compensate restaurant and delivery partners. BiteSwift reserves the right to deny refunds based on prior cancellation history.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            },
            {
                id: 100046,
                title: 'Cookie Policy',
                description: 'BiteSwift uses cookies and similar technologies to improve your experience, remember preferences, and analyse platform usage. You can manage cookie preferences in your browser settings at any time.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: 'Read More',
                hyperLink: null
            }
        ]
    },
    {
        type: 'faq',
        title: 'FAQs',
        description: 'Frequently asked questions about ordering, payments, delivery, and your BiteSwift account.',
        data: [
            {
                id: 100047,
                title: 'Can I edit my order?',
                description: 'Orders can be edited only before the restaurant confirms them. Click Help \u2192 "I want to modify items in my order" and a support agent will assist you.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100048,
                title: 'How do I cancel my order?',
                description: "Go to Help \u2192 'I want to cancel my order'. Cancellation fees may apply to compensate restaurant and delivery partners.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100050,
                title: 'Is there a minimum order value?',
                description: 'BiteSwift has no platform-wide minimum order value. Individual restaurants may set their own minimums, which are shown at checkout.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100051,
                title: 'Do you charge a delivery fee?',
                description: 'Delivery fees vary by city and restaurant. If a delivery fee applies it will be clearly shown on the Review Order page before you pay.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100052,
                title: 'How long does delivery take?',
                description: "Estimated delivery time is shown for each restaurant based on your location and current conditions. Most orders arrive within 30\u201345 minutes.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100053,
                title: 'What are your delivery hours?',
                description: 'Delivery hours depend on restaurant availability in your area. Most restaurants on BiteSwift operate from 8 AM to midnight.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100054,
                title: 'Can I order from any location?',
                description: 'BiteSwift delivers from any restaurant listed in your search results. Enable GPS so the app can detect your location and show nearby options.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100055,
                title: 'Can I order from multiple restaurants in one order?',
                description: 'Currently each order is fulfilled by one restaurant. You can place separate orders from different restaurants.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100057,
                title: 'Can I schedule an order in advance?',
                description: "Yes \u2014 tap the delivery time selector to choose a future slot. Scheduled ordering is available in select cities.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100058,
                title: 'Can I change the delivery address after placing an order?',
                description: 'Minor changes (flat number, landmark) are allowed. Major address changes are not possible after the order is placed. Contact support or call your delivery partner directly.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100060,
                title: "I didn't receive my referral reward",
                description: 'Referral rewards are credited after the referred person completes their first successful transaction. If you still have not received it, email support@biteswift.in within 48 hours.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100061,
                title: 'How do I deactivate my account?',
                description: 'Write to us at support@biteswift.in to request account deactivation. We will process it within 7 working days.',
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100074,
                title: 'Will BiteSwift be accountable for food quality or quantity?',
                description: "Quality and quantity are the restaurant's responsibility. If you experience an issue, submit feedback through the app and we will relay it to the restaurant.",
                isLeaf: true,
                isResolutionNode: false,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    },
    {
        type: 'biteswift-one-faq',
        title: 'BiteSwift One FAQs',
        description: "Everything about BiteSwift One \u2014 our membership plan with free deliveries, exclusive discounts, and more.",
        data: [
            {
                id: 100229,
                title: 'Are BiteSwift One benefits available at all restaurants?',
                description: 'Free delivery applies to all food delivery restaurants within 10 km of your location. Member-only discounts of up to 30% are available at select partner restaurants, on top of regular offers.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100228,
                title: 'Is there a limit on free deliveries?',
                description: "No. BiteSwift One members get unlimited free deliveries on all restaurants within 10 km for all orders above \u20B9149, throughout the membership period.",
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100223,
                title: 'Can I club BiteSwift One discounts with other offers?',
                description: 'Yes. BiteSwift One extra discounts are applied on top of regular restaurant offers. There is no upper cap on savings.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100227,
                title: 'How do I renew my membership?',
                description: 'You can purchase a new plan after your current one expires. Early renewal is not available yet.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100225,
                title: 'Can I cancel, pause, or transfer my membership?',
                description: 'Currently, cancellation, pausing, or transfer of BiteSwift One memberships is not supported. We are working to offer this in the future.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100233,
                title: 'On which platforms can I use BiteSwift One benefits?',
                description: 'BiteSwift One benefits are available on Android, iOS, and mobile web. Desktop is not currently supported.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            },
            {
                id: 100265,
                title: 'Is BiteSwift One available in all cities?',
                description: 'BiteSwift One is currently available in select cities. We are expanding to more cities soon.',
                isLeaf: true,
                isResolutionNode: true,
                options: [],
                hyperLinkText: null,
                hyperLink: null
            }
        ]
    }
];



var $0285261d32b071b9$var$SOCIAL_LINKS = [
    {
        label: 'Portfolio',
        icon: 'lucide:globe',
        href: 'https://singhshiv.netlify.app/'
    },
    {
        label: 'GitHub',
        icon: 'lucide:github',
        href: 'https://github.com/sh1v-max'
    },
    {
        label: 'LinkedIn',
        icon: 'lucide:linkedin',
        href: 'https://www.linkedin.com/in/shiv-shankar-singh-/'
    },
    {
        label: 'X',
        icon: 'simple-icons:x',
        href: 'https://x.com/1amWaziR'
    },
    {
        label: 'Email',
        icon: 'lucide:mail',
        href: 'mailto:singhshiv0427@gmail.com'
    }
];
// Which footer column labels should link to a real route
var $0285261d32b071b9$var$ROUTE_MAP = {
    About: '/about',
    'Help & Support': '/contact'
};
var $0285261d32b071b9$var$Footer = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "footer-inner",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "footer-brand",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $lEL1W.Link), {
                                to: "/",
                                className: "footer-logo",
                                children: [
                                    "\uD83C\uDF7D\uFE0F ",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "BiteSwift"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "footer-tagline",
                                children: "Delivering happiness, one meal at a time. Fast, fresh, and always on time."
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "footer-social",
                                children: $0285261d32b071b9$var$SOCIAL_LINKS.map(function(param) {
                                    var label = param.label, icon = param.icon, href = param.href;
                                    return /*#__PURE__*/ (0, $iD4WH.jsx)("a", (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                                        href: href,
                                        className: "footer-social-icon",
                                        "aria-label": label,
                                        title: label
                                    }, !href.startsWith('mailto:') && {
                                        target: '_blank',
                                        rel: 'noopener noreferrer'
                                    }), {
                                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $cff12353be849bfd$export$f04a61298a47a40f), {
                                            icon: icon,
                                            width: 18,
                                            height: 18
                                        })
                                    }), label);
                                })
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "footer-app-badges",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                        className: "app-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "badge-icon",
                                                children: "\uD83D\uDCF1"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("small", {
                                                        children: "Get it on"
                                                    }),
                                                    "Google Play"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                        className: "app-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "badge-icon",
                                                children: "\uD83C\uDF4E"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("small", {
                                                        children: "Download on the"
                                                    }),
                                                    "App Store"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $30f9340b3b908793$export$d26e8f33c4622b5b).map(function(section) {
                        return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "footer-col",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                                    className: "footer-col-title",
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsx)("ul", {
                                    className: "footer-col-list",
                                    children: section.data.map(function(item) {
                                        return $0285261d32b071b9$var$ROUTE_MAP[item] ? /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                                                to: $0285261d32b071b9$var$ROUTE_MAP[item],
                                                className: "footer-link",
                                                children: item
                                            })
                                        }, item) : /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "footer-link",
                                                children: item
                                            })
                                        }, item);
                                    })
                                })
                            ]
                        }, section.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "footer-bottom",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " BiteSwift Technologies Pvt. Ltd. All rights reserved."
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                        className: "footer-bottom-right",
                        children: "Made with \u2764\uFE0F in India"
                    })
                ]
            })
        ]
    });
};
var $0285261d32b071b9$export$2e2bcd8739ae039 = $0285261d32b071b9$var$Footer;



var $iD4WH = parcelRequire("iD4WH");


var $lEL1W = parcelRequire("lEL1W");

var $a8d71aff005fbb78$var$FEATURES = [
    {
        icon: "\uD83D\uDE80",
        title: 'Fast & Reliable',
        desc: 'Average delivery in 30 minutes, tracked live from kitchen to your door.'
    },
    {
        icon: "\uD83C\uDF7D\uFE0F",
        title: 'Wide Selection',
        desc: '200+ restaurants across every cuisine, from biryani to bubble tea.'
    },
    {
        icon: "\uD83D\uDCB0",
        title: 'Fair Pricing',
        desc: "Transparent fees and regular offers \u2014 no hidden surprises at checkout."
    },
    {
        icon: "\uD83D\uDD12",
        title: 'Secure Payments',
        desc: "UPI, cards, or cash on delivery \u2014 your choice, always protected."
    }
];
var $a8d71aff005fbb78$var$About = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "about-page",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "about-hero",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "about-detail",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "about-eyebrow",
                                children: "About BiteSwift"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("h1", {
                                children: [
                                    "Food delivery,",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "done right."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "about-lede",
                                children: "We connect you with the best restaurants in your city \u2014 fast delivery, fresh food, and a seamless ordering experience from browse to bite."
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "about-stats",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                                children: "200+"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                children: "Restaurants"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                                children: "30 min"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                children: "Avg delivery"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                                children: "4.8\u2605"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                children: "Avg rating"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                                to: "/contact",
                                className: "about-cta",
                                children: "Get in touch \u2192"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "about-img",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                            className: "image",
                            src: (0, $1ad00fd5a6f8ced9$export$a91f4fe650c27642),
                            alt: "Fresh food from BiteSwift"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "about-features",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                        children: "Why choose BiteSwift?"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "about-features-grid",
                        children: $a8d71aff005fbb78$var$FEATURES.map(function(f) {
                            return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "about-feature-card",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "about-feature-icon",
                                        children: f.icon
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                                        children: f.title
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                        children: f.desc
                                    })
                                ]
                            }, f.title);
                        })
                    })
                ]
            })
        ]
    });
};
var $a8d71aff005fbb78$export$2e2bcd8739ae039 = $a8d71aff005fbb78$var$About;



var $72osQ = parcelRequire("72osQ");



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");


var $700624f0f3cfba7a$var$DEV_LINKS = [
    {
        label: 'Email',
        icon: 'lucide:mail',
        href: 'mailto:singhshiv0427@gmail.com'
    },
    {
        label: 'GitHub',
        icon: 'lucide:github',
        href: 'https://github.com/sh1v-max'
    },
    {
        label: 'LinkedIn',
        icon: 'lucide:linkedin',
        href: 'https://www.linkedin.com/in/shiv-shankar-singh-/'
    },
    {
        label: 'X',
        icon: 'simple-icons:x',
        href: 'https://x.com/1amWaziR'
    },
    {
        label: 'Portfolio',
        icon: 'lucide:globe',
        href: 'https://singhshiv.netlify.app/'
    }
];
var $700624f0f3cfba7a$var$Contact = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)({
        name: '',
        email: '',
        message: ''
    }), 2), form = _useState[0], setForm = _useState[1];
    var _useState1 // idle | sending | sent
     = (0, $2nwvT._)((0, $dQFEZ.useState)('idle'), 2), status = _useState1[0], setStatus = _useState1[1];
    var handleChange = function(e) {
        return setForm(function(f) {
            return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, f), (0, $72osQ._)({}, e.target.name, e.target.value));
        });
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        setStatus('sending');
        setTimeout(function() {
            setStatus('sent');
            setForm({
                name: '',
                email: '',
                message: ''
            });
        }, 1200);
    };
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "contact-container",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                className: "contact-us",
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                className: "description",
                children: "We'd love to hear from you \u2014 questions, feedback, or just a hello. Reach out any time."
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "dev-contact",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                        className: "dev-contact-label",
                        children: "This project was built by Shiv Shankar Singh \u2014 connect directly:"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "dev-contact-links",
                        children: $700624f0f3cfba7a$var$DEV_LINKS.map(function(param) {
                            var label = param.label, icon = param.icon, href = param.href;
                            return /*#__PURE__*/ (0, $iD4WH.jsx)("a", (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                                href: href,
                                className: "dev-contact-link",
                                "aria-label": label,
                                title: label
                            }, !href.startsWith('mailto:') && {
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            }), {
                                children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $cff12353be849bfd$export$f04a61298a47a40f), {
                                    icon: icon,
                                    width: 18,
                                    height: 18
                                })
                            }), label);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "contact-info",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCCD"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                children: "Address"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                children: "BiteSwift HQ, 12th Floor, Tower B, Embassy TechVillage, Bangalore \u2013 560103"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCDE"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                children: "Phone"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                                children: [
                                    "+91 70689 00427",
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("br", {}),
                                    "Mon \u2013 Sat, 9 AM \u2013 9 PM"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                className: "contact-icon",
                                children: "\uD83D\uDCE7"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                children: "support@biteswift.in"
                            })
                        ]
                    })
                ]
            }),
            status === 'sent' ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "contact-success",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        children: "\u2705"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                        children: "Message sent!"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                        children: "Thanks for reaching out \u2014 we'll get back to you within 24 hours."
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        onClick: function() {
                            return setStatus('idle');
                        },
                        children: "Send another message"
                    })
                ]
            }) : /*#__PURE__*/ (0, $iD4WH.jsxs)("form", {
                className: "contact-form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                        children: "Send Us a Message"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                        type: "text",
                        name: "name",
                        placeholder: "Your Name",
                        value: form.name,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                        type: "email",
                        name: "email",
                        placeholder: "Your Email",
                        value: form.email,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("textarea", {
                        name: "message",
                        placeholder: "Your Message",
                        rows: "4",
                        value: form.message,
                        onChange: handleChange,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        type: "submit",
                        disabled: status === 'sending',
                        children: status === 'sending' ? /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            className: "contact-spinner"
                        }) : 'Send Message'
                    })
                ]
            })
        ]
    });
};
var $700624f0f3cfba7a$export$2e2bcd8739ae039 = $700624f0f3cfba7a$var$Contact;



var $iD4WH = parcelRequire("iD4WH");

var $c2rik = parcelRequire("c2rik");
var $4e1b68af05c768aa$var$Error = function() {
    var err = (0, $c2rik.useRouteError)();
    console.log(err);
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "error-container",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("main", {
            className: "error-content",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                    children: "Oops!"
                }),
                /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                    children: [
                        err.status,
                        ": ",
                        err.statusText
                    ]
                })
            ]
        })
    });
};
var $4e1b68af05c768aa$export$2e2bcd8739ae039 = $4e1b68af05c768aa$var$Error;



var $lEL1W = parcelRequire("lEL1W");
var $c2rik = parcelRequire("c2rik");



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");



var $lEL1W = parcelRequire("lEL1W");
var $c2rik = parcelRequire("c2rik");
var $c2rik = parcelRequire("c2rik");

var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $dQFEZ = parcelRequire("dQFEZ");

// Fallback menu data used when the Swiggy menu API is unreachable.
// Structure mirrors the real Swiggy API response shape so no component changes needed.
// imageId values starting with "https://" are handled as full URLs in ItemList.js.
// veg/non-veg is inferred from the name+description text, bestseller from rating —
// keeps every makeItem() call site untouched while still populating the real
// Swiggy fields (itemAttribute.vegClassifier, ribbon.text) that ItemList.js reads.


var $73b46ff5a16647e9$var$NON_VEG_HINTS = [
    'chicken',
    'lamb',
    'mutton',
    'fish',
    'prawn',
    'shrimp',
    'pepperoni',
    'bacon',
    'pork',
    'guanciale',
    'seekh',
    'kebab'
];
var $73b46ff5a16647e9$var$makeItem = function(id, name, price, description, imageId) {
    var rating = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : '4.1', ratingCount = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : '120+';
    var haystack = "".concat(name, " ").concat(description).toLowerCase();
    var isVeg = !$73b46ff5a16647e9$var$NON_VEG_HINTS.some(function(hint) {
        return haystack.includes(hint);
    });
    var isBestseller = parseFloat(rating) >= 4.4;
    return {
        card: {
            info: (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({
                id: id,
                name: name,
                price: price * 100,
                defaultPrice: price * 100,
                description: description,
                imageId: imageId,
                itemAttribute: {
                    vegClassifier: isVeg ? 'VEG' : 'NONVEG'
                }
            }, isBestseller && {
                ribbon: {
                    text: 'Bestseller'
                }
            }), {
                ratings: {
                    aggregatedRating: {
                        rating: rating,
                        ratingCountV2: ratingCount
                    }
                }
            })
        }
    };
};
var $73b46ff5a16647e9$var$makeCategory = function(title, items) {
    return {
        card: {
            card: {
                '@type': 'type.googleapis.com/swiggy.presentation.food.v2.ItemCategory',
                title: title,
                itemCards: items
            }
        }
    };
};
var $73b46ff5a16647e9$var$makeMenu = function(resId, info, categories) {
    return {
        cards: [
            {},
            {},
            {
                card: {
                    card: {
                        info: info
                    }
                }
            },
            {},
            {
                groupedCard: {
                    cardGroupMap: {
                        REGULAR: {
                            cards: categories
                        }
                    }
                }
            }
        ]
    };
};
// ─── North Indian — The Spice Route (mock-101) ───────────────────────────────
var $73b46ff5a16647e9$var$SPICE_ROUTE_MENU = $73b46ff5a16647e9$var$makeMenu('mock-101', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=660&q=80',
    name: 'The Spice Route',
    areaName: 'Koramangala',
    avgRating: 4.4,
    avgRatingString: '4.4',
    totalRatingsString: '5K+ ratings',
    costForTwoMessage: "\u20B9350 for two",
    cuisines: [
        'North Indian',
        'Mughlai',
        'Biryani'
    ],
    sla: {
        slaString: '28-33 mins'
    }
}, [
    $73b46ff5a16647e9$var$makeCategory("Bestsellers \uD83D\uDD25", [
        $73b46ff5a16647e9$var$makeItem('i101a', 'Butter Chicken', 299, 'Tender chicken in a rich, creamy tomato-butter gravy. Best paired with naan.', 'https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?w=300&q=80', '4.5', '2.1K+'),
        $73b46ff5a16647e9$var$makeItem('i101b', 'Dal Makhani', 229, 'Slow-cooked black lentils simmered overnight in butter and cream. A classic.', 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=300&q=80', '4.3', '1.4K+'),
        $73b46ff5a16647e9$var$makeItem('i101c', 'Chicken Biryani', 349, 'Fragrant basmati rice layered with spiced chicken, saffron, and caramelised onions.', 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=300&q=80', '4.6', '3.2K+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Breads & Rice', [
        $73b46ff5a16647e9$var$makeItem('i101d', 'Garlic Naan', 69, 'Soft leavened bread brushed with garlic butter, baked in a tandoor.', 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=300&q=80', '4.2', '800+'),
        $73b46ff5a16647e9$var$makeItem('i101e', 'Steamed Basmati Rice', 79, 'Long-grain aromatic basmati rice, steamed to perfection.', 'https://images.unsplash.com/photo-1536304993881-ff86e0c9b5d0?w=300&q=80', '4.0', '600+'),
        $73b46ff5a16647e9$var$makeItem('i101f', 'Laccha Paratha', 89, 'Flaky, layered whole wheat flatbread cooked on a griddle with butter.', 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=300&q=80', '4.1', '450+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Starters', [
        $73b46ff5a16647e9$var$makeItem('i101g', 'Chicken Tikka', 279, 'Juicy chicken marinated in yoghurt and spices, char-grilled in the tandoor.', 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=300&q=80', '4.4', '1.8K+'),
        $73b46ff5a16647e9$var$makeItem('i101h', 'Paneer Tikka', 249, 'Cottage cheese cubes marinated in spiced yoghurt and grilled with peppers & onions.', 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=300&q=80', '4.3', '1.2K+'),
        $73b46ff5a16647e9$var$makeItem('i101i', 'Seekh Kebab', 299, 'Minced lamb mixed with herbs and spices, skewered and grilled over charcoal.', 'https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?w=300&q=80', '4.2', '950+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Desserts', [
        $73b46ff5a16647e9$var$makeItem('i101j', 'Gulab Jamun', 99, 'Soft milk-solid dumplings soaked in rose-flavoured sugar syrup. Served warm.', 'https://images.unsplash.com/photo-1551024709-8f23081b5cc2?w=300&q=80', '4.5', '700+'),
        $73b46ff5a16647e9$var$makeItem('i101k', 'Kheer', 119, 'Creamy rice pudding simmered with cardamom, saffron, and topped with pistachios.', 'https://images.unsplash.com/photo-1505253716362-afaea1d3d1af?w=300&q=80', '4.2', '480+')
    ])
]);
// ─── Italian — Pizzeria Roma (mock-102) ──────────────────────────────────────
var $73b46ff5a16647e9$var$PIZZERIA_ROMA_MENU = $73b46ff5a16647e9$var$makeMenu('mock-102', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=660&q=80',
    name: 'Pizzeria Roma',
    areaName: 'Indiranagar',
    avgRating: 4.5,
    avgRatingString: '4.5',
    totalRatingsString: '8K+ ratings',
    costForTwoMessage: "\u20B9450 for two",
    cuisines: [
        'Pizza',
        'Italian',
        'Pasta'
    ],
    sla: {
        slaString: '25-30 mins'
    }
}, [
    $73b46ff5a16647e9$var$makeCategory("Pizzas \uD83C\uDF55", [
        $73b46ff5a16647e9$var$makeItem('i102a', 'Margherita', 299, 'San Marzano tomato, fresh mozzarella, basil, extra-virgin olive oil. A timeless classic.', 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=300&q=80', '4.6', '3.5K+'),
        $73b46ff5a16647e9$var$makeItem('i102b', 'Pepperoni Feast', 399, 'Loaded with premium pepperoni slices on a mozzarella base with rich tomato sauce.', 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=300&q=80', '4.7', '4.1K+'),
        $73b46ff5a16647e9$var$makeItem('i102c', 'BBQ Chicken', 429, 'Smoky BBQ base, grilled chicken, red onions, and mozzarella finished with fresh coriander.', 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=300&q=80', '4.4', '2.2K+'),
        $73b46ff5a16647e9$var$makeItem('i102d', 'Farm Veggie', 349, 'Bell peppers, mushrooms, olives, sun-dried tomatoes, and spinach on a garlic white sauce.', 'https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=300&q=80', '4.2', '1.1K+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Pasta', [
        $73b46ff5a16647e9$var$makeItem('i102e', 'Penne Arrabbiata', 279, 'Penne in a spicy San Marzano tomato and garlic sauce with fresh basil.', 'https://images.unsplash.com/photo-1608219992759-8d74ed8d76eb?w=300&q=80', '4.3', '980+'),
        $73b46ff5a16647e9$var$makeItem('i102f', 'Spaghetti Carbonara', 329, 'Spaghetti tossed with egg, pecorino romano, guanciale, and black pepper.', 'https://images.unsplash.com/photo-1612874742237-6526221588e3?w=300&q=80', '4.5', '1.6K+'),
        $73b46ff5a16647e9$var$makeItem('i102g', 'Pesto Fusilli', 299, 'Fusilli with house-made basil pesto, cherry tomatoes, and parmesan shavings.', 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=300&q=80', '4.2', '760+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Sides & Drinks', [
        $73b46ff5a16647e9$var$makeItem('i102h', 'Garlic Bread', 149, "Toasted ciabatta with roasted garlic butter and parsley. Add cheese for \u20B930 extra.", 'https://images.unsplash.com/photo-1619535860434-cf9b902db9b6?w=300&q=80', '4.4', '2.4K+'),
        $73b46ff5a16647e9$var$makeItem('i102i', 'Tiramisu', 199, 'Classic Italian dessert with espresso-soaked ladyfingers and mascarpone cream.', 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=300&q=80', '4.6', '1.3K+'),
        $73b46ff5a16647e9$var$makeItem('i102j', 'San Pellegrino Sparkling', 99, 'Chilled Italian sparkling mineral water, 500ml.', 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=300&q=80', '4.0', '300+')
    ])
]);
// ─── Chinese — Dragon Bowl (mock-103) ────────────────────────────────────────
var $73b46ff5a16647e9$var$DRAGON_BOWL_MENU = $73b46ff5a16647e9$var$makeMenu('mock-103', {
    cloudinaryImageId: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=660&q=80',
    name: 'Dragon Bowl',
    areaName: 'HSR Layout',
    avgRating: 4.2,
    avgRatingString: '4.2',
    totalRatingsString: '3K+ ratings',
    costForTwoMessage: "\u20B9300 for two",
    cuisines: [
        'Chinese',
        'Asian',
        'Noodles'
    ],
    sla: {
        slaString: '30-35 mins'
    }
}, [
    $73b46ff5a16647e9$var$makeCategory("Dim Sum & Starters \uD83E\uDD5F", [
        $73b46ff5a16647e9$var$makeItem('i103a', 'Steamed Chicken Dumplings', 199, 'Juicy chicken and ginger dumplings, steamed and served with soy-chilli dipping sauce.', 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=300&q=80', '4.5', '1.8K+'),
        $73b46ff5a16647e9$var$makeItem('i103b', 'Crispy Spring Rolls', 169, 'Golden fried rolls stuffed with glass noodles, cabbage, and mushrooms.', 'https://images.unsplash.com/photo-1515669097368-22e68427d265?w=300&q=80', '4.2', '1.1K+'),
        $73b46ff5a16647e9$var$makeItem('i103c', 'Chilli Chicken (Dry)', 229, 'Wok-tossed crispy chicken with chillies, soy, and sesame. A restaurant classic.', 'https://images.unsplash.com/photo-1603360946369-dc9bb6258143?w=300&q=80', '4.4', '2.3K+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Noodles & Rice', [
        $73b46ff5a16647e9$var$makeItem('i103d', 'Hakka Noodles', 199, 'Wok-tossed egg noodles with vegetables in a dark soy and sesame sauce.', 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=300&q=80', '4.3', '1.9K+'),
        $73b46ff5a16647e9$var$makeItem('i103e', 'Schezwan Fried Rice', 219, 'Spicy Schezwan sauce tossed with rice, eggs, spring onions, and your choice of protein.', 'https://images.unsplash.com/photo-1536304993881-ff86e0c9b5d0?w=300&q=80', '4.2', '1.4K+'),
        $73b46ff5a16647e9$var$makeItem('i103f', 'Singapore Noodles', 239, 'Thin rice vermicelli stir-fried with curry powder, shrimp, and colourful vegetables.', 'https://images.unsplash.com/photo-1569050467447-ce54b3bbc37d?w=300&q=80', '4.1', '820+')
    ]),
    $73b46ff5a16647e9$var$makeCategory('Soups', [
        $73b46ff5a16647e9$var$makeItem('i103g', 'Hot & Sour Soup', 149, 'Bold, tangy broth with tofu, mushrooms, bamboo shoots, and chilli oil.', 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=300&q=80', '4.0', '640+'),
        $73b46ff5a16647e9$var$makeItem('i103h', 'Sweet Corn Chicken Soup', 139, 'Comforting cream-style corn soup with shredded chicken and egg ribbons.', 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=300&q=80', '4.1', '570+')
    ])
]);
// ─── Generic fallback (shown for mock-104 through mock-120) ──────────────────
var $73b46ff5a16647e9$var$GENERIC_MENU = function(resId, resName, cuisine) {
    return $73b46ff5a16647e9$var$makeMenu(resId, {
        cloudinaryImageId: 'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=660&q=80',
        name: resName,
        areaName: 'Bangalore',
        avgRating: 4.2,
        avgRatingString: '4.2',
        totalRatingsString: '1K+ ratings',
        costForTwoMessage: "\u20B9300 for two",
        cuisines: [
            cuisine
        ],
        sla: {
            slaString: '30-35 mins'
        }
    }, [
        $73b46ff5a16647e9$var$makeCategory('Popular', [
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-a"), 'Chef\'s Special', 299, 'Our most-loved dish, prepared fresh with premium ingredients and the chef\'s secret spice blend.', 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=300&q=80', '4.4', '900+'),
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-b"), 'Classic Combo', 349, "A satisfying combination of our bestsellers served together \u2014 great value for one.", 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=300&q=80', '4.2', '650+'),
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-c"), 'House Starter', 179, 'A crispy, flavourful starter that\'s been a crowd favourite since day one.', 'https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?w=300&q=80', '4.1', '480+')
        ]),
        $73b46ff5a16647e9$var$makeCategory('Mains', [
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-d"), 'Signature Main Course', 329, "Our flagship main course \u2014 bold flavours, generous portions, made to order.", 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=300&q=80', '4.3', '1.1K+'),
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-e"), 'Vegetarian Delight', 249, 'A hearty, flavour-packed vegetarian option that satisfies every time.', 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=300&q=80', '4.0', '420+')
        ]),
        $73b46ff5a16647e9$var$makeCategory('Desserts & Drinks', [
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-f"), 'House Dessert', 149, "A sweet finish to your meal \u2014 ask your delivery partner for today's special.", 'https://images.unsplash.com/photo-1551024709-8f23081b5cc2?w=300&q=80', '4.3', '390+'),
            $73b46ff5a16647e9$var$makeItem("".concat(resId, "-g"), 'Fresh Lime Soda', 79, "Chilled fresh lime with soda \u2014 sweet, salted, or mixed.", 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=300&q=80', '4.0', '290+')
        ])
    ]);
};
// Map of resId → menu data
var $73b46ff5a16647e9$var$MOCK_MENU_MAP = {
    'mock-101': $73b46ff5a16647e9$var$SPICE_ROUTE_MENU,
    'mock-102': $73b46ff5a16647e9$var$PIZZERIA_ROMA_MENU,
    'mock-103': $73b46ff5a16647e9$var$DRAGON_BOWL_MENU
};
var $73b46ff5a16647e9$export$c9a7a65a56a52b97 = function(resId) {
    var resName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'Restaurant', cuisine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'Indian';
    var _MOCK_MENU_MAP_resId;
    return (_MOCK_MENU_MAP_resId = $73b46ff5a16647e9$var$MOCK_MENU_MAP[resId]) !== null && _MOCK_MENU_MAP_resId !== void 0 ? _MOCK_MENU_MAP_resId : $73b46ff5a16647e9$var$GENERIC_MENU(resId, resName, cuisine);
};
var $73b46ff5a16647e9$export$2e2bcd8739ae039 = $73b46ff5a16647e9$var$MOCK_MENU_MAP;


var $b70bbb8b216b90ce$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function() {
            var _parsed_cards, data, json, parsed, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch((0, $1ad00fd5a6f8ced9$export$b77c1aa4fb57bd1c) + resId)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        parsed = json === null || json === void 0 ? void 0 : json.data;
                        // Swiggy's menu API is reliably blocked by bot-detection outside a real
                        // browser session — fall back to a mock menu so the page still works.
                        if (parsed && ((_parsed_cards = parsed.cards) === null || _parsed_cards === void 0 ? void 0 : _parsed_cards.length)) setResInfo(parsed);
                        else setResInfo((0, $73b46ff5a16647e9$export$c9a7a65a56a52b97)(resId));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setResInfo((0, $73b46ff5a16647e9$export$c9a7a65a56a52b97)(resId));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $b70bbb8b216b90ce$export$2e2bcd8739ae039 = $b70bbb8b216b90ce$var$useRestaurantMenu;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $e883a8b060cd5681$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
var $e883a8b060cd5681$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("arrow-left", $e883a8b060cd5681$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $3e695f5cdc6c1429$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
var $3e695f5cdc6c1429$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("search", $3e695f5cdc6c1429$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $59911afdede6064b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
var $59911afdede6064b$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("star", $59911afdede6064b$export$3efd853dbb351e94);



var $iD4WH = parcelRequire("iD4WH");

var $iD4WH = parcelRequire("iD4WH");






var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $8wAe0 = parcelRequire("8wAe0");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $gyGuQ = parcelRequire("gyGuQ");
function $d079121360b168c5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $gyGuQ._)(object);
        if (object === null) break;
    }
    return object;
}


function $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $8665ac34acf389ad$export$71511d61b312f219 = Reflect.get;
    else $8665ac34acf389ad$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $d079121360b168c5$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver || target);
}



var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");
// src/utils/formatProdErrorMessage.ts

var $72osQ = parcelRequire("72osQ");



var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
function $20ec22595b3da151$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $20ec22595b3da151$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $20ec22595b3da151$var$symbol_observable_default = $20ec22595b3da151$var$$$observable;
// src/utils/actionTypes.ts
var $20ec22595b3da151$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $20ec22595b3da151$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($20ec22595b3da151$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($20ec22595b3da151$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($20ec22595b3da151$var$randomString());
    }
};
var $20ec22595b3da151$export$4219e499db7ca678 = $20ec22595b3da151$var$ActionTypes;
// src/utils/isPlainObject.ts
function $20ec22595b3da151$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $20ec22595b3da151$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($20ec22595b3da151$var$isDate(val)) return "date";
    if ($20ec22595b3da151$var$isError(val)) return "error";
    var constructorName = $20ec22595b3da151$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $20ec22595b3da151$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $20ec22595b3da151$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $20ec22595b3da151$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $20ec22595b3da151$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(1));
        return enhancer($20ec22595b3da151$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$20ec22595b3da151$export$53b83ca8eaab0383(action)) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $20ec22595b3da151$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $72osQ._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $bJtXW._)(observer)) !== "object" || observer === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $20ec22595b3da151$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $20ec22595b3da151$export$4219e499db7ca678.INIT
    });
    var store = (0, $72osQ._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $20ec22595b3da151$var$symbol_observable_default, observable);
    return store;
}
function $20ec22595b3da151$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $20ec22595b3da151$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $20ec22595b3da151$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $20ec22595b3da151$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$20ec22595b3da151$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($20ec22595b3da151$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $20ec22595b3da151$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $20ec22595b3da151$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(13));
    });
}
function $20ec22595b3da151$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $20ec22595b3da151$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $20ec22595b3da151$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $20ec22595b3da151$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $bJtXW._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $20ec22595b3da151$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2us1u._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $20ec22595b3da151$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2us1u._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $20ec22595b3da151$export$f672e0b6f7222cd7.apply(void 0, (0, $2us1u._)(chain))(store.dispatch);
            return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $20ec22595b3da151$export$b956e38827fca970(action) {
    return $20ec22595b3da151$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $kK8g8 = parcelRequire("kK8g8");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
var $b262cabcae0d8be6$var$__defProp = Object.defineProperty;
var $b262cabcae0d8be6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b262cabcae0d8be6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b262cabcae0d8be6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b262cabcae0d8be6$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b262cabcae0d8be6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b262cabcae0d8be6$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b262cabcae0d8be6$var$__hasOwnProp.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($b262cabcae0d8be6$var$__getOwnPropSymbols) try {
        for(var _iterator = $b262cabcae0d8be6$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($b262cabcae0d8be6$var$__propIsEnum.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $b262cabcae0d8be6$var$__publicField = function(obj, key, value) {
    $b262cabcae0d8be6$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b262cabcae0d8be6$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b262cabcae0d8be6$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2us1u._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b262cabcae0d8be6$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b262cabcae0d8be6$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($b262cabcae0d8be6$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b262cabcae0d8be6$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $b262cabcae0d8be6$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $bJtXW._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $bJtXW._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $b262cabcae0d8be6$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b262cabcae0d8be6$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b262cabcae0d8be6$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b262cabcae0d8be6$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, $b262cabcae0d8be6$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b262cabcae0d8be6$var$$REVISION = 0;
var $b262cabcae0d8be6$var$CURRENT_TRACKER = null;
var $b262cabcae0d8be6$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
        (0, $grujF._)(this, Cell);
        $b262cabcae0d8be6$var$__publicField(this, "revision", $b262cabcae0d8be6$var$$REVISION);
        $b262cabcae0d8be6$var$__publicField(this, "_value");
        $b262cabcae0d8be6$var$__publicField(this, "_lastValue");
        $b262cabcae0d8be6$var$__publicField(this, "_isEqual", $b262cabcae0d8be6$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $dhMkv._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$b262cabcae0d8be6$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $b262cabcae0d8be6$var$tripleEq(a, b) {
    return a === b;
}
var $b262cabcae0d8be6$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $grujF._)(this, TrackingCache);
        $b262cabcae0d8be6$var$__publicField(this, "_cachedValue");
        $b262cabcae0d8be6$var$__publicField(this, "_cachedRevision", -1);
        $b262cabcae0d8be6$var$__publicField(this, "_deps", []);
        $b262cabcae0d8be6$var$__publicField(this, "hits", 0);
        $b262cabcae0d8be6$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $dhMkv._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $b262cabcae0d8be6$var$CURRENT_TRACKER;
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2us1u._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $b262cabcae0d8be6$var$getValue(cell) {
    if (!(cell instanceof $b262cabcae0d8be6$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b262cabcae0d8be6$var$setValue(storage, value) {
    if (!(storage instanceof $b262cabcae0d8be6$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b262cabcae0d8be6$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
    return new $b262cabcae0d8be6$var$Cell(initialValue, isEqual);
}
function $b262cabcae0d8be6$var$createCache(fn) {
    $b262cabcae0d8be6$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b262cabcae0d8be6$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b262cabcae0d8be6$var$neverEq = function(a, b) {
    return false;
};
function $b262cabcae0d8be6$var$createTag() {
    return $b262cabcae0d8be6$var$createCell(null, $b262cabcae0d8be6$var$neverEq);
}
function $b262cabcae0d8be6$var$dirtyTag(tag, value) {
    $b262cabcae0d8be6$var$setValue(tag, value);
}
var $b262cabcae0d8be6$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b262cabcae0d8be6$var$createTag();
    $b262cabcae0d8be6$var$getValue(tag);
};
var $b262cabcae0d8be6$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $b262cabcae0d8be6$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b262cabcae0d8be6$var$REDUX_PROXY_LABEL = Symbol();
var $b262cabcae0d8be6$var$nextId = 0;
var $b262cabcae0d8be6$var$proto = Object.getPrototypeOf({});
var $b262cabcae0d8be6$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ObjectTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy(this, $b262cabcae0d8be6$var$objectProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) === "symbol") return childValue;
            if (key in $b262cabcae0d8be6$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $bJtXW._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b262cabcae0d8be6$var$createNode(childValue);
                if (childNode.tag) $b262cabcae0d8be6$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b262cabcae0d8be6$var$createTag();
                    tag.value = childValue;
                }
                $b262cabcae0d8be6$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $b262cabcae0d8be6$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b262cabcae0d8be6$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ArrayTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy([
        this
    ], $b262cabcae0d8be6$var$arrayProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        if (key === "length") $b262cabcae0d8be6$var$consumeCollection(node);
        return $b262cabcae0d8be6$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.has(node, prop);
    }
};
function $b262cabcae0d8be6$var$createNode(value) {
    if (Array.isArray(value)) return new $b262cabcae0d8be6$var$ArrayTreeNode(value);
    return new $b262cabcae0d8be6$var$ObjectTreeNode(value);
}
function $b262cabcae0d8be6$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b262cabcae0d8be6$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b262cabcae0d8be6$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $b262cabcae0d8be6$var$dirtyCollection(node);
            $b262cabcae0d8be6$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue1)) === "object" && newChildValue1 !== null) $b262cabcae0d8be6$var$updateNode(childNode, newChildValue1);
        else {
            $b262cabcae0d8be6$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $b262cabcae0d8be6$var$deleteNode(node) {
    if (node.tag) $b262cabcae0d8be6$var$dirtyTag(node.tag, null);
    $b262cabcae0d8be6$var$dirtyCollection(node);
    for(var key in node.tags)$b262cabcae0d8be6$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$b262cabcae0d8be6$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $b262cabcae0d8be6$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b262cabcae0d8be6$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $b262cabcae0d8be6$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b262cabcae0d8be6$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b262cabcae0d8be6$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b262cabcae0d8be6$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b262cabcae0d8be6$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $bJtXW._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $b262cabcae0d8be6$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $b262cabcae0d8be6$var$createSingletonCache(comparator) : $b262cabcae0d8be6$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b262cabcae0d8be6$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b262cabcae0d8be6$export$c8f9cf88d9fdee55(func) {
    var node = $b262cabcae0d8be6$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $b262cabcae0d8be6$var$createCacheKeyComparator($b262cabcae0d8be6$export$3f025202a230c6dd);
    var cache = $b262cabcae0d8be6$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b262cabcae0d8be6$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b262cabcae0d8be6$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $grujF._)(this, StrongRef);
        this.value = value;
    }
    (0, $dhMkv._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $b262cabcae0d8be6$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b262cabcae0d8be6$var$StrongRef;
var $b262cabcae0d8be6$var$UNTERMINATED = 0;
var $b262cabcae0d8be6$var$TERMINATED = 1;
function $b262cabcae0d8be6$var$createCacheNode() {
    return {
        s: $b262cabcae0d8be6$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b262cabcae0d8be6$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $b262cabcae0d8be6$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $b262cabcae0d8be6$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $b262cabcae0d8be6$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $b262cabcae0d8be6$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $b262cabcae0d8be6$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b262cabcae0d8be6$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b262cabcae0d8be6$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc), "]"));
        var combinedOptions = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $b262cabcae0d8be6$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $b262cabcae0d8be6$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2us1u._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2us1u._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $b262cabcae0d8be6$export$595d22ed68ca2841 = /* @__PURE__ */ $b262cabcae0d8be6$export$5943f4447f6ef248($b262cabcae0d8be6$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b262cabcae0d8be6$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$export$595d22ed68ca2841;
    $b262cabcae0d8be6$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $bJtXW._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $b262cabcae0d8be6$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $21ccc86701ec53ef$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $21ccc86701ec53ef$export$dd164f5517779f15 = $21ccc86701ec53ef$var$createThunkMiddleware();
var $21ccc86701ec53ef$export$16d06542a1949d9e = $21ccc86701ec53ef$var$createThunkMiddleware;


var $ca04af99794d5fdc$var$__defProp = Object.defineProperty;
var $ca04af99794d5fdc$var$__defProps = Object.defineProperties;
var $ca04af99794d5fdc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ca04af99794d5fdc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ca04af99794d5fdc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca04af99794d5fdc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ca04af99794d5fdc$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $ca04af99794d5fdc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $ca04af99794d5fdc$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($ca04af99794d5fdc$var$__hasOwnProp.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($ca04af99794d5fdc$var$__propIsEnum.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $ca04af99794d5fdc$var$__spreadProps = function(a, b) {
    return $ca04af99794d5fdc$var$__defProps(a, $ca04af99794d5fdc$var$__getOwnPropDescs(b));
};
var $ca04af99794d5fdc$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($ca04af99794d5fdc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $ca04af99794d5fdc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $ca04af99794d5fdc$var$__publicField = function(obj, key, value) {
    return $ca04af99794d5fdc$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
};
var $ca04af99794d5fdc$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $b262cabcae0d8be6$export$5943f4447f6ef248).apply(void 0, (0, $2us1u._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2us1u._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value
            ].concat((0, $2us1u._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $ca04af99794d5fdc$export$a5d3c27355e35910 = /* @__PURE__ */ $ca04af99794d5fdc$export$aab6de9e3dbb1473((0, $b262cabcae0d8be6$export$8402dc26d96f6902));
var $ca04af99794d5fdc$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $bJtXW._)(arguments[0]) === "object") return 0, $20ec22595b3da151$export$f672e0b6f7222cd7;
    return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ca04af99794d5fdc$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ca04af99794d5fdc$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2us1u._)(args));
            if (!prepared) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(0));
            return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $ca04af99794d5fdc$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ca04af99794d5fdc$var$hasMatchFunction(action);
}
function $ca04af99794d5fdc$export$ebd532f9034651f3(action) {
    return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && Object.keys(action).every($ca04af99794d5fdc$var$isValidKey);
}
function $ca04af99794d5fdc$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ca04af99794d5fdc$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $ca04af99794d5fdc$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
var $ca04af99794d5fdc$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $j6Mzi._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $grujF._)(this, _Tuple);
        var _this;
        _this = (0, $f3Okx._)(this, _Tuple, (0, $2us1u._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $dhMkv._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $8665ac34acf389ad$export$71511d61b312f219)((0, $gyGuQ._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr[0].concat(this)));
                return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $1EZOw._)(Array));
function $ca04af99794d5fdc$var$freezeDraftable(val) {
    return (0, $kK8g8.isDraftable)(val) ? (0, $kK8g8.produce)(val, function() {}) : val;
}
function $ca04af99794d5fdc$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $ca04af99794d5fdc$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $ca04af99794d5fdc$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $ca04af99794d5fdc$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $ca04af99794d5fdc$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $ca04af99794d5fdc$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $ca04af99794d5fdc$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $ca04af99794d5fdc$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $20ec22595b3da151$export$53b83ca8eaab0383)(val);
}
function $ca04af99794d5fdc$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ca04af99794d5fdc$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) === "object") {
                foundNestedSerializable = $ca04af99794d5fdc$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $ca04af99794d5fdc$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ca04af99794d5fdc$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$ca04af99794d5fdc$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $ca04af99794d5fdc$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $ca04af99794d5fdc$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ca04af99794d5fdc$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $ca04af99794d5fdc$export$1908877435b1d5e9();
        if (thunk) {
            if ($ca04af99794d5fdc$var$isBoolean(thunk)) middlewareArray.push((0, $21ccc86701ec53ef$export$dd164f5517779f15));
            else middlewareArray.push((0, $21ccc86701ec53ef$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $ca04af99794d5fdc$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ca04af99794d5fdc$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $72osQ._)({}, $ca04af99794d5fdc$export$8fb31c0f05df007b, true)
        };
    };
};
var $ca04af99794d5fdc$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $ca04af99794d5fdc$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2us1u._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ca04af99794d5fdc$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $ca04af99794d5fdc$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ca04af99794d5fdc$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $ca04af99794d5fdc$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $ca04af99794d5fdc$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ca04af99794d5fdc$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $bJtXW._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $ca04af99794d5fdc$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $ca04af99794d5fdc$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $20ec22595b3da151$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducer);
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var finalCompose = (0, $20ec22595b3da151$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ca04af99794d5fdc$var$composeWithDevTools($ca04af99794d5fdc$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $bJtXW._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $20ec22595b3da151$export$9ff26e0402cc7b7).apply(void 0, (0, $2us1u._)(finalMiddleware));
    var getDefaultEnhancers = $ca04af99794d5fdc$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $2us1u._)(storeEnhancers));
    return (0, $20ec22595b3da151$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ca04af99794d5fdc$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ca04af99794d5fdc$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ca04af99794d5fdc$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $2nwvT._)($ca04af99794d5fdc$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($ca04af99794d5fdc$var$isStateFunction(initialState)) getInitialState = function() {
        return $ca04af99794d5fdc$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $ca04af99794d5fdc$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2us1u._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $kK8g8.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $kK8g8.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $kK8g8.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $ca04af99794d5fdc$var$matches = function(matcher, action) {
    if ($ca04af99794d5fdc$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ca04af99794d5fdc$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ca04af99794d5fdc$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ca04af99794d5fdc$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$872dec21e9a69476()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $ca04af99794d5fdc$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $ca04af99794d5fdc$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
}
function $ca04af99794d5fdc$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $ca04af99794d5fdc$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $ca04af99794d5fdc$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ca04af99794d5fdc$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $ca04af99794d5fdc$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ca04af99794d5fdc$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ca04af99794d5fdc$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $grujF._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $grujF._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $ca04af99794d5fdc$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ca04af99794d5fdc$var$externalAbortMessage = "External signal was aborted";
var $ca04af99794d5fdc$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $ca04af99794d5fdc$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            var signal = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).signal;
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ca04af99794d5fdc$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                if (signal) {
                    if (signal.aborted) abort($ca04af99794d5fdc$var$externalAbortMessage);
                    else signal.addEventListener("abort", function() {
                        return abort($ca04af99794d5fdc$var$externalAbortMessage);
                    }, {
                        once: true
                    });
                }
                var promise = (0, $g3gsR._)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$ca04af99794d5fdc$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $ca04af99794d5fdc$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $ca04af99794d5fdc$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $ca04af99794d5fdc$var$RejectWithValue) throw result;
                                            if (result instanceof $ca04af99794d5fdc$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $ca04af99794d5fdc$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($ca04af99794d5fdc$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ca04af99794d5fdc$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $ca04af99794d5fdc$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ca04af99794d5fdc$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ca04af99794d5fdc$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ca04af99794d5fdc$export$343355ed40c51c46 = (0, $72osQ._)({}, $ca04af99794d5fdc$var$asyncThunkSymbol, $ca04af99794d5fdc$export$6abd22dc03e5063f);
var $ca04af99794d5fdc$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($ca04af99794d5fdc$export$23a094319a4b586 || {});
function $ca04af99794d5fdc$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $ca04af99794d5fdc$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ca04af99794d5fdc$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(11));
        var reducers = (typeof options.reducers === "function" ? options.reducers($ca04af99794d5fdc$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $ca04af99794d5fdc$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ca04af99794d5fdc$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $2nwvT._)(typeof options.extraReducers === "function" ? $ca04af99794d5fdc$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ca04af99794d5fdc$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $ca04af99794d5fdc$var$getOrInsertComputed(injectedSelectorCache, injected, function() {
                    return /* @__PURE__ */ new WeakMap();
                });
                return $ca04af99794d5fdc$var$getOrInsertComputed(selectorCache, selectState, function() {
                    var _a2;
                    var map = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $2nwvT._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                            map[name2] = $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $ca04af99794d5fdc$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2us1u._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ca04af99794d5fdc$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ca04af99794d5fdc$export$affdea4146de9cf5();
function $ca04af99794d5fdc$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ca04af99794d5fdc$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $72osQ._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2us1u._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ca04af99794d5fdc$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareCallback) : $ca04af99794d5fdc$export$309c7a02b0b0bc62(type));
}
function $ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ca04af99794d5fdc$var$noop,
        pending: pending || $ca04af99794d5fdc$var$noop,
        rejected: rejected || $ca04af99794d5fdc$var$noop,
        settled: settled || $ca04af99794d5fdc$var$noop
    });
}
function $ca04af99794d5fdc$var$noop() {}
// src/entities/entity_state.ts
function $ca04af99794d5fdc$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($ca04af99794d5fdc$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ca04af99794d5fdc$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $ca04af99794d5fdc$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $ca04af99794d5fdc$var$isDraftTyped = (0, $kK8g8.isDraft);
function $ca04af99794d5fdc$var$createSingleArgumentStateOperator(mutator) {
    var operator = $ca04af99794d5fdc$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ca04af99794d5fdc$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ca04af99794d5fdc$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ca04af99794d5fdc$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $kK8g8.produce)(state, runMutator);
    };
}
function $ca04af99794d5fdc$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $ca04af99794d5fdc$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ca04af99794d5fdc$var$getCurrent(value) {
    return (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value;
}
function $ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $ca04af99794d5fdc$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $ca04af99794d5fdc$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $ca04af99794d5fdc$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $ca04af99794d5fdc$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably),
        removeOne: $ca04af99794d5fdc$var$createStateOperator(removeOneMutably),
        removeMany: $ca04af99794d5fdc$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ca04af99794d5fdc$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $ca04af99794d5fdc$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($ca04af99794d5fdc$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $ca04af99794d5fdc$var$getCurrent(state.entities);
        var currentIds = $ca04af99794d5fdc$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $ca04af99794d5fdc$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ca04af99794d5fdc$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $ca04af99794d5fdc$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, sortComparer) : $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $ca04af99794d5fdc$var$createSelectorsFactory();
    return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ca04af99794d5fdc$var$task = "task";
var $ca04af99794d5fdc$var$listener = "listener";
var $ca04af99794d5fdc$var$completed = "completed";
var $ca04af99794d5fdc$var$cancelled = "cancelled";
var $ca04af99794d5fdc$var$taskCancelled = "task-".concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$taskCompleted = "task-".concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$var$listenerCancelled = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$listenerCompleted = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $grujF._)(this, TaskAbortError);
    this.code = code;
    $ca04af99794d5fdc$var$__publicField(this, "name", "TaskAbortError");
    $ca04af99794d5fdc$var$__publicField(this, "message");
    this.message = "".concat($ca04af99794d5fdc$var$task, " ").concat($ca04af99794d5fdc$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $ca04af99794d5fdc$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($ca04af99794d5fdc$export$378fa86b259c0280(32));
};
var $ca04af99794d5fdc$var$noop2 = function() {};
var $ca04af99794d5fdc$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ca04af99794d5fdc$var$noop2;
    promise.catch(onError);
    return promise;
};
var $ca04af99794d5fdc$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $ca04af99794d5fdc$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $ca04af99794d5fdc$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $ca04af99794d5fdc$export$cb1bdac908fed7f(reason);
    }
};
function $ca04af99794d5fdc$var$raceWithSignal(signal, promise) {
    var cleanup = $ca04af99794d5fdc$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $ca04af99794d5fdc$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ca04af99794d5fdc$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $ca04af99794d5fdc$var$noop2;
    });
}
var $ca04af99794d5fdc$var$runTask = /*#__PURE__*/ function() {
    var _ref = (0, $g3gsR._)(function(task2, cleanUp) {
        var value, error;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $ca04af99794d5fdc$var$createPause = function(signal) {
    return function(promise) {
        return $ca04af99794d5fdc$var$catchRejection($ca04af99794d5fdc$var$raceWithSignal(signal, promise).then(function(output) {
            $ca04af99794d5fdc$var$validateActive(signal);
            return output;
        }));
    };
};
var $ca04af99794d5fdc$var$createDelay = function(signal) {
    var pause = $ca04af99794d5fdc$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $ca04af99794d5fdc$var$assign = Object.assign;
var $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN = {};
var $ca04af99794d5fdc$var$alm = "listenerMiddleware";
var $ca04af99794d5fdc$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $ca04af99794d5fdc$var$addAbortSignalListener(parentAbortSignal, function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $ca04af99794d5fdc$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $ca04af99794d5fdc$var$runTask(/*#__PURE__*/ (0, $g3gsR._)(function() {
            var result2;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(parentAbortSignal);
                        $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $ca04af99794d5fdc$var$createPause(childAbortController.signal),
                                delay: $ca04af99794d5fdc$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ca04af99794d5fdc$var$noop2));
        return {
            result: $ca04af99794d5fdc$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCancelled);
            }
        };
    };
};
var $ca04af99794d5fdc$var$createTakePattern = function(startListening, signal) {
    var take = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $ca04af99794d5fdc$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $ca04af99794d5fdc$var$catchRejection(take(predicate, timeout));
    };
};
var $ca04af99794d5fdc$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $ca04af99794d5fdc$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(21));
    $ca04af99794d5fdc$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ca04af99794d5fdc$var$createListenerEntry = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var entry = {
        id: $ca04af99794d5fdc$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $ca04af99794d5fdc$var$createListenerEntry;
    }
});
var $ca04af99794d5fdc$var$findListenerEntry = function(listenerMap, options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
    return Array.from(listenerMap.values()).find(function(entry) {
        var matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $ca04af99794d5fdc$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
    });
};
var $ca04af99794d5fdc$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($ca04af99794d5fdc$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $ca04af99794d5fdc$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $ca04af99794d5fdc$export$f03a6b845d3fb58b = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/add")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$f03a6b845d3fb58b;
    }
});
var $ca04af99794d5fdc$export$b1b8022855fb2b71 = /* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/removeAll"));
var $ca04af99794d5fdc$export$b03e9483f936dccb = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/remove")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$b03e9483f936dccb;
    }
});
var $ca04af99794d5fdc$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($ca04af99794d5fdc$var$alm, "/error")
    ].concat((0, $2us1u._)(args)));
};
var $ca04af99794d5fdc$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $ca04af99794d5fdc$var$defaultErrorHandler : _middlewareOptions_onError;
    $ca04af99794d5fdc$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var _a;
        var entry = (_a = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options)) != null ? _a : $ca04af99794d5fdc$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $ca04af99794d5fdc$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var entry = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $ca04af99794d5fdc$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $ca04af99794d5fdc$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $ca04af99794d5fdc$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $ca04af99794d5fdc$var$createDelay(internalTaskController.signal),
                                pause: $ca04af99794d5fdc$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $ca04af99794d5fdc$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $ca04af99794d5fdc$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f)) $ca04af99794d5fdc$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $ca04af99794d5fdc$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $20ec22595b3da151$export$b956e38827fca970)(action)) return next(action);
                if ($ca04af99794d5fdc$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ca04af99794d5fdc$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ca04af99794d5fdc$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $ca04af99794d5fdc$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $ca04af99794d5fdc$var$createMiddlewareEntry = function(middleware) {
    return {
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $ca04af99794d5fdc$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $ca04af99794d5fdc$export$4bb1606a79445586 = function() {
    var instanceId = $ca04af99794d5fdc$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            $ca04af99794d5fdc$var$getOrInsertComputed(middlewareMap, middleware2, $ca04af99794d5fdc$var$createMiddlewareEntry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $ca04af99794d5fdc$var$getOrInsertComputed(entry.applied, api, entry.middleware);
        });
        return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(void 0, (0, $2us1u._)(appliedMiddleware));
    };
    var isWithMiddleware = $ca04af99794d5fdc$export$9dd1fb32974da385(withMiddleware, $ca04af99794d5fdc$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2us1u._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ca04af99794d5fdc$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $ca04af99794d5fdc$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $ca04af99794d5fdc$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $ca04af99794d5fdc$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ca04af99794d5fdc$var$isStateProxy = function(value) {
    return !!value && !!value[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ca04af99794d5fdc$var$createStateProxy = function(state, reducerMap) {
    return $ca04af99794d5fdc$var$getOrInsertComputed($ca04af99794d5fdc$var$stateProxyMap, state, function() {
        return new Proxy(state, {
            get: function(target, prop, receiver) {
                if (prop === $ca04af99794d5fdc$var$ORIGINAL_STATE) return target;
                var result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    var reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        var reducerResult = reducer(void 0, {
                            type: $ca04af99794d5fdc$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        });
    });
};
var $ca04af99794d5fdc$var$original = function(state) {
    if (!$ca04af99794d5fdc$var$isStateProxy(state)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(25));
    return state[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $ca04af99794d5fdc$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($ca04af99794d5fdc$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducerMap) : $ca04af99794d5fdc$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $ca04af99794d5fdc$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2us1u._)(args))) : state, reducerMap)
            ].concat((0, $2us1u._)(args)));
        };
    }, {
        original: $ca04af99794d5fdc$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ca04af99794d5fdc$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $4572e6a798353cb7$var$findItem = function(items, id) {
    return items.find(function(item) {
        return item.card.info.id === id;
    });
};
var $4572e6a798353cb7$var$cartSlice = (0, $ca04af99794d5fdc$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            var _action_payload_card_info, _action_payload_card, _action_payload;
            var id = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_card = _action_payload.card) === null || _action_payload_card === void 0 ? void 0 : (_action_payload_card_info = _action_payload_card.info) === null || _action_payload_card_info === void 0 ? void 0 : _action_payload_card_info.id;
            var existing = $4572e6a798353cb7$var$findItem(state.items, id);
            if (existing) existing.quantity += 1;
            else state.items.push((0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, action.payload), {
                quantity: 1
            }));
        },
        removeItem: function(state, action) {
            state.items = state.items.filter(function(item) {
                return item.card.info.id !== action.payload;
            });
        },
        incrementQuantity: function(state, action) {
            var item = $4572e6a798353cb7$var$findItem(state.items, action.payload);
            if (item) item.quantity += 1;
        },
        decrementQuantity: function(state, action) {
            var item = $4572e6a798353cb7$var$findItem(state.items, action.payload);
            if (!item) return;
            if (item.quantity <= 1) state.items = state.items.filter(function(i) {
                return i.card.info.id !== action.payload;
            });
            else item.quantity -= 1;
        },
        clearCart: function(state) {
            state.items.length = 0;
        }
    }
});
var $4572e6a798353cb7$var$_cartSlice_actions = $4572e6a798353cb7$var$cartSlice.actions;
var $4572e6a798353cb7$export$fb9705de59d96855 = $4572e6a798353cb7$var$_cartSlice_actions.addItem, $4572e6a798353cb7$export$fe2d9b4e03920b4c = $4572e6a798353cb7$var$_cartSlice_actions.removeItem, $4572e6a798353cb7$export$992d1dcfb85ffd46 = $4572e6a798353cb7$var$_cartSlice_actions.incrementQuantity, $4572e6a798353cb7$export$f7f4b3ebb8c96d1d = $4572e6a798353cb7$var$_cartSlice_actions.decrementQuantity, $4572e6a798353cb7$export$810121176e3e3671 = $4572e6a798353cb7$var$_cartSlice_actions.clearCart;
var $4572e6a798353cb7$export$2e2bcd8739ae039 = $4572e6a798353cb7$var$cartSlice.reducer;


var $fd924853ff309141$var$ratingColor = function(rating) {
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
var $fd924853ff309141$var$ItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var getQuantity = function(id) {
        var _cartItems_find;
        return ((_cartItems_find = cartItems.find(function(c) {
            return c.card.info.id === id;
        })) === null || _cartItems_find === void 0 ? void 0 : _cartItems_find.quantity) || 0;
    };
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "menu-item-list",
        children: items.map(function(item) {
            var _ratings_aggregatedRating, _ratings_aggregatedRating1;
            var _item_card_info = item.card.info, id = _item_card_info.id, name = _item_card_info.name, price = _item_card_info.price, defaultPrice = _item_card_info.defaultPrice, ratings = _item_card_info.ratings, imageId = _item_card_info.imageId, description = _item_card_info.description, itemAttribute = _item_card_info.itemAttribute, ribbon = _item_card_info.ribbon;
            var rating = ratings === null || ratings === void 0 ? void 0 : (_ratings_aggregatedRating = ratings.aggregatedRating) === null || _ratings_aggregatedRating === void 0 ? void 0 : _ratings_aggregatedRating.rating;
            var ratingCount = ratings === null || ratings === void 0 ? void 0 : (_ratings_aggregatedRating1 = ratings.aggregatedRating) === null || _ratings_aggregatedRating1 === void 0 ? void 0 : _ratings_aggregatedRating1.ratingCountV2;
            var isVeg = (itemAttribute === null || itemAttribute === void 0 ? void 0 : itemAttribute.vegClassifier) === 'VEG';
            var quantity = getQuantity(id);
            var _ref;
            return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "menu-items",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "left",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "menu-item-name-row",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "veg-indicator ".concat(isVeg ? 'veg-indicator--veg' : 'veg-indicator--nonveg'),
                                        title: isVeg ? 'Veg' : 'Non-veg'
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                        children: name
                                    }),
                                    (ribbon === null || ribbon === void 0 ? void 0 : ribbon.text) && /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        className: "menu-item-badge",
                                        children: ribbon.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("h4", {
                                children: [
                                    "\u20B9",
                                    ((_ref = price !== null && price !== void 0 ? price : defaultPrice) !== null && _ref !== void 0 ? _ref : 0) / 100
                                ]
                            }),
                            description && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                children: description.slice(0, 140)
                            }),
                            rating && /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "rating",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $59911afdede6064b$export$2e2bcd8739ae039), {
                                        size: 13,
                                        fill: "currentColor",
                                        style: {
                                            color: $fd924853ff309141$var$ratingColor(rating)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            rating,
                                            ratingCount ? " (".concat(ratingCount, ")") : ''
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "right",
                        children: [
                            imageId && /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                                src: imageId.startsWith('http') ? imageId : (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + imageId,
                                alt: name
                            }),
                            quantity > 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "qty-stepper",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                        onClick: function() {
                                            return dispatch((0, $4572e6a798353cb7$export$f7f4b3ebb8c96d1d)(id));
                                        },
                                        "aria-label": "Decrease quantity",
                                        children: "\u2212"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: quantity
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                        onClick: function() {
                                            return dispatch((0, $4572e6a798353cb7$export$992d1dcfb85ffd46)(id));
                                        },
                                        "aria-label": "Increase quantity",
                                        children: "+"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "add-btn",
                                onClick: function() {
                                    return dispatch((0, $4572e6a798353cb7$export$fb9705de59d96855)(item));
                                },
                                children: "ADD"
                            })
                        ]
                    })
                ]
            }, id);
        })
    });
};
var $fd924853ff309141$export$2e2bcd8739ae039 = $fd924853ff309141$var$ItemList;


/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $793ffbe75e84884a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
var $793ffbe75e84884a$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("chevron-down", $793ffbe75e84884a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.26.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $ecfab0b3fe8b62dd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
var $ecfab0b3fe8b62dd$export$2e2bcd8739ae039 = (0, $b9b3db22bf3a92cf$export$2e2bcd8739ae039)("chevron-up", $ecfab0b3fe8b62dd$export$3efd853dbb351e94);


var $c2a8cdcb1b3fe8a1$var$RestaurantCategory = function(param) {
    var data = param.data, showItems = param.showItems, setShowIndex = param.setShowIndex, _param_forceOpen = param.forceOpen, forceOpen = _param_forceOpen === void 0 ? false : _param_forceOpen;
    var _data_title, _data_itemCards;
    var isOpen = forceOpen || showItems;
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "menu-category",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "menu-category-header ".concat(forceOpen ? 'menu-category-header--static' : ''),
                onClick: forceOpen ? undefined : setShowIndex,
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                        className: "menu-category-title",
                        children: [
                            data === null || data === void 0 ? void 0 : (_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.slice(0, 40),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                className: "menu-category-count",
                                children: [
                                    "(",
                                    data === null || data === void 0 ? void 0 : (_data_itemCards = data.itemCards) === null || _data_itemCards === void 0 ? void 0 : _data_itemCards.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    !forceOpen && /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        className: "menu-category-arrow",
                        children: isOpen ? /*#__PURE__*/ (0, $iD4WH.jsx)((0, $ecfab0b3fe8b62dd$export$2e2bcd8739ae039), {
                            size: 20
                        }) : /*#__PURE__*/ (0, $iD4WH.jsx)((0, $793ffbe75e84884a$export$2e2bcd8739ae039), {
                            size: 20
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fd924853ff309141$export$2e2bcd8739ae039), {
                items: data === null || data === void 0 ? void 0 : data.itemCards
            })
        ]
    });
};
var $c2a8cdcb1b3fe8a1$export$2e2bcd8739ae039 = $c2a8cdcb1b3fe8a1$var$RestaurantCategory;



var $dQFEZ = parcelRequire("dQFEZ");

var $0a68001968864957$var$FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80';
var $0a68001968864957$var$ratingColor = function(rating) {
    if (rating >= 4.3) return 'var(--bs-success)';
    if (rating >= 3.8) return 'var(--bs-warn)';
    return 'var(--bs-danger)';
};
var $0a68001968864957$var$RestaurantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_1;
    var resId = (0, $c2rik.useParams)().resId;
    var navigate = (0, $c2rik.useNavigate)();
    var resInfo = (0, $b70bbb8b216b90ce$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(0), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(''), 2), searchText = _useState1[0], setSearchText = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), vegOnly = _useState2[0], setVegOnly = _useState2[1];
    var _useState3 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), bestsellerOnly = _useState3[0], setBestsellerOnly = _useState3[1];
    if (resInfo === null) return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $0cbdcd5845c3443e$export$2e2bcd8739ae039), {});
    var _ref = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info) || {}, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, areaName = _ref.areaName, avgRating = _ref.avgRating, totalRatingsString = _ref.totalRatingsString, costForTwoMessage = _ref.costForTwoMessage, cuisines = _ref.cuisines, sla = _ref.sla;
    var cards = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[4]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_1.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards) || [];
    var categories = cards.filter(function(c) {
        var _c_card_card, _c_card;
        return (c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card['card']) === null || _c_card_card === void 0 ? void 0 : _c_card_card['@type']) === 'type.googleapis.com/swiggy.presentation.food.v2.ItemCategory';
    });
    var rating = avgRating !== null && avgRating !== void 0 ? avgRating : 3.8;
    var heroImage = (cloudinaryImageId === null || cloudinaryImageId === void 0 ? void 0 : cloudinaryImageId.startsWith('http')) ? cloudinaryImageId : (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + cloudinaryImageId;
    // ── Search / veg / bestseller filtering ─────────────────────────────
    var hasActiveFilters = searchText.trim() || vegOnly || bestsellerOnly;
    var itemMatchesFilters = function(item) {
        var _item_card, _info_itemAttribute, _info_ribbon, _info_name;
        var info = item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : _item_card.info;
        if (!info) return false;
        if (vegOnly && ((_info_itemAttribute = info.itemAttribute) === null || _info_itemAttribute === void 0 ? void 0 : _info_itemAttribute.vegClassifier) !== 'VEG') return false;
        if (bestsellerOnly && !((_info_ribbon = info.ribbon) === null || _info_ribbon === void 0 ? void 0 : _info_ribbon.text)) return false;
        if (searchText.trim() && !((_info_name = info.name) === null || _info_name === void 0 ? void 0 : _info_name.toLowerCase().includes(searchText.trim().toLowerCase()))) return false;
        return true;
    };
    var filteredCategories = categories.map(function(category) {
        var _category_card_card, _category_card;
        return {
            category: category,
            items: ((category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : (_category_card_card = _category_card.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.itemCards) || []).filter(itemMatchesFilters)
        };
    }).filter(function(param) {
        var items = param.items;
        return items.length > 0;
    });
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "restaurant-page",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "menu-breadcrumb",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                        to: "/",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        className: "breadcrumb-sep",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("section", {
                className: "menu-hero",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "menu-hero-media",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                                src: heroImage,
                                alt: name,
                                onError: function(e) {
                                    e.target.onerror = null;
                                    e.target.src = $0a68001968864957$var$FALLBACK_IMAGE;
                                }
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "menu-hero-scrim"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        className: "menu-hero-back",
                        onClick: function() {
                            return navigate(-1);
                        },
                        "aria-label": "Go back",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $e883a8b060cd5681$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "menu-hero-content",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                                children: name
                            }),
                            areaName && /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                                className: "menu-hero-area",
                                children: [
                                    "\uD83D\uDCCD ",
                                    areaName
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "menu-hero-info",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        className: "rating",
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $59911afdede6064b$export$2e2bcd8739ae039), {
                                                size: 14,
                                                fill: "currentColor",
                                                style: {
                                                    color: $0a68001968864957$var$ratingColor(rating)
                                                }
                                            }),
                                            rating,
                                            " (",
                                            totalRatingsString || '1K+ ratings',
                                            ")"
                                        ]
                                    }),
                                    costForTwoMessage && /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\xb7 ",
                                            costForTwoMessage
                                        ]
                                    }),
                                    (sla === null || sla === void 0 ? void 0 : sla.slaString) && /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\xb7 \u23F3 ",
                                            sla.slaString
                                        ]
                                    })
                                ]
                            }),
                            (cuisines === null || cuisines === void 0 ? void 0 : cuisines.length) > 0 && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "menu-hero-cuisines",
                                children: cuisines.join(', ')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "restaurant-container",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "menu-toolbar",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "menu-search",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $3e695f5cdc6c1429$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                        type: "text",
                                        placeholder: "Search for dishes",
                                        value: searchText,
                                        onChange: function(e) {
                                            return setSearchText(e.target.value);
                                        }
                                    }),
                                    searchText && /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                        className: "menu-search-clear",
                                        onClick: function() {
                                            return setSearchText('');
                                        },
                                        "aria-label": "Clear search",
                                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $bab7dcf773ac5003$export$2e2bcd8739ae039), {
                                            size: 15
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "menu-filter-chips",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                        className: "menu-filter-chip ".concat(vegOnly ? 'active' : ''),
                                        onClick: function() {
                                            return setVegOnly(function(v) {
                                                return !v;
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "veg-indicator veg-indicator--veg"
                                            }),
                                            "Veg only"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                        className: "menu-filter-chip ".concat(bestsellerOnly ? 'active' : ''),
                                        onClick: function() {
                                            return setBestsellerOnly(function(v) {
                                                return !v;
                                            });
                                        },
                                        children: "\uD83D\uDD25 Bestseller"
                                    })
                                ]
                            })
                        ]
                    }),
                    hasActiveFilters ? filteredCategories.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "menu-no-results",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                children: "\uD83C\uDF7D\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                children: "No dishes match your filters."
                            })
                        ]
                    }) : filteredCategories.map(function(param) {
                        var category = param.category, items = param.items;
                        var _category_card_card, _category_card;
                        return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $c2a8cdcb1b3fe8a1$export$2e2bcd8739ae039), {
                            data: (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, category.card.card), {
                                itemCards: items
                            }),
                            forceOpen: true
                        }, category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : (_category_card_card = _category_card.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.title);
                    }) : categories.map(function(category, index) {
                        var _category_card, _category_card_card, _category_card1;
                        return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $c2a8cdcb1b3fe8a1$export$2e2bcd8739ae039), {
                            data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                            showItems: index === showIndex,
                            setShowIndex: function() {
                                return setShowIndex(index === showIndex ? null : index);
                            }
                        }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : (_category_card_card = _category_card1.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.title);
                    })
                ]
            })
        ]
    });
};
var $0a68001968864957$export$2e2bcd8739ae039 = $0a68001968864957$var$RestaurantMenu;



var $dQFEZ = parcelRequire("dQFEZ");
var $f6a0a5e5117df21a$var$UserContext = /*#__PURE__*/ (0, $dQFEZ.createContext)({
    loggedInUser: "Default User"
});
var $f6a0a5e5117df21a$export$2e2bcd8739ae039 = $f6a0a5e5117df21a$var$UserContext;





var $c9ec9760ecd75932$var$appStore = (0, $ca04af99794d5fdc$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $4572e6a798353cb7$export$2e2bcd8739ae039)
    }
});
var $c9ec9760ecd75932$export$2e2bcd8739ae039 = $c9ec9760ecd75932$var$appStore;



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");


var $lEL1W = parcelRequire("lEL1W");



var $711a04e9b448458e$var$DELIVERY_FEE = 40;
var $711a04e9b448458e$var$PLATFORM_FEE = 6;
var $711a04e9b448458e$var$GST_RATE = 0.05;
var $711a04e9b448458e$var$COUPONS = {
    BITESWIFT20: {
        discount: function(subtotal) {
            return subtotal >= 200 ? 20 : 0;
        },
        minOrder: 200
    },
    FREEDEL: {
        discount: function() {
            return 0;
        },
        freeDelivery: true
    }
};
var $711a04e9b448458e$var$PAYMENT_METHODS = [
    {
        id: 'upi',
        label: 'UPI',
        icon: "\uD83D\uDCF1"
    },
    {
        id: 'card',
        label: 'Card',
        icon: "\uD83D\uDCB3"
    },
    {
        id: 'cod',
        label: 'Cash on Delivery',
        icon: "\uD83D\uDCB5"
    }
];
var $711a04e9b448458e$var$generateOrderId = function() {
    return "#BS".concat(Math.floor(100000 + Math.random() * 900000));
};
var $711a04e9b448458e$var$randomEta = function() {
    return "".concat(25 + Math.floor(Math.random() * 15), "-").concat(40 + Math.floor(Math.random() * 10), " mins");
};
var $711a04e9b448458e$var$Cart = function() {
    var _PAYMENT_METHODS_find;
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(''), 2), couponInput = _useState[0], setCouponInput = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), appliedCoupon = _useState1[0], setAppliedCoupon = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(''), 2), couponError = _useState2[0], setCouponError = _useState2[1];
    var _useState3 = (0, $2nwvT._)((0, $dQFEZ.useState)('upi'), 2), paymentMethod = _useState3[0], setPaymentMethod = _useState3[1];
    var _useState4 = (0, $2nwvT._)((0, $dQFEZ.useState)(false), 2), isPlacingOrder = _useState4[0], setIsPlacingOrder = _useState4[1];
    var _useState5 = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), order = _useState5[0], setOrder = _useState5[1];
    var subtotal = cartItems.reduce(function(sum, item) {
        var _item_card_info_price, _ref;
        var price = ((_ref = (_item_card_info_price = item.card.info.price) !== null && _item_card_info_price !== void 0 ? _item_card_info_price : item.card.info.defaultPrice) !== null && _ref !== void 0 ? _ref : 0) / 100;
        return sum + price * item.quantity;
    }, 0);
    var gst = subtotal * $711a04e9b448458e$var$GST_RATE;
    var coupon = appliedCoupon ? $711a04e9b448458e$var$COUPONS[appliedCoupon] : null;
    var discount = coupon ? coupon.discount(subtotal) : 0;
    var deliveryFee = (coupon === null || coupon === void 0 ? void 0 : coupon.freeDelivery) ? 0 : $711a04e9b448458e$var$DELIVERY_FEE;
    var total = subtotal + gst + deliveryFee + $711a04e9b448458e$var$PLATFORM_FEE - discount;
    var handleApplyCoupon = function() {
        var code = couponInput.trim().toUpperCase();
        if (!code) return;
        var found = $711a04e9b448458e$var$COUPONS[code];
        if (!found) {
            setCouponError('Invalid coupon code');
            return;
        }
        if (found.minOrder && subtotal < found.minOrder) {
            setCouponError("Add \u20B9".concat((found.minOrder - subtotal).toFixed(0), " more to use this code"));
            return;
        }
        setAppliedCoupon(code);
        setCouponError('');
    };
    var handleRemoveCoupon = function() {
        setAppliedCoupon(null);
        setCouponInput('');
        setCouponError('');
    };
    var handlePlaceOrder = function() {
        setIsPlacingOrder(true);
        setTimeout(function() {
            setOrder({
                id: $711a04e9b448458e$var$generateOrderId(),
                items: cartItems,
                total: total,
                paymentMethod: paymentMethod,
                eta: $711a04e9b448458e$var$randomEta()
            });
            dispatch((0, $4572e6a798353cb7$export$810121176e3e3671)());
            setIsPlacingOrder(false);
        }, 1400);
    };
    if (order) return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "cart-status",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                className: "cart-status-icon",
                children: "\uD83C\uDF89"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                children: "Order placed!"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                className: "cart-order-id",
                children: [
                    "Order ",
                    order.id
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                children: [
                    "Arriving in ",
                    /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                        children: order.eta
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "order-receipt",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                        children: "Order summary"
                    }),
                    order.items.map(function(item) {
                        var _item_card_info_price, _ref;
                        return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                            className: "order-receipt-row",
                            children: [
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                    children: [
                                        item.quantity,
                                        " \xd7 ",
                                        item.card.info.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                    children: [
                                        "\u20B9",
                                        (((_ref = (_item_card_info_price = item.card.info.price) !== null && _item_card_info_price !== void 0 ? _item_card_info_price : item.card.info.defaultPrice) !== null && _ref !== void 0 ? _ref : 0) / 100 * item.quantity).toFixed(0)
                                    ]
                                })
                            ]
                        }, item.card.info.id);
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "order-receipt-row order-receipt-total",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                children: "Total paid"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                children: [
                                    "\u20B9",
                                    order.total.toFixed(0)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                        className: "order-payment-method",
                        children: [
                            "Paid via ",
                            (_PAYMENT_METHODS_find = $711a04e9b448458e$var$PAYMENT_METHODS.find(function(p) {
                                return p.id === order.paymentMethod;
                            })) === null || _PAYMENT_METHODS_find === void 0 ? void 0 : _PAYMENT_METHODS_find.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                to: "/",
                className: "cart-cta",
                children: "Back to home"
            })
        ]
    });
    if (cartItems.length === 0) return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "cart-status",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                className: "cart-status-icon",
                children: "\uD83D\uDED2"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                children: "Your cart is empty"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                children: "Looks like you haven't added anything yet."
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                to: "/",
                className: "cart-cta",
                children: "Browse restaurants"
            })
        ]
    });
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "cart-page",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "cart-header",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                        children: "Your Cart"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                        className: "cart-clear-btn",
                        onClick: function() {
                            return dispatch((0, $4572e6a798353cb7$export$810121176e3e3671)());
                        },
                        children: "Clear cart"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "cart-body",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "cart-main",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "cart-items",
                                children: cartItems.map(function(item) {
                                    var _item_card_info = item.card.info, id = _item_card_info.id, name = _item_card_info.name, price = _item_card_info.price, defaultPrice = _item_card_info.defaultPrice, imageId = _item_card_info.imageId, description = _item_card_info.description;
                                    var _ref;
                                    var unitPrice = ((_ref = price !== null && price !== void 0 ? price : defaultPrice) !== null && _ref !== void 0 ? _ref : 0) / 100;
                                    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        className: "cart-item",
                                        children: [
                                            imageId && /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                                                className: "cart-item-img",
                                                src: imageId.startsWith('http') ? imageId : (0, $1ad00fd5a6f8ced9$export$3c67ec6258c4a827) + imageId,
                                                alt: name
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "cart-item-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                                                        children: name
                                                    }),
                                                    description && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                                        children: description.slice(0, 90)
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                                        className: "cart-item-price",
                                                        children: [
                                                            "\u20B9",
                                                            unitPrice
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "cart-item-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                        className: "qty-stepper",
                                                        children: [
                                                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                                                onClick: function() {
                                                                    return dispatch((0, $4572e6a798353cb7$export$f7f4b3ebb8c96d1d)(id));
                                                                },
                                                                "aria-label": "Decrease quantity",
                                                                children: "\u2212"
                                                            }),
                                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                                children: item.quantity
                                                            }),
                                                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                                                onClick: function() {
                                                                    return dispatch((0, $4572e6a798353cb7$export$992d1dcfb85ffd46)(id));
                                                                },
                                                                "aria-label": "Increase quantity",
                                                                children: "+"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                                        className: "cart-remove-btn",
                                                        onClick: function() {
                                                            return dispatch((0, $4572e6a798353cb7$export$fe2d9b4e03920b4c)(id));
                                                        },
                                                        children: "Remove"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                className: "cart-item-subtotal",
                                                children: [
                                                    "\u20B9",
                                                    (unitPrice * item.quantity).toFixed(0)
                                                ]
                                            })
                                        ]
                                    }, id);
                                })
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-section",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                        children: "Delivery address"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                        className: "cart-address",
                                        children: [
                                            /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                className: "cart-address-icon",
                                                children: "\uD83D\uDCCD"
                                            }),
                                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("strong", {
                                                        children: "Home"
                                                    }),
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                                        children: "221B, Koramangala 4th Block, Bangalore, Karnataka 560034"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-section",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                        children: "Payment method"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                        className: "payment-methods",
                                        children: $711a04e9b448458e$var$PAYMENT_METHODS.map(function(method) {
                                            return /*#__PURE__*/ (0, $iD4WH.jsxs)("button", {
                                                className: "payment-method ".concat(paymentMethod === method.id ? 'active' : ''),
                                                onClick: function() {
                                                    return setPaymentMethod(method.id);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                                        children: method.icon
                                                    }),
                                                    method.label
                                                ]
                                            }, method.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "cart-summary",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                                children: "Bill summary"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                                className: "cart-coupon",
                                children: appliedCoupon ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                    className: "cart-coupon-applied",
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                            children: [
                                                "\uD83C\uDFF7\uFE0F ",
                                                appliedCoupon,
                                                " applied"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                            onClick: handleRemoveCoupon,
                                            children: "Remove"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $iD4WH.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                            className: "cart-coupon-input",
                                            children: [
                                                /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Enter coupon code",
                                                    value: couponInput,
                                                    onChange: function(e) {
                                                        setCouponInput(e.target.value);
                                                        setCouponError('');
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                                    onClick: handleApplyCoupon,
                                                    children: "Apply"
                                                })
                                            ]
                                        }),
                                        couponError && /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                            className: "cart-coupon-error",
                                            children: couponError
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Item total"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            subtotal.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "GST & restaurant charges"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            gst.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Delivery fee"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: deliveryFee === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $iD4WH.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $iD4WH.jsxs)("s", {
                                                    children: [
                                                        "\u20B9",
                                                        $711a04e9b448458e$var$DELIVERY_FEE
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $iD4WH.jsx)("em", {
                                                    children: "FREE"
                                                })
                                            ]
                                        }) : "\u20B9".concat(deliveryFee)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Platform fee"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            $711a04e9b448458e$var$PLATFORM_FEE
                                        ]
                                    })
                                ]
                            }),
                            discount > 0 && /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row cart-summary-discount",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "Coupon discount"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u2212\u20B9",
                                            discount.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "cart-summary-row cart-summary-total",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: "To pay"
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            total.toFixed(0)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "cart-checkout-btn",
                                onClick: handlePlaceOrder,
                                disabled: isPlacingOrder,
                                children: isPlacingOrder ? /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                    className: "cart-btn-spinner"
                                }) : 'Place Order'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $711a04e9b448458e$export$2e2bcd8739ae039 = $711a04e9b448458e$var$Cart;



var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");

var $lEL1W = parcelRequire("lEL1W");
var $c2rik = parcelRequire("c2rik");
var $c2rik = parcelRequire("c2rik");





var $7bebe2ea78750d6e$var$COLLECTION_URL = '/.netlify/functions/swiggy-collection';
var $7bebe2ea78750d6e$var$extractRestaurants = function() {
    var cards = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var card = _step.value;
            var _card_card_card_gridElements_infoWithStyle, _card_card_card_gridElements, _card_card_card, _card_card;
            var grid = card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_gridElements = _card_card_card.gridElements) === null || _card_card_card_gridElements === void 0 ? void 0 : (_card_card_card_gridElements_infoWithStyle = _card_card_card_gridElements.infoWithStyle) === null || _card_card_card_gridElements_infoWithStyle === void 0 ? void 0 : _card_card_card_gridElements_infoWithStyle.restaurants;
            if (grid === null || grid === void 0 ? void 0 : grid.length) return grid;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return cards.map(function(c) {
        var _c_card;
        return c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : _c_card.card;
    }).filter(function(c) {
        var _c_info;
        return c === null || c === void 0 ? void 0 : (_c_info = c.info) === null || _c_info === void 0 ? void 0 : _c_info.id;
    }).map(function(c) {
        return {
            info: c.info
        };
    });
};
var $7bebe2ea78750d6e$var$RestaurantCardWithDiscount = (0, $befb75561cb9b7e5$export$69fb0609e92726e3)((0, $befb75561cb9b7e5$export$2e2bcd8739ae039));
var $7bebe2ea78750d6e$var$CollectionPage = function() {
    var slug = (0, $c2rik.useParams)().slug;
    var navigate = (0, $c2rik.useNavigate)();
    var category = (0, $de128caf1be3641e$export$a513ea61a7bee91c).find(function(c) {
        return c.slug === slug;
    });
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), restaurants = _useState[0], setRestaurants = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    (0, $dQFEZ.useEffect)(function() {
        if (!category) {
            navigate('/');
            return;
        }
        setRestaurants([]);
        setIsLoading(true);
        fetchRestaurants();
    }, [
        slug
    ]);
    var fetchRestaurants = /*#__PURE__*/ function() {
        var _ref = (0, $g3gsR._)(function() {
            var _json_data, res, json, _json_data_cards, list, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetch("".concat($7bebe2ea78750d6e$var$COLLECTION_URL, "?collection=").concat(category.collection, "&tags=").concat(category.tags, "&offset=0"))
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 2:
                        json = _state.sent();
                        list = $7bebe2ea78750d6e$var$extractRestaurants((_json_data_cards = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.cards) !== null && _json_data_cards !== void 0 ? _json_data_cards : []);
                        setRestaurants(list);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        console.error('[CollectionPage] fetch error:', e.message);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchRestaurants() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!category) return null;
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "collection-page",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "collection-back-bar",
                children: /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                    className: "collection-back-btn",
                    onClick: function() {
                        return navigate('/');
                    },
                    children: "\u2190 Back"
                })
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "collection-header",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                        className: "collection-header-emoji",
                        children: category.emoji
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "collection-header-text",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("h1", {
                                children: [
                                    category.label,
                                    " Restaurants"
                                ]
                            }),
                            !isLoading && /*#__PURE__*/ (0, $iD4WH.jsxs)("p", {
                                children: [
                                    restaurants.length,
                                    " restaurant",
                                    restaurants.length !== 1 ? 's' : '',
                                    " near you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("section", {
                className: "collection-restaurants",
                children: isLoading ? /*#__PURE__*/ (0, $iD4WH.jsx)((0, $0cbdcd5845c3443e$export$2e2bcd8739ae039), {}) : restaurants.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            children: category.emoji
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("h3", {
                            children: [
                                "No ",
                                category.label,
                                " restaurants found"
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                            children: "Try a different category or check back later."
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            onClick: function() {
                                return navigate('/');
                            },
                            children: "Back to home"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                    className: "restaurant-grid",
                    children: restaurants.map(function(restaurant) {
                        return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.Link), {
                            to: '/restaurant/' + restaurant.info.id,
                            className: "card-link",
                            children: restaurant.info.aggregatedDiscountInfoV3 ? /*#__PURE__*/ (0, $iD4WH.jsx)($7bebe2ea78750d6e$var$RestaurantCardWithDiscount, {
                                resData: restaurant
                            }) : /*#__PURE__*/ (0, $iD4WH.jsx)((0, $befb75561cb9b7e5$export$2e2bcd8739ae039), {
                                resData: restaurant
                            })
                        }, restaurant.info.id);
                    })
                })
            })
        ]
    });
};
var $7bebe2ea78750d6e$export$2e2bcd8739ae039 = $7bebe2ea78750d6e$var$CollectionPage;



var $be4aacfa9ee5643d$var$Grocery = /*#__PURE__*/ (0, $dQFEZ.lazy)(function() {
    return (parcelRequire("aod4b"));
});
// it's not same import as above, it's dynamic import... a function
var $be4aacfa9ee5643d$var$AppLayout = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), userName = _useState[0], setUserName = _useState[1];
    // authentication
    (0, $dQFEZ.useEffect)(function() {
        // make api call and send username and password
        var data = {
            name: 'User'
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $d7d37dc522b09008$export$2881499e37b75b9a), {
        store: (0, $c9ec9760ecd75932$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $f6a0a5e5117df21a$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $97819e7f4fb8b01d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $c2rik.Outlet), {}),
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $0285261d32b071b9$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $be4aacfa9ee5643d$var$appRouter = (0, $lEL1W.createBrowserRouter)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $iD4WH.jsx)($be4aacfa9ee5643d$var$AppLayout, {}),
        children: [
            {
                path: '/',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $44eff52b21fb216f$export$2e2bcd8739ae039), {})
            },
            {
                path: '/about',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $a8d71aff005fbb78$export$2e2bcd8739ae039), {})
            },
            {
                path: '/contact',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $700624f0f3cfba7a$export$2e2bcd8739ae039), {})
            },
            {
                path: '/restaurant/:resId',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $0a68001968864957$export$2e2bcd8739ae039), {})
            },
            {
                path: '/cart',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $711a04e9b448458e$export$2e2bcd8739ae039), {})
            },
            {
                path: '/collection/:slug',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $7bebe2ea78750d6e$export$2e2bcd8739ae039), {})
            },
            {
                path: '/grocery',
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $dQFEZ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "page-loading",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            className: "page-loading-spinner"
                        })
                    }),
                    children: /*#__PURE__*/ (0, $iD4WH.jsx)($be4aacfa9ee5643d$var$Grocery, {})
                })
            }
        ],
        errorElement: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $4e1b68af05c768aa$export$2e2bcd8739ae039), {})
    }
]);
var $be4aacfa9ee5643d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8dbfa3fee6dc40a7$exports))).createRoot(document.getElementById('root'));
$be4aacfa9ee5643d$var$root.render(/*#__PURE__*/ (0, $iD4WH.jsx)((0, $lEL1W.RouterProvider), {
    router: $be4aacfa9ee5643d$var$appRouter
})) // lazy loading is a technique in which we load only the required part of the application and not the entire application at once
 // we can use lazy loading with react-router-dom by using dynamic import
;

})();
//# sourceMappingURL=repo.d920a464.js.map
